const data =[
  {
    AcresBurned: 257314,
    AdminUnit: 'Stanislaus National Forest/Yosemite National Park',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/17/rim-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2013-09-06T18:30:00Z',
    Latitude: 37.857,
    Location: '3 miles east of Groveland along Hwy 120',
    Longitude: -120.086,
    MajorIncident: 'False',
    Name: 'Rim Fire',
    Started: '2013-08-17T15:25:00Z',
    UniqueId: '5fb18d4d-213f-4d83-a179-daaf11939e78'
  },
  {
    AcresBurned: 30274,
    AdminUnit: 'USFS Angeles National Forest/Los Angeles County/CAL FIRE',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/30/powerhouse-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2013-06-08T18:30:00Z',
    Latitude: 34.585595,
    Location: 'Angeles National Forest',
    Longitude: -118.423176,
    MajorIncident: 'False',
    Name: 'Powerhouse Fire',
    Started: '2013-05-30T15:28:00Z',
    UniqueId: 'bf37805e-1cc2-4208-9972-753e47874c87'
  },
  {
    AcresBurned: 27531,
    AdminUnit: 'CAL FIRE Riverside Unit / San Bernardino National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/15/mountain-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-07-30T18:00:00Z',
    Latitude: 33.7095,
    Location: 'Hwy 243 & Hwy 74 near Mountain Center',
    Longitude: -116.72885,
    MajorIncident: 'False',
    Name: 'Mountain Fire',
    Started: '2013-07-15T13:43:00Z',
    UniqueId: 'a3149fec-4d48-427c-8b2c-59e8b79d59db'
  },
  {
    AcresBurned: 27440,
    AdminUnit: 'Tahoe National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/8/10/american-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '2013-08-30T08:00:00Z',
    Latitude: 39.12,
    Location: 'Deadwood Ridge, northeast of Foresthill',
    Longitude: -120.65,
    MajorIncident: 'False',
    Name: 'American Fire',
    Started: '2013-08-10T16:30:00Z',
    UniqueId: '8213f5c7-34fa-403b-a4bc-da2ace6e6625'
  },
  {
    AcresBurned: 24251,
    AdminUnit: 'Ventura County Fire/CAL FIRE',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/2/springs-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2013-05-11T06:30:00Z',
    Latitude: 0,
    Location: 'Southbound Highway 101 at Camarillo Springs Road, Camarillo',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Springs Fire',
    Started: '2013-05-02T07:01:00Z',
    UniqueId: '46731fb8-3350-4920-bdf7-910ac0eb715c'
  },
  {
    AcresBurned: 22992,
    AdminUnit: 'Sierra National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/7/22/aspen-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2013-09-24T20:15:00Z',
    Latitude: 37.279,
    Location: 'Seven miles north of Big Creek',
    Longitude: -119.318,
    MajorIncident: 'False',
    Name: 'Aspen Fire',
    Started: '2013-07-22T22:15:00Z',
    UniqueId: 'bee8c339-4f26-4b78-a5b4-a8a0ebdb8786'
  },
  {
    AcresBurned: 20292,
    AdminUnit: 'CAL FIRE Riverside Unit / San Bernardino National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/7/silver-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-08-12T18:00:00Z',
    Latitude: 33.86157,
    Location: 'Poppet Flats Rd near Hwy 243, south of Banning',
    Longitude: -116.90427,
    MajorIncident: 'True',
    Name: 'Silver Fire',
    Started: '2013-08-07T14:05:00Z',
    UniqueId: 'c400203b-a7fd-4bd8-803a-f3c74bc32a2b'
  },
  {
    AcresBurned: 14754,
    AdminUnit: 'Klamath National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/7/31/salmon-river-complex/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2013-08-31T06:45:00Z',
    Latitude: 41.32,
    Location: 'North Fork of the Salmon River, West of Sawyers Bar, Klamath National Forest',
    Longitude: -123.176,
    MajorIncident: 'False',
    Name: 'Salmon River Complex',
    Started: '2013-07-31T22:00:00Z',
    UniqueId: 'ba76c009-09c9-497c-b923-1ac8cf05c20d'
  },
  {
    AcresBurned: 12503,
    AdminUnit: 'Six Rivers National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/8/10/corral-complex/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2013-08-12T12:00:00Z',
    Latitude: 41.035,
    Location: 'Tish Tang Ridge east of Hoopa Valley Reservation',
    Longitude: -123.488,
    MajorIncident: 'False',
    Name: 'Corral Complex',
    Started: '2013-08-10T11:40:00Z',
    UniqueId: 'f3dcbca8-f8ed-46d0-8f6e-9c7fc2fb03e6'
  },
  {
    AcresBurned: 11429,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/23/deer-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2013-08-29T16:45:00Z',
    Latitude: 40.04263,
    Location: 'Near Deer Creek, 12 miles east of Los Molinos.',
    Longitude: -121.85397,
    MajorIncident: 'True',
    Name: 'Deer Fire',
    Started: '2013-08-23T14:15:00Z',
    UniqueId: '956dbcf6-db40-4b61-b235-4ede14738f1e'
  },
  {
    AcresBurned: 8073,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/9/9/clover-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2013-09-15T07:30:00Z',
    Latitude: 40.498332,
    Location: 'Community of Igo, 10 miles southwest of Redding',
    Longitude: -122.535496,
    MajorIncident: 'True',
    Name: 'Clover Fire',
    Started: '2013-09-09T12:32:00Z',
    UniqueId: '92af9783-eda9-4186-afe9-447f61a92636'
  },
  {
    AcresBurned: 7055,
    AdminUnit: 'CAL FIRE San Diego Unit / Cleveland National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/6/chariot-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2013-07-15T06:15:00Z',
    Latitude: 32.95435,
    Location: 'off Sunrise Hwy, 9 miles southeast of Julian',
    Longitude: -116.47381,
    MajorIncident: 'True',
    Name: 'Chariot Fire',
    Started: '2013-07-06T12:55:00Z',
    UniqueId: 'ee19b2ec-a96a-4738-994e-fb3ea016e053'
  },
  {
    AcresBurned: 6965,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/1/panther-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2013-05-09T09:00:00Z',
    Latitude: 40.190062,
    Location: '140K3 Line, 8 miles northwest of Butte Meadows',
    Longitude: -121.595555,
    MajorIncident: 'True',
    Name: 'Panther Fire',
    Started: '2013-05-01T09:12:00Z',
    UniqueId: '53122f0f-fefc-4dbf-b2d8-566b42ced66d'
  },
  // {
  //   AcresBurned: 4346,
  //   AdminUnit: 'CAL FIRE / USFS Los Padres National Forest',
  //   ArchiveYear: 2013,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2013/5/15/grand-fire/',
  //   Counties: 'Kern',
  //   CountyIds: 1556,
  //   Extinguished: '2013-05-21T19:45:00Z',
  //   Latitude: 34.7861,
  //   Location: 'South of Frazier Mountain Park Rd, South of Frazier Park',
  //   Longitude: -118.9411,
  //   MajorIncident: 'True',
  //   Name: 'Grand Fire',
  //   Started: '2013-05-15T12:50:00Z',
  //   UniqueId: 'e0d038e9-0926-4c05-8317-ec7075a04b12'
  // },
  // {
  //   AcresBurned: 4346,
  //   AdminUnit: 'CAL FIRE / USFS Los Padres National Forest',
  //   ArchiveYear: 2013,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2013/5/15/grand-fire/',
  //   Counties: 'Ventura',
  //   CountyIds: 1556,
  //   Extinguished: '2013-05-21T19:45:00Z',
  //   Latitude: 34.7861,
  //   Location: 'South of Frazier Mountain Park Rd, South of Frazier Park',
  //   Longitude: -118.9411,
  //   MajorIncident: 'True',
  //   Name: 'Grand Fire',
  //   Started: '2013-05-15T12:50:00Z',
  //   UniqueId: 'e0d038e9-0926-4c05-8317-ec7075a04b12'
  // },
  {
    AcresBurned: 3505,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/11/22/mccabe-fire/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2013-11-27T18:15:00Z',
    Latitude: 38.8167,
    Location: 'The Geysers area, 10 miles northeast of Geyserville',
    Longitude: -122.8498,
    MajorIncident: 'True',
    Name: 'McCabe Fire',
    Started: '2013-11-22T02:04:00Z',
    UniqueId: 'b4bc1480-cbb8-4ef2-8d5f-88a496d21d10'
  },
  {
    AcresBurned: 3166,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/1/summit-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-05-04T18:30:00Z',
    Latitude: 34.288877,
    Location: 'Mias Canyon and Bluff Road in Banning',
    Longitude: -116.941311,
    MajorIncident: 'True',
    Name: 'Summit Fire',
    Started: '2013-05-01T12:38:00Z',
    UniqueId: 'a1b14be5-a8cf-4e40-8588-96becf4c5879'
  },
  {
    AcresBurned: 3111,
    AdminUnit: 'CAL FIRE Santa-Clara Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/9/8/morgan-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2013-09-14T17:30:00Z',
    Latitude: 37.90757,
    Location: 'off Morgan Territory Road, Southeast of Clayton',
    Longitude: -121.882582,
    MajorIncident: 'True',
    Name: 'Morgan Fire',
    Started: '2013-09-08T13:08:00Z',
    UniqueId: 'e33b2d80-7fec-4470-9e79-440d349b0d95'
  },
  {
    AcresBurned: 2781,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/23/san-felipe-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2013-05-26T17:45:00Z',
    Latitude: 33.12111,
    Location: 'San Felipe Road, north of Highway 78, East of Julian',
    Longitude: -116.52579,
    MajorIncident: 'True',
    Name: 'San Felipe Fire',
    Started: '2013-05-23T12:20:00Z',
    UniqueId: '859479e3-918c-42c6-bb74-5fdc17930a16'
  },
  {
    AcresBurned: 2462,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/16/swedes-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2013-08-22T18:00:00Z',
    Latitude: 39.446268,
    Location: 'southeast of Oroville',
    Longitude: -121.38236,
    MajorIncident: 'True',
    Name: 'Swedes Fire',
    Started: '2013-08-16T16:37:00Z',
    UniqueId: '0758e1c0-95ea-47e7-b5c1-5f3ea96bc664'
  },
  {
    AcresBurned: 2236,
    AdminUnit: 'Camp Pendleton Marine Corps Base',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/10/5/deluz-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2013-10-09T19:00:00Z',
    Latitude: 33.341,
    Location: 'On Camp Pendleton, west of Fallbrook',
    Longitude: -117.3092,
    MajorIncident: 'False',
    Name: 'DeLuz Fire',
    Started: '2013-10-05T12:45:00Z',
    UniqueId: '9fb847ce-44c7-4a11-a733-a6cc82838671'
  },
  {
    AcresBurned: 2060,
    AdminUnit: 'Sequoia National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/8/24/fish-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2013-09-24T20:15:00Z',
    Latitude: 36.208,
    Location: 'Golden Trout Wilderness on the Sequoia National Forest.',
    Longitude: -118.444,
    MajorIncident: 'False',
    Name: 'Fish Fire',
    Started: '2013-08-24T14:31:00Z',
    UniqueId: 'a4de6058-c68c-4924-bfb5-dc8ecc3b54c0'
  },
  {
    AcresBurned: 1984,
    AdminUnit: 'USFS Los Padres National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/5/27/white-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2013-05-30T19:30:00Z',
    Latitude: 34.55048,
    Location: 'Southeast of Lake Cachuma, approx. 12 miles southeast of Santa Ynez',
    Longitude: -119.82429,
    MajorIncident: 'False',
    Name: 'White Fire',
    Started: '2013-05-27T14:45:00Z',
    UniqueId: 'abc61995-8bea-4be1-aa49-ee378ab3baaa'
  },
  {
    AcresBurned: 1708,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit / Sierra National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/16/carstens-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2013-06-26T11:15:00Z',
    Latitude: 37.58202,
    Location: 'Off Carstens Road, east of 140 in the Midpines area.',
    Longitude: -119.91071,
    MajorIncident: 'True',
    Name: 'Carstens Fire',
    Started: '2013-06-16T14:12:00Z',
    UniqueId: 'bb2eb175-43a3-4a5c-bff6-e3669e52c1d1'
  },
  {
    AcresBurned: 1383,
    AdminUnit: 'Cleveland National Forest / CAL FIRE Riverside Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/5/falls-fire/',
    Counties: 'Riverside',
    CountyIds: '33,',
    Extinguished: '2013-08-09T18:45:00Z',
    Latitude: 33.62236,
    Location: 'Ortega Highway, west of Lake Elsinoire',
    Longitude: -117.40288,
    MajorIncident: 'False',
    Name: 'Falls Fire',
    Started: '2013-08-05T10:10:00Z',
    UniqueId: '4867ac70-663e-48f4-b9ae-ca0a486234ca'
  },
  {
    AcresBurned: 1271,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/26/general-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2013-05-31T06:15:00Z',
    Latitude: 33.04458,
    Location: 'Banner Grade area, south of Hwy 78 & east of Hwy 79, southeast of Julian',
    Longitude: -116.5209,
    MajorIncident: 'True',
    Name: 'General Fire',
    Started: '2013-05-26T12:04:00Z',
    UniqueId: '07a5397c-a665-4f84-9a82-5f689cb2c8f3'
  },
  {
    AcresBurned: 1070,
    AdminUnit: 'Stanislaus National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/8/5/power-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2013-08-14T08:30:00Z',
    Latitude: 38.25108,
    Location: 'Near Beardsley Lake, northeast of Sonora',
    Longitude: -120.02778,
    MajorIncident: 'False',
    Name: 'Power Fire',
    Started: '2013-08-05T06:00:00Z',
    UniqueId: '1e8441c2-f426-40b4-9f4f-3de9f7e232b9'
  },
  {
    AcresBurned: 917,
    AdminUnit: 'Los Padres National Forest / CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/12/16/pfeiffer-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2013-12-20T20:00:00Z',
    Latitude: 0,
    Location: 'Pfeiffer Ridge Road and Highway 1 near Big Sur',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Pfeiffer Fire',
    Started: '2013-12-16T00:20:00Z',
    UniqueId: '0681ea77-2e43-43c4-9ae9-34fb168c0c03'
  },
  {
    AcresBurned: 794,
    AdminUnit: 'Sequoia National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/8/18/shirley-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2013-08-24T13:45:00Z',
    Latitude: 35.707,
    Location: 'Lower Kern River Canyon area off Highway 178',
    Longitude: -118.588,
    MajorIncident: 'False',
    Name: 'Shirley Fire',
    Started: '2013-08-18T23:12:00Z',
    UniqueId: '5421868e-52ba-4737-8169-325e0aa040e4'
  },
  {
    AcresBurned: 712,
    AdminUnit: 'CAL FIRE / Kern County Fire / State Parks / US Forest Service',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/19/rancho-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2013-07-22T18:45:00Z',
    Latitude: 34.882,
    Location: 'West side of Interstate 5 in Lebec (Kern County)',
    Longitude: -118.9194,
    MajorIncident: 'True',
    Name: 'Rancho Fire',
    Started: '2013-07-19T12:00:00Z',
    UniqueId: '591a56a5-e9c0-45a0-96bd-34098588c39b'
  },
  {
    AcresBurned: 712,
    AdminUnit: 'CAL FIRE/Los Angeles County',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/17/lake-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2013-05-18T19:00:00Z',
    Latitude: 34.49149,
    Location: 'I-5 Southbound at Lake Hughes Road',
    Longitude: -118.610044,
    MajorIncident: 'False',
    Name: 'Lake Fire',
    Started: '2013-05-17T13:23:00Z',
    UniqueId: '39af7eac-c188-411f-8c8a-d165c5fca4a9'
  },
  {
    AcresBurned: 612,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/23/water-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2013-07-25T18:30:00Z',
    Latitude: 34.90327,
    Location: 'West side of Interstate 5 at Tejon Ranch',
    Longitude: -118.93388,
    MajorIncident: 'False',
    Name: 'Water Fire',
    Started: '2013-07-23T09:15:00Z',
    UniqueId: '86faecab-ed3a-4fce-95cf-89433a825c72'
  },
  {
    AcresBurned: 572,
    AdminUnit: 'Eldorado National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/7/8/kyburz-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2013-07-11T18:30:00Z',
    Latitude: 38.774,
    Location: 'Off Hwy 50 at 30 Mile Tract, Kyburz',
    Longitude: -120.298,
    MajorIncident: 'False',
    Name: 'Kyburz Fire',
    Started: '2013-07-08T12:45:00Z',
    UniqueId: 'd778a3f0-2d23-43c1-b9bc-1ea33898fab2'
  },
  {
    AcresBurned: 534,
    AdminUnit: 'CAL FIRE San Bernardino Unit/ City of Redlands/San Bernardino Sheriff',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/28/mills-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2013-07-01T06:00:00Z',
    Latitude: 34.071556,
    Location: 'south of Highway 38 & Bryant Street, northwest of Yucaipa',
    Longitude: -117.048397,
    MajorIncident: 'True',
    Name: 'Mills Fire',
    Started: '2013-06-28T14:30:00Z',
    UniqueId: '6011819c-19ac-46c2-aa48-0ee8be0e48c0'
  },
  {
    AcresBurned: 513,
    AdminUnit: 'Plumas National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/8/18/plumas-lightning-complex-hough/',
    Counties: 'Plumas',
    CountyIds: 32,
    Extinguished: '2013-08-25T13:15:00Z',
    Latitude: 40.00842,
    Location: 'Keddie Ridge/North Arm areas of Indian Valley near Taylorsville',
    Longitude: -120.764666,
    MajorIncident: 'False',
    Name: 'Plumas Lightning Complex (Hough)',
    Started: '2013-08-18T18:30:00Z',
    UniqueId: '5015b3c2-2bae-4cce-9bf8-f1b25b0ce1e6'
  },
  {
    AcresBurned: 510,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/4/gorgonio-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-05-05T18:45:00Z',
    Latitude: 33.894055,
    Location: 'Highway 243, south of Banning and north of Pine Cove',
    Longitude: -116.855019,
    MajorIncident: 'False',
    Name: 'Gorgonio Fire',
    Started: '2013-05-04T11:43:00Z',
    UniqueId: '958ce6d2-97f9-4848-8620-d14ab87f329d'
  },
  {
    AcresBurned: 502,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/3/fox-fire-formally-3-7-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2013-07-05T18:30:00Z',
    Latitude: 41.2415,
    Location: '5 miles northwest of Aiden',
    Longitude: -121.035,
    MajorIncident: 'False',
    Name: 'Fox Fire (formally 3-7 Fire)',
    Started: '2013-07-03T22:56:00Z',
    UniqueId: '8b51033d-abc6-4ea4-8983-990ad4e1c45e'
  },
  {
    AcresBurned: 500,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/6/1/branch-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2013-06-03T18:30:00Z',
    Latitude: 35.15832,
    Location: 'west of the Carrizo Plain, Los Padres National Forest',
    Longitude: -120.05131,
    MajorIncident: 'False',
    Name: 'Branch Fire',
    Started: '2013-06-01T17:27:00Z',
    UniqueId: '213dc89e-9f29-4480-91a6-aec5fb694999'
  },
  {
    AcresBurned: 492,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/1/kirker-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2013-07-01T18:40:00Z',
    Latitude: 37.96866,
    Location: 'Kirker Pass Road south of Pittsburg',
    Longitude: -121.91453,
    MajorIncident: 'False',
    Name: 'Kirker Fire',
    Started: '2013-07-01T13:19:00Z',
    UniqueId: '522114fe-ada8-49a9-9bb2-5891103ff0ca'
  },
  {
    AcresBurned: 482,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/16/rolling-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2013-06-18T19:30:00Z',
    Latitude: 37.015575,
    Location: 'off Hwy 41 & Road 145, northwest of Friant',
    Longitude: -119.78106,
    MajorIncident: 'True',
    Name: 'Rolling Fire',
    Started: '2013-06-16T18:17:00Z',
    UniqueId: '05d0fed7-8502-4a6f-9c5c-b9cee0e75408'
  },
  {
    AcresBurned: 413,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/8/20/gobblers-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2013-08-20T13:32:00Z',
    Latitude: 34.302,
    Location: 'upper end of Lytle Creek',
    Longitude: -117.598,
    MajorIncident: 'False',
    Name: 'Gobblers Fire',
    Started: '2013-08-20T13:32:00Z',
    UniqueId: 'b202bd85-c5ef-4bdf-8270-d556f95c3742'
  },
  {
    AcresBurned: 406,
    AdminUnit: 'CAL FIRE San Bernardino Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/2/24/river-fire/',
    Counties: 'Inyo',
    CountyIds: 14,
    Extinguished: '2013-02-28T20:00:00Z',
    Latitude: 36.602575,
    Location: 'south of Narrow Gauge Rd & north of Hwy 136, east of Lone Pine',
    Longitude: -118.01651,
    MajorIncident: 'True',
    Name: 'River Fire',
    Started: '2013-02-24T08:16:00Z',
    UniqueId: '094719ba-a47b-4abb-9ec5-a506b2b9fd23'
  },
  {
    AcresBurned: 376,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/10/3/putah-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2013-10-04T16:55:00Z',
    Latitude: 38.628,
    Location: 'off Berryessa Knoxville Rd near Lake Berryessa',
    Longitude: -122.289,
    MajorIncident: 'True',
    Name: 'Putah Fire',
    Started: '2013-10-03T20:33:00Z',
    UniqueId: '1f94fce5-49a5-4220-bc99-f003ab4d3e60'
  },
  {
    AcresBurned: 354,
    AdminUnit: 'CAL FIRE San Benito-Monterey',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/3/tres-pinos-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2013-05-03T18:45:00Z',
    Latitude: 37.160346,
    Location: 'Highway 25 and Horizon Rd, Community of Tres',
    Longitude: -120.937494,
    MajorIncident: 'False',
    Name: 'Tres Pinos Fire',
    Started: '2013-05-03T11:42:00Z',
    UniqueId: 'ca68f3c4-4906-4952-b794-4531d7da8369'
  },
  {
    AcresBurned: 311,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/2/28/jurupa-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-03-02T19:00:00Z',
    Latitude: 0,
    Location: 'Rio Rancho Rd & Calle Hermosa, Jurupa Valley',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Jurupa Fire',
    Started: '2013-02-28T16:43:00Z',
    UniqueId: '99cb21da-9639-4300-9a97-1cadc993189f'
  },
  {
    AcresBurned: 305,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/10/4/summit-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2013-10-05T22:00:00Z',
    Latitude: 39.439,
    Location: 'off District Center Dr & Fortune Way in Palermo',
    Longitude: -121.497,
    MajorIncident: 'True',
    Name: 'Summit Fire',
    Started: '2013-10-04T17:37:00Z',
    UniqueId: 'd922e7c8-814a-412b-a40b-53072d0983ea'
  },
  {
    AcresBurned: 303,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/30/shelton-fire/',
    Counties: 'San Joaquin',
    CountyIds: 39,
    Extinguished: '2013-05-30T13:25:00Z',
    Latitude: 38.04993,
    Location: 'off North Shelton Rd in the Linden Peters area',
    Longitude: -120.90325,
    MajorIncident: 'False',
    Name: 'Shelton Fire',
    Started: '2013-05-30T11:20:00Z',
    UniqueId: '0b51d59b-457d-4a62-b066-55c2b8d400e2'
  },
  {
    AcresBurned: 298,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/3/lone-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2013-06-03T20:00:00Z',
    Latitude: 39.434183,
    Location: 'Palermo Road and Lone Tree Road near Palermo',
    Longitude: -121.576804,
    MajorIncident: 'True',
    Name: 'Lone Fire',
    Started: '2013-06-03T13:49:00Z',
    UniqueId: '1a5192f1-bc99-4130-8683-381e0534b76a'
  },
  {
    AcresBurned: 296,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/1/22/becks-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2013-01-23T10:15:00Z',
    Latitude: 0,
    Location: 'North of Highway 29, southeast of Kelseyville',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Becks Fire',
    Started: '2013-01-22T11:08:00Z',
    UniqueId: '7a4a3552-3bea-4428-984c-e2edef13980f'
  },
  {
    AcresBurned: 274,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/1/concord-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2013-07-01T18:30:00Z',
    Latitude: 39.90465,
    Location: 'off Concord Ave & Vineyard Parkway in Brentwood',
    Longitude: -121.74367,
    MajorIncident: 'False',
    Name: 'Concord Fire',
    Started: '2013-07-01T15:41:00Z',
    UniqueId: '95399a9c-8b3e-4413-9f56-5ed57d3d81b3'
  },
  {
    AcresBurned: 274,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/4/30/gold-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2013-05-01T07:00:00Z',
    Latitude: 37.116295,
    Location: 'Between Road 210 and Road 200 near Fine Gold Creek in the community of O',
    Longitude: -119.635004,
    MajorIncident: 'False',
    Name: 'Gold Fire',
    Started: '2013-04-30T12:59:00Z',
    UniqueId: '357ffc13-bef9-48eb-810f-c5de851972eb'
  },
  {
    AcresBurned: 268,
    AdminUnit: 'Angeles National Forest/Los Angeles County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/9/23/madre-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2013-09-28T08:00:00Z',
    Latitude: 34.149,
    Location: 'San Gabriel Canyon 1/4 mile west of the entrance station',
    Longitude: -117.908,
    MajorIncident: 'False',
    Name: 'Madre Fire',
    Started: '2013-09-23T18:00:00Z',
    UniqueId: 'eb5a3f2a-0c25-417a-af78-bb0d643247c7'
  },
  {
    AcresBurned: 263,
    AdminUnit: 'CAL FIRE San Diego Unit / Cleveland National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/9/9/lyon-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2013-09-12T18:15:00Z',
    Latitude: 32.710918,
    Location: 'Four Corners, Lyons Valley Road, east of Lyons Peak',
    Longitude: -116.746023,
    MajorIncident: 'True',
    Name: 'Lyon Fire',
    Started: '2013-09-09T13:09:00Z',
    UniqueId: 'f6f6fefa-ac4e-466f-815e-492416e37b98'
  },
  {
    AcresBurned: 243,
    AdminUnit: 'Angeles National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/8/8/sharp-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2013-08-13T23:45:00Z',
    Latitude: 34.35,
    Location: 'Sheep canyon just south of Wrightwood',
    Longitude: -117.62,
    MajorIncident: 'False',
    Name: 'Sharp Fire',
    Started: '2013-08-08T12:15:00Z',
    UniqueId: '62eabea3-40be-497d-94e4-150f011b925f'
  },
  {
    AcresBurned: 240,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/8/vasco-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2013-06-08T13:25:00Z',
    Latitude: 37.775057,
    Location: 'off Vasco Road & North Vasco Road, north of Livermore',
    Longitude: -121.737213,
    MajorIncident: 'False',
    Name: 'Vasco Fire',
    Started: '2013-06-08T10:16:00Z',
    UniqueId: '2ad509e4-99f1-4e1a-81eb-839f772f9c45'
  },
  {
    AcresBurned: 237,
    AdminUnit: 'CAL FIRE/Placer County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/13/pfe-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '2013-06-13T14:15:00Z',
    Latitude: 38.729297,
    Location: 'PFE Road and Watt Avenue, West Roseville',
    Longitude: -121.380862,
    MajorIncident: 'False',
    Name: 'PFE Fire',
    Started: '2013-06-13T11:28:00Z',
    UniqueId: 'fe47b1c2-b9c0-44be-8d10-f270056db35c'
  },
  {
    AcresBurned: 226,
    AdminUnit: 'Mendocino National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/6/12/daves-fire/',
    Counties: 'Glenn',
    CountyIds: 11,
    Extinguished: '2013-06-17T09:00:00Z',
    Latitude: 0,
    Location: '15 miles northwest of Elk Creek off County Road 306',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Daves Fire',
    Started: '2013-06-12T15:17:00Z',
    UniqueId: 'f3a3c56c-d2fc-49df-b0e2-ab36356b17d4'
  },
  {
    AcresBurned: 217,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/1/306-fire/',
    Counties: 'Glenn',
    CountyIds: 11,
    Extinguished: '2013-05-05T18:00:00Z',
    Latitude: 39.514139,
    Location: '2 miles south of the community of Elk Creek',
    Longitude: -122.560862,
    MajorIncident: 'True',
    Name: '306 Fire',
    Started: '2013-05-01T19:00:00Z',
    UniqueId: '5649e78d-7c26-4698-89a0-b0fa9a35cf78'
  },
  {
    AcresBurned: 213,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/7/17/tassajara-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2013-07-17T19:30:00Z',
    Latitude: 0,
    Location: 'Tassajara Hot Springs, near the Zen Center',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Tassajara Fire',
    Started: '2013-07-17T13:23:00Z',
    UniqueId: '0d38ff45-833e-488a-881f-30f24678c49c'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'San Bernardino National Forest/CAL FIRE San Bernardino Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/9/24/sierra-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2013-09-30T08:30:00Z',
    Latitude: 34.2,
    Location: 'in the Cajon Pass west of I-15 near Glen Helen Road',
    Longitude: -117.417,
    MajorIncident: 'False',
    Name: 'Sierra Fire',
    Started: '2013-09-24T15:51:00Z',
    UniqueId: 'f7358513-329f-4dba-8980-4cd3a19b469a'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/4/vina-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2013-07-04T10:30:00Z',
    Latitude: 40.012398,
    Location: 'Tehama-Vina Rd and Sherman Rd, Los Molinos',
    Longitude: -122.079871,
    MajorIncident: 'False',
    Name: 'Vina Fire',
    Started: '2013-07-04T07:30:00Z',
    UniqueId: 'c94959d7-eb88-4724-8feb-ba0662afca10'
  },
  {
    AcresBurned: 196,
    AdminUnit: 'CAL FIRE Shasta Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/19/burney-lightning-series-warner-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2013-08-23T19:15:00Z',
    Latitude: 40.5445,
    Location: 'Fall River Mills and McAruther area',
    Longitude: -121.3754,
    MajorIncident: 'True',
    Name: 'Burney Lightning Series (Warner Fire)',
    Started: '2013-08-19T17:48:00Z',
    UniqueId: 'f21a41c6-0905-4531-9bdf-2456d0051eed'
  },
  {
    AcresBurned: 195,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/19/paskenta-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2013-07-19T15:00:00Z',
    Latitude: 39.961309,
    Location: 'West of Corning',
    Longitude: -122.330879,
    MajorIncident: 'False',
    Name: 'Paskenta Fire',
    Started: '2013-07-19T13:32:00Z',
    UniqueId: '4423899b-6197-4ef5-9f73-bca1763f17e6'
  },
  {
    AcresBurned: 190,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/11/21/silverado-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2013-11-23T18:30:00Z',
    Latitude: 38.382,
    Location: 'Off Silverado Trail in the Soda Canyon area near Napa',
    Longitude: -122.311,
    MajorIncident: 'True',
    Name: 'Silverado Fire',
    Started: '2013-11-21T21:39:00Z',
    UniqueId: '79d476e5-0b4d-48e2-a105-2bba5c1140e9'
  },
  {
    AcresBurned: 170,
    AdminUnit: 'Santa Barbara County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/28/olive-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2013-05-29T10:30:00Z',
    Latitude: 34.611824,
    Location: 'Hwy 246 and Meadowvale, East of Solvang',
    Longitude: -120.074655,
    MajorIncident: 'False',
    Name: 'Olive Fire',
    Started: '2013-05-28T15:24:00Z',
    UniqueId: 'cb5f34a0-177e-445d-9349-dd94063a01d0'
  },
  {
    AcresBurned: 163,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/11/4/capay-fire/',
    Counties: 'Yolo',
    CountyIds: 57,
    Extinguished: '2013-11-04T15:35:00Z',
    Latitude: 38.67479,
    Location: 'Off County Road 23 & County Road 81, Southwest of Esparto',
    Longitude: -122.08725,
    MajorIncident: 'False',
    Name: 'Capay Fire',
    Started: '2013-11-04T11:41:00Z',
    UniqueId: '0aa08938-eaab-4a60-8891-946197328f94'
  },
  {
    AcresBurned: 163,
    AdminUnit: 'CAL FIRE / Sacramento Metropolitan Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/19/50-fire/',
    Counties: 'El Dorado',
    CountyIds: 934,
    Extinguished: '2013-07-19T17:15:00Z',
    Latitude: 38.63987,
    Location: 'South of Hwy 50 at the El Dorado and Sacramento County line',
    Longitude: -121.08438,
    MajorIncident: 'False',
    Name: '50 Fire',
    Started: '2013-07-19T14:12:00Z',
    UniqueId: '4630e9ce-88ec-4159-9bc9-25ff5f8216cc'
  },
  // {
  //   AcresBurned: 163,
  //   AdminUnit: 'CAL FIRE / Sacramento Metropolitan Fire',
  //   ArchiveYear: 2013,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2013/7/19/50-fire/',
  //   Counties: 'Sacramento',
  //   CountyIds: 934,
  //   Extinguished: '2013-07-19T17:15:00Z',
  //   Latitude: 38.63987,
  //   Location: 'South of Hwy 50 at the El Dorado and Sacramento County line',
  //   Longitude: -121.08438,
  //   MajorIncident: 'False',
  //   Name: '50 Fire',
  //   Started: '2013-07-19T14:12:00Z',
  //   UniqueId: '4630e9ce-88ec-4159-9bc9-25ff5f8216cc'
  // },
  {
    AcresBurned: 159,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/10/4/crane-fire/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2013-10-05T07:45:00Z',
    Latitude: 38.34599,
    Location: 'near Crane Creek Regional Park off Pressley Rd, east of Rohnert Park',
    Longitude: -122.6503,
    MajorIncident: 'False',
    Name: 'Crane Fire',
    Started: '2013-10-04T12:25:00Z',
    UniqueId: '1460f2d9-853b-4901-bed3-ac196e00bb3a'
  },
  {
    AcresBurned: 158,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/26/lakeville-fire/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2013-07-26T17:45:00Z',
    Latitude: 38.17693,
    Location: 'Off Lakeville Hwy, 6 miles SE of Petaluma',
    Longitude: -122.51253,
    MajorIncident: 'False',
    Name: 'Lakeville Fire',
    Started: '2013-07-26T13:45:00Z',
    UniqueId: 'c9b5d1ff-c042-4b39-8bac-b10fb6fc6c13'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/10/4/highland-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2013-10-04T10:30:00Z',
    Latitude: 0,
    Location: 'Highland Road, Livermore',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Highland Fire',
    Started: '2013-10-04T07:35:00Z',
    UniqueId: '6a48000a-6198-46dd-9a91-0b0159183145'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/16/redlands-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-07-17T07:45:00Z',
    Latitude: 33.990128,
    Location: 'Redlands Boulevard and San Timoteo Canyon Road, north of Moreno Valley',
    Longitude: -117.164997,
    MajorIncident: 'False',
    Name: 'Redlands Fire',
    Started: '2013-07-16T17:48:00Z',
    UniqueId: 'd48a839f-d8da-44d7-9b35-b9f61aa28c61'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/12/diablo-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2013-07-13T21:45:00Z',
    Latitude: 37.436,
    Location: 'off Diablo Grande Parkway, west of I-5, southwest of Patterson',
    Longitude: -121.1955,
    MajorIncident: 'False',
    Name: 'Diablo Fire',
    Started: '2013-07-12T15:35:00Z',
    UniqueId: '873074c8-4b6d-417b-a78c-1d1430027805'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'CAL FIRE/Fresno County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/25/george-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2013-06-25T17:15:00Z',
    Latitude: 36.7218,
    Location: 'off Bronco Lane in Squaw Valley',
    Longitude: -119.2248,
    MajorIncident: 'False',
    Name: 'George Fire',
    Started: '2013-06-25T13:36:00Z',
    UniqueId: '23ec2f69-da30-4983-80c2-1f04bfea6f9a'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/22/neal-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2013-05-22T09:30:00Z',
    Latitude: 0,
    Location: 'Neal Road, southwest of Paradise',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Neal Fire',
    Started: '2013-05-22T00:56:00Z',
    UniqueId: '28ffc826-6789-429c-9801-f3a02dbb320a'
  },
  {
    AcresBurned: 149,
    AdminUnit: 'Los Angeles County Fire Department',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/28/magic-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2013-05-29T15:30:00Z',
    Latitude: 34.419284,
    Location: 'off Magic Mtn Parkway in Valencia',
    Longitude: -118.58688,
    MajorIncident: 'False',
    Name: 'Magic Fire',
    Started: '2013-05-28T11:30:00Z',
    UniqueId: '794412f2-1ba2-4217-ac38-49272a96fb6f'
  },
  {
    AcresBurned: 134,
    AdminUnit: 'Sequoia National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/9/8/angora-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2013-09-24T20:15:00Z',
    Latitude: 36.258,
    Location: 'Golden Trout Wilderness',
    Longitude: -118.459,
    MajorIncident: 'False',
    Name: 'Angora Fire',
    Started: '2013-09-08T11:53:00Z',
    UniqueId: 'd332a628-6290-4e91-b8d0-4dc663b80c38'
  },
  {
    AcresBurned: 125,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/1/yellow-fire/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2013-05-03T06:15:00Z',
    Latitude: 38.638828,
    Location: 'Hwy 128 & Yellow Jacket Ranch Rd in Knights Valley, northwest of Calistoga',
    Longitude: -122.655616,
    MajorIncident: 'True',
    Name: 'Yellow Fire',
    Started: '2013-05-01T02:01:00Z',
    UniqueId: '64e4f81e-d872-44c4-ba8d-111fa77124ba'
  },
  {
    AcresBurned: 124,
    AdminUnit: 'CAL FIRE Sanoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/18/california-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2013-06-18T22:30:00Z',
    Latitude: 38.08744,
    Location: 'Off Lake Herman Rd, west of Hwy 680 in Benicia',
    Longitude: -122.13802,
    MajorIncident: 'False',
    Name: 'California Fire',
    Started: '2013-06-18T15:18:00Z',
    UniqueId: '2b403f03-fe84-450a-90b7-befb8acc7e70'
  },
  {
    AcresBurned: 124,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/4/152-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2013-06-05T08:30:00Z',
    Latitude: 37.03776,
    Location: 'Hwy 152 in San Luis Creek Reservoir',
    Longitude: -121.006939,
    MajorIncident: 'False',
    Name: '152 Fire',
    Started: '2013-06-04T15:42:00Z',
    UniqueId: 'f9e85371-fc46-4f54-822c-7dcdaadde551'
  },
  {
    AcresBurned: 124,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/25/smiley-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-05-25T23:00:00Z',
    Latitude: 33.963591,
    Location: 'Off Smiley Blvd & Vista Suelto Rd, north of Moreno Valley',
    Longitude: -117.187934,
    MajorIncident: 'False',
    Name: 'Smiley Fire',
    Started: '2013-05-25T14:59:00Z',
    UniqueId: '9795afee-7e60-4ab3-b5c3-7df67f91c5f9'
  },
  {
    AcresBurned: 120,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/11/8/cantwell-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2013-11-10T18:30:00Z',
    Latitude: 38.882214,
    Location: 'South of Morgan Valley Rd and East of Hwy 29, Community of Lower Lake',
    Longitude: -122.567525,
    MajorIncident: 'True',
    Name: 'Cantwell Fire',
    Started: '2013-11-08T13:42:00Z',
    UniqueId: '20ba8b6b-78d4-46a7-995b-d8fa38cbf3b8'
  },
  {
    AcresBurned: 116,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/16/union-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2013-08-16T17:55:00Z',
    Latitude: 38.682378,
    Location: 'off Koki Ln and Pleasant Valley Rd, northwest of Diamond Springs',
    Longitude: -120.839075,
    MajorIncident: 'True',
    Name: 'Union Fire',
    Started: '2013-08-16T13:55:00Z',
    UniqueId: 'db009f8f-8b9d-44bb-a3f6-83f319c84d72'
  },
  {
    AcresBurned: 110,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/8/17/cleghorn-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2013-08-18T20:55:00Z',
    Latitude: 34.287,
    Location: 'I-15 Cajon Pass south of Cleghorn Road',
    Longitude: -117.451,
    MajorIncident: 'False',
    Name: 'Cleghorn Fire',
    Started: '2013-08-17T17:25:00Z',
    UniqueId: 'c7f05927-66a4-403c-9048-aeb42eca0211'
  },
  {
    AcresBurned: 108,
    AdminUnit: 'CAL FIRE/Fresno County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/13/clinton-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2013-06-13T21:30:00Z',
    Latitude: 36.772425,
    Location: 'Clinton and Highland, East of Fresno',
    Longitude: -119.628389,
    MajorIncident: 'False',
    Name: 'Clinton Fire',
    Started: '2013-06-13T11:54:00Z',
    UniqueId: 'a2cfda2a-21c1-4e45-90b5-37d931b4a926'
  },
  {
    AcresBurned: 105,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/29/freeman-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2013-06-29T18:30:00Z',
    Latitude: 36.1531,
    Location: 'off Hwy 198, 10 miles east of King City',
    Longitude: -120.8973,
    MajorIncident: 'False',
    Name: 'Freeman Fire',
    Started: '2013-06-29T14:09:00Z',
    UniqueId: '58317b8d-7f4d-466f-b2c7-035c25fb00f0'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'Angeles National Forest / Los Angeles County Fire Department',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/8/9/bee-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2013-08-11T19:15:00Z',
    Latitude: 0,
    Location: 'San Francisquito Canyon Rd & Stator Ln',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Bee Fire',
    Started: '2013-08-09T17:15:00Z',
    UniqueId: 'c6044e8d-c054-44f2-bc92-24510df4deef'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/2/murphy-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2013-06-02T16:55:00Z',
    Latitude: 37.91529,
    Location: 'off Lime Kiln Rd',
    Longitude: -120.33313,
    MajorIncident: 'False',
    Name: 'Murphy Fire',
    Started: '2013-06-02T13:30:00Z',
    UniqueId: '98bfbb7c-8446-4e2e-a268-7e961353723c'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/22/border-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2013-05-23T08:30:00Z',
    Latitude: 32.564465,
    Location: 'Off Alta Rd in the Otay Mesa area',
    Longitude: -116.900368,
    MajorIncident: 'False',
    Name: 'Border Fire',
    Started: '2013-05-22T16:14:00Z',
    UniqueId: 'e077e091-f890-477c-b948-eb23774b432e'
  },
  {
    AcresBurned: 98,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/9/28/highland-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2013-09-29T18:15:00Z',
    Latitude: 38.9252,
    Location: 'off Highland Springs Rd, southeast of Kelseyville',
    Longitude: -122.966,
    MajorIncident: 'False',
    Name: 'Highland Fire',
    Started: '2013-09-28T13:57:00Z',
    UniqueId: 'b20a2031-12c9-4e9c-9f44-ac82c26e6c66'
  },
  {
    AcresBurned: 97,
    AdminUnit: 'Modoc National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/9/5/davis-creek-complex/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2013-09-24T20:15:00Z',
    Latitude: 41.73325,
    Location: 'Both sides of Davis Creek near Hwy 395, south of Goose Lake',
    Longitude: -120.375,
    MajorIncident: 'False',
    Name: 'Davis Creek Complex',
    Started: '2013-09-05T15:57:00Z',
    UniqueId: '308ce8d5-67c8-4edb-9e2f-bf6295f98d7e'
  },
  {
    AcresBurned: 97,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/8/24/little-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2013-08-30T08:00:00Z',
    Latitude: 33.642,
    Location: 'near Thomas Mountain south of Lake Hemet on the San Jacinto Ranger District.',
    Longitude: -116.706,
    MajorIncident: 'False',
    Name: 'Little Fire',
    Started: '2013-08-24T15:09:00Z',
    UniqueId: 'b5109726-5e91-4c10-96f8-2a5bb72e5a59'
  },
  {
    AcresBurned: 97,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/9/coyote-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2013-08-12T09:30:00Z',
    Latitude: 40.88886,
    Location: 'Southeast of Coyote Reservoir, 20 miles southeast of Bieber',
    Longitude: -120.958126,
    MajorIncident: 'False',
    Name: 'Coyote Fire',
    Started: '2013-08-09T15:51:00Z',
    UniqueId: '2b84c8a2-e2e8-45a2-9221-e8075608c218'
  },
  {
    AcresBurned: 96,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/12/roadrunner-fire/',
    Counties: 'Amador',
    CountyIds: 3,
    Extinguished: '2013-06-13T09:45:00Z',
    Latitude: 38.27783,
    Location: 'Roadrunner Drive, south of Ione',
    Longitude: -120.966016,
    MajorIncident: 'False',
    Name: 'Roadrunner Fire',
    Started: '2013-06-12T16:43:00Z',
    UniqueId: 'bf59bc5b-1398-4ae5-adef-6f61b9ee1b90'
  },
  {
    AcresBurned: 94,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/9/24/creek-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2013-09-24T17:30:00Z',
    Latitude: 35.4393,
    Location: 'off Toro Creek Rd, east of Cayucos',
    Longitude: -120.8358,
    MajorIncident: 'False',
    Name: 'Creek Fire',
    Started: '2013-09-24T03:20:00Z',
    UniqueId: 'ac469123-da14-4821-b824-c6cf66138514'
  },
  {
    AcresBurned: 92,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/1/branch-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2013-08-04T14:45:00Z',
    Latitude: 39.6612,
    Location: 'Near Rocky Peak - North Fork Lake Oroville near Cherokee',
    Longitude: -121.50354,
    MajorIncident: 'True',
    Name: 'Branch Fire',
    Started: '2013-08-01T16:01:00Z',
    UniqueId: '0b51d3d5-bb3a-426d-9c12-c1878a01d7cf'
  },
  {
    AcresBurned: 91,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/19/lilly-2-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2013-05-20T19:10:00Z',
    Latitude: 37.1927,
    Location: 'Off Road 400 & Sandy Beach Dr. in Yosemite Lakes',
    Longitude: -119.7917,
    MajorIncident: 'True',
    Name: 'Lilly 2 Fire',
    Started: '2013-05-19T15:07:00Z',
    UniqueId: '2b765a08-c770-4b19-baa8-00dffe3fa838'
  },
  {
    AcresBurned: 90,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/21/water-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-05-21T19:30:00Z',
    Latitude: 33.9582,
    Location: 'Off Whitewater Canyon Road in Whitewater',
    Longitude: -116.6534,
    MajorIncident: 'False',
    Name: 'Water Fire',
    Started: '2013-05-21T14:16:00Z',
    UniqueId: '13850faa-5bab-4fd7-bac3-433ce9250c4d'
  },
  {
    AcresBurned: 85,
    AdminUnit: 'CAL FIRE San Luis Obispo',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/7/adelaida-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2013-07-07T22:00:00Z',
    Latitude: 35.62743,
    Location: 'off Adelaida Rd & Vineyard Dr, west of Paso Robles',
    Longitude: -120.83417,
    MajorIncident: 'False',
    Name: 'Adelaida Fire',
    Started: '2013-07-07T13:16:00Z',
    UniqueId: 'a97d2b3a-3a53-424f-852c-5f1b8d199cc3'
  },
  {
    AcresBurned: 82,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/11/22/retek-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2013-11-22T17:30:00Z',
    Latitude: 39.0442,
    Location: 'Off Hwy 101 at Henry Station Rd, north of Hopland',
    Longitude: -123.1478,
    MajorIncident: 'False',
    Name: 'Retek Fire',
    Started: '2013-11-22T10:06:00Z',
    UniqueId: 'e9e43213-b2fc-47bc-92cd-117ccd6e4780'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/31/centerville-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2013-09-01T18:00:00Z',
    Latitude: 39.731878,
    Location: 'Off Centerville Rd in the Butte Creek Canyon in the community of Centerville, west of Magalia',
    Longitude: -121.713938,
    MajorIncident: 'True',
    Name: 'Centerville Fire',
    Started: '2013-08-31T17:23:00Z',
    UniqueId: 'dd374f36-e7cb-4a48-91ee-e8be101e0f88'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE / Fresno County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/4/9/butte-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2013-04-09T15:30:00Z',
    Latitude: 0,
    Location: 'Butte Ave near Conejo Ave near the community of Helm.',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Butte Fire',
    Started: '2013-04-09T12:35:00Z',
    UniqueId: '3513f584-632d-4fd0-a98a-646eb0753248'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/9/15/tehama-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2013-09-15T19:00:00Z',
    Latitude: 0,
    Location: 'East of Molinos',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Tehama Fire',
    Started: '2013-09-15T17:39:00Z',
    UniqueId: 'ff13baa0-35e0-44dd-b994-38ada16baf7b'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'San Bernardino County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/25/silverwood-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2013-07-26T18:15:00Z',
    Latitude: 34.316,
    Location: 'Hwy 138 west of Hwy 173',
    Longitude: -117.352,
    MajorIncident: 'False',
    Name: 'Silverwood Fire',
    Started: '2013-07-25T15:09:00Z',
    UniqueId: 'ed51bbd2-6f8e-4f46-9073-3673a583fada'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/12/revis-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2013-06-14T16:30:00Z',
    Latitude: 37.169379,
    Location: 'Off Revis Road & Yosemite Springs Parkway in Yosemite Lake Parks area in Coarsegold',
    Longitude: -119.75636,
    MajorIncident: 'True',
    Name: 'Revis Fire',
    Started: '2013-06-12T16:40:00Z',
    UniqueId: '7055a440-5d4c-4f58-bac9-2954ff6698a5'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'USFS San Bernardino National Forest, CAL FIRE San Bernardino Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/13/lytle-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2013-05-15T08:15:00Z',
    Latitude: 34.1834,
    Location: 'I-15 at Sierra Ave, near Lytle Creek',
    Longitude: -117.4408,
    MajorIncident: 'True',
    Name: 'Lytle Fire',
    Started: '2013-05-13T13:30:00Z',
    UniqueId: 'e2c4b308-9a2d-483b-8434-999bef9adc7c'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/4/30/silverado-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2013-05-01T17:15:00Z',
    Latitude: 38.441792,
    Location: '7300 block of Silverado Trail, north of Napa',
    Longitude: -122.350844,
    MajorIncident: 'False',
    Name: 'Silverado Fire',
    Started: '2013-04-30T23:44:00Z',
    UniqueId: 'd8d1c943-7b5d-4885-9043-f41075d6eded'
  },
  {
    AcresBurned: 73,
    AdminUnit: 'CAL FIRE San Bernardino Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/9/11/liveoak-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2013-09-12T08:45:00Z',
    Latitude: 34.003151,
    Location: 'Live Oak Canyon Rd, South of I-10 near cities of Redlands and Yucaipa.',
    Longitude: -117.106075,
    MajorIncident: 'False',
    Name: 'Liveoak Fire',
    Started: '2013-09-11T16:57:00Z',
    UniqueId: '31f21c59-8a94-4b17-91aa-88ca14817162'
  },
  {
    AcresBurned: 73,
    AdminUnit: 'CAL FIRE Nevada-Placer-Yuba Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/8/mcganney-fire/',
    Counties: 'Yuba',
    CountyIds: 58,
    Extinguished: '2013-07-08T17:30:00Z',
    Latitude: 39.206,
    Location: 'off Highway 20 and McGanney Lane, west of Smartsville',
    Longitude: -121.31634,
    MajorIncident: 'False',
    Name: 'McGanney Fire',
    Started: '2013-07-08T09:59:00Z',
    UniqueId: '397ed8e6-6088-4e03-9316-8f50c65a83be'
  },
  {
    AcresBurned: 72,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/1/cedar-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2013-05-04T19:00:00Z',
    Latitude: 0,
    Location: 'Off Cedar Creek Loop Rd, South of Butte Meadows',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Cedar Fire',
    Started: '2013-05-01T04:16:00Z',
    UniqueId: 'c6228c11-4388-4b33-aa18-3593c90f72ad'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/16/double-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2013-08-18T18:30:00Z',
    Latitude: 39.013682,
    Location: 'Hwy 20 and Mule Skinner Rd., Clear Lake Oaks',
    Longitude: -122.491894,
    MajorIncident: 'True',
    Name: 'Double Fire',
    Started: '2013-08-16T17:57:00Z',
    UniqueId: 'ae025ba5-8b5d-48de-ad5e-3037de3d18e9'
  },
  {
    AcresBurned: 68,
    AdminUnit: 'Modoc National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/9/7/rail-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2013-09-05T21:00:00Z',
    Latitude: 41.569,
    Location: 'Rail Mountain, 7 miles NW of Canby',
    Longitude: -120.959,
    MajorIncident: 'False',
    Name: 'Rail Fire',
    Started: '2013-09-07T17:30:00Z',
    UniqueId: '0875cf4e-9948-45ed-a76d-d74564319b49'
  },
  {
    AcresBurned: 64,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/11/14/wheeler-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2013-11-15T16:00:00Z',
    Latitude: 34.384,
    Location: 'Wheeler Canyon, north of Santa Paula',
    Longitude: -119.13249,
    MajorIncident: 'False',
    Name: 'Wheeler Fire',
    Started: '2013-11-14T11:05:00Z',
    UniqueId: '0adb968c-eb85-41c5-8e08-04c0ec386c79'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/8/6/tram-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-08-08T09:00:00Z',
    Latitude: 38.838,
    Location: 'Off of Hwy 111 & Tramway Rd in Palm Springs',
    Longitude: -116.61,
    MajorIncident: 'False',
    Name: 'Tram Fire',
    Started: '2013-08-06T13:39:00Z',
    UniqueId: 'ac568737-dae6-4050-b1f4-62ab1f9ec930'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'CAL FIRE/Riverside County  Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/4/relay-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-08-04T18:00:00Z',
    Latitude: 33.91027,
    Location: 'near Mt. David, south of Beaumont',
    Longitude: -116.99895,
    MajorIncident: 'False',
    Name: 'Relay Fire',
    Started: '2013-08-04T16:29:00Z',
    UniqueId: '0658b1f8-5323-4152-b6d1-b208736587db'
  },
  {
    AcresBurned: 52,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/31/tyler-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2013-08-31T21:30:00Z',
    Latitude: 39.333401,
    Location: 'North San Juan Area, Highway 49 and Tyler Foote Road',
    Longitude: -121.107022,
    MajorIncident: 'False',
    Name: 'Tyler Fire',
    Started: '2013-08-31T14:42:00Z',
    UniqueId: '1476673c-df55-4c39-b117-d9d067f8a020'
  },
  {
    AcresBurned: 51,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/11/8/toro-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2013-11-09T17:00:00Z',
    Latitude: 35.457978,
    Location: 'Toro Creek Rd. and Hwy 41 West, Morro Bay',
    Longitude: -120.751555,
    MajorIncident: 'True',
    Name: 'Toro Fire',
    Started: '2013-11-08T10:30:00Z',
    UniqueId: '587c03e3-4831-47c1-8c03-c08176e91b11'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/11/23/bruner-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2013-11-24T08:45:00Z',
    Latitude: 39.0448,
    Location: 'Off Bruner Drive & Al Drive, Clearlake Oaks',
    Longitude: -122.7656,
    MajorIncident: 'False',
    Name: 'Bruner Fire',
    Started: '2013-11-23T12:04:00Z',
    UniqueId: '3f3e234c-04e1-4941-a79f-23ddc419bf59'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/15/cottonwood-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2013-08-15T17:00:00Z',
    Latitude: 41.923323,
    Location: 'Cottonwood Creek Rd., 2 miles north of Hornbrook',
    Longitude: -122.578393,
    MajorIncident: 'False',
    Name: 'Cottonwood Fire',
    Started: '2013-08-15T14:40:00Z',
    UniqueId: 'e16c204e-58d6-4f78-bc97-729b16ef9f83'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/12/uvas-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2013-07-12T17:45:00Z',
    Latitude: 37.1438,
    Location: 'Uvas Road and Casa Loma Road, near Calero County Park,  west of Morgan Hill',
    Longitude: -121.7804,
    MajorIncident: 'False',
    Name: 'Uvas Fire',
    Started: '2013-07-12T13:09:00Z',
    UniqueId: 'e779a754-29fd-472f-8d29-46cfee32d3c2'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/4/grant-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2013-07-04T11:30:00Z',
    Latitude: 37.7393,
    Location: 'off Grant Ln Rd & I-580 in the Altamont Pass, 5 miles west of Tracy',
    Longitude: -121.5869,
    MajorIncident: 'False',
    Name: 'Grant Fire',
    Started: '2013-07-04T10:00:00Z',
    UniqueId: '07fb8b11-f39b-4cd0-8a27-2d4fef7fe680'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/25/homestead-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2013-05-25T18:45:00Z',
    Latitude: 35.5123,
    Location: 'Homestead Rd & Hwy 41, northeast of Atascadero',
    Longitude: -120.6368,
    MajorIncident: 'False',
    Name: 'Homestead Fire',
    Started: '2013-05-25T17:35:00Z',
    UniqueId: '5b5ce06d-7ea9-4d28-b564-715fd0d04f3f'
  },
  {
    AcresBurned: 46,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/17/bridges-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2013-08-19T07:10:00Z',
    Latitude: 38.06231,
    Location: 'Parrott\'s Ferry Road north of the bridge, near Vallecito & New Melones Lake',
    Longitude: -120.45233,
    MajorIncident: 'True',
    Name: 'Bridges Fire',
    Started: '2013-08-17T10:11:00Z',
    UniqueId: '10445e2c-979d-49a2-82c2-c3789bd2449a'
  },
  {
    AcresBurned: 46,
    AdminUnit: 'CAL FIRE/Fresno County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/17/sierra-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2013-06-19T08:45:00Z',
    Latitude: 37.03087,
    Location: 'Black Mountain Road at Lodge Road near Sierra High School, southeast of Auberry',
    Longitude: -119.463757,
    MajorIncident: 'False',
    Name: 'Sierra Fire',
    Started: '2013-06-17T14:41:00Z',
    UniqueId: '15e7e15d-f707-473e-b0f3-6534cfd845b7'
  },
  {
    AcresBurned: 45,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/23/pratt-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2013-07-23T16:00:00Z',
    Latitude: 38.980846,
    Location: 'Hwy 175 & Pratt Ranch Road, East of Hopland',
    Longitude: -123.067671,
    MajorIncident: 'False',
    Name: 'Pratt Fire',
    Started: '2013-07-23T13:29:00Z',
    UniqueId: 'f1d7f375-8aa3-4cb5-a864-bae9bb90cbd1'
  },
  {
    AcresBurned: 44,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/12/10/happy-camp-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2013-12-11T17:30:00Z',
    Latitude: 0,
    Location: 'off Happy Camp Canyon Rd near Moorpark',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Happy Camp Fire',
    Started: '2013-12-10T02:26:00Z',
    UniqueId: 'cbb685c8-df00-4cdf-8925-7239fa21a049'
  },
  {
    AcresBurned: 43,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/9/fiddler-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2013-07-09T15:00:00Z',
    Latitude: 40.373,
    Location: 'off Fiddler',
    Longitude: -122.7338,
    MajorIncident: 'False',
    Name: 'Fiddler Fire',
    Started: '2013-07-09T11:59:00Z',
    UniqueId: '3f64fc8a-8870-4e64-b60a-3e13c8532acd'
  },
  {
    AcresBurned: 42,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/8/viper-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-06-08T19:00:00Z',
    Latitude: 33.96936,
    Location: 'off San Timoteo Canyon Rd and Viper Rd, north of Moreno Valley',
    Longitude: -117.1265,
    MajorIncident: 'False',
    Name: 'Viper Fire',
    Started: '2013-06-08T15:37:00Z',
    UniqueId: 'e9505435-e861-4f33-9069-b0040fb2a135'
  },
  {
    AcresBurned: 41,
    AdminUnit: 'CAL FIRE San Mateo-Santa Cruz Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/9/7/chestnut-fire/',
    Counties: 'San Mateo',
    CountyIds: 41,
    Extinguished: '2013-09-07T20:00:00Z',
    Latitude: 37.667295,
    Location: 'Chestnut Ave and Hillside Blvd, San Bruno Mountain, South San Francisco',
    Longitude: -122.427285,
    MajorIncident: 'False',
    Name: 'Chestnut Fire',
    Started: '2013-09-07T13:55:00Z',
    UniqueId: 'b30ee931-f349-4d21-a38a-d346c516b104'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/12/31/grant-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2013-12-31T16:00:00Z',
    Latitude: 37.342186,
    Location: 'off Mount Hamilton Road near Grant Ranch County Park',
    Longitude: -121.717706,
    MajorIncident: 'False',
    Name: 'Grant Fire',
    Started: '2013-12-31T05:30:00Z',
    UniqueId: '7a168690-06e5-4056-97c8-73b834204744'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'Orange County Fire Authority',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/10/6/baker-fire/',
    Counties: 'Orange',
    CountyIds: 30,
    Extinguished: '2013-10-09T08:00:00Z',
    Latitude: 33.7655,
    Location: 'Off Baker Canyon Rd, Silverado Canyon area, east of Irvine',
    Longitude: -117.6649,
    MajorIncident: 'False',
    Name: 'Baker Fire',
    Started: '2013-10-06T10:52:00Z',
    UniqueId: '9a110003-2f4c-4ac7-a3e5-b4e713f8d1fe'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/9/26/valley-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2013-09-28T09:15:00Z',
    Latitude: 0,
    Location: 'off I-8 & Los Coches Rd near Lakeside',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Valley Fire',
    Started: '2013-09-26T17:29:00Z',
    UniqueId: '487a3f42-fd84-4598-bc48-130ad241c883'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/16/pierce-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-08-16T21:00:00Z',
    Latitude: 33.570291,
    Location: 'Ave 66 and Pierce Street',
    Longitude: -116.10815,
    MajorIncident: 'False',
    Name: 'Pierce Fire',
    Started: '2013-08-16T13:31:00Z',
    UniqueId: 'f23f8148-6ec4-4885-9729-0dad7c744485'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/31/trout-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2013-07-31T19:25:00Z',
    Latitude: 0,
    Location: 'Siskiyou Wildlife Refuge, 5 miles SE of Montague',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Trout Fire',
    Started: '2013-07-31T15:25:00Z',
    UniqueId: '0e197989-042e-4c73-8820-f98e0b6fdd52'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/19/heacock-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-07-20T19:30:00Z',
    Latitude: 33.9634,
    Location: 'Heacock St & Sandy Glade Ave in Moreno Valley',
    Longitude: -117.2508,
    MajorIncident: 'False',
    Name: 'Heacock Fire',
    Started: '2013-07-19T16:21:00Z',
    UniqueId: '8fb3a438-3146-4b8d-8f20-bfa8d6610f84'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/14/palmyrita-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-06-15T08:00:00Z',
    Latitude: 34.001745,
    Location: 'Highgrove Pass Rd and Pigeon Pass Rd, Community of Highgrove',
    Longitude: -117.302057,
    MajorIncident: 'False',
    Name: 'Palmyrita Fire',
    Started: '2013-06-14T13:47:00Z',
    UniqueId: '2d1f0c40-92e7-4540-991b-d353ed68ec6c'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Riverside Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/16/54-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-05-17T08:30:00Z',
    Latitude: 33.655638,
    Location: 'Avenue 54 and Tyler Street, near the community of Coachella',
    Longitude: -116.161201,
    MajorIncident: 'True',
    Name: '54 Fire',
    Started: '2013-05-16T13:48:00Z',
    UniqueId: 'e215290f-d0b4-48fd-be32-f599959347b1'
  },
  {
    AcresBurned: 38,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/24/empire-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2013-08-24T11:45:00Z',
    Latitude: 38.89555,
    Location: 'off Hwy 193 & Empire Creek Cir near Georgetown',
    Longitude: -120.84716,
    MajorIncident: 'False',
    Name: 'Empire Fire',
    Started: '2013-08-24T14:54:00Z',
    UniqueId: 'fea7802f-ba70-450a-9ad1-96e2751293a9'
  },
  {
    AcresBurned: 38,
    AdminUnit: 'CAL FIRE Sanoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/7/indian-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2013-08-07T18:30:00Z',
    Latitude: 39.1591,
    Location: 'Off Bartlett Springs Road near Indian Valley Reservoir, 10 miles northeast of Clearlake Oaks',
    Longitude: -122.5906,
    MajorIncident: 'False',
    Name: 'Indian Fire',
    Started: '2013-08-07T12:35:00Z',
    UniqueId: 'b5b63934-923d-4504-a9b1-75c885477a8d'
  },
  {
    AcresBurned: 38,
    AdminUnit: 'CAL FIRE Santa Clara Unit / Alameda County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/6/fallon-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2013-07-06T14:30:00Z',
    Latitude: 37.74241,
    Location: 'off Fallon Rd & Camino Tassajara near Dublin',
    Longitude: -121.86216,
    MajorIncident: 'False',
    Name: 'Fallon Fire',
    Started: '2013-07-06T13:09:00Z',
    UniqueId: '4c04a4e5-f580-4e62-bb53-2575c72d29dc'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE/Fresno County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/13/michelle-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2013-06-13T21:30:00Z',
    Latitude: 36.763367,
    Location: 'off McKinley Ave & Academy Ave, north of Sanger',
    Longitude: -119.558244,
    MajorIncident: 'False',
    Name: 'Michelle Fire',
    Started: '2013-06-13T15:54:00Z',
    UniqueId: '953f17a1-2034-467b-b48c-28da1a9af60e'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/20/cottontail-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2013-05-20T19:10:00Z',
    Latitude: 35.49864,
    Location: 'Cayucos Creek Rd & Thunder Canyon Rd north of Cayucos',
    Longitude: -120.91375,
    MajorIncident: 'False',
    Name: 'Cottontail Fire',
    Started: '2013-05-20T15:45:00Z',
    UniqueId: 'f17c523c-bf01-4245-899b-7c2331096dae'
  },
  {
    AcresBurned: 34,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/4/honey-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2013-08-05T08:17:00Z',
    Latitude: 0,
    Location: 'Honey Bee Road, West of Redding',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Honey Fire',
    Started: '2013-08-04T18:00:00Z',
    UniqueId: '15dc8848-9380-40a8-86b7-2b783be8f29d'
  },
  {
    AcresBurned: 33,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/11/7/dersch-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2013-11-07T19:45:00Z',
    Latitude: 40.483662,
    Location: 'Off Dersch Rd and Hyrax, Millville',
    Longitude: -122.140914,
    MajorIncident: 'False',
    Name: 'Dersch Fire',
    Started: '2013-11-07T16:10:00Z',
    UniqueId: '29a2efda-c28f-4a41-9c6d-8cb8f763d464'
  },
  {
    AcresBurned: 31,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/22/chuckwagon-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2013-07-23T15:10:00Z',
    Latitude: 37.965364,
    Location: 'near the 4500 block of Chuckwagon Drive, Copperopolis',
    Longitude: -120.696362,
    MajorIncident: 'False',
    Name: 'Chuckwagon Fire',
    Started: '2013-07-22T12:34:00Z',
    UniqueId: '68dadbb3-6a63-483a-add9-491a69d9e0ad'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/9/15/lakeshore-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2013-09-15T17:14:00Z',
    Latitude: 38.9777,
    Location: 'near the community of Clearlake',
    Longitude: -122.683,
    MajorIncident: 'True',
    Name: 'Lakeshore Fire',
    Started: '2013-09-15T19:45:00Z',
    UniqueId: '51e00abb-53d0-4014-9224-2a853b1d6bcf'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/5/lake-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2013-06-06T07:00:00Z',
    Latitude: 38.99233,
    Location: 'Lakeshore Drive and Patterson Drive in Clearlake Oaks',
    Longitude: -122.703193,
    MajorIncident: 'False',
    Name: 'Lake Fire',
    Started: '2013-06-05T16:05:00Z',
    UniqueId: 'dcb21e64-9d38-47c2-848b-e8e0dea5c2de'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/4/20/fawnskin-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2013-04-22T09:00:00Z',
    Latitude: 34.288877,
    Location: 'west of Delamar Mountain, north of the community of Fawnskin, northside of Big Bear Lake',
    Longitude: -116.941311,
    MajorIncident: 'False',
    Name: 'Fawnskin Fire',
    Started: '2013-04-20T17:30:00Z',
    UniqueId: '58f89ff8-bd3e-4355-b1c0-8fa05c747d3f'
  },
  // {
  //   AcresBurned: 28,
  //   AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
  //   ArchiveYear: 2013,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2013/6/10/sonoma-lake-napa-unit-lightning-fires/',
  //   Counties: 'Sonoma',
  //   CountyIds: 4948176,
  //   Extinguished: '2013-06-14T15:45:00Z',
  //   Latitude: 38.4229,
  //   Location: 'throughout Sonoma, Solano, Lake & Colusa Counties',
  //   Longitude: -122.0437,
  //   MajorIncident: 'True',
  //   Name: 'Sonoma-Lake-Napa Unit Lightning Fires',
  //   Started: '2013-06-10T00:46:00Z',
  //   UniqueId: '5ce45b6c-81b5-422c-9078-8c68dd872c8a'
  // },
  // {
  //   AcresBurned: 28,
  //   AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
  //   ArchiveYear: 2013,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2013/6/10/sonoma-lake-napa-unit-lightning-fires/',
  //   Counties: 'Solano',
  //   CountyIds: 4948176,
  //   Extinguished: '2013-06-14T15:45:00Z',
  //   Latitude: 38.4229,
  //   Location: 'throughout Sonoma, Solano, Lake & Colusa Counties',
  //   Longitude: -122.0437,
  //   MajorIncident: 'True',
  //   Name: 'Sonoma-Lake-Napa Unit Lightning Fires',
  //   Started: '2013-06-10T00:46:00Z',
  //   UniqueId: '5ce45b6c-81b5-422c-9078-8c68dd872c8a'
  // },
  // {
  //   AcresBurned: 28,
  //   AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
  //   ArchiveYear: 2013,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2013/6/10/sonoma-lake-napa-unit-lightning-fires/',
  //   Counties: 'Lake',
  //   CountyIds: 4948176,
  //   Extinguished: '2013-06-14T15:45:00Z',
  //   Latitude: 38.4229,
  //   Location: 'throughout Sonoma, Solano, Lake & Colusa Counties',
  //   Longitude: -122.0437,
  //   MajorIncident: 'True',
  //   Name: 'Sonoma-Lake-Napa Unit Lightning Fires',
  //   Started: '2013-06-10T00:46:00Z',
  //   UniqueId: '5ce45b6c-81b5-422c-9078-8c68dd872c8a'
  // },
  {
    AcresBurned: 28,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/10/sonoma-lake-napa-unit-lightning-fires/',
    Counties: 'Colusa',
    CountyIds: 4948176,
    Extinguished: '2013-06-14T15:45:00Z',
    Latitude: 38.4229,
    Location: 'throughout Sonoma, Solano, Lake & Colusa Counties',
    Longitude: -122.0437,
    MajorIncident: 'True',
    Name: 'Sonoma-Lake-Napa Unit Lightning Fires',
    Started: '2013-06-10T00:46:00Z',
    UniqueId: '5ce45b6c-81b5-422c-9078-8c68dd872c8a'
  },
  {
    AcresBurned: 27,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/8/14/cloverdale-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2013-08-14T20:35:00Z',
    Latitude: 40.473356,
    Location: 'Cloverdale Rd. and Dale Rd., Happy Valley, 9 miles SW of Redding',
    Longitude: -122.48259,
    MajorIncident: 'False',
    Name: 'Cloverdale Fire',
    Started: '2013-08-14T15:37:00Z',
    UniqueId: '0537a175-8fe9-4f5f-b56f-77848fa195f4'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/28/flume-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2013-07-28T17:50:00Z',
    Latitude: 32.612773,
    Location: 'Barrett Lake Road and Highway 94',
    Longitude: -116.707335,
    MajorIncident: 'False',
    Name: 'Flume Fire',
    Started: '2013-07-28T09:43:00Z',
    UniqueId: 'c6cfeed9-55bb-4fdb-8a52-e4d947dba721'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Sanoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/6/20/mount-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2013-06-20T13:15:00Z',
    Latitude: 38.98058,
    Location: 'Off Konocti Rd & Oak Hills Ln, east of Kelseyville',
    Longitude: -122.81796,
    MajorIncident: 'False',
    Name: 'Mount Fire',
    Started: '2013-06-20T14:29:00Z',
    UniqueId: 'd489b45e-dcba-4eaa-8bb5-6a23255562da'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Riverside Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/20/cherry-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-05-20T18:50:00Z',
    Latitude: 33.96201,
    Location: 'Off Sunset Ave & Mesa St in Banning',
    Longitude: -116.907213,
    MajorIncident: 'False',
    Name: 'Cherry Fire',
    Started: '2013-05-20T13:47:00Z',
    UniqueId: 'a60e315c-23d5-4ba4-869c-5c1e22a25e7a'
  },
  {
    AcresBurned: 23,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/11/23/dam-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2013-11-24T18:45:00Z',
    Latitude: 38.9289,
    Location: 'Off Dam Rd, southeast of Clear Lake',
    Longitude: -122.5818,
    MajorIncident: 'False',
    Name: 'Dam Fire',
    Started: '2013-11-23T14:17:00Z',
    UniqueId: '720f1d0a-81b7-4a00-85db-be3d9587ea3e'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/12/30/refuse-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2013-12-30T20:30:00Z',
    Latitude: 0,
    Location: 'off Refuse Road near Covelo',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Refuse Fire',
    Started: '2013-12-30T11:00:00Z',
    UniqueId: '23d84ebe-9c31-4e3c-b0ad-b23aa510abeb'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/7/19/gilman-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-07-19T19:30:00Z',
    Latitude: 33.94528,
    Location: 'Hwy 60 east of Gilman Springs Rd, east of Moreno Valley',
    Longitude: -117.09306,
    MajorIncident: 'False',
    Name: 'Gilman Fire',
    Started: '2013-07-19T17:31:00Z',
    UniqueId: '2b300dd5-4474-4b8a-9b4c-3a3014afe27d'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2013,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2013/5/12/ranger-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2013-05-13T09:00:00Z',
    Latitude: 0,
    Location: 'Off Range Circle Dr in Yosemite Lake',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Ranger Fire',
    Started: '2013-05-12T13:02:00Z',
    UniqueId: '3ddf82b4-0631-4148-807e-181277adeca5'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Six Rivers National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/8/3/orleans-complex/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2013-08-03T15:00:00Z',
    Latitude: 41.333,
    Location: '10 miles east of Somes Bar, California',
    Longitude: -123.376,
    MajorIncident: 'False',
    Name: 'Orleans Complex',
    Started: '2013-08-03T08:00:00Z',
    UniqueId: '7d4f107b-66a9-43d2-819d-ec855c2947bf'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'USFS San Bernardino National Forest',
    ArchiveYear: 2013,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2013/6/9/hathaway-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2013-06-09T16:45:00Z',
    Latitude: 33.99647,
    Location: 'Hathaway Canyon area, northeast of Banning',
    Longitude: -116.84137,
    MajorIncident: 'False',
    Name: 'Hathaway Fire',
    Started: '2013-06-09T12:30:00Z',
    UniqueId: 'befb9d5c-c0ea-48b8-8589-2586be0275af'
  },
  {
    AcresBurned: 97717,
    AdminUnit: 'CAL FIRE / USFS - El Dorado National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/9/13/king-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2014-10-09T17:20:00Z',
    Latitude: 38.805437,
    Location: 'Near Pollock Pines',
    Longitude: -120.629714,
    MajorIncident: 'True',
    Name: 'King Fire',
    Started: '2014-09-13T16:32:00Z',
    UniqueId: '3df6ecf7-f095-483d-b1c4-2dc969d61261'
  },
  {
    AcresBurned: 50042,
    AdminUnit: 'CAL FIRE Siskiyou Unit / USFS-Klamath National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/8/2/july-complex/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2014-08-06T10:00:00Z',
    Latitude: 0,
    Location: 'Whites Fire approximately 4 miles East of Sawyer Bar<p> Log Fire approximately 6 miles West of Greenview<p>Leef Fire approximately 7 miles Southwest of Callahan.',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'July Complex',
    Started: '2014-08-02T09:00:00Z',
    UniqueId: '550c60e9-6b15-4e64-bf4b-9bd5d1cb359d'
  },
  {
    AcresBurned: 39736,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit / USFS - Lassen National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/30/bald-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2014-08-15T14:00:00Z',
    Latitude: 40.901,
    Location: '8 miles southeast of Fall River Mills',
    Longitude: -121.368,
    MajorIncident: 'False',
    Name: 'Bald Fire',
    Started: '2014-07-30T20:15:00Z',
    UniqueId: '045a1a18-72e4-4579-b64c-f34b33a1031b'
  },
  {
    AcresBurned: 35302,
    AdminUnit: 'CAL FIRE Siskiyou Unit / Oregon Dept. of Forestry / Oregon Office of The State Fire Marshal',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/30/oregon-gulch-fire-part-of-the-beaver-complex/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2014-08-18T09:45:00Z',
    Latitude: 42.048,
    Location: 'Community of Copco, South of Oregon Border',
    Longitude: -122.345,
    MajorIncident: 'False',
    Name: 'Oregon Gulch Fire (part of the Beaver Complex)',
    Started: '2014-07-30T23:00:00Z',
    UniqueId: '3b2609f0-b3a2-493c-bf66-c5b5f64409f8'
  },
  {
    AcresBurned: 32496,
    AdminUnit: 'US Forest Service - Klamath National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/7/30/beaver-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2014-09-02T13:00:00Z',
    Latitude: 0,
    Location: 'north of Highway 96, off of Beaver Creek Road',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Beaver Fire',
    Started: '2014-07-30T00:00:00Z',
    UniqueId: '30702a48-f9b0-44c3-8ddb-acc837bc6a34'
  },
  {
    AcresBurned: 32416,
    AdminUnit: 'CAL FIRE / USFS - Lassen National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/31/eiler-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2014-08-25T10:00:00Z',
    Latitude: 40.72,
    Location: '12 miles southeast of Burney near Old Station',
    Longitude: -121.562,
    MajorIncident: 'True',
    Name: 'Eiler Fire',
    Started: '2014-07-31T18:04:00Z',
    UniqueId: '60ea04ec-5f5e-4a49-8fbc-fa50c17a1199'
  },
  {
    AcresBurned: 14416,
    AdminUnit: 'Marine Corps Base Camp Pendleton',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/5/15/pulgas-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2014-05-21T17:00:00Z',
    Latitude: 0,
    Location: 'Off Interstate 5 at Las Pulgas Rd, north of Oceanside',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Pulgas Fire',
    Started: '2014-05-15T14:45:00Z',
    UniqueId: '2a3d56c7-2ba7-4f83-8e69-7ae9bab18b71'
  },
  {
    AcresBurned: 13838,
    AdminUnit: 'US Forest Service - Sierra National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/7/28/french-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2014-07-28T14:30:00Z',
    Latitude: 0,
    Location: 'Rock Creek Drainage, south of Mammoth Pool Reservoir',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'French Fire',
    Started: '2014-07-28T05:45:00Z',
    UniqueId: '61c14593-8614-4365-afa7-264fcaa6ea2a'
  },
  {
    AcresBurned: 13153,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/30/day-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2014-08-13T07:00:00Z',
    Latitude: 41.1336,
    Location: 'North of the community of Day',
    Longitude: -121.2144,
    MajorIncident: 'True',
    Name: 'Day Fire',
    Started: '2014-07-30T19:01:00Z',
    UniqueId: 'e3b7143d-6faa-4962-9fe5-c2d1559c5d20'
  },
  {
    AcresBurned: 12661,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/11/bully-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2014-07-26T20:00:00Z',
    Latitude: 40.4314,
    Location: 'Plantina Road at Bland Road, Igo',
    Longitude: -122.750788,
    MajorIncident: 'True',
    Name: 'Bully Fire',
    Started: '2014-07-11T15:37:00Z',
    UniqueId: '3a1fab73-882a-478c-b289-504497db4d64'
  },
  {
    AcresBurned: 12536,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/30/lodge-lightning-complex/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2014-09-09T19:30:00Z',
    Latitude: 0,
    Location: 'Wilderness Lodge and Eel River Canyon area',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Lodge Lightning Complex',
    Started: '2014-07-30T06:27:00Z',
    UniqueId: '7c6a9617-1c79-4b4d-9833-e76532f59103'
  },
  {
    AcresBurned: 6488,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/4/monticello-fire/',
    Counties: 'Yolo',
    CountyIds: 57,
    Extinguished: '2014-07-12T18:00:00Z',
    Latitude: 38.512,
    Location: 'Hwy 128 at Monticello Dam, southeast shore of Lake Berryessa',
    Longitude: -122.104,
    MajorIncident: 'True',
    Name: 'Monticello Fire',
    Started: '2014-07-04T21:32:00Z',
    UniqueId: '756d8f5b-bc05-4741-a5a3-3b20ca21906d'
  },
  {
    AcresBurned: 6258,
    AdminUnit: 'US Forest Service - Shasta Trinity National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/7/30/coffee-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2014-11-14T13:00:00Z',
    Latitude: 41.141,
    Location: 'East Fork of the Coffee Creek Drainage',
    Longitude: -122.805,
    MajorIncident: 'False',
    Name: 'Coffee Fire',
    Started: '2014-07-30T20:30:00Z',
    UniqueId: '9d3fb01e-c29e-436a-82f8-c110a0b35179'
  },
  {
    AcresBurned: 5503,
    AdminUnit: 'CAL FIRE Siskiyou Unit / USFS-Klamath National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/31/little-deer-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2014-08-18T10:00:00Z',
    Latitude: 41.682,
    Location: 'near Little Deer Mountain along Highway 97',
    Longitude: -122.127,
    MajorIncident: 'False',
    Name: 'Little Deer Fire',
    Started: '2014-07-31T17:45:00Z',
    UniqueId: '59a31adf-4f31-4bf6-a6c6-fe62d2d2587f'
  },
  {
    AcresBurned: 5367,
    AdminUnit: 'Marine Corps Base Camp Pendleton',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/5/14/tomahawk-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2014-05-19T09:20:00Z',
    Latitude: 33.3529,
    Location: 'Traveled from Naval Weapons Station, Fallbrook and is now on Camp Pendleton',
    Longitude: -117.284889,
    MajorIncident: 'True',
    Name: 'Tomahawk Fire',
    Started: '2014-05-14T09:45:00Z',
    UniqueId: '2b35bd0d-169f-4a81-835b-13bf527031a6'
  },
  {
    AcresBurned: 4840,
    AdminUnit: 'Department of Defense, US Army',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/6/19/stoney-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2014-06-21T19:00:00Z',
    Latitude: 0,
    Location: 'Nacimiento Fergusson Road & Stoney Valley, Fort Hunter Liggett',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Stoney Fire',
    Started: '2014-06-19T15:14:00Z',
    UniqueId: 'e54fa953-24b9-4581-86f3-9931fdf3ca5e'
  },
  {
    AcresBurned: 4772,
    AdminUnit: 'Yosemite National Park',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/8/16/meadow-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2014-12-12T13:45:00Z',
    Latitude: 0,
    Location: 'East of Little Yosemite Valley',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Meadow Fire',
    Started: '2014-08-16T00:00:00Z',
    UniqueId: '8bc9d00d-5f81-4a73-b14f-8145890c8d50'
  },
  {
    AcresBurned: 4689,
    AdminUnit: 'Yosemite National Park and Stanislaus National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/7/26/el-portal-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2014-08-10T08:15:00Z',
    Latitude: 0,
    Location: 'Near Highway 140 and community of El Portal',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'El Portal Fire',
    Started: '2014-07-26T17:00:00Z',
    UniqueId: '3383fa93-aaf8-4f81-a980-5ba86b893039'
  },
  // {
  //   AcresBurned: 4300,
  //   AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
  //   ArchiveYear: 2014,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2014/7/1/butts-fire/',
  //   Counties: 'Napa',
  //   CountyIds: 2817,
  //   Extinguished: '2014-07-09T18:00:00Z',
  //   Latitude: 38.664,
  //   Location: 'Off Butts Canyon Rd in Pope Valley, northwest of Lake Berryessa',
  //   Longitude: -122.454,
  //   MajorIncident: 'True',
  //   Name: 'Butts Fire',
  //   Started: '2014-07-01T12:08:00Z',
  //   UniqueId: '2437bb57-1d09-4892-8c26-a60661dae1d9'
  // },
  {
    AcresBurned: 4300,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/1/butts-fire/',
    Counties: 'Lake',
    CountyIds: 2817,
    Extinguished: '2014-07-09T18:00:00Z',
    Latitude: 38.664,
    Location: 'Off Butts Canyon Rd in Pope Valley, northwest of Lake Berryessa',
    Longitude: -122.454,
    MajorIncident: 'True',
    Name: 'Butts Fire',
    Started: '2014-07-01T12:08:00Z',
    UniqueId: '2437bb57-1d09-4892-8c26-a60661dae1d9'
  },
  {
    AcresBurned: 4240,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/25/sand-fire/',
    Counties: 'Amador',
    CountyIds: 39,
    Extinguished: '2014-08-02T19:15:00Z',
    Latitude: 38.5691,
    Location: 'East of Highway 49, 5 miles north of Plymouth',
    Longitude: -120.7819,
    MajorIncident: 'True',
    Name: 'Sand Fire',
    Started: '2014-07-25T16:34:00Z',
    UniqueId: '4d07ccc3-32be-4a1d-acac-18333884c97d'
  },
  // {
  //   AcresBurned: 4240,
  //   AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
  //   ArchiveYear: 2014,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2014/7/25/sand-fire/',
  //   Counties: 'El Dorado',
  //   CountyIds: 39,
  //   Extinguished: '2014-08-02T19:15:00Z',
  //   Latitude: 38.5691,
  //   Location: 'East of Highway 49, 5 miles north of Plymouth',
  //   Longitude: -120.7819,
  //   MajorIncident: 'True',
  //   Name: 'Sand Fire',
  //   Started: '2014-07-25T16:34:00Z',
  //   UniqueId: '4d07ccc3-32be-4a1d-acac-18333884c97d'
  // },
  {
    AcresBurned: 4045,
    AdminUnit: 'Kern County Fire / Sequoia National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/8/18/way-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2014-08-27T18:00:00Z',
    Latitude: 35.7206,
    Location: 'north side of Hwy 155, northwest of Wofford Heights',
    Longitude: -118.4747,
    MajorIncident: 'False',
    Name: 'Way Fire',
    Started: '2014-08-18T14:30:00Z',
    UniqueId: '4b281a55-65b6-43e8-bab2-3689356d82e5'
  },
  {
    AcresBurned: 3895,
    AdminUnit: 'Sequoia National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/6/13/shirley-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2014-06-20T08:30:00Z',
    Latitude: 35.70683,
    Location: '3 Miles south of Shirley Meadows',
    Longitude: -118.555527,
    MajorIncident: 'False',
    Name: 'Shirley Fire',
    Started: '2014-06-13T17:00:00Z',
    UniqueId: '8ede9823-938e-4786-97b8-a0f42b852cb2'
  },
  {
    AcresBurned: 2143,
    AdminUnit: 'CAL FIRE San Bernardino / USFS / Rancho Cucamonga Fire',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/4/30/etiwanda-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2014-05-05T17:30:00Z',
    Latitude: 34.169346,
    Location: 'North of Rancho Cucamonga',
    Longitude: -117.547374,
    MajorIncident: 'True',
    Name: 'Etiwanda Fire',
    Started: '2014-04-30T08:00:00Z',
    UniqueId: '13bfff2c-cb2f-4ed9-a7f8-6985646a2d5d'
  },
  {
    AcresBurned: 1995,
    AdminUnit: 'San Marcos Fire / CAL FIRE San Diego Unit / Elfin Forest Fire Dept',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/5/14/cocos-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2014-05-22T18:15:00Z',
    Latitude: 33.1137,
    Location: 'Village Drive and Twin Oaks Road, San Marcos',
    Longitude: -117.1599,
    MajorIncident: 'True',
    Name: 'Cocos Fire',
    Started: '2014-05-14T16:00:00Z',
    UniqueId: '1b1cba8f-7893-4eea-82d9-dc78663fd911'
  },
  {
    AcresBurned: 1952,
    AdminUnit: 'Angeles National Forest and LA County Fire Department',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/1/16/colby-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2014-01-27T10:00:00Z',
    Latitude: 34.1703,
    Location: 'near Morris Reservoir, north of Glendora',
    Longitude: -117.8816,
    MajorIncident: 'False',
    Name: 'Colby Fire',
    Started: '2014-01-16T05:50:00Z',
    UniqueId: '1fe0ea01-23e8-47a1-8fbd-ced6cf655e4d'
  },
  {
    AcresBurned: 1680,
    AdminUnit: 'Sequoia National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/7/11/nicolls-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2014-07-21T14:45:00Z',
    Latitude: 35.642,
    Location: 'Kelso Valley/Onyx area',
    Longitude: -118.15,
    MajorIncident: 'False',
    Name: 'Nicolls Fire',
    Started: '2014-07-11T13:46:00Z',
    UniqueId: '45abd556-f41f-4507-91a5-1cf2f751bb4c'
  },
  {
    AcresBurned: 1651,
    AdminUnit: 'Modoc National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/7/1/modoc-lightning-complex/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2014-07-03T10:30:00Z',
    Latitude: 41.89,
    Location: '15 fires across the Modoc National Forest',
    Longitude: -120.79,
    MajorIncident: 'False',
    Name: 'Modoc Lightning Complex',
    Started: '2014-07-01T19:00:00Z',
    UniqueId: '8f48a8a9-facf-49e8-92dc-ea1147e53792'
  },
  {
    AcresBurned: 1548,
    AdminUnit: 'CAL FIRE San Diego Unit/San Diego City Fire/Rancho Santa Fe Fire District',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/5/13/bernardo-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2014-05-17T20:14:00Z',
    Latitude: 33.003,
    Location: 'off Nighthawk Lane, southwest of Rancho Bernardo',
    Longitude: -117.133,
    MajorIncident: 'True',
    Name: 'Bernardo Fire',
    Started: '2014-05-13T11:00:00Z',
    UniqueId: '9e5ee790-ee7e-4b40-b300-7a3046901162'
  },
  {
    AcresBurned: 1469,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit / Modoc National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/3/gulch-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2014-07-07T07:00:00Z',
    Latitude: 41.489,
    Location: 'Off highway 139, 15 miles north of Canby - The fire is burning on the east side of Hwy 139',
    Longitude: -120.904,
    MajorIncident: 'True',
    Name: 'Gulch Fire',
    Started: '2014-07-03T15:46:00Z',
    UniqueId: '00089805-cdee-4607-8b67-1653bee463bc'
  },
  {
    AcresBurned: 1457,
    AdminUnit: 'Marine Corps Base Camp Pendleton',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/5/16/san-mateo-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2014-05-20T23:30:00Z',
    Latitude: 33.417572,
    Location: 'in the Talega area of Marine Corps Base Camp Pendleton',
    Longitude: -117.550567,
    MajorIncident: 'False',
    Name: 'San Mateo Fire',
    Started: '2014-05-16T11:24:00Z',
    UniqueId: 'b0b5efed-3edc-4a4b-97c8-95a79d12d0c6'
  },
  {
    AcresBurned: 1375,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/9/10/gulch-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2014-09-16T09:30:00Z',
    Latitude: 40.7101,
    Location: 'On Backbone Ridge, east of Bella Vista, 15 miles northeast of Redding',
    Longitude: -122.171,
    MajorIncident: 'True',
    Name: 'Gulch Fire',
    Started: '2014-09-10T00:30:00Z',
    UniqueId: 'b22e378f-bfbc-40b8-aaa7-29ec6db13db1'
  },
  {
    AcresBurned: 1080,
    AdminUnit: 'Yosemite National Park',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/7/17/dark-hole-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2014-08-20T19:00:00Z',
    Latitude: 0,
    Location: 'near the Yosemite Creek Campground.',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Dark Hole Fire',
    Started: '2014-07-17T01:00:00Z',
    UniqueId: 'c7f39aa9-394d-4d19-bcd9-a8ee4f036e01'
  },
  {
    AcresBurned: 968,
    AdminUnit: 'US Forest Service - Cleveland National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/9/12/silverado-fire/',
    Counties: 'Orange',
    CountyIds: 30,
    Extinguished: '2014-09-22T15:00:00Z',
    Latitude: 33.748,
    Location: 'off of Silverado Canyon Road south of Corona',
    Longitude: -117.601,
    MajorIncident: 'False',
    Name: 'Silverado Fire',
    Started: '2014-09-12T10:30:00Z',
    UniqueId: '568ea489-caa1-43c3-928a-9d0b836c0c54'
  },
  {
    AcresBurned: 865,
    AdminUnit: 'Lassen National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/1/2/campbell-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2014-01-10T18:30:00Z',
    Latitude: 40.134597,
    Location: 'Ishi Wilderness, north of Campbellville in the Lassen National Forest',
    Longitude: -121.790183,
    MajorIncident: 'False',
    Name: 'Campbell Fire',
    Started: '2014-01-02T20:00:00Z',
    UniqueId: '353e7df7-440c-4c41-a27c-b35bb1e2831c'
  },
  {
    AcresBurned: 677,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/5/26/hunters-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2014-06-02T18:30:00Z',
    Latitude: 0,
    Location: 'Hunters Valley area, near the southeast shore of Lake McClure',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Hunters Fire',
    Started: '2014-05-26T15:33:00Z',
    UniqueId: '8d3451be-f3be-4a8b-b747-ab121f0d52cb'
  },
  {
    AcresBurned: 632,
    AdminUnit: 'Santa Barbara County Fire',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/5/13/miguelito-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2014-05-19T09:20:00Z',
    Latitude: 34.609,
    Location: 'Off Santa Miguelito Canyon Road in Lompoc',
    Longitude: -120.454,
    MajorIncident: 'True',
    Name: 'Miguelito Fire',
    Started: '2014-05-13T14:00:00Z',
    UniqueId: 'd08b0c4e-35d3-43fb-8af8-1756b1789172'
  },
  {
    AcresBurned: 612,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/8/18/junction-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2014-08-25T08:25:00Z',
    Latitude: 37.3433,
    Location: 'off Road 425A, near the Hwy 41 and Hwy 49 junction in Oakhurst',
    Longitude: -119.6581,
    MajorIncident: 'True',
    Name: 'Junction Fire',
    Started: '2014-08-18T13:50:00Z',
    UniqueId: '58e7e466-8807-404e-9ef6-5a6ae11a0084'
  },
  {
    AcresBurned: 600,
    AdminUnit: 'Carlsbad Fire Department',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/5/14/poinsettia-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2014-05-17T00:00:00Z',
    Latitude: 33.1109,
    Location: 'off Poinsettia Ln & Alicante Rd in Carlsbad',
    Longitude: -117.279,
    MajorIncident: 'False',
    Name: 'Poinsettia Fire',
    Started: '2014-05-14T10:30:00Z',
    UniqueId: 'cc18296d-573a-4737-8e4e-1221d75d1e7b'
  },
  {
    AcresBurned: 580,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/8/24/oregon-fire/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2014-08-28T19:00:00Z',
    Latitude: 40.7412,
    Location: 'off Hwy 299 at Oregon Mountain Summit, near Weaverville',
    Longitude: -122.946,
    MajorIncident: 'True',
    Name: 'Oregon Fire',
    Started: '2014-08-24T16:36:00Z',
    UniqueId: '3b954901-aa80-4894-b330-c287d47b68be'
  },
  {
    AcresBurned: 516,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/9/15/boles-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2014-10-11T18:50:00Z',
    Latitude: 41.42384,
    Location: 'City of Weed',
    Longitude: -122.37432,
    MajorIncident: 'True',
    Name: 'Boles Fire',
    Started: '2014-09-15T13:38:00Z',
    UniqueId: 'ad164a35-8b27-4f96-b78e-952b08a333e8'
  },
  {
    AcresBurned: 487,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/6/4/59-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2014-06-05T20:00:00Z',
    Latitude: 37.76617,
    Location: 'near Bonds Flat Rd & La Grange Rd (J59), west of Don Pedro Reservoir',
    Longitude: -120.45087,
    MajorIncident: 'False',
    Name: '59 Fire',
    Started: '2014-06-04T11:45:00Z',
    UniqueId: '1a0bbf7e-7f9b-4359-9c91-85dec2e2869a'
  },
  {
    AcresBurned: 459,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/10/8/applegate-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '2014-10-15T07:50:00Z',
    Latitude: 0,
    Location: 'on the eastside of Interstate 80 in the Applegate area',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Applegate Fire',
    Started: '2014-10-08T13:33:00Z',
    UniqueId: 'd71ab3e8-ead1-4d54-b489-2a2f23073d8b'
  },
  {
    AcresBurned: 403,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/9/13/black-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2014-09-17T16:10:00Z',
    Latitude: 0,
    Location: 'Black Bart Trail, North of Lake Mendocino',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Black Fire',
    Started: '2014-09-13T15:48:00Z',
    UniqueId: '60b1ae62-1688-44b3-8447-66785e692e92'
  },
  {
    AcresBurned: 400,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/3/19/encinal-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2014-03-21T18:00:00Z',
    Latitude: 36.6313,
    Location: 'Off Encinal Rd, 8 miles southeast of Salinas',
    Longitude: -121.4819,
    MajorIncident: 'True',
    Name: 'Encinal Fire',
    Started: '2014-03-19T16:45:00Z',
    UniqueId: 'cb580f06-5d43-46aa-8b2c-f2b5a21eff02'
  },
  {
    AcresBurned: 389,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/28/web-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2014-08-01T17:30:00Z',
    Latitude: 0,
    Location: 'Web Hollow & Big Chico Creek near Forest Ranch',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Web Fire',
    Started: '2014-07-28T13:11:00Z',
    UniqueId: '69b38608-fab1-4df5-b9e9-0fd28bc505ba'
  },
  {
    AcresBurned: 380,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/5/14/highway-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2014-05-15T18:30:00Z',
    Latitude: 33.312,
    Location: 'off Old Hwy 395 and I-15 in the Deer Springs area',
    Longitude: -117.162,
    MajorIncident: 'True',
    Name: 'Highway Fire',
    Started: '2014-05-14T13:00:00Z',
    UniqueId: 'ebea3cc2-c0ad-4de2-829a-0b544183461b'
  },
  {
    AcresBurned: 350,
    AdminUnit: 'CAL FIRE / Riverside County Fire Department',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/3/15/pierce-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2014-03-16T08:30:00Z',
    Latitude: 0,
    Location: 'off Ave 66 and Pierce St in Thermal',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Pierce Fire',
    Started: '2014-03-15T16:37:00Z',
    UniqueId: 'af1dd364-be2a-4818-81fb-dea0e527d6c5'
  },
  {
    AcresBurned: 333,
    AdminUnit: 'CAL FIRE Humboldt Del-Norte Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/1/4/red-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2014-01-08T19:15:00Z',
    Latitude: 40.884415,
    Location: 'South of Berry Summit, west of Willow Creek',
    Longitude: -123.773779,
    MajorIncident: 'False',
    Name: 'Red Fire',
    Started: '2014-01-04T12:00:00Z',
    UniqueId: '6d75c6a4-12cb-4f18-8951-f2737e980916'
  },
  {
    AcresBurned: 320,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/9/14/courtney-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2014-09-22T07:15:00Z',
    Latitude: 37.311915,
    Location: 'Courtney Lane and 7 Hills Rd, Oakhurst',
    Longitude: -119.604124,
    MajorIncident: 'True',
    Name: 'Courtney Fire',
    Started: '2014-09-14T13:36:00Z',
    UniqueId: '614efdbb-937e-47a0-9ffd-919e5e0de436'
  },
  {
    AcresBurned: 311,
    AdminUnit: 'Yosemite National Park',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/10/7/dog-rock-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2014-10-12T18:00:00Z',
    Latitude: 37,
    Location: 'Hwy 140 at Indian Creek, El Portal Community',
    Longitude: 40.34,
    MajorIncident: 'False',
    Name: 'Dog Rock Fire',
    Started: '2014-10-07T15:05:00Z',
    UniqueId: 'ba17d495-8ce6-4a0f-a3ba-487bd877969e'
  },
  {
    AcresBurned: 300,
    AdminUnit: 'CAL FIRE is in Unified Command with Mariposa County Fire and Sheriff’s Departments',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/9/5/bridge-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2014-09-12T09:00:00Z',
    Latitude: 0,
    Location: 'Highway 49 at Harris Road, 10 miles east of Mariposa',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Bridge Fire',
    Started: '2014-09-05T12:39:00Z',
    UniqueId: '987ced78-a554-4a1b-a2f2-2f8329292067'
  },
  {
    AcresBurned: 300,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/24/gun-club-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2014-07-25T09:15:00Z',
    Latitude: 0,
    Location: 'Gun Club Rd. at the Santa Fe Canal, Gustine',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Gun Club Fire',
    Started: '2014-07-24T12:06:00Z',
    UniqueId: 'deb3922d-eba2-4f08-abf7-d453d14e32ab'
  },
  {
    AcresBurned: 274,
    AdminUnit: 'US Forest Service - Angeles National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/8/17/tecolote-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2014-12-12T13:30:00Z',
    Latitude: 34.267,
    Location: '18 miles north of Glendora, off Highway 39 and mile marker 28.',
    Longitude: -117.867,
    MajorIncident: 'False',
    Name: 'Tecolote Fire',
    Started: '2014-08-17T14:30:00Z',
    UniqueId: 'd805c9b9-da39-4771-965f-b3cd4c37c84b'
  },
  {
    AcresBurned: 269,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/6/5/hetch-hetchy-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2014-06-06T09:30:00Z',
    Latitude: 37.787,
    Location: 'off La Grange Rd (J59) at Hetch Hetchy power lines, northwest shore of Don Pedro Reservoir',
    Longitude: -120.452,
    MajorIncident: 'False',
    Name: 'Hetch Hetchy Fire',
    Started: '2014-06-05T13:04:00Z',
    UniqueId: 'b5d32131-cf00-4e34-9e08-b74d68a3174f'
  },
  {
    AcresBurned: 247,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/9/13/dog-bar-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2014-09-18T18:45:00Z',
    Latitude: 39.113682,
    Location: 'Off Dog Bar Rd & Taylor Crossing Rd near Alta Sierra',
    Longitude: -120.999508,
    MajorIncident: 'True',
    Name: 'Dog Bar Fire',
    Started: '2014-09-13T14:07:00Z',
    UniqueId: 'a794ecf9-2e8d-4721-a272-a3e66d2e7621'
  },
  {
    AcresBurned: 225,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/6/13/tehama-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2014-06-13T13:50:00Z',
    Latitude: 40.009827,
    Location: 'Rancho Tehama, southwest of Red Bluff',
    Longitude: -122.345078,
    MajorIncident: 'False',
    Name: 'Tehama Fire',
    Started: '2014-06-13T12:23:00Z',
    UniqueId: '724209e0-12b0-4d49-b798-8ccacf95e668'
  },
  {
    AcresBurned: 217,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/3/banner-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2014-07-06T09:15:00Z',
    Latitude: 33.078948,
    Location: 'Banner Grade, east of Julian',
    Longitude: -116.576454,
    MajorIncident: 'True',
    Name: 'Banner Fire',
    Started: '2014-07-03T10:43:00Z',
    UniqueId: 'd2623c2c-ff3d-419e-a129-b3aa542c05c4'
  },
  {
    AcresBurned: 210,
    AdminUnit: 'Six Rivers National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/9/12/bald-hill-3-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2014-09-15T11:00:00Z',
    Latitude: 41.134,
    Location: '1 mile northwest of Hoopa',
    Longitude: -123.753,
    MajorIncident: 'False',
    Name: 'Bald Hill 3 Fire',
    Started: '2014-09-12T15:00:00Z',
    UniqueId: 'd4523b72-45cf-4de2-8ccf-3905f1dc8dbd'
  },
  {
    AcresBurned: 190,
    AdminUnit: 'US Forest Service - Angeles National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/8/14/shoemaker-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2014-12-12T14:00:00Z',
    Latitude: 34.235,
    Location: 'upper end of East Fork San Gabriel River, North of Glendora',
    Longitude: -117.771,
    MajorIncident: 'False',
    Name: 'Shoemaker Fire',
    Started: '2014-08-14T12:48:00Z',
    UniqueId: 'accb599e-35b8-4d5e-8d13-d0e4b0e4a1eb'
  },
  {
    AcresBurned: 175,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/5/25/indian-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2014-05-26T08:45:00Z',
    Latitude: 39.1647,
    Location: 'Near Indian Valley Reservoir, East of Clearlake Oaks',
    Longitude: -122.5983,
    MajorIncident: 'False',
    Name: 'Indian Fire',
    Started: '2014-05-25T12:20:00Z',
    UniqueId: 'b454456c-1fa9-4766-b179-6df36b4d844b'
  },
  {
    AcresBurned: 143,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/9/dry-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2014-07-10T07:30:00Z',
    Latitude: 40.6569,
    Location: 'off Hwy 299 & Dry Creek Rd, east of Bella Vista',
    Longitude: -122.2215,
    MajorIncident: 'False',
    Name: 'Dry Fire',
    Started: '2014-07-09T13:45:00Z',
    UniqueId: 'dcbc7afb-cdef-49a3-822e-20bbaa86a5d0'
  },
  {
    AcresBurned: 130,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/6/10/haigh-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2014-06-13T18:30:00Z',
    Latitude: 37.7103,
    Location: 'Highway 49 and Haigh Rd., north of Coulterville',
    Longitude: -120.197,
    MajorIncident: 'True',
    Name: 'Haigh Fire',
    Started: '2014-06-10T15:11:00Z',
    UniqueId: '50567f4a-c56d-4d73-9855-f5d81fa74025'
  },
  {
    AcresBurned: 125,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/6/30/curie-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2014-07-01T08:30:00Z',
    Latitude: 0,
    Location: 'Off Curie Drive south of San Jose',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Curie Fire',
    Started: '2014-06-30T14:10:00Z',
    UniqueId: '7a5c1b23-ac7c-44de-8f1a-1866ea9bf617'
  },
  {
    AcresBurned: 125,
    AdminUnit: 'USFS - Cleveland National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/3/8/gun-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2014-03-11T11:00:00Z',
    Latitude: 32.81,
    Location: 'Off Interstate 8 & Sunrise Hwy, near Pine Valley',
    Longitude: -116.49,
    MajorIncident: 'False',
    Name: 'Gun Fire',
    Started: '2014-03-08T12:30:00Z',
    UniqueId: 'a67fe9bc-b8ec-4ed1-a2e8-06623aab7039'
  },
  {
    AcresBurned: 120,
    AdminUnit: 'CAL FIRE Tuolumne Calaveras Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/6/20/reed-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2014-06-21T19:00:00Z',
    Latitude: 120.679019,
    Location: 'off George Reed Drive and Pool Station Road, San Andreas',
    Longitude: 38.178241,
    MajorIncident: 'False',
    Name: 'Reed Fire',
    Started: '2014-06-20T15:27:00Z',
    UniqueId: '2b382ade-87e2-4cff-92f7-67328139d7eb'
  },
  {
    AcresBurned: 120,
    AdminUnit: 'CAL FIRE Nevada-Placer-Yuba Unit / Placer County Fire',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/1/22/brewer-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '2014-01-22T16:35:00Z',
    Latitude: 0,
    Location: 'off South Brewer Road, west of Roseville',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Brewer Fire',
    Started: '2014-01-22T13:10:00Z',
    UniqueId: '072e04ed-1f34-45e8-b7c2-3788ebf3be4c'
  },
  {
    AcresBurned: 113,
    AdminUnit: 'CAL FIRE San Bernardino Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/4/19/bridges-fire/',
    Counties: 'Inyo',
    CountyIds: 14,
    Extinguished: '2014-04-21T19:15:00Z',
    Latitude: 37.399,
    Location: 'off Highway 6 & 5 Bridges Rd, 5 miles northeast of Bishop',
    Longitude: -118.352,
    MajorIncident: 'True',
    Name: 'Bridges Fire',
    Started: '2014-04-19T15:54:00Z',
    UniqueId: '1faad916-32b9-4cd0-94b8-dacfe71fa9f8'
  },
  {
    AcresBurned: 106,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/1/25/lake-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2014-01-26T18:00:00Z',
    Latitude: 36.8266,
    Location: 'off Trimmer Springs Rd & Sunnyslope Rd near Pine Flat Lake',
    Longitude: -119.3415,
    MajorIncident: 'False',
    Name: 'Lake Fire',
    Started: '2014-01-25T06:37:00Z',
    UniqueId: 'd529636e-33d0-484b-9c6f-093ba33736b7'
  },
  {
    AcresBurned: 105,
    AdminUnit: 'Oceanside Fire Department',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/5/14/river-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2014-05-19T09:20:00Z',
    Latitude: 0,
    Location: 'North River Road and College Blvd., Oceanside',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'River Fire',
    Started: '2014-05-14T12:12:00Z',
    UniqueId: '811b6ea7-2a1b-414b-90fa-9edc6db21d46'
  },
  {
    AcresBurned: 101,
    AdminUnit: 'US Forest Service - Modoc National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/8/12/little-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2014-08-13T06:15:00Z',
    Latitude: 41.507,
    Location: 'Northeast of Mud Springs, 9 miles South of Tionesta',
    Longitude: -121.266,
    MajorIncident: 'False',
    Name: 'Little Fire',
    Started: '2014-08-12T15:00:00Z',
    UniqueId: '91669a3c-d533-4eaa-a8d7-505d55f89e46'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/9/3/saratoga-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2014-09-05T18:30:00Z',
    Latitude: 0,
    Location: 'off Hwy 20 & Saratoga Road, west of Upper Lake',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Saratoga Fire',
    Started: '2014-09-03T16:03:00Z',
    UniqueId: 'cd91c23b-9e4f-484f-bb5a-09881545da38'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE Riverside Unit / Riverside County Fire',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/9/1/interstate-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2014-09-01T22:00:00Z',
    Latitude: 0,
    Location: 'I-15 at Temescal Canyon Rd in Alberhill',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Interstate Fire',
    Started: '2014-09-01T14:03:00Z',
    UniqueId: '58054798-7e26-4aa0-8af9-a4c91ebcca8b'
  },
  {
    AcresBurned: 94,
    AdminUnit: 'US Forest Service - El Dorado National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/9/14/irene-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2014-09-17T18:45:00Z',
    Latitude: 38.59,
    Location: 'Mokelumne Wilderness',
    Longitude: -120.028,
    MajorIncident: 'False',
    Name: 'Irene Fire',
    Started: '2014-09-14T09:15:00Z',
    UniqueId: '7e60b4f7-8497-4155-9879-a3198b2ce696'
  },
  {
    AcresBurned: 90,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/6/6/valley-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2014-06-08T19:45:00Z',
    Latitude: 0,
    Location: 'off Hunters Valley Road near the southeast shore of Lake McClure.',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Valley Fire',
    Started: '2014-06-06T17:29:00Z',
    UniqueId: 'a856545c-5922-4d6a-bffb-2048188c0fa3'
  },
  {
    AcresBurned: 85,
    AdminUnit: 'CAL FIRE Tuolumne Calaveras Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/6/22/oak-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2014-06-24T19:00:00Z',
    Latitude: 38.058,
    Location: 'Oak Valley Road at Pool Station Road, south of San Andreas',
    Longitude: -120.66,
    MajorIncident: 'True',
    Name: 'Oak Fire',
    Started: '2014-06-22T12:37:00Z',
    UniqueId: '06ae83a9-125e-4cf5-826e-8b541b2308fd'
  },
  {
    AcresBurned: 84,
    AdminUnit: 'US Forest Service - Tahoe National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/8/18/boca-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2014-08-19T16:45:00Z',
    Latitude: 39.3918,
    Location: 'off Interstate 80 at Hirschdale, east of Truckee',
    Longitude: -120.0805,
    MajorIncident: 'False',
    Name: 'Boca Fire',
    Started: '2014-08-18T10:00:00Z',
    UniqueId: '605ac5e1-9903-45ba-872d-3d9c437457d7'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/8/28/casa-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2014-08-31T08:15:00Z',
    Latitude: 0,
    Location: 'Hwy 152 at Casa De Fruta, 10 miles east of Gilroy',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Casa Fire',
    Started: '2014-08-28T15:10:00Z',
    UniqueId: 'f2d201e0-515b-4df7-96f4-0ff840da4ed3'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/11/marsh-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2014-07-12T18:00:00Z',
    Latitude: 37.5359,
    Location: 'off Marsh Creek Rd., near Aspara Drive, east of Clayton',
    Longitude: -121.5118,
    MajorIncident: 'True',
    Name: 'Marsh Fire',
    Started: '2014-07-11T21:57:00Z',
    UniqueId: 'dc1a83b0-500c-440f-85d7-7090884f5487'
  },
  {
    AcresBurned: 79,
    AdminUnit: 'Stanislaus National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/9/7/montgomery-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2014-09-09T19:45:00Z',
    Latitude: 0,
    Location: 'Near Ponderosa Way & Tuolumne River Rd, south of Coulterville',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Montgomery Fire',
    Started: '2014-09-07T16:46:00Z',
    UniqueId: 'eb9797e5-4caa-4514-8098-6bd120c0e3c6'
  },
  {
    AcresBurned: 78,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/23/sabina-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2014-07-24T09:00:00Z',
    Latitude: 0,
    Location: 'Sabina Road and Ballinger Road in the community of Aguanga',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Sabina Fire',
    Started: '2014-07-23T10:47:00Z',
    UniqueId: '7ac5c3c7-ba1d-47c4-8678-727729c51465'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/5/cassel-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2014-07-08T18:30:00Z',
    Latitude: 40.5719,
    Location: 'Off Cassel Road at Thrush Road, in Cassel',
    Longitude: -121.3415,
    MajorIncident: 'True',
    Name: 'Cassel Fire',
    Started: '2014-07-05T18:44:00Z',
    UniqueId: '0bc42201-27c2-4b3d-a329-ce44bc1261d9'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/4/30/san-lucas-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2014-05-01T19:00:00Z',
    Latitude: 36.103,
    Location: 'San Lucas & Jolon Rd, west of King City',
    Longitude: -121.117,
    MajorIncident: 'False',
    Name: 'San Lucas Fire',
    Started: '2014-04-30T14:25:00Z',
    UniqueId: '91c3081d-33b4-46f2-8774-032c57f0f6a2'
  },
  {
    AcresBurned: 72,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/14/wildlife-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2014-07-16T08:00:00Z',
    Latitude: 39.4664,
    Location: 'Wildlife Area - Larkin Road, west of Oroville<br><br>Road Closures: None, the Wildlife area north of the Afterbay Outlet is closed to the public.',
    Longitude: -121.6129,
    MajorIncident: 'False',
    Name: 'Wildlife Fire',
    Started: '2014-07-14T18:00:00Z',
    UniqueId: '9c21bb74-e919-403c-8a43-05f561669e4e'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'CAL FIRE Tuolumne Caleveras Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/9/4/jackson-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2014-09-05T09:15:00Z',
    Latitude: 37.8316,
    Location: 'Hwy 49 & Jacksonville Rd near the community of Moccasin',
    Longitude: -120.3434,
    MajorIncident: 'False',
    Name: 'Jackson Fire',
    Started: '2014-09-04T11:51:00Z',
    UniqueId: '726710bb-32d4-46bf-9729-7f3396defcf0'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'Sequoia National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/7/1/ranch-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2014-07-06T08:30:00Z',
    Latitude: 0,
    Location: 'Southwest of Greenhorn Summit',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Ranch Fire',
    Started: '2014-07-01T18:15:00Z',
    UniqueId: '9487beeb-6c40-46fc-b4b3-a353a688a826'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/6/12/norman-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2014-06-13T08:00:00Z',
    Latitude: 121.999,
    Location: 'off Rolling Hills Lane, north of Vacaville',
    Longitude: 38.453,
    MajorIncident: 'False',
    Name: 'Norman Fire',
    Started: '2014-06-12T14:29:00Z',
    UniqueId: '45cf54ae-c166-4f81-816f-2e0ef959a56e'
  },
  {
    AcresBurned: 65,
    AdminUnit: 'Inyo National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/9/16/june-fire/',
    Counties: 'Inyo',
    CountyIds: 14,
    Extinguished: '2014-09-21T09:00:00Z',
    Latitude: 0,
    Location: 'at the base of June Mountain',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'June Fire',
    Started: '2014-09-16T19:07:00Z',
    UniqueId: '5463296a-0cfa-46a1-bd8a-dfbf1afc996b'
  },
  {
    AcresBurned: 62,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/9/21/nelson-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2014-09-22T16:30:00Z',
    Latitude: 0,
    Location: 'off Nelson Ranch Rd, 9 mile south of Ukiah',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Nelson Fire',
    Started: '2014-09-21T16:13:00Z',
    UniqueId: 'a44b9e07-680d-4857-9d27-834363373a83'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/1/1/honcut-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2014-01-02T07:30:00Z',
    Latitude: 0,
    Location: 'off Palermo Honcut Highway and Ahart Road near the community of Honcut',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Honcut Fire',
    Started: '2014-01-01T10:46:00Z',
    UniqueId: '42af9060-4b93-4919-bd89-9fe684b41fd3'
  },
  {
    AcresBurned: 57,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/3/28/van-buren-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2014-03-29T17:15:00Z',
    Latitude: 33.5982,
    Location: 'Off Ave 62 and Van Buren St in Thermal',
    Longitude: -116.1985,
    MajorIncident: 'False',
    Name: 'Van Buren Fire',
    Started: '2014-03-28T14:31:00Z',
    UniqueId: 'edff6f87-80b8-4c0d-8f6a-45c6e798b7fa'
  },
  {
    AcresBurned: 56,
    AdminUnit: 'Marine Corps Base - Camp Pendleton',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/5/14/freeway-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2014-05-20T11:30:00Z',
    Latitude: 0,
    Location: 'Naval Weapons Station, Fallbrook',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Freeway Fire',
    Started: '2014-05-14T17:43:00Z',
    UniqueId: '36076476-0b5d-445a-a82b-27f953f3dde1'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/5/14/fiddler-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2014-05-15T11:30:00Z',
    Latitude: 40.39,
    Location: 'Off Perla Rd & Fiddlers Rd in Igo',
    Longitude: -122.721,
    MajorIncident: 'False',
    Name: 'Fiddler Fire',
    Started: '2014-05-14T14:00:00Z',
    UniqueId: '2c241790-d062-4b15-9a25-8e511c0febab'
  },
  {
    AcresBurned: 48,
    AdminUnit: 'CAL FIRE San Bernardino Unit / Chino Valley Fire District',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/10/16/bane-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2014-10-17T18:15:00Z',
    Latitude: 33.93869,
    Location: 'in Chino Hills State Park near the Bane Canyon entrance',
    Longitude: -117.70643,
    MajorIncident: 'False',
    Name: 'Bane Fire',
    Started: '2014-10-16T14:34:00Z',
    UniqueId: 'f5552e75-f74c-4bc0-99b8-6c66ee8cde3d'
  },
  {
    AcresBurned: 47,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/7/interlake-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: ',40',
    Extinguished: '2014-07-08T18:30:00Z',
    Latitude: 35.8218,
    Location: 'along Interlake Road between Monterey & San Luis Obispo County',
    Longitude: -121.0226,
    MajorIncident: 'False',
    Name: 'Interlake Fire',
    Started: '2014-07-07T16:12:00Z',
    UniqueId: '1df51ee3-c15a-4266-bf3d-d52272189cff'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/6/9/morgan-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2014-06-11T07:30:00Z',
    Latitude: 36.991825,
    Location: 'near the 16,000 block of Highway 168 near Prather',
    Longitude: -119.525506,
    MajorIncident: 'True',
    Name: 'Morgan Fire',
    Started: '2014-06-09T15:15:00Z',
    UniqueId: '857e832f-17bd-4ad2-8789-99b003187049'
  },
  {
    AcresBurned: 38,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/7/hutto-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2014-07-08T06:56:00Z',
    Latitude: 39.1871,
    Location: 'on Hutto Rd & Keller Rd in Smartsville',
    Longitude: -121.2687,
    MajorIncident: 'False',
    Name: 'Hutto Fire',
    Started: '2014-07-07T16:35:00Z',
    UniqueId: '61506ea2-3f16-4aa6-ba54-d7788c3a2b35'
  },
  {
    AcresBurned: 37,
    AdminUnit: 'CAL FIRE Humboldt-Del Norte Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/8/1/mcclellan-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2014-08-02T08:00:00Z',
    Latitude: 0,
    Location: 'on Hwy 36 at McClellan Mountain Rd in Dinsmore',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'McClellan Fire',
    Started: '2014-08-01T15:47:00Z',
    UniqueId: '0567f7bd-c345-4124-9526-b8f88a938b01'
  },
  {
    AcresBurned: 37,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/5/27/lake-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2014-05-29T08:45:00Z',
    Latitude: 0,
    Location: 'Hwy 132 and Lake Rd near LaGrange',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Lake Fire',
    Started: '2014-05-27T11:23:00Z',
    UniqueId: '4075bfa7-794b-446c-b30d-0a8d38085419'
  },
  {
    AcresBurned: 31,
    AdminUnit: 'CAL FIRE Riverside County Fire',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/6/6/bogart-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2014-06-07T19:00:00Z',
    Latitude: 0,
    Location: 'in Bogart Park in Cherry Valley',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Bogart Fire',
    Started: '2014-06-06T17:32:00Z',
    UniqueId: 'fc0e054f-887f-4bb5-87af-bde461bf4e4a'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/29/siskiyou-county-lightning-fires/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2014-08-02T11:00:00Z',
    Latitude: 0,
    Location: 'Throughout Siskiyou County',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Siskiyou County Lightning Fires',
    Started: '2014-07-29T13:00:00Z',
    UniqueId: '279d9058-7545-488b-8a83-51b12e60cb47'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/9/bible-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2014-07-09T16:45:00Z',
    Latitude: 38.608336,
    Location: 'off Mt Aukum Rd, Somerset',
    Longitude: -120.703238,
    MajorIncident: 'False',
    Name: 'Bible Fire',
    Started: '2014-07-09T14:34:00Z',
    UniqueId: 'da607cd1-32fc-44c0-bd7a-ba14ad0a14cc'
  },
  {
    AcresBurned: 29,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/5/5/jacumba-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2014-05-06T10:20:00Z',
    Latitude: 32.665,
    Location: 'Off Interstate 8, east of McCain Valley Rd, east of Boulevard',
    Longitude: -116.222,
    MajorIncident: 'False',
    Name: 'Jacumba Fire',
    Started: '2014-05-05T16:36:00Z',
    UniqueId: 'd5cb2477-6627-4ef6-bab1-d0eecc4ad12a'
  },
  {
    AcresBurned: 27,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/9/11/stage-coach-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2014-09-15T14:20:00Z',
    Latitude: 38.695961,
    Location: 'Berryessa Estates, North of Lake Berryessa',
    Longitude: -122.384054,
    MajorIncident: 'False',
    Name: 'Stage Coach Fire',
    Started: '2014-09-11T15:14:00Z',
    UniqueId: '7e564dd5-1d4e-4999-8aea-93691ad314ac'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/9/29/foothill-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2014-09-30T15:00:00Z',
    Latitude: 0,
    Location: 'off Foothill Rd near Ventura',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Foothill Fire',
    Started: '2014-09-29T19:35:00Z',
    UniqueId: '6e986794-095c-4ba4-a129-cc45ab69d4ec'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/8/29/leopard-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2014-08-29T13:15:00Z',
    Latitude: 40,
    Location: 'Hyrax Road at Dersch Road, east of Redding',
    Longitude: 29.24,
    MajorIncident: 'False',
    Name: 'Leopard Fire',
    Started: '2014-08-29T12:21:00Z',
    UniqueId: '952443ab-3af0-431d-9040-c73a45925401'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/6/11/hall-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2014-06-09T19:15:00Z',
    Latitude: 36.742747,
    Location: 'near Hwy 180 & Hall Lane near Squaw Valley',
    Longitude: -119.241493,
    MajorIncident: 'False',
    Name: 'Hall Fire',
    Started: '2014-06-11T07:30:00Z',
    UniqueId: 'ccc2ec2b-4941-4bbd-ae60-be6706d97f13'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'US Forest Service - Lake Tahoe Basin Management Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/9/25/cascade-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2014-09-25T07:27:00Z',
    Latitude: 38.9195001,
    Location: 'Desolation Wilderness, 8 miles west of South Lake Tahoe',
    Longitude: -120.1140659,
    MajorIncident: 'False',
    Name: 'Cascade Fire',
    Started: '2014-09-25T18:00:00Z',
    UniqueId: '0b2d503c-7bd5-45e7-b029-61306ae6e7c0'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/8/16/border-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2014-08-17T07:45:00Z',
    Latitude: 32.59154,
    Location: 'on Kuebler Ranch near Otay Mountain',
    Longitude: -116.89516,
    MajorIncident: 'False',
    Name: 'Border Fire',
    Started: '2014-08-16T16:22:00Z',
    UniqueId: '64812487-ac4c-40da-b069-2884d7a04675'
  },
  {
    AcresBurned: 18,
    AdminUnit: 'CAL FIRE Humboldt Del-Norte Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/1/3/bridge-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2014-01-04T18:30:00Z',
    Latitude: 0,
    Location: 'near the community of Bridgeville',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Bridge Fire',
    Started: '2014-01-03T10:30:00Z',
    UniqueId: '4f7bb6c9-8b10-4892-89a8-d2b78931aa10'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'Shasta - Trinity National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/7/1/west-fire/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2014-07-03T10:45:00Z',
    Latitude: 40.41,
    Location: 'near the Trinity Pines community',
    Longitude: -123.24,
    MajorIncident: 'False',
    Name: 'West Fire',
    Started: '2014-07-01T03:45:00Z',
    UniqueId: '62c2a563-1768-4c94-ac71-694a553cfdf8'
  },
  {
    AcresBurned: 14,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/7/21/iowa-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '2014-07-22T18:00:00Z',
    Latitude: 0,
    Location: 'Iowa Hill Road south of Colfax',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Iowa Fire',
    Started: '2014-07-21T14:49:00Z',
    UniqueId: 'e22ad5eb-2085-4a09-887f-fc54756527ce'
  },
  {
    AcresBurned: 14,
    AdminUnit: 'CAL FIRE Riverside Unit',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/6/4/santa-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2014-06-04T16:30:00Z',
    Latitude: 0,
    Location: 'off Santa Rosa & Rancho California Road in Temecula',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Santa Fire',
    Started: '2014-06-04T15:18:00Z',
    UniqueId: '43bd24a5-fe63-4a1f-bb61-75d201f2c829'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'USFS - Sierra National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/8/26/pines-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2014-12-12T13:45:00Z',
    Latitude: 37,
    Location: 'Malum Ridge Road near Bass Lake',
    Longitude: 18.4,
    MajorIncident: 'False',
    Name: 'Pines Fire',
    Started: '2014-08-26T16:23:00Z',
    UniqueId: 'a2da7754-e907-48f2-a023-0a3053cf2903'
  },
  {
    AcresBurned: 6,
    AdminUnit: 'CAL FIRE / Napa County Fire',
    ArchiveYear: 2014,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2014/8/24/south-napa-earthquake/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2014-08-31T18:00:00Z',
    Latitude: 0,
    Location: 'City and County of Napa',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'South Napa Earthquake',
    Started: '2014-08-24T03:20:00Z',
    UniqueId: '9617f422-bb7b-41ae-8ad6-670ffff875ab'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'US Forest Service - Klamath National Forest',
    ArchiveYear: 2014,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2014/8/11/happy-camp-complex/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2014-08-14T09:30:00Z',
    Latitude: 41.796,
    Location: 'in the Happy Camp area',
    Longitude: -123.374,
    MajorIncident: 'False',
    Name: 'Happy Camp Complex',
    Started: '2014-08-11T22:00:00Z',
    UniqueId: 'da500577-e558-4446-832f-0e537cc55204'
  },
  {
    AcresBurned: 151623,
    AdminUnit: 'Sierra National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/7/31/rough-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2015-11-09T12:00:00Z',
    Latitude: 36.874,
    Location: '5 miles North of Hume Lake and 2.5 miles to the southwest of Spanish Mountain 5',
    Longitude: -118.905,
    MajorIncident: 'False',
    Name: 'Rough Fire',
    Started: '2015-07-31T19:00:00Z',
    UniqueId: '8c788c0a-d1fc-46d7-a17c-23f786831f7d'
  },
  {
    AcresBurned: 77081,
    AdminUnit: 'USFS - Shasta-Trinity National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/7/30/river-complex/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2015-07-31T20:25:00Z',
    Latitude: 0,
    Location: 'Near the communities of Dailey Ranch, Hoboken, Denny and Trinity Village.',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'River Complex',
    Started: '2015-07-30T22:30:00Z',
    UniqueId: '7c83452f-e6f0-47af-aa25-1d0fff3a594f'
  },
  {
    AcresBurned: 69438,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/29/rocky-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2015-08-14T18:15:00Z',
    Latitude: 38.8863538,
    Location: 'near Morgan Valley Road and Rocky Creek Road, east of Clear Lake',
    Longitude: -122.4762475,
    MajorIncident: 'True',
    Name: 'Rocky Fire',
    Started: '2015-07-29T15:29:00Z',
    UniqueId: '23e85238-2966-452c-8f21-fa93a51e889b'
  },
  {
    AcresBurned: 36503,
    AdminUnit: 'USFS - Shasta-Trinity National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/7/30/fork-complex/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2015-08-24T10:00:00Z',
    Latitude: 0,
    Location: 'Near the communities of Hayfork, Hyampom, and Harrison Gulch,',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Fork Complex',
    Started: '2015-07-30T21:30:00Z',
    UniqueId: '33e56fb3-20fc-47a5-810c-6fccef8400be'
  },
  {
    AcresBurned: 31359,
    AdminUnit: 'CAL FIRE / San Bernardino National Forest / San Bernardino County Fire/ San Bernardino County Sheriffs',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/17/lake-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2015-08-01T22:15:00Z',
    Latitude: 34.160277777778,
    Location: 'Off Hwy 38, south of Big Bear Lake',
    Longitude: -116.89277777778,
    MajorIncident: 'False',
    Name: 'Lake Fire',
    Started: '2015-06-17T15:52:00Z',
    UniqueId: '17616590-ce26-4c73-bf81-70d338d027ce'
  },
  {
    AcresBurned: 30361,
    AdminUnit: 'USFS - Six Rivers National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/7/31/gasquet-complex/',
    Counties: 'Del Norte',
    CountyIds: 8,
    Extinguished: '2015-08-04T09:00:00Z',
    Latitude: 0,
    Location: 'Gasquet area',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Gasquet Complex',
    Started: '2015-07-31T21:00:00Z',
    UniqueId: '450e1ea6-2ed7-4df2-b533-698b0c86dd40'
  },
  {
    AcresBurned: 29416,
    AdminUnit: 'USFS - Shasta - Trinity National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/7/30/south-complex/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2015-08-03T14:00:00Z',
    Latitude: 0,
    Location: 'Hyampom area',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'South Complex',
    Started: '2015-07-30T16:00:00Z',
    UniqueId: '7243645e-960d-4422-a281-cc6b42ca8938'
  },
  // {
  //   AcresBurned: 25118,
  //   AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
  //   ArchiveYear: 2015,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2015/8/9/jerusalem-fire/',
  //   Counties: 'Lake',
  //   CountyIds: 1728,
  //   Extinguished: '2015-08-25T06:45:00Z',
  //   Latitude: 38.8142503,
  //   Location: 'Jerusalem Valley area, northeast of Middletown',
  //   Longitude: -122.4867319,
  //   MajorIncident: 'True',
  //   Name: 'Jerusalem Fire',
  //   Started: '2015-08-09T15:34:00Z',
  //   UniqueId: '94a7ae52-fed9-4997-b972-1761aa4b89ca'
  // },
  {
    AcresBurned: 25118,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/9/jerusalem-fire/',
    Counties: 'Napa',
    CountyIds: 1728,
    Extinguished: '2015-08-25T06:45:00Z',
    Latitude: 38.8142503,
    Location: 'Jerusalem Valley area, northeast of Middletown',
    Longitude: -122.4867319,
    MajorIncident: 'True',
    Name: 'Jerusalem Fire',
    Started: '2015-08-09T15:34:00Z',
    UniqueId: '94a7ae52-fed9-4997-b972-1761aa4b89ca'
  },
  {
    AcresBurned: 10570,
    AdminUnit: 'Bureau of Land Management',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/8/3/dodge-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2015-08-04T10:37:00Z',
    Latitude: 40.938,
    Location: '17 miles northeast of Ravendale',
    Longitude: -120.105,
    MajorIncident: 'False',
    Name: 'Dodge Fire',
    Started: '2015-08-03T14:15:00Z',
    UniqueId: '293c6467-7b2e-43a3-94c1-41cec4339b67'
  },
  {
    AcresBurned: 7509,
    AdminUnit: 'USFS - Six Rivers National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/8/1/nickowitz-fire/',
    Counties: 'Del Norte',
    CountyIds: 8,
    Extinguished: '2015-11-09T12:00:00Z',
    Latitude: 0,
    Location: 'near Orleans',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Nickowitz Fire',
    Started: '2015-08-01T23:23:00Z',
    UniqueId: 'c4da9583-d7ad-4d8c-834c-3688c1bf3949'
  },
  // {
  //   AcresBurned: 7000,
  //   AdminUnit: 'CAL FIRE San Bernardino Unit',
  //   ArchiveYear: 2015,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2015/2/6/round-fire/',
  //   Counties: 'Inyo',
  //   CountyIds: 1426,
  //   Extinguished: '2015-02-12T07:35:00Z',
  //   Latitude: 0,
  //   Location: 'Westside of Highway 395 at the Sherwin Grade',
  //   Longitude: 0,
  //   MajorIncident: 'True',
  //   Name: 'Round Fire',
  //   Started: '2015-02-06T14:07:00Z',
  //   UniqueId: '7ed61f45-7e2b-449b-8ead-d34b75a5e818'
  // },
  {
    AcresBurned: 7000,
    AdminUnit: 'CAL FIRE San Bernardino Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/2/6/round-fire/',
    Counties: 'Mono',
    CountyIds: 1426,
    Extinguished: '2015-02-12T07:35:00Z',
    Latitude: 0,
    Location: 'Westside of Highway 395 at the Sherwin Grade',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Round Fire',
    Started: '2015-02-06T14:07:00Z',
    UniqueId: '7ed61f45-7e2b-449b-8ead-d34b75a5e818'
  },
  {
    AcresBurned: 6980,
    AdminUnit: 'USFS - Sequoia National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/7/19/cabin-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2015-09-05T18:00:00Z',
    Latitude: 36.24,
    Location: 'Golden Trout Wilderness, Sequoia National Forest',
    Longitude: -118.54,
    MajorIncident: 'False',
    Name: 'Cabin Fire',
    Started: '2015-07-19T08:00:00Z',
    UniqueId: 'c316e4c3-4455-4a12-8ecc-af75339adf8f'
  },
  {
    AcresBurned: 5702,
    AdminUnit: 'US Forest Service - Sierra National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/25/willow-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2015-08-13T10:30:00Z',
    Latitude: 37.279722,
    Location: 'off of Willow Canyon Drive and Road 274, southeast of Bass Lake',
    Longitude: -119.50014,
    MajorIncident: 'False',
    Name: 'Willow Fire',
    Started: '2015-07-25T14:30:00Z',
    UniqueId: '8650f48d-5ea2-4dfc-96d2-f0d3f300b1e4'
  },
  {
    AcresBurned: 4883,
    AdminUnit: 'CAL FIRE Humboldt - Del Norte Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/30/humboldt-lightning-fires/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2015-08-19T19:15:00Z',
    Latitude: 0,
    Location: 'Alder Point-Blocksburg, Southeastern Humboldt County',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Humboldt Lightning Fires',
    Started: '2015-07-30T16:02:00Z',
    UniqueId: '5bc18279-c038-4c2a-926c-433fe3cd4287'
  },
  {
    AcresBurned: 4863,
    AdminUnit: 'USFS Modoc National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/7/30/frog-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2015-07-31T20:00:00Z',
    Latitude: 41.399,
    Location: 'SW of Lava Campground',
    Longitude: -121.392,
    MajorIncident: 'False',
    Name: 'Frog Fire',
    Started: '2015-07-30T17:45:00Z',
    UniqueId: 'a063b897-28aa-43e5-b608-1b79f770050c'
  },
  {
    AcresBurned: 4250,
    AdminUnit: 'CAL FIRE San Bernardino Unit/ San Bernardino National Forest / San Bernardino County Fire',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/17/north-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2015-07-21T07:00:00Z',
    Latitude: 34.339,
    Location: 'off Interstate 15, south of Oaks Hills, in the Cajon Pass area',
    Longitude: -117.478,
    MajorIncident: 'True',
    Name: 'North Fire',
    Started: '2015-07-17T14:33:00Z',
    UniqueId: '3d81d2e5-d6e5-4368-864b-a9e29e7e5022'
  },
  {
    AcresBurned: 3676,
    AdminUnit: 'Inyo National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/8/14/walker-fire/',
    Counties: 'Mono',
    CountyIds: 26,
    Extinguished: '2015-08-23T17:45:00Z',
    Latitude: 0,
    Location: 'north of Walker Lake & north of June Lake Loop',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Walker Fire',
    Started: '2015-08-14T21:31:00Z',
    UniqueId: 'a195c911-2179-4591-ab00-e67297f2db04'
  },
  {
    AcresBurned: 2700,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/19/tesla-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2015-08-22T18:30:00Z',
    Latitude: 37.3845,
    Location: 'off Tesla Rd near Correl Hollow, between Livermore and Tracy',
    Longitude: -121.3732,
    MajorIncident: 'True',
    Name: 'Tesla Fire',
    Started: '2015-08-19T14:45:00Z',
    UniqueId: '8fc920eb-ca45-4d77-9a92-1326eca602d6'
  },
  {
    AcresBurned: 2446,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit/ Los Padres National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/16/cuesta-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2015-08-28T18:15:00Z',
    Latitude: 35.3477,
    Location: 'Off Highway 101 in the Cuesta Grade, north of San Luis Obispo',
    Longitude: -120.6269,
    MajorIncident: 'True',
    Name: 'Cuesta Fire',
    Started: '2015-08-16T18:13:00Z',
    UniqueId: 'fde8f46b-0225-4489-be2d-68453a524190'
  },
  {
    AcresBurned: 2304,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/25/lowell-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2015-08-12T19:15:00Z',
    Latitude: 39.192088,
    Location: 'In the Steep Hollow drainage west of Alta',
    Longitude: -120.882313,
    MajorIncident: 'True',
    Name: 'Lowell Fire',
    Started: '2015-07-25T14:37:00Z',
    UniqueId: 'd6b4bed4-f3d6-488a-a2fb-54c7cbfbd8b3'
  },
  {
    AcresBurned: 1850,
    AdminUnit: 'Camp Pendleton Military Base',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/8/13/horno-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2015-08-18T19:00:00Z',
    Latitude: 0,
    Location: 'Camp Pendleton',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Horno Fire',
    Started: '2015-08-13T13:03:00Z',
    UniqueId: '8049295f-23fe-4c7e-9be1-cded644dc737'
  },
  {
    AcresBurned: 1791,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/20/park-hill-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2015-06-24T18:30:00Z',
    Latitude: 0,
    Location: 'Park Hill Rd & Las Pilitas Rd, east of Santa Margarita',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Park Hill Fire',
    Started: '2015-06-20T14:41:00Z',
    UniqueId: '99cea36f-5797-409d-8be9-8140b2e63320'
  },
  {
    AcresBurned: 1542,
    AdminUnit: 'USFS Shasta-Trinity National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/6/10/saddle-fire/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2015-06-29T09:00:00Z',
    Latitude: 40.924,
    Location: '4 miles northwest of Hyampom',
    Longitude: -123.168,
    MajorIncident: 'False',
    Name: 'Saddle Fire',
    Started: '2015-06-10T15:00:00Z',
    UniqueId: '2aae391b-7b00-47d9-ba73-d71ad706bdad'
  },
  {
    AcresBurned: 1450,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/31/creek-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2015-08-01T19:00:00Z',
    Latitude: 0,
    Location: 'off Hwy 152 & San Luis Creek, west of Santa Nella',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Creek Fire',
    Started: '2015-07-31T21:37:00Z',
    UniqueId: '26c17f1d-6524-44b2-b126-4d411ba823c8'
  },
  {
    AcresBurned: 1333,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/18/mccabe-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2015-07-21T07:15:00Z',
    Latitude: 0,
    Location: 'off McCabe Rd and I-5, north of San Luis Reservoir',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'McCabe Fire',
    Started: '2015-07-18T22:27:00Z',
    UniqueId: '506eefb2-cae3-48dd-bd92-315ad1782184'
  },
  {
    AcresBurned: 1086,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/9/19/tassajara-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2015-09-27T18:15:00Z',
    Latitude: 36.3699644,
    Location: 'Tassajara Rd at Carmel Valley Rd',
    Longitude: -121.589554,
    MajorIncident: 'True',
    Name: 'Tassajara Fire',
    Started: '2015-09-19T15:00:00Z',
    UniqueId: '1f54817c-8832-4a47-8ede-ab8072f52677'
  },
  {
    AcresBurned: 1049,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/4/18/highway-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2015-04-24T07:30:00Z',
    Latitude: 33.884313,
    Location: 'at Hwy 71/Hwy 91 near the Prado Basin',
    Longitude: -117.642759,
    MajorIncident: 'True',
    Name: 'Highway Fire',
    Started: '2015-04-18T18:12:00Z',
    UniqueId: '8e3c0b14-01e5-4c41-8641-ff987ac10ad9'
  },
  {
    AcresBurned: 1042,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/9/11/lumpkin-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2015-09-17T19:30:00Z',
    Latitude: 39.5218,
    Location: 'off Lumpkin Road and Forbestown Road, Robinson Mill',
    Longitude: -121.3363,
    MajorIncident: 'True',
    Name: 'Lumpkin Fire',
    Started: '2015-09-11T14:15:00Z',
    UniqueId: 'f7067bff-efb4-4ca6-a627-6145836857ec'
  },
  {
    AcresBurned: 920,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/18/corrine-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2015-06-25T18:45:00Z',
    Latitude: 37.165767,
    Location: 'Road 222 and Tunoi Place, north of Auberry',
    Longitude: -119.523943,
    MajorIncident: 'True',
    Name: 'Corrine Fire',
    Started: '2015-06-18T21:00:00Z',
    UniqueId: 'fa8ba2dd-c9f7-454a-870b-1b39c0d8b31a'
  },
  {
    AcresBurned: 860,
    AdminUnit: 'CAL FIRE Butte Unit / Butte County Fire',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/10/3/meridian-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2015-10-04T18:40:00Z',
    Latitude: 0,
    Location: 'off Hwy 99 & Meridian Rd, north of Chico',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Meridian Fire',
    Started: '2015-10-03T21:15:00Z',
    UniqueId: '88e1ae5b-593f-4d0d-958d-bd56a877a535'
  },
  {
    AcresBurned: 673,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit / Mendocino National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/9/2/elk-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2015-09-08T19:28:00Z',
    Latitude: 55.23,
    Location: 'Off of Elk Mountain Road and Mount Dinger Road, north of Upper Lake',
    Longitude: -122,
    MajorIncident: 'True',
    Name: 'Elk Fire',
    Started: '2015-09-02T14:57:00Z',
    UniqueId: '0eed7005-6ace-4eb2-8919-eb131c246f84'
  },
  {
    AcresBurned: 670,
    AdminUnit: 'CAL FIRE San Benito - Monterey Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/10/12/cienega-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2015-10-16T18:00:00Z',
    Latitude: 36.70854,
    Location: 'Cienega Rd & Limekiln Rd, south of Hollister',
    Longitude: -121.32734,
    MajorIncident: 'True',
    Name: 'Cienega Fire',
    Started: '2015-10-12T16:00:00Z',
    UniqueId: '8e71e23c-6161-480e-b8ca-f03147475e4d'
  },
  {
    AcresBurned: 543,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/10/anza-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2015-08-15T17:30:00Z',
    Latitude: 33.5736,
    Location: 'Highway 74 east of Highway 371',
    Longitude: -116.5387,
    MajorIncident: 'False',
    Name: 'Anza Fire',
    Started: '2015-08-10T11:44:00Z',
    UniqueId: '592f14da-405c-4e6d-a83b-8937322524ad'
  },
  {
    AcresBurned: 509,
    AdminUnit: 'USFS - Inyo National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/2/6/van-dyke-fire/',
    Counties: 'Mono',
    CountyIds: 26,
    Extinguished: '2015-02-20T19:00:00Z',
    Latitude: 0,
    Location: 'Point Ranch, South of Bridgeport',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Van Dyke Fire',
    Started: '2015-02-06T16:52:00Z',
    UniqueId: 'f1b8fec0-ff6c-413d-bedb-d2e9c9ffb764'
  },
  {
    AcresBurned: 500,
    AdminUnit: 'Sierra National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/6/18/sky-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2015-06-19T08:15:00Z',
    Latitude: 0,
    Location: 'Rd 632, 2 miles from Hwy 41, Community of Calvin Crest',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Sky Fire',
    Started: '2015-06-18T14:31:00Z',
    UniqueId: '3a9bd55c-a384-402b-b673-2563200ce59e'
  },
  {
    AcresBurned: 430,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/21/triple-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2015-07-26T10:30:00Z',
    Latitude: 36.085212,
    Location: 'Globe Dr and Mountain Rd, Springville',
    Longitude: -118.824235,
    MajorIncident: 'True',
    Name: 'Triple Fire',
    Started: '2015-07-21T12:35:00Z',
    UniqueId: '9e2f6af4-ea45-4163-b6a1-e1fe9571fda3'
  },
  {
    AcresBurned: 415,
    AdminUnit: 'USFS - Yosemite National Park',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/9/7/tenaya-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2015-09-11T11:00:00Z',
    Latitude: 0,
    Location: 'north rim of Yosemite Valley, east of Yosemite Falls',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Tenaya Fire',
    Started: '2015-09-07T21:23:00Z',
    UniqueId: 'd01b8e54-43e5-4643-8742-a14e1c2980f8'
  },
  {
    AcresBurned: 415,
    AdminUnit: 'Los Angeles County Fire',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/6/24/calgrove-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2015-06-26T17:00:00Z',
    Latitude: 34.361007,
    Location: 'Southbound Interstate 5, North of Calgrove, Santa Clarita',
    Longitude: -118.535793,
    MajorIncident: 'False',
    Name: 'Calgrove Fire',
    Started: '2015-06-24T13:22:00Z',
    UniqueId: 'e61d1b0b-4f19-460a-a6ac-e83a6e0a05a9'
  },
  {
    AcresBurned: 400,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/29/swedes-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2015-08-03T17:00:00Z',
    Latitude: 39.43963,
    Location: 'Swedes Flat Road, 3 miles north of Bangor',
    Longitude: -121.38794,
    MajorIncident: 'True',
    Name: 'Swedes Fire',
    Started: '2015-07-29T11:25:00Z',
    UniqueId: '7428460d-f47d-45c0-8a86-3fb653829860'
  },
  {
    AcresBurned: 374,
    AdminUnit: 'Los Angeles County Fire Department /  Montebello Fire Department',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/8/16/lincoln-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2015-08-20T08:10:00Z',
    Latitude: 0,
    Location: 'off Lincoln Ave, in the Whittier Narrows Park, City of Montebello',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Lincoln Fire',
    Started: '2015-08-16T13:30:00Z',
    UniqueId: '0011ce0f-5493-4bef-b6e1-4674a0393b0c'
  },
  {
    AcresBurned: 355,
    AdminUnit: 'CAL FIRE Amador El Dorado Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/2/ione-fire/',
    Counties: 'Amador',
    CountyIds: 3,
    Extinguished: '2015-07-02T06:36:00Z',
    Latitude: 0,
    Location: 'off Ione Rd & Hwy 16, east of Rancho Murietta',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Ione Fire',
    Started: '2015-07-02T01:58:00Z',
    UniqueId: 'c3f64286-b2a0-4ab1-9f6b-d934d5b82228'
  },
  {
    AcresBurned: 300,
    AdminUnit: 'Angeles National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/8/16/warm-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2015-08-16T20:00:00Z',
    Latitude: 0,
    Location: 'Lake Hughes Rd at Warm Springs Rehab Center',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Warm Fire',
    Started: '2015-08-16T15:30:00Z',
    UniqueId: '15b01fbd-1962-4092-bcc4-d95ab7fafea2'
  },
  {
    AcresBurned: 300,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/5/site-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2015-06-06T07:15:00Z',
    Latitude: 0,
    Location: 'near Corral Hollow Road and the Alameda-San Joaquin county line.',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Site Fire',
    Started: '2015-06-05T20:22:00Z',
    UniqueId: '186f5cdd-aa7d-4f9e-84ae-83112801c790'
  },
  {
    AcresBurned: 282,
    AdminUnit: 'USFS - Los Padres National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/8/2/chorro-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2015-08-12T08:00:00Z',
    Latitude: 0,
    Location: 'Maricopa Highway 33 & Chorro Grande Canyon, north of Ojai',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Chorro Fire',
    Started: '2015-08-02T13:15:00Z',
    UniqueId: '7e1e0693-4690-4d11-afe6-74652d68c3ef'
  },
  {
    AcresBurned: 275,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/5/11/forebay-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2015-05-11T12:15:00Z',
    Latitude: 37.08312,
    Location: 'off Hwy 152 near the O’Neill Forebay',
    Longitude: -121.06963,
    MajorIncident: 'False',
    Name: 'Forebay Fire',
    Started: '2015-05-11T10:26:00Z',
    UniqueId: '316804d6-471a-4c73-8b05-89b8abc8eeac'
  },
  {
    AcresBurned: 242,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/5/28/christensen-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2015-05-28T10:30:00Z',
    Latitude: 0,
    Location: 'Christensen Rd and Burns Rd in the Altamont Pass area',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Christensen Fire',
    Started: '2015-05-28T17:00:00Z',
    UniqueId: '7c162fbf-922c-4128-9e30-a1e8848e15ab'
  },
  {
    AcresBurned: 227,
    AdminUnit: 'USFS - Mendocino National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/7/30/mendocino-national-forest-lightning-complex/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2015-08-07T21:00:00Z',
    Latitude: 0,
    Location: 'throughout Mendocino National Forest',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Mendocino National Forest Lightning Complex',
    Started: '2015-07-30T14:00:00Z',
    UniqueId: '8c030522-da26-492f-80e2-a249e741d9cb'
  },
  {
    AcresBurned: 215,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/9/9/pacheco-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2015-09-10T18:50:00Z',
    Latitude: 0,
    Location: 'off Hwy 152 at Dinosaur Point, 3 miles west of San Luis Reservoir',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Pacheco Fire',
    Started: '2015-09-09T15:58:00Z',
    UniqueId: 'f58b224d-b7d2-4311-9d65-c7440a1ceb53'
  },
  {
    AcresBurned: 215,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/22/peterson-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2015-08-27T15:15:00Z',
    Latitude: 38.925764,
    Location: 'off Peterson Lane and Adobe Creek Road, near Kelseyville',
    Longitude: -122.879272,
    MajorIncident: 'True',
    Name: 'Peterson Fire',
    Started: '2015-08-22T17:30:00Z',
    UniqueId: '02d470c1-bf41-4ff9-9424-f680cef5bbbc'
  },
  {
    AcresBurned: 214,
    AdminUnit: 'Orange County Fire Authority',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/13/241-fire/',
    Counties: 'Orange',
    CountyIds: 30,
    Extinguished: '2015-07-15T18:45:00Z',
    Latitude: 33.7626,
    Location: 'Hwy 241, south of Santiago Canyon Rd, near Irvine Lake (Orange County)',
    Longitude: -117.7274,
    MajorIncident: 'False',
    Name: '241 Fire',
    Started: '2015-07-13T10:47:00Z',
    UniqueId: 'ca7da36b-1951-4d52-92b2-1a0b04aab586'
  },
  {
    AcresBurned: 212,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/29/china-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2015-08-01T19:00:00Z',
    Latitude: 40.415108,
    Location: 'China Gulch, Happy Valley, Southwest of Redding',
    Longitude: -122.439939,
    MajorIncident: 'True',
    Name: 'China Fire',
    Started: '2015-07-29T17:55:00Z',
    UniqueId: 'efe937e3-8b63-4495-b578-e2582fb2166d'
  },
  {
    AcresBurned: 211,
    AdminUnit: 'Santa Barnara County Fire Department',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/6/29/mesa-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2015-06-29T17:05:00Z',
    Latitude: 0,
    Location: 'off Burton Mesa Blvd in Lompoc',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Mesa Fire',
    Started: '2015-06-29T13:11:00Z',
    UniqueId: 'f3765dfa-fa7b-47d7-8914-a032f229a892'
  },
  {
    AcresBurned: 204,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/29/big-creek-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2015-08-04T18:00:00Z',
    Latitude: 37.823,
    Location: 'off Hwy120 and Sprague Rd near Groveland',
    Longitude: -120.15644,
    MajorIncident: 'True',
    Name: 'Big Creek Fire',
    Started: '2015-07-29T16:30:00Z',
    UniqueId: '55a1ec97-90fb-48df-8414-203b91adcd76'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'USFS - Angeles National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/7/17/pines-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2015-08-04T08:15:00Z',
    Latitude: 34.367,
    Location: 'Angeles Crest Highway (Hwy 2) north of Wrightwood and near Big Pines',
    Longitude: -117.683,
    MajorIncident: 'False',
    Name: 'Pines Fire',
    Started: '2015-07-17T21:30:00Z',
    UniqueId: '0c9948a7-98ad-4b42-888e-a7c2a4f536fa'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'Shasta-Trinity National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/2/24/stephens-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2015-03-02T09:00:00Z',
    Latitude: 41.485,
    Location: 'Approx. 18 miles northeast of McCloud, just south of Horse Peak',
    Longitude: -121.851,
    MajorIncident: 'False',
    Name: 'Stephens Fire',
    Started: '2015-02-24T12:15:00Z',
    UniqueId: 'b3062936-6b2f-4177-b3f6-0fc288049339'
  },
  {
    AcresBurned: 195,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/30/vasco-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2015-07-30T16:00:00Z',
    Latitude: 37.81629,
    Location: 'Vasco Rd,  3 miles southwest of Byron',
    Longitude: -121.68113,
    MajorIncident: 'False',
    Name: 'Vasco Fire',
    Started: '2015-07-30T11:18:00Z',
    UniqueId: '652938d9-2f23-41d8-a49c-30b218594762'
  },
  {
    AcresBurned: 186,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/8/14/rustic-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2015-08-16T12:00:00Z',
    Latitude: 0,
    Location: 'Rustic Hills Drive in the Wood Ranch area Simi Valley',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Rustic Fire',
    Started: '2015-08-14T15:22:00Z',
    UniqueId: '4c10bd30-e348-430c-9f12-932c8a03f6f8'
  },
  {
    AcresBurned: 181,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/13/cooley-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2015-07-14T08:30:00Z',
    Latitude: 41.8048,
    Location: '5 miles North of the community of Montague on Cooley Rd',
    Longitude: -122.5029,
    MajorIncident: 'False',
    Name: 'Cooley Fire',
    Started: '2015-07-13T17:56:00Z',
    UniqueId: '8b35629f-50f4-4b32-b286-ce48cb1200e7'
  },
  {
    AcresBurned: 171,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/17/wildcat-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2015-06-19T17:45:00Z',
    Latitude: 32.9421,
    Location: 'Wildcat Canyon Rd and Barona Rd, east of Fernbrook',
    Longitude: -116.8534,
    MajorIncident: 'False',
    Name: 'Wildcat Fire',
    Started: '2015-06-17T17:03:00Z',
    UniqueId: 'fc2ea6bf-e925-49f9-8390-9997c01b612d'
  },
  {
    AcresBurned: 170,
    AdminUnit: 'CAL FIRE Fresno Kings Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/9/9/creek-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2015-09-11T19:17:00Z',
    Latitude: 40.400196,
    Location: 'Squaw Valley Road and Sand Creek Road',
    Longitude: -120.553075,
    MajorIncident: 'False',
    Name: 'Creek Fire',
    Started: '2015-09-09T14:30:00Z',
    UniqueId: '9a3df964-7794-411c-9043-967476fe77e6'
  },
  {
    AcresBurned: 170,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/4/black-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2015-07-04T20:15:00Z',
    Latitude: 39.8448,
    Location: 'off Black Butte Rd, near Black Butte Lake',
    Longitude: -122.3638,
    MajorIncident: 'False',
    Name: 'Black Fire',
    Started: '2015-07-04T16:33:00Z',
    UniqueId: '8d5b00c1-0ec0-43bb-a03e-822d5fe2af52'
  },
  {
    AcresBurned: 167,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/20/flat-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2015-08-21T18:45:00Z',
    Latitude: 0,
    Location: 'southeast of Woody, south of Poso Flat Road & Burke Creek',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Flat Fire',
    Started: '2015-08-20T15:57:00Z',
    UniqueId: '33b7d824-9803-4c07-8231-9cf210e34417'
  },
  {
    AcresBurned: 167,
    AdminUnit: 'USFS - Cleveland National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/7/24/cutca-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2015-07-26T06:45:00Z',
    Latitude: 33.383889,
    Location: 'On Palomar Mountain, north of the Palomar Observatory',
    Longitude: -116.868611,
    MajorIncident: 'False',
    Name: 'Cutca Fire',
    Started: '2015-07-24T16:18:00Z',
    UniqueId: 'd7757da4-f9e1-451f-8316-26065888dfc2'
  },
  {
    AcresBurned: 164,
    AdminUnit: 'Ventura County Fire',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/6/22/river-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2015-06-25T07:00:00Z',
    Latitude: 0,
    Location: 'Acacia Way and Corporation Court, Santa Paula',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'River Fire',
    Started: '2015-06-22T07:00:00Z',
    UniqueId: 'aece9ff6-ddfd-4240-bb7a-894831d1a67d'
  },
  {
    AcresBurned: 158,
    AdminUnit: 'CAL FIRE Humboldt-Del Norte Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/24/queen-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2015-08-01T21:45:00Z',
    Latitude: 41.295667,
    Location: 'off Hwy 169 & McKinnon Hill Rd, 5 miles southeast of Pecwan',
    Longitude: -123.784067,
    MajorIncident: 'True',
    Name: 'Queen Fire',
    Started: '2015-07-24T23:00:00Z',
    UniqueId: '8be9d271-ed9c-4bc9-9c22-4eff8956ab7b'
  },
  {
    AcresBurned: 158,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/18/cook-fire/',
    Counties: 'Yuba',
    CountyIds: 58,
    Extinguished: '2015-06-22T11:45:00Z',
    Latitude: 39.2688,
    Location: 'UC Field Station, Scott Forbes Road',
    Longitude: -121.26471,
    MajorIncident: 'True',
    Name: 'Cook Fire',
    Started: '2015-06-18T13:07:00Z',
    UniqueId: 'b5fa450f-9b84-4d90-9956-bda9dfe32f28'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/6/sky-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2015-07-08T20:45:00Z',
    Latitude: 38.4113,
    Location: 'Mix Canyon Rd & Sky Ranch Road, northwest of Vacaville',
    Longitude: -122.0789,
    MajorIncident: 'True',
    Name: 'Sky Fire',
    Started: '2015-07-06T10:47:00Z',
    UniqueId: '28b81794-bb66-466e-b9dc-337c47be5678'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'CAL FIRE Riverside County Fire',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/1/merwin-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2015-07-04T13:00:00Z',
    Latitude: 0,
    Location: 'off Merwin St in Moreno Valley',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Merwin Fire',
    Started: '2015-07-01T20:38:00Z',
    UniqueId: '1a06d125-d5c1-46bc-b8d4-08f31246f246'
  },
  {
    AcresBurned: 146,
    AdminUnit: 'CAL FIRE Humboldt-Del Norte Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/18/horse-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2015-08-29T07:00:00Z',
    Latitude: 40.1058823,
    Location: 'Saddle Mountain Road, 6 miles NE Shelter Cove',
    Longitude: -124.0720419,
    MajorIncident: 'True',
    Name: 'Horse Fire',
    Started: '2015-08-18T18:30:00Z',
    UniqueId: 'cbaa4a28-c732-4c11-9d44-7da6c3bd8e42'
  },
  {
    AcresBurned: 137,
    AdminUnit: '**This was NOT a CAL FIRE Incident. Click this link for more information from the US Forest Service',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/4/13/ward-fire/',
    Counties: 'Plumas',
    CountyIds: 32,
    Extinguished: '2015-04-18T23:50:00Z',
    Latitude: 40.050833333333,
    Location: 'East of Taylorsville',
    Longitude: -120.70166666667,
    MajorIncident: 'False',
    Name: 'Ward Fire',
    Started: '2015-04-13T05:30:00Z',
    UniqueId: '84cb525c-7a90-4d31-8d55-d9729c05b286'
  },
  {
    AcresBurned: 135,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/21/red-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2015-06-23T18:25:00Z',
    Latitude: 37.072561,
    Location: 'Red Tail Road and Road 211, south of O\'Neal',
    Longitude: -119.6958,
    MajorIncident: 'False',
    Name: 'Red Fire',
    Started: '2015-06-21T12:08:00Z',
    UniqueId: '0f537c6f-8a74-48f4-9fbf-ad00942ffba0'
  },
  {
    AcresBurned: 128,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/25/democrat-fire/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2015-08-29T18:45:00Z',
    Latitude: 40.724898,
    Location: 'Democrat Gulch, west of Weaverville',
    Longitude: -122.96174,
    MajorIncident: 'True',
    Name: 'Democrat Fire',
    Started: '2015-08-25T14:08:00Z',
    UniqueId: 'da522578-443a-4c52-a9bb-d72bbb84dcdb'
  },
  {
    AcresBurned: 122,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/18/collier-fire/',
    Counties: 'San Joaquin',
    CountyIds: 39,
    Extinguished: '2015-06-18T21:15:00Z',
    Latitude: 0,
    Location: 'Jack Tone Rd & Collier Rd, east of Herald',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Collier Fire',
    Started: '2015-06-18T14:09:00Z',
    UniqueId: 'a4df2aae-dab6-4531-b4f4-a535f77b483f'
  },
  {
    AcresBurned: 116,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/23/3-11-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2015-07-26T10:10:00Z',
    Latitude: 41.29226,
    Location: 'on Splawn Mountain, northeast of Bieber',
    Longitude: -121.172117,
    MajorIncident: 'False',
    Name: '3-11 Fire',
    Started: '2015-07-23T16:40:00Z',
    UniqueId: '0da79ccb-9701-4c27-8831-f10593fb8a90'
  },
  {
    AcresBurned: 114,
    AdminUnit: 'CAL FIRE Tuolumne Calaveras Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/13/mark-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2015-08-18T07:15:00Z',
    Latitude: 38.052,
    Location: 'Marks Ranch Rd south of Angels Camp',
    Longitude: -120.5577,
    MajorIncident: 'True',
    Name: 'Mark Fire',
    Started: '2015-08-13T16:15:00Z',
    UniqueId: 'fe668595-0980-4f41-af0c-3f14c4d391c2'
  },
  {
    AcresBurned: 112,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/15/tulloch-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2015-08-16T19:20:00Z',
    Latitude: 37.83618,
    Location: 'south of Hwy 108 & Tulloch Rd, south of Lake Tulloch',
    Longitude: -120.61691,
    MajorIncident: 'False',
    Name: 'Tulloch Fire',
    Started: '2015-08-15T16:11:00Z',
    UniqueId: '72c7a5c9-82c2-44c4-8bf2-241fb36e1ee7'
  },
  {
    AcresBurned: 111,
    AdminUnit: 'Bureau of Land Management - Northern California District',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/6/30/shinn-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2015-07-03T18:00:00Z',
    Latitude: 0,
    Location: 'near Shinn Mountain, 10 miles southeast of Ravendale',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Shinn Fire',
    Started: '2015-06-30T18:00:00Z',
    UniqueId: 'a0d1975a-fe2c-411d-93c0-13b479eee916'
  },
  {
    AcresBurned: 110,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/9/3/apple-fire/',
    Counties: 'Sacramento',
    CountyIds: 34,
    Extinguished: '2015-09-03T14:30:00Z',
    Latitude: 0,
    Location: 'Off Apple Rd in Wilton',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Apple Fire',
    Started: '2015-09-03T12:12:00Z',
    UniqueId: '20348e67-4eac-42ae-ad4e-57ca0add2914'
  },
  {
    AcresBurned: 110,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/8/36-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2015-08-09T20:30:00Z',
    Latitude: 40.3506868,
    Location: 'off Highwat 36 near Paynes Creek',
    Longitude: -121.7786799,
    MajorIncident: 'True',
    Name: '36 Fire',
    Started: '2015-08-08T14:55:00Z',
    UniqueId: 'ffbc1cb8-be33-4483-8442-85ab2587dce4'
  },
  {
    AcresBurned: 110,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/8/riosa-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '2015-06-08T11:45:00Z',
    Latitude: 0,
    Location: 'Riosa Rd & Thousand Oaks Dr, north of Lincoln',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Riosa Fire',
    Started: '2015-06-08T10:33:00Z',
    UniqueId: '38fd77e5-9688-42b4-b092-f517e75ef7a8'
  },
  {
    AcresBurned: 109,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/9/11/walker-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2015-09-13T10:15:00Z',
    Latitude: 40.47512,
    Location: 'Windwalker Ln & Small Farms Dr in Igo',
    Longitude: -122.52541,
    MajorIncident: 'True',
    Name: 'Walker Fire',
    Started: '2015-09-11T15:08:00Z',
    UniqueId: 'dbd39ec2-546c-4afc-9ff2-b1939eead03e'
  },
  {
    AcresBurned: 108,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/9/8/oak-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2015-09-15T19:15:00Z',
    Latitude: 38.04684,
    Location: 'off Old Oak Ranch Rd & Big Hill Rd in the Cedar Ridge area, northeast of Sonora',
    Longitude: -120.30188,
    MajorIncident: 'True',
    Name: 'Oak Fire',
    Started: '2015-09-08T13:23:00Z',
    UniqueId: '40f44488-051f-4412-a577-c932f2ce751d'
  },
  {
    AcresBurned: 104,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/10/2/munjar-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2015-10-02T17:50:00Z',
    Latitude: 39.8707,
    Location: 'Munjar Rd, 10 miles north of Chico',
    Longitude: -121.8938,
    MajorIncident: 'False',
    Name: 'Munjar Fire',
    Started: '2015-10-02T14:38:00Z',
    UniqueId: '897d01d8-dd38-43e2-bcd6-fa62aac03318'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/6/25/sterling-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2015-06-29T09:00:00Z',
    Latitude: 34.165974,
    Location: 'Sterling Avenue x Foothill Drive East',
    Longitude: -117.243878,
    MajorIncident: 'False',
    Name: 'Sterling Fire',
    Started: '2015-06-25T18:30:00Z',
    UniqueId: 'ff28ce24-a13b-4903-85de-faec825de35b'
  },
  {
    AcresBurned: 95,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/9/19/laureles-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2015-09-21T18:20:00Z',
    Latitude: 36.5696373,
    Location: 'off Laureles Grade and Highway 68',
    Longitude: -121.7556029,
    MajorIncident: 'False',
    Name: 'Laureles Fire',
    Started: '2015-09-19T15:25:00Z',
    UniqueId: '9569dcd6-c94f-4849-a90a-db58bfc77bee'
  },
  {
    AcresBurned: 95,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/10/deer-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2015-07-15T07:00:00Z',
    Latitude: 35.7183,
    Location: 'southwest of Lake Nacimiento',
    Longitude: -121.0157,
    MajorIncident: 'True',
    Name: 'Deer Fire',
    Started: '2015-07-10T12:41:00Z',
    UniqueId: '598a3d54-ce60-466e-b44f-0e7c8f9e4ff5'
  },
  {
    AcresBurned: 90,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/30/sprig-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2015-07-31T18:30:00Z',
    Latitude: 40.49865,
    Location: 'Sprig Way and Millville Plains Rd, Millville; 10 miles southeast of Redding',
    Longitude: -122.20109,
    MajorIncident: 'False',
    Name: 'Sprig Fire',
    Started: '2015-07-30T12:57:00Z',
    UniqueId: '8232dfd5-eda3-4766-83ec-83365cf21d93'
  },
  {
    AcresBurned: 86,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/30/advance-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2015-08-05T17:45:00Z',
    Latitude: 36.49845,
    Location: '5 miles north of the community of Three Rivers near Advance',
    Longitude: -118.9009,
    MajorIncident: 'True',
    Name: 'Advance Fire',
    Started: '2015-07-30T12:40:00Z',
    UniqueId: '2a6270c5-859f-4ffa-91c2-ecbee5ebdd7b'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE San Diego Unit / Chula Vista Fire Department',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/26/otay-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2015-06-26T22:15:00Z',
    Latitude: 32.6449163,
    Location: 'off Otay Lakes Road and Woods Drive in Chula Vista',
    Longitude: -116.9454387,
    MajorIncident: 'False',
    Name: 'Otay Fire',
    Started: '2015-06-26T16:06:00Z',
    UniqueId: '45a0a39f-b4b0-409c-9057-0942c567b7c3'
  },
  {
    AcresBurned: 80,
    AdminUnit: '**This is no longer a CAL FIRE incident.  At 6 pm on Thursday, June 04, BIA took over management of the fire**',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/1/harrison-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2015-06-05T16:32:00Z',
    Latitude: 0,
    Location: 'Avenue 66 and Harrison Street near Thermal',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Harrison Fire',
    Started: '2015-06-01T10:16:00Z',
    UniqueId: 'c5e798e2-cba3-4d9a-aa19-389f845bf877'
  },
  {
    AcresBurned: 77,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/23/3-12-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2015-07-25T22:00:00Z',
    Latitude: 40.856422,
    Location: 'in Dixie Valley, southwest of Bieber',
    Longitude: -121.101623,
    MajorIncident: 'False',
    Name: '3-12 Fire',
    Started: '2015-07-23T17:30:00Z',
    UniqueId: '12f68592-30e3-461c-b489-bc99ba52a38a'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/2/fern-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2015-08-04T18:00:00Z',
    Latitude: 40.67868,
    Location: 'Fern Rd and Oak Run Rd, 1 mile east of the Community of Oak Run',
    Longitude: -121.93244,
    MajorIncident: 'True',
    Name: 'Fern Fire',
    Started: '2015-08-02T03:00:00Z',
    UniqueId: 'dfd02b2e-7e2d-4636-a178-0ebff2d170c8'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/29/mallard-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2015-07-31T18:40:00Z',
    Latitude: 40.509552,
    Location: 'off Mallard Way in Millville',
    Longitude: -122.199227,
    MajorIncident: 'True',
    Name: 'Mallard Fire',
    Started: '2015-07-29T16:30:00Z',
    UniqueId: '259d9359-0cc2-4058-bfc2-f28ab2a540f4'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'USFS - El Dorado National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/7/23/kyburz-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2015-07-29T14:15:00Z',
    Latitude: 38.776,
    Location: 'off Hwy 50 at White Hall Canyon Dr in Kyburz',
    Longitude: -120.404,
    MajorIncident: 'False',
    Name: 'Kyburz Fire',
    Started: '2015-07-23T14:00:00Z',
    UniqueId: '74635a69-f34f-4c6e-9e09-1a32d732bb42'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/1/webb-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2015-07-01T20:20:00Z',
    Latitude: 0,
    Location: 'off LaPorte Rd, east of Bangor',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Webb Fire',
    Started: '2015-07-01T13:05:00Z',
    UniqueId: '8581f0b0-92da-4ce1-8d6f-e32557515a1e'
  },
  {
    AcresBurned: 72,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/9/2/olive-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2015-09-03T19:35:00Z',
    Latitude: 26.42,
    Location: 'Off of Olive Tree Lane, south of Oroville',
    Longitude: -121,
    MajorIncident: 'True',
    Name: 'Olive Fire',
    Started: '2015-09-02T13:18:00Z',
    UniqueId: '3435fd06-f77e-42c3-8fa5-261cf0cb828c'
  },
  {
    AcresBurned: 69,
    AdminUnit: 'Klamath National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/8/20/prairie-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2015-08-22T18:00:00Z',
    Latitude: 0,
    Location: 'LaHonda Well area northeast of the community of Tennant',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Prairie Fire',
    Started: '2015-08-20T16:00:00Z',
    UniqueId: 'bd869df0-5333-4b9f-957f-b3d563f09f94'
  },
  {
    AcresBurned: 67,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/15/pass-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2015-06-15T18:45:00Z',
    Latitude: 35.77937,
    Location: 'Off of Hwy 41 near Cottonwood Pass',
    Longitude: -120.19482,
    MajorIncident: 'False',
    Name: 'Pass Fire',
    Started: '2015-06-15T15:46:00Z',
    UniqueId: '17b99f78-78b8-4bd1-90fc-5d9c3cb61b95'
  },
  {
    AcresBurned: 65,
    AdminUnit: 'San Bernardino National Foerst',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/8/1/scales-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2015-08-05T09:00:00Z',
    Latitude: 0,
    Location: 'Cajon Pass, I-15 and Highway 138',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Scales Fire',
    Started: '2015-08-01T13:04:00Z',
    UniqueId: 'd95a4f8c-008a-4691-b1b2-9173b4dca34d'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'CAL FIRE Fresno Unit/Fresno County Fire',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/18/kerkhoff-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2015-07-22T10:00:00Z',
    Latitude: 0,
    Location: 'off Powerhouse Rd, near Kercknoff Lake, north of the community of Auberry',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Kerkhoff Fire',
    Started: '2015-07-18T16:31:00Z',
    UniqueId: '77b8e450-18b2-4fc4-a9d0-403594095482'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/19/dixie-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2015-06-20T19:35:00Z',
    Latitude: 40.875667,
    Location: 'Dixie Valley, south of Bieber',
    Longitude: -121.033667,
    MajorIncident: 'False',
    Name: 'Dixie Fire',
    Started: '2015-06-19T16:15:00Z',
    UniqueId: '1ca8b1e7-5590-448b-86ba-6dfa4937baa6'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'CAL FIRE Riverside Unit / Riverside County Fire',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/18/grapefruit-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2015-06-21T07:25:00Z',
    Latitude: 0,
    Location: 'Off Grapefruit Blvd in Thermal',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Grapefruit Fire',
    Started: '2015-06-18T14:16:00Z',
    UniqueId: '2d114fe4-57c1-4ac1-a9ec-923dde4d9292'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/18/triangle-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2015-06-19T20:05:00Z',
    Latitude: 0,
    Location: 'Triangle Rd and Nickel Plate Rd, north of Bootjack',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Triangle Fire',
    Started: '2015-06-18T12:03:00Z',
    UniqueId: '8d98f943-8a04-4ad5-b884-84986a521c3f'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/16/north-fire/',
    Counties: 'Amador',
    CountyIds: 3,
    Extinguished: '2015-06-17T06:45:00Z',
    Latitude: 38.260777,
    Location: 'Dry Creek and E Prouty Rd, west of Herald',
    Longitude: -121.135426,
    MajorIncident: 'False',
    Name: 'North Fire',
    Started: '2015-06-16T16:42:00Z',
    UniqueId: 'e2077d05-1f06-4939-8857-9f630a4b722e'
  },
  {
    AcresBurned: 59,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/3/point-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2015-08-04T08:15:00Z',
    Latitude: 40.3929,
    Location: 'Gas Point and Happy Valley Rd, west of Cottonwood',
    Longitude: -122.40546,
    MajorIncident: 'True',
    Name: 'Point Fire',
    Started: '2015-08-03T14:28:00Z',
    UniqueId: '6c5fcfc7-659a-44ee-b225-c4ae919882e7'
  },
  {
    AcresBurned: 58,
    AdminUnit: 'Shasta-Trinity National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/10/10/military-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2015-10-10T18:45:00Z',
    Latitude: 0,
    Location: 'Along Military Pass Road',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Military Fire',
    Started: '2015-10-10T12:00:00Z',
    UniqueId: 'e4223f98-44fa-44bd-9ec9-3219206068d2'
  },
  {
    AcresBurned: 55,
    AdminUnit: 'USFS - San Bernardino National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/8/23/summit-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2015-09-11T15:00:00Z',
    Latitude: 34.23,
    Location: 'at Knickerbocker Road and Pine Knot, south of Big Bear Lake',
    Longitude: -116.883,
    MajorIncident: 'False',
    Name: 'Summit Fire',
    Started: '2015-08-23T12:25:00Z',
    UniqueId: 'd0875efe-54fb-4cc2-b647-4f4d210df118'
  },
  {
    AcresBurned: 55,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/9/de-luz-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2015-08-10T15:05:00Z',
    Latitude: 33.4115972,
    Location: 'De Luz Rd and De Luz Murrieta Rd',
    Longitude: -117.2886249,
    MajorIncident: 'False',
    Name: 'De Luz Fire',
    Started: '2015-08-09T08:22:00Z',
    UniqueId: '3cc1aa4c-b87d-4b4d-99b1-83dc56291b33'
  },
  {
    AcresBurned: 55,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/17/fork-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2015-06-17T18:30:00Z',
    Latitude: 40.0133,
    Location: 'Off Lowery Rd, north of Paskenta',
    Longitude: -122.552,
    MajorIncident: 'False',
    Name: 'Fork Fire',
    Started: '2015-06-17T12:50:00Z',
    UniqueId: '7934d7bb-15e1-4217-8fa1-552e4f3d8091'
  },
  {
    AcresBurned: 54,
    AdminUnit: 'CAL FIRE San Bernardino Unit/San Bernardino National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/12/mill-2-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2015-07-21T07:20:00Z',
    Latitude: 34.0783472,
    Location: 'Mill Creek Rd and Bryant St, east of Mentone',
    Longitude: -117.0487863,
    MajorIncident: 'True',
    Name: 'Mill 2 Fire',
    Started: '2015-07-12T14:46:00Z',
    UniqueId: 'c8fb2c4c-2275-4ad1-aef3-859e332a1a47'
  },
  {
    AcresBurned: 53,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/25/tesla-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2015-06-25T18:45:00Z',
    Latitude: 0,
    Location: 'off Tesla Road, southeast of Livermore',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Tesla Fire',
    Started: '2015-06-25T16:10:00Z',
    UniqueId: '418c9abb-935a-4157-91a3-f511c197785b'
  },
  {
    AcresBurned: 52,
    AdminUnit: 'Santa Barbara County Fire',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/1/white-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '1969-12-31T16:00:00Z',
    Latitude: 34.9522,
    Location: 'off White Oak Ln, east of Santa Maria',
    Longitude: -120.2903,
    MajorIncident: 'False',
    Name: 'White Fire',
    Started: '2015-08-01T14:32:00Z',
    UniqueId: 'f136ba8d-f6bb-4bad-9815-1d56f9dc8650'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/11/7/potrero-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2015-11-07T16:45:00Z',
    Latitude: 34.15,
    Location: 'Hidden Valley area, southwest of Thousand Oaks',
    Longitude: -118.879444,
    MajorIncident: 'False',
    Name: 'Potrero Fire',
    Started: '2015-11-07T01:45:00Z',
    UniqueId: '3f31752f-4f51-4705-9fe4-50beec88a0e8'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/30/mendocino-lightning-fires/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2015-08-03T08:55:00Z',
    Latitude: 39.43301,
    Location: 'Community of Willits and Brooktrails',
    Longitude: -123.36316,
    MajorIncident: 'False',
    Name: 'Mendocino Lightning Fires',
    Started: '2015-07-30T13:36:00Z',
    UniqueId: '9f031bfa-47bc-4fee-aca1-988462d6ab53'
  },
  {
    AcresBurned: 45,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/9/9/antelope-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2015-09-15T19:10:00Z',
    Latitude: 0,
    Location: 'Antelope Canyon south of Tehachapi',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Antelope Fire',
    Started: '2015-09-09T11:45:00Z',
    UniqueId: 'e1ad9125-1179-4d00-891b-7b62699069d0'
  },
  {
    AcresBurned: 45,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/2/geary-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2015-07-03T20:00:00Z',
    Latitude: 0,
    Location: 'off Geary Road in the Sunol Wilderness, 10 miles east of Fremont',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Geary Fire',
    Started: '2015-07-02T04:40:00Z',
    UniqueId: 'a6143c76-aa03-4161-bf5e-4d8e4a1136d2'
  },
  {
    AcresBurned: 45,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/5/fku-lightning-fires/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2015-06-06T20:00:00Z',
    Latitude: 0,
    Location: 'near Auberry',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'FKU Lightning Fires',
    Started: '2015-06-05T17:00:00Z',
    UniqueId: '8e9dca1d-9ae9-4fc3-89ab-815a4d3f09cc'
  },
  {
    AcresBurned: 43,
    AdminUnit: 'USFS - Modoc National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/7/9/mason-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2015-07-13T11:00:00Z',
    Latitude: 0,
    Location: 'Near Clear Lake and Mason Reservoir',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Mason Fire',
    Started: '2015-07-09T15:00:00Z',
    UniqueId: 'ff70bb48-8823-49d9-b6cd-935cc407aacb'
  },
  {
    AcresBurned: 42,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/30/highway-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2015-07-03T17:55:00Z',
    Latitude: 0,
    Location: 'off Hwy 101 near Monterey Frontage Rd, South of Gilroy',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Highway Fire',
    Started: '2015-06-30T15:23:00Z',
    UniqueId: '10a86822-77a8-45b1-8caf-aefd7b679db5'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Lassen - Modoc Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/9/9/center-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2015-09-10T07:49:00Z',
    Latitude: 40.400196,
    Location: 'Center Rd, east of Susanville',
    Longitude: -120.553075,
    MajorIncident: 'False',
    Name: 'Center Fire',
    Started: '2015-09-09T14:12:00Z',
    UniqueId: '75c14933-9916-4dfe-ac66-7d98706a5172'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/28/sullivan-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2015-07-28T15:00:00Z',
    Latitude: 37.24523,
    Location: 'Sullivan Rd and Orestimba Rd, 10 miles West of Newman',
    Longitude: -121.20324,
    MajorIncident: 'False',
    Name: 'Sullivan Fire',
    Started: '2015-07-28T12:10:00Z',
    UniqueId: '57397ed5-93a3-4e60-9142-9a3e38164ee9'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/10/ascot-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2015-07-10T17:00:00Z',
    Latitude: 38.1029,
    Location: 'Lake Herman Rd and Sky Valley Rd',
    Longitude: -122.1578,
    MajorIncident: 'True',
    Name: 'Ascot Fire',
    Started: '2015-07-10T13:36:00Z',
    UniqueId: 'dff0f39c-bed4-4910-9c22-d9ccd4142809'
  },
  {
    AcresBurned: 38,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/16/chiles-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2015-06-17T13:10:00Z',
    Latitude: 38.5287,
    Location: 'Chiles Pope Valley Rd. & Lower Chiles Valley Rd., East of St. Helena',
    Longitude: -122.3415,
    MajorIncident: 'True',
    Name: 'Chiles Fire',
    Started: '2015-06-16T14:27:00Z',
    UniqueId: 'e3272697-2587-45ac-b525-76b85fabaa90'
  },
  {
    AcresBurned: 36,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/9/garage-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2015-06-10T09:45:00Z',
    Latitude: 0,
    Location: 'off Pope Valley Road & Howell Mountain Road in Pope Valley',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Garage Fire',
    Started: '2015-06-09T15:23:00Z',
    UniqueId: '2513b19f-3509-4e0f-8d87-85785061af02'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/9/8/browns-fire/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2015-09-10T17:05:00Z',
    Latitude: 40,
    Location: 'Hwy 299 and Little Browns Creek Rd east of Weaverville',
    Longitude: 41.46,
    MajorIncident: 'False',
    Name: 'Browns Fire',
    Started: '2015-09-08T15:56:00Z',
    UniqueId: '5046e2ed-e2c3-4932-8f89-64dcdf19022d'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE Amador El-Dorado Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/3/ranch-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2015-07-05T11:30:00Z',
    Latitude: 0,
    Location: 'off French Creek Rd, south of Shingle Springs',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Ranch Fire',
    Started: '2015-07-03T09:28:00Z',
    UniqueId: 'a4e4603a-f0fc-4d7a-845b-6c668bfcb81e'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/28/covelo-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2015-06-29T07:15:00Z',
    Latitude: 39.7806004,
    Location: 'off Highway 162 and Cemetery Lane, Covelo',
    Longitude: -123.248214,
    MajorIncident: 'False',
    Name: 'Covelo Fire',
    Started: '2015-06-28T13:30:00Z',
    UniqueId: '56dc8f9c-98e5-4aad-b3e9-bbee503b29e9'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/9/22/mccourtney-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2015-09-21T14:36:00Z',
    Latitude: 39.081,
    Location: 'off McCourtney Rd & Perimeter Rd, east of Camp Far West Reservoir',
    Longitude: -121.194,
    MajorIncident: 'False',
    Name: 'McCourtney Fire',
    Started: '2015-09-22T07:00:00Z',
    UniqueId: 'c27d03c6-361e-44b3-8335-a1fe06f88fd7'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/29/kramer-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2015-08-30T08:00:00Z',
    Latitude: 41.12362,
    Location: 'off of Kramer Road and 4 Corners Road, west of Beiber',
    Longitude: -121.194256,
    MajorIncident: 'False',
    Name: 'Kramer Fire',
    Started: '2015-08-29T16:06:00Z',
    UniqueId: 'bb500714-470e-4529-a15a-11d96e85cc68'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/3/francis-fire/',
    Counties: 'Yuba',
    CountyIds: 58,
    Extinguished: '2015-08-05T07:30:00Z',
    Latitude: 39.33303,
    Location: 'Colgate Powerhouse south of Dobbins',
    Longitude: -121.18735,
    MajorIncident: 'False',
    Name: 'Francis Fire',
    Started: '2015-08-03T18:07:00Z',
    UniqueId: '139766ba-33ac-442e-9a6b-b78d270c110a'
  },
  {
    AcresBurned: 29,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/11/11/banister-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2015-11-12T18:00:00Z',
    Latitude: 0,
    Location: 'off Wood Ranch Parkway 2 miles sw of Simi Valley',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Banister Fire',
    Started: '2015-11-11T17:40:00Z',
    UniqueId: 'f843961b-2c26-427d-87ba-0bde7ce9ecba'
  },
  {
    AcresBurned: 26,
    AdminUnit: 'CAL FIRE Nevada Yuba Placer Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/22/baxter-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '2015-07-22T19:50:00Z',
    Latitude: 38.9361,
    Location: 'Baxter Grade Rd, 3 miles West of Auburn',
    Longitude: -121.1548,
    MajorIncident: 'False',
    Name: 'Baxter Fire',
    Started: '2015-07-22T18:17:00Z',
    UniqueId: 'ee7ec0f0-4f5d-4fe1-b2fa-bc15f91519b3'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/24/park-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2015-07-25T16:05:00Z',
    Latitude: 32.682547,
    Location: 'Off of Lake Morena Drive near Lake Morena Park, north of Campo',
    Longitude: -116.51684,
    MajorIncident: 'False',
    Name: 'Park Fire',
    Started: '2015-07-24T12:43:00Z',
    UniqueId: 'a80b8ab7-eba5-4ef7-9992-0cf828138f1b'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/20/betabel-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2015-07-20T15:30:00Z',
    Latitude: 36.8727,
    Location: 'off Hwy 101 between Anzar Rd & Hwy 156, in Aromas',
    Longitude: -121.5681,
    MajorIncident: 'False',
    Name: 'Betabel Fire',
    Started: '2015-07-20T13:23:00Z',
    UniqueId: '296fc88f-e646-4c89-9b46-3ac0f88ff910'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/16/lake-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2015-07-17T15:15:00Z',
    Latitude: 33.21407,
    Location: 'off Highway 76, near Moretti Junction, near Lake Henshaw',
    Longitude: -116.73472,
    MajorIncident: 'False',
    Name: 'Lake Fire',
    Started: '2015-07-16T11:30:00Z',
    UniqueId: '98b0706c-ac34-4d9a-9ceb-55996099daed'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Amador El Dorado Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/2/buckaroo-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2015-07-05T11:30:00Z',
    Latitude: 0,
    Location: 'off Bucks Bar Cir & Buckaroo Trail near Somerset',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Buckaroo Fire',
    Started: '2015-07-02T17:10:00Z',
    UniqueId: 'f251d96b-f29d-46eb-be0a-9f431837d8f5'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/7/fox-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2015-06-09T09:00:00Z',
    Latitude: 0,
    Location: 'Lookout Mountain Rd & Fox Field Lane, south of Mormon Bar',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Fox Fire',
    Started: '2015-06-07T12:06:00Z',
    UniqueId: '794934ea-f2b0-4b88-b853-3f2510654e09'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/5/oasis-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2015-06-06T06:45:00Z',
    Latitude: 0,
    Location: 'Hwy 20 near Lake County- Colusa County Line',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Oasis Fire',
    Started: '2015-06-05T19:57:00Z',
    UniqueId: 'a992b7d3-64d5-420e-8c26-0ded8f828414'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Riverside Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/5/snow-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2015-06-05T19:00:00Z',
    Latitude: 0,
    Location: 'Snow Creek Road, south of Highway 111',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Snow Fire',
    Started: '2015-06-05T13:32:00Z',
    UniqueId: '9987126f-9cfe-4cae-baf6-8b0d82969e51'
  },
  {
    AcresBurned: 24,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/21/dorris-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2015-07-22T17:00:00Z',
    Latitude: 41.999341,
    Location: 'Off Hwy 161 & Hwy 97, northeast of Dorris',
    Longitude: -121.891226,
    MajorIncident: 'True',
    Name: 'Dorris Fire',
    Started: '2015-07-21T17:00:00Z',
    UniqueId: '098eb80f-1ecb-489d-baef-1440fa0e98d6'
  },
  {
    AcresBurned: 23,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/4/soda-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2015-07-05T09:00:00Z',
    Latitude: 39.0263,
    Location: 'off Hwy 253, 4 miles northeast of Boonville (Mendocino County).',
    Longitude: -123.303,
    MajorIncident: 'False',
    Name: 'Soda Fire',
    Started: '2015-07-04T15:30:00Z',
    UniqueId: '58dda3b8-3643-4f73-bee0-0a4cae0cb079'
  },
  {
    AcresBurned: 22,
    AdminUnit: 'CAL FIRE Sonoma Lake Napa',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/8/24/grade-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2015-08-25T18:30:00Z',
    Latitude: 38.831478,
    Location: 'Jerusalem Grade Rd & June Bug Rd, 7 miles northeast of Middletown',
    Longitude: -122.53428,
    MajorIncident: 'False',
    Name: 'Grade Fire',
    Started: '2015-08-24T12:12:00Z',
    UniqueId: '909d6135-070c-4e3b-ba22-23877fb603c3'
  },
  {
    AcresBurned: 21,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/10/29/gibraltar-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2015-11-09T12:00:00Z',
    Latitude: 34.4828,
    Location: 'between Montecito Peak and Coldspring Saddle',
    Longitude: -119.63216,
    MajorIncident: 'False',
    Name: 'Gibraltar Fire',
    Started: '2015-10-29T05:30:00Z',
    UniqueId: 'fbd3c0a8-7191-473c-bb05-43616711b6c5'
  },
  {
    AcresBurned: 21,
    AdminUnit: 'CAL FIRE Riverside County Fire',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/12/spider-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2015-07-12T19:48:00Z',
    Latitude: 33.986204,
    Location: 'San Timoteo Canyon Rd and Redlands Blvd, northeast of Moreno Valley',
    Longitude: -117.43942,
    MajorIncident: 'True',
    Name: 'Spider Fire',
    Started: '2015-07-12T13:52:00Z',
    UniqueId: '48284911-67cd-4394-8aad-053d3b2cf5db'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Humboldt-Del Norte Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/10/bald-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2015-06-11T18:15:00Z',
    Latitude: 41.1513,
    Location: 'off Bald Hills Rd, 15 miles east of Hwy 101 & Orick',
    Longitude: -123.8292,
    MajorIncident: 'True',
    Name: 'Bald Fire',
    Started: '2015-06-10T07:42:00Z',
    UniqueId: 'ccd896f2-f071-4d26-ba9b-f413de4d6b77'
  },
  {
    AcresBurned: 19,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/6/27/pleasure-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2015-06-28T18:00:00Z',
    Latitude: 38.519132,
    Location: 'Steele Canyon Rd. and Headlands Dr., Lake Berryessa',
    Longitude: -122.181878,
    MajorIncident: 'False',
    Name: 'Pleasure Fire',
    Started: '2015-06-27T12:51:00Z',
    UniqueId: '7c98e8db-6a6a-4f66-bfe7-7d24e926c986'
  },
  {
    AcresBurned: 18,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/7/keswick-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2015-07-08T16:30:00Z',
    Latitude: 40.5953,
    Location: 'Middle Creek Road, north of Hwy 299',
    Longitude: -122.4397,
    MajorIncident: 'True',
    Name: 'Keswick Fire',
    Started: '2015-07-07T12:34:00Z',
    UniqueId: '64fa2a72-b964-421d-b88f-5ac2e37647d4'
  },
  {
    AcresBurned: 16,
    AdminUnit: 'CAL FIRE Humboldt-Del Norte Unit',
    ArchiveYear: 2015,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2015/7/28/buck-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2015-07-31T19:00:00Z',
    Latitude: 40.1093,
    Location: 'off Alderpoint Road & Wallan Road near Garberville',
    Longitude: -123.774,
    MajorIncident: 'False',
    Name: 'Buck Fire',
    Started: '2015-07-28T17:19:00Z',
    UniqueId: '0a645cbe-2d5a-4e2b-80c9-cb9167641cca'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'USFS - Six Rivers National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/7/30/mad-river-complex/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2015-08-01T15:25:00Z',
    Latitude: 0,
    Location: 'Near Ruth Lake area',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Mad River Complex',
    Started: '2015-07-30T16:00:00Z',
    UniqueId: '3e699b76-7a4b-4b5d-a391-89b640953195'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'US Forest Service - Humboldt - Toiyabe National Forest',
    ArchiveYear: 2015,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2015/6/19/washington-fire/',
    Counties: 'Alpine',
    CountyIds: 2,
    Extinguished: '2015-06-22T12:05:00Z',
    Latitude: 38.598056,
    Location: 'south of Markleeville',
    Longitude: -119.751944,
    MajorIncident: 'False',
    Name: 'Washington Fire',
    Started: '2015-06-19T19:00:00Z',
    UniqueId: '470d19d4-384d-497a-9770-cd2e2a3f3196'
  },
  {
    AcresBurned: 132127,
    AdminUnit: 'US Forest Service - Los Padres National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/22/soberanes-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2016-10-13T11:30:00Z',
    Latitude: 36.45994,
    Location: 'Soberanes Creek, Garrapata State Park, Palo Colorado, north of Big Sur',
    Longitude: -121.89938,
    MajorIncident: 'True',
    Name: 'Soberanes Fire',
    Started: '2016-07-22T08:48:00Z',
    UniqueId: '977ac7ce-4204-4cd3-9f89-727142165261'
  },
  {
    AcresBurned: 48019,
    AdminUnit: 'Bureau of Land Management',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/23/erskine-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2016-07-11T09:40:00Z',
    Latitude: 35.6115,
    Location: 'Off Erskine Creek Rd in Lake Isabella',
    Longitude: -118.45628,
    MajorIncident: 'False',
    Name: 'Erskine Fire',
    Started: '2016-06-23T15:51:00Z',
    UniqueId: '91816ff6-d4ec-4f31-8d40-bf2538aca09b'
  },
  {
    AcresBurned: 46344,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/13/chimney-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2016-09-06T07:30:00Z',
    Latitude: 35.70595,
    Location: 'Running Deer Rd & Chimney Rock Rd south of Lake Nacimiento',
    Longitude: -120.98316,
    MajorIncident: 'True',
    Name: 'Chimney Fire',
    Started: '2016-08-13T16:03:00Z',
    UniqueId: '040d03d0-fbdd-438c-8174-f81e4a1bba57'
  },
  {
    AcresBurned: 36274,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/16/blue-cut-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2016-08-23T07:45:00Z',
    Latitude: 34.30372,
    Location: 'off of I-15 and Hwy 138, north of San Bernardino',
    Longitude: -117.49342,
    MajorIncident: 'True',
    Name: 'Blue Cut Fire',
    Started: '2016-08-16T10:44:00Z',
    UniqueId: 'ea5193a1-69bc-4684-bfcd-235c17d36756'
  },
  {
    AcresBurned: 33867,
    AdminUnit: 'USFS Klamath National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/8/27/gap-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2016-08-28T18:15:00Z',
    Latitude: 41.851,
    Location: 'off Seiad Creek Rd, 5 miles northeast o Seiad Valley',
    Longitude: -123.118,
    MajorIncident: 'False',
    Name: 'Gap Fire',
    Started: '2016-08-27T18:00:00Z',
    UniqueId: '85683fd7-b507-4ec7-8bbd-fb7033a42665'
  },
  {
    AcresBurned: 32606,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/18/rey-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2016-09-15T15:20:00Z',
    Latitude: 0,
    Location: 'off of Hwy 154 and Paradise Rd, north of Santa Barbara',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Rey Fire',
    Started: '2016-08-18T17:57:00Z',
    UniqueId: 'dc3f57ff-a935-4c25-bbe3-e00eeb5b5f42'
  },
  {
    AcresBurned: 29322,
    AdminUnit: 'Sequoia National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/8/16/cedar-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2016-10-01T06:00:00Z',
    Latitude: 35.7506,
    Location: 'off of Hwy 155 in the Greenhorn Mountains, west of Wofford Heights',
    Longitude: -118.5678,
    MajorIncident: 'False',
    Name: 'Cedar Fire',
    Started: '2016-08-16T16:35:00Z',
    UniqueId: 'e247e423-6171-4184-9dca-b373de703885'
  },
  {
    AcresBurned: 12518,
    AdminUnit: 'Vandenberg Air Force Base',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/9/17/canyon-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2016-09-27T14:00:00Z',
    Latitude: 34.63445,
    Location: 'Santa Ynez Ridge Road and Egress Road, south side of Vandenberg Air Force Base',
    Longitude: -120.54421,
    MajorIncident: 'False',
    Name: 'Canyon Fire',
    Started: '2016-09-17T17:20:00Z',
    UniqueId: 'f6afb8c4-32dc-4e6d-8d30-e6b7ccd4a62f'
  },
  {
    AcresBurned: 8110,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/7/pilot-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2016-08-16T08:00:00Z',
    Latitude: 34.28771,
    Location: 'Pilot Rock & Hwy 138, southeast of Hesperia',
    Longitude: -117.27338,
    MajorIncident: 'True',
    Name: 'Pilot Fire',
    Started: '2016-08-07T12:18:00Z',
    UniqueId: '69c7b8cc-061e-4ca6-b5e8-83c6ae9d8a25'
  },
  {
    AcresBurned: 7609,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/19/border-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2016-06-30T18:30:00Z',
    Latitude: 32.60729,
    Location: 'off Highway 188 and Highway 94 near Tecate',
    Longitude: -116.63028,
    MajorIncident: 'True',
    Name: 'Border Fire',
    Started: '2016-06-19T11:03:00Z',
    UniqueId: '33099cdd-ccfc-454e-b5a3-770a69a30bd3'
  },
  {
    AcresBurned: 7474,
    AdminUnit: 'U.S Los Padres National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/15/sherpa-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2016-07-12T14:30:00Z',
    Latitude: 34.776,
    Location: 'west of Goleta',
    Longitude: -119.643,
    MajorIncident: 'True',
    Name: 'Sherpa Fire',
    Started: '2016-06-15T15:21:00Z',
    UniqueId: 'ffb3293b-3349-49c5-a7cb-c488391e8a72'
  },
  {
    AcresBurned: 7050,
    AdminUnit: 'CAL FIRE Fresno Kings Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/9/mineral-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2016-08-18T19:00:00Z',
    Latitude: 36.09974,
    Location: 'off Hwy 198 & Mineral Springs Rd, W of Coalinga',
    Longitude: -120.51057,
    MajorIncident: 'True',
    Name: 'Mineral Fire',
    Started: '2016-08-09T13:08:00Z',
    UniqueId: '346c59b1-375e-4d42-876a-d97b769c939f'
  },
  {
    AcresBurned: 5731,
    AdminUnit: 'CAL FIRE Sonoma Lake Napa Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/2/cold-fire/',
    Counties: 'Yolo',
    CountyIds: 57,
    Extinguished: '2016-08-12T15:00:00Z',
    Latitude: 38.52513,
    Location: 'off of Highway 128 west of Pleasants Valley Road, west of Winters',
    Longitude: -122.06788,
    MajorIncident: 'True',
    Name: 'Cold Fire',
    Started: '2016-08-02T16:36:00Z',
    UniqueId: '057fd4e2-7400-4fc4-9b23-3daf67fc8610'
  },
  // {
  //   AcresBurned: 5646,
  //   AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit / El Dorado National Forest',
  //   ArchiveYear: 2016,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2016/6/28/trailhead-fire/',
  //   Counties: 'El Dorado',
  //   CountyIds: 931,
  //   Extinguished: '2016-07-18T09:50:00Z',
  //   Latitude: 38.96741,
  //   Location: 'along the  Middle Fork of the American River near Todd Valley',
  //   Longitude: -120.9375,
  //   MajorIncident: 'True',
  //   Name: 'Trailhead Fire',
  //   Started: '2016-06-28T13:55:00Z',
  //   UniqueId: 'b604ffa7-8cee-4724-bb82-f1f4553a192f'
  // },
  {
    AcresBurned: 5646,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit / El Dorado National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/28/trailhead-fire/',
    Counties: 'Placer',
    CountyIds: 931,
    Extinguished: '2016-07-18T09:50:00Z',
    Latitude: 38.96741,
    Location: 'along the  Middle Fork of the American River near Todd Valley',
    Longitude: -120.9375,
    MajorIncident: 'True',
    Name: 'Trailhead Fire',
    Started: '2016-06-28T13:55:00Z',
    UniqueId: 'b604ffa7-8cee-4724-bb82-f1f4553a192f'
  },
  {
    AcresBurned: 5443,
    AdminUnit: 'Inyo National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/9/17/owens-river-fire/',
    Counties: 'Inyo',
    CountyIds: 14,
    Extinguished: '2016-09-18T08:10:00Z',
    Latitude: 37.75985,
    Location: 'Clark Canyon, north of Mammoth Lakes, east of Hwy 395',
    Longitude: -118.95309,
    MajorIncident: 'False',
    Name: 'Owens River Fire',
    Started: '2016-09-17T13:49:00Z',
    UniqueId: '821c040d-a17c-4934-990f-ca7d441a303a'
  },
  {
    AcresBurned: 5399,
    AdminUnit: 'Angeles National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/6/20/san-gabriel-complex-formerly-fish-reservoir-fires/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2018-04-23T15:07:00Z',
    Latitude: 0,
    Location: 'south of Azusa',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'San Gabriel Complex (Formerly Fish & Reservoir Fires)',
    Started: '2016-06-20T13:59:00Z',
    UniqueId: '2b8f9fdc-f812-4d72-9163-c5356d8ae04b'
  },
  {
    AcresBurned: 4824,
    AdminUnit: 'Angeles National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/11/14/marek-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2016-11-14T14:00:00Z',
    Latitude: 34.31,
    Location: 'Lake View Terrace',
    Longitude: -118.335,
    MajorIncident: 'False',
    Name: 'Marek Fire',
    Started: '2016-11-14T05:45:00Z',
    UniqueId: 'ca1227b3-1458-44c9-b32e-2994e309f940'
  },
  {
    AcresBurned: 4474,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/26/loma-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2017-09-19T10:30:00Z',
    Latitude: 37.10632,
    Location: 'off Loma Prieta Rd and Loma Chiquita Rd 10 miles NW of Morgan Hill',
    Longitude: -121.85318,
    MajorIncident: 'True',
    Name: 'Loma Fire',
    Started: '2016-09-26T14:42:00Z',
    UniqueId: '2dfac408-d2ab-4ff9-94aa-91be9d07bb59'
  },
  {
    AcresBurned: 4347,
    AdminUnit: 'Sequoia National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/10/29/meadow-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2016-12-19T13:30:00Z',
    Latitude: 35.984,
    Location: 'East of Trail of 100 Giants between Lloyd Meadow Road and Western Divide Highway.',
    Longitude: -118.551,
    MajorIncident: 'False',
    Name: 'Meadow Fire',
    Started: '2016-10-29T11:15:00Z',
    UniqueId: '89c304db-e288-4582-90d4-884d57fd71f9'
  },
  {
    AcresBurned: 3929,
    AdminUnit: 'CALFIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/13/clayton-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2016-08-26T18:00:00Z',
    Latitude: 38.89741,
    Location: 'off Hwy 29 and Clayton Creek south of Lower Lake',
    Longitude: -122.60664,
    MajorIncident: 'True',
    Name: 'Clayton Fire',
    Started: '2016-08-13T18:03:00Z',
    UniqueId: 'a0950d5e-6f35-4023-bb60-6737146ba7bd'
  },
  {
    AcresBurned: 3876,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/22/metz-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2016-05-25T18:15:00Z',
    Latitude: 36.38123,
    Location: 'Metz Rd & Blue Jay Ln, southeast of Soledad',
    Longitude: -121.20059,
    MajorIncident: 'True',
    Name: 'Metz Fire',
    Started: '2016-05-22T15:27:00Z',
    UniqueId: '55fa95e6-f09e-42c4-889b-a4b5b63dccf2'
  },
  {
    AcresBurned: 3712,
    AdminUnit: 'Camp Roberts Fire Department',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/18/roberts-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2016-05-20T18:00:00Z',
    Latitude: 0,
    Location: '10 miles northwest of Paso Robles on Camp Roberts Military Base',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Roberts Fire',
    Started: '2016-05-18T14:27:00Z',
    UniqueId: '50f908c4-841a-4125-8563-5c3e1866ff8a'
  },
  {
    AcresBurned: 2944,
    AdminUnit: 'CAL FIRE Fresno Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/1/curry-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2016-07-05T07:05:00Z',
    Latitude: 36.0749,
    Location: 'Curry Mountain, 7 miles SW of Coalinga',
    Longitude: -120.452041,
    MajorIncident: 'True',
    Name: 'Curry Fire',
    Started: '2016-07-01T17:16:00Z',
    UniqueId: '423df2bd-4464-44e0-8b8a-74f953613287'
  },
  {
    AcresBurned: 2860,
    AdminUnit: 'USFS Klamath National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/6/7/pony-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2016-11-08T10:15:00Z',
    Latitude: 41.623,
    Location: '15 miles SW of Happy Camp (Siskiyou County)',
    Longitude: -123.557,
    MajorIncident: 'False',
    Name: 'Pony Fire',
    Started: '2016-06-07T02:45:00Z',
    UniqueId: '103e1cb6-0a02-4ca8-8739-4cf77b5d1c98'
  },
  {
    AcresBurned: 2819,
    AdminUnit: 'Inyo National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/8/4/clark-fire/',
    Counties: 'Mono',
    CountyIds: 26,
    Extinguished: '2016-08-07T19:14:00Z',
    Latitude: 0,
    Location: 'on Bald Mountain, northeast of Mammoth',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Clark Fire',
    Started: '2016-08-04T14:09:00Z',
    UniqueId: 'afa76746-3e42-48ed-bff6-e65ef40c6037'
  },
  {
    AcresBurned: 2652,
    AdminUnit: 'Modoc National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/9/17/soup-complex/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2016-10-13T11:30:00Z',
    Latitude: 41.2649,
    Location: 'Soup Springs, 12 miles east of Likely',
    Longitude: -120.3178,
    MajorIncident: 'False',
    Name: 'Soup Complex',
    Started: '2016-09-17T14:37:00Z',
    UniqueId: '92c20948-6ff6-4a2c-b13f-32c75e71b16c'
  },
  {
    AcresBurned: 2575,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/11/willard-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2016-09-22T07:00:00Z',
    Latitude: 40.3915,
    Location: 'off of Willard Creek Road, west of Susanville',
    Longitude: -120.7845,
    MajorIncident: 'True',
    Name: 'Willard Fire',
    Started: '2016-09-11T11:33:00Z',
    UniqueId: '1243f711-c29f-4bc3-a7e7-c705a6fc40f2'
  },
  {
    AcresBurned: 2520,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/4/coleman-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2016-06-20T08:30:00Z',
    Latitude: 36.01542,
    Location: 'off Mission Creek Rd and Milpitas Rd north of Fort Hunter Liggett',
    Longitude: -121.25029,
    MajorIncident: 'False',
    Name: 'Coleman Fire',
    Started: '2016-06-04T14:33:00Z',
    UniqueId: 'b8cf80c7-b617-4fe4-91b0-43b40d38c7f6'
  },
  {
    AcresBurned: 2304,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/6/30/pine-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2016-06-30T16:55:00Z',
    Latitude: 34.701,
    Location: 'Near Haddock Campground, 3 miles west of the Pine Mtn Lodge, above Middle Sespe.',
    Longitude: -119.144,
    MajorIncident: 'False',
    Name: 'Pine Fire',
    Started: '2016-06-30T16:55:00Z',
    UniqueId: '8653f541-d3ca-44b4-9edd-5a4a57349f2f'
  },
  {
    AcresBurned: 2241,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/30/goose-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2016-08-09T18:30:00Z',
    Latitude: 37.01591,
    Location: 'Off Gooseberry Ln & Morgan Canyon, south of Prather',
    Longitude: -119.50507,
    MajorIncident: 'True',
    Name: 'Goose Fire',
    Started: '2016-07-30T16:40:00Z',
    UniqueId: 'bd2b7bdc-0f92-451a-a3a5-03569d27c952'
  },
  {
    AcresBurned: 2100,
    AdminUnit: 'USFS Sierra National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/10/11/sacata-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2016-10-20T07:00:00Z',
    Latitude: 36.94536,
    Location: 'near Sacata Ridge, located above Pine Flat',
    Longitude: -119.25959,
    MajorIncident: 'False',
    Name: 'Sacata Fire',
    Started: '2016-10-11T12:58:00Z',
    UniqueId: '59084c8f-904c-42cb-9aa8-cae4a1f8c6ef'
  },
  {
    AcresBurned: 1785,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/1/deer-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2016-07-08T19:00:00Z',
    Latitude: 35.20993,
    Location: 'Hwy 223 & Deertrail Rd., east of Arvin',
    Longitude: -118.72272,
    MajorIncident: 'True',
    Name: 'Deer Fire',
    Started: '2016-07-01T14:05:00Z',
    UniqueId: '140def53-175c-4f5d-b8e3-de0643781ff7'
  },
  {
    AcresBurned: 1547,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/25/sawmill-fire/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2016-09-29T17:00:00Z',
    Latitude: 38.80017,
    Location: 'off Big Geysers Road and Geysers Resort Road, 10 miles east of Cloverdale',
    Longitude: -122.82895,
    MajorIncident: 'True',
    Name: 'Sawmill Fire',
    Started: '2016-09-25T10:43:00Z',
    UniqueId: '8d9b87e4-6fdb-49e4-ba6d-be85ffd6b222'
  },
  {
    AcresBurned: 1470,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/30/bogart-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2016-09-02T18:10:00Z',
    Latitude: 0,
    Location: 'Off Winesap Avenue & International Park Road, north of Beaumont, near Cherry Valley',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Bogart Fire',
    Started: '2016-08-30T12:25:00Z',
    UniqueId: '944e953f-ed28-4b99-8d60-d352c702e6f9'
  },
  {
    AcresBurned: 1246,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/25/dinosaur-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2016-06-26T18:50:00Z',
    Latitude: 37.07147,
    Location: 'Off Hwy152 at Dinosaur Point, westside of San Luis Reservoir',
    Longitude: -121.20155,
    MajorIncident: 'False',
    Name: 'Dinosaur Fire',
    Started: '2016-06-25T23:45:00Z',
    UniqueId: 'ec90eb29-e776-43da-a814-0c41463ae3c9'
  },
  {
    AcresBurned: 1245,
    AdminUnit: 'Camp Pendleton Military Base',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/7/21/roblar-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2016-07-30T14:15:00Z',
    Latitude: 33.393,
    Location: 'Roblar Rd and Case Springs (Camp Pendleton)',
    Longitude: -117.35093,
    MajorIncident: 'False',
    Name: 'Roblar Fire',
    Started: '2016-07-21T16:06:00Z',
    UniqueId: '78eccd24-9fe2-4ccd-90fa-a1e0fdc19b41'
  },
  {
    AcresBurned: 1109,
    AdminUnit: 'Los Angeles County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/7/9/sage-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2016-07-16T12:00:00Z',
    Latitude: 34.36763,
    Location: 'off of Calgrove Blvd, southwest of Santa Clarita',
    Longitude: -118.57245,
    MajorIncident: 'False',
    Name: 'Sage Fire',
    Started: '2016-07-09T12:04:00Z',
    UniqueId: '79b446a4-d809-4aa2-9f30-091a05ed697d'
  },
  {
    AcresBurned: 1080,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/26/marshes-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2016-10-04T22:00:00Z',
    Latitude: 37.79635,
    Location: 'off Hwy. 49 and Marshes Flat Road north of Don Pedro Reservoir',
    Longitude: -120.32484,
    MajorIncident: 'True',
    Name: 'Marshes Fire',
    Started: '2016-09-26T12:20:00Z',
    UniqueId: '3a4871dc-2299-4934-8a31-b92780fe31a3'
  },
  {
    AcresBurned: 850,
    AdminUnit: 'CAL FIRE / Butte County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/5/saddle-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2016-09-12T14:51:00Z',
    Latitude: 39.6871,
    Location: 'Off Pentz Rd & Lime Saddle Rd, south of Paradise',
    Longitude: -121.571,
    MajorIncident: 'True',
    Name: 'Saddle Fire',
    Started: '2016-09-05T16:28:00Z',
    UniqueId: 'c94fda40-ab7a-42d1-bfc9-ca5f39fb6e7d'
  },
  {
    AcresBurned: 710,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/24/grade-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2016-08-30T06:45:00Z',
    Latitude: 41.7813,
    Location: 'off Hwy 263, 2 miles north of Yreka',
    Longitude: -122.611,
    MajorIncident: 'True',
    Name: 'Grade Fire',
    Started: '2016-08-24T14:55:00Z',
    UniqueId: 'a2a6199c-704a-4826-a51b-23e6ee123349'
  },
  {
    AcresBurned: 650,
    AdminUnit: 'Inyo National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/6/25/marina-fire/',
    Counties: 'Mono',
    CountyIds: 26,
    Extinguished: '2016-07-09T08:30:00Z',
    Latitude: 37.97,
    Location: 'Hwy 395 & Mono Lake',
    Longitude: -119.14,
    MajorIncident: 'False',
    Name: 'Marina Fire',
    Started: '2016-06-25T06:30:00Z',
    UniqueId: '1bc85249-0d96-42d7-a23f-db99bdce17a4'
  },
  {
    AcresBurned: 599,
    AdminUnit: 'CAL Fire Humboldt-Del Norte Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/22/tully-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2016-09-04T06:55:00Z',
    Latitude: 41.28486,
    Location: 'off of Hwy 169 & Martin\'s Ferry Rd, northwest of Weitchpec',
    Longitude: -123.82268,
    MajorIncident: 'True',
    Name: 'Tully Fire',
    Started: '2016-08-22T16:03:00Z',
    UniqueId: 'da72b0c2-835d-42a5-8fa8-4de5442610cc'
  },
  {
    AcresBurned: 554,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/8/fort-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2016-07-10T19:37:00Z',
    Latitude: 34.913,
    Location: 'off of I-5, east of Grapevine',
    Longitude: 118.9082,
    MajorIncident: 'False',
    Name: 'Fort Fire',
    Started: '2016-07-08T11:15:00Z',
    UniqueId: 'fe112320-013f-434e-b66c-101234292711'
  },
  {
    AcresBurned: 550,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/2/99-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2016-08-03T08:00:00Z',
    Latitude: 39.6708,
    Location: 'Off of Highway 99 and Neal Road, south of Chico',
    Longitude: -121.7192,
    MajorIncident: 'False',
    Name: '99 Fire',
    Started: '2016-08-02T14:35:00Z',
    UniqueId: 'e5122d1e-2bfc-4fa6-8152-da309e02c004'
  },
  {
    AcresBurned: 518,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/26/range-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2016-08-29T10:30:00Z',
    Latitude: 35.2013,
    Location: 'off Deer Trail Dr & Hwy 223, 6 miles east of Arvin',
    Longitude: -118.7212,
    MajorIncident: 'False',
    Name: 'Range Fire',
    Started: '2016-08-26T10:10:00Z',
    UniqueId: '2656ad63-b3e1-467f-9982-0229fd31c0f5'
  },
  {
    AcresBurned: 464,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/30/colyear-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2016-07-04T07:45:00Z',
    Latitude: 40.0353,
    Location: 'Colyear Springs Road, 7 miles west of Red Bank',
    Longitude: -122.56939,
    MajorIncident: 'True',
    Name: 'Colyear Fire',
    Started: '2016-06-30T13:32:00Z',
    UniqueId: '69eaa890-889e-4be9-810d-3dcee8d55981'
  },
  {
    AcresBurned: 450,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/28/willow-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2016-08-31T18:50:00Z',
    Latitude: 38.1874,
    Location: 'Off Willow Creek Rd & Mountain Ranch Rd, east of San Andreas',
    Longitude: -120.6381,
    MajorIncident: 'True',
    Name: 'Willow Fire',
    Started: '2016-08-28T13:07:00Z',
    UniqueId: 'db833182-22df-44cc-ba10-0901e74222bc'
  },
  {
    AcresBurned: 441,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/8/fiddler-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2016-07-12T07:00:00Z',
    Latitude: 40.36873,
    Location: 'off Fiddlers Road, southwest of Igo',
    Longitude: -122.72913,
    MajorIncident: 'True',
    Name: 'Fiddler Fire',
    Started: '2016-07-08T22:45:00Z',
    UniqueId: '67c0a269-05bb-4b4f-af22-68a1c5ac3adf'
  },
  {
    AcresBurned: 400,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/18/beale-fire/',
    Counties: 'Yuba',
    CountyIds: 58,
    Extinguished: '2016-08-18T21:30:00Z',
    Latitude: 36.16965,
    Location: 'off of Hammonton Smartsville Rd and Doolittle Rd, near Beale AFB',
    Longitude: -121.38775,
    MajorIncident: 'False',
    Name: 'Beale Fire',
    Started: '2016-08-18T15:35:00Z',
    UniqueId: '822c934f-11be-48a9-8e60-f3f6802ef24d'
  },
  {
    AcresBurned: 395,
    AdminUnit: 'US Forest Service - Sequoia National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/8/22/tule-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2016-11-08T10:15:00Z',
    Latitude: 36.1648,
    Location: 'off Hwy 190, 4 miles northeast of Springville',
    Longitude: -118.73906,
    MajorIncident: 'False',
    Name: 'Tule Fire',
    Started: '2016-08-22T22:00:00Z',
    UniqueId: '954fb899-decb-461b-a0dd-76442e3370d3'
  },
  {
    AcresBurned: 380,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/11/howard-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2016-09-14T18:00:00Z',
    Latitude: 41.4657,
    Location: 'in Howards Gulch, north of Canby',
    Longitude: -120.9066,
    MajorIncident: 'False',
    Name: 'Howard Fire',
    Started: '2016-09-11T14:15:00Z',
    UniqueId: '97772dc4-7fde-4412-982c-974b3316e22b'
  },
  {
    AcresBurned: 372,
    AdminUnit: 'CAL FIRE Amador- El Dorado Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/28/rancho-fire/',
    Counties: 'Amador',
    CountyIds: 3,
    Extinguished: '2016-06-29T07:30:00Z',
    Latitude: 38.385,
    Location: 'Hwy 104, west of Ione',
    Longitude: -121.003611,
    MajorIncident: 'False',
    Name: 'Rancho Fire',
    Started: '2016-06-28T19:02:00Z',
    UniqueId: '5689b708-61e8-4451-8ad6-68d9684704c6'
  },
  {
    AcresBurned: 360,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/13/hog-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2016-09-13T14:30:00Z',
    Latitude: 40.30594,
    Location: 'Off Hwy 36 near Hog Lake, northeast of Red Bluff',
    Longitude: -122.1295,
    MajorIncident: 'True',
    Name: 'Hog Fire',
    Started: '2016-09-13T23:10:00Z',
    UniqueId: '060ef833-2d3f-47d4-a1d4-146d1b9a5928'
  },
  {
    AcresBurned: 341,
    AdminUnit: 'CAL FIRE Tuolumne Calaveras Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/12/pacheco-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2016-07-16T18:30:00Z',
    Latitude: 38.08056,
    Location: 'off Lanford Pacheco Rd, south of Valley Springs',
    Longitude: -120.81394,
    MajorIncident: 'False',
    Name: 'Pacheco Fire',
    Started: '2016-07-12T13:14:00Z',
    UniqueId: '85832754-5848-4454-84fc-8b0a9abbff40'
  },
  {
    AcresBurned: 310,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/2/appaloosa-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2016-07-08T19:32:00Z',
    Latitude: 38.02845,
    Location: 'Appaloosa Rd. and Pinto Dr., 5 miles southwest of Angels Camp',
    Longitude: -120.61153,
    MajorIncident: 'False',
    Name: 'Appaloosa Fire',
    Started: '2016-07-02T14:55:00Z',
    UniqueId: '902a3085-e518-4090-a2e5-20d0482b4dc2'
  },
  {
    AcresBurned: 306,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/19/flat-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2016-09-21T09:30:00Z',
    Latitude: 0,
    Location: 'off Granite Rd and Poso Flat Rd., 5 miles south of Woody',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Flat Fire',
    Started: '2016-09-19T14:13:00Z',
    UniqueId: '376f08dc-071a-4ef5-9035-cf61b4f2fa3b'
  },
  {
    AcresBurned: 304,
    AdminUnit: 'USFS Sequoia National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/8/28/havilah-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2016-08-28T18:50:00Z',
    Latitude: 35.4976,
    Location: 'south of Lake Isabella',
    Longitude: -118.5097,
    MajorIncident: 'False',
    Name: 'Havilah Fire',
    Started: '2016-08-28T18:50:00Z',
    UniqueId: 'fa457abb-66d2-4f82-80fd-452e824e871f'
  },
  {
    AcresBurned: 300,
    AdminUnit: 'Beale Air Force Base',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/20/butte-fire/',
    Counties: 'Sutter',
    CountyIds: 51,
    Extinguished: '2016-09-20T18:00:00Z',
    Latitude: 39.188321,
    Location: 'off Pass Road and Kellogg Road (Near Sutter Buttes West of Yuba City',
    Longitude: -121.78003,
    MajorIncident: 'False',
    Name: 'Butte Fire',
    Started: '2016-09-20T09:30:00Z',
    UniqueId: 'f669c502-b400-4ad9-ae95-bfd9c31f903c'
  },
  {
    AcresBurned: 278,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/25/dewolf-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2016-05-25T08:00:00Z',
    Latitude: 36.88286,
    Location: 'DeWolf Ave & Behymer Ave, 2 miles north of Clovis',
    Longitude: -119.654,
    MajorIncident: 'False',
    Name: 'DeWolf Fire',
    Started: '2016-05-25T01:03:00Z',
    UniqueId: '09ab0430-7679-494c-96d4-d7d938351cf4'
  },
  {
    AcresBurned: 277,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/26/creek-fire/',
    Counties: 'Yolo',
    CountyIds: 57,
    Extinguished: '2016-06-27T06:15:00Z',
    Latitude: 38.69971,
    Location: 'off Hwy 16, 4 miles south of Brooks, near the Cache Creek Casino',
    Longitude: -122.15457,
    MajorIncident: 'False',
    Name: 'Creek Fire',
    Started: '2016-06-26T15:45:00Z',
    UniqueId: 'eb0fe9ad-f9f5-4bde-ad34-527ffd647669'
  },
  {
    AcresBurned: 248,
    AdminUnit: 'US Forest Service - Plumas NF',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/9/26/tobin-fire/',
    Counties: 'Plumas',
    CountyIds: 32,
    Extinguished: '2016-10-06T17:15:00Z',
    Latitude: 39.92,
    Location: 'north of Hwy 70 and west of Jackass Creek Road',
    Longitude: -121.32,
    MajorIncident: 'False',
    Name: 'Tobin Fire',
    Started: '2016-09-26T13:23:00Z',
    UniqueId: 'abd0a296-217d-4a6a-9da0-5eb05f56f863'
  },
  {
    AcresBurned: 237,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/17/king-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2016-06-20T06:00:00Z',
    Latitude: 0,
    Location: 'north of Hwy 198, east of Hwy 25',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'King Fire',
    Started: '2016-06-17T14:30:00Z',
    UniqueId: 'e84f2562-1126-4255-9df4-dd7a32460e43'
  },
  {
    AcresBurned: 221,
    AdminUnit: 'Kern County Fire / Sequoia National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/13/onyx-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2016-07-14T12:00:00Z',
    Latitude: 35.68313,
    Location: 'off Coyote Trail & Rocky Hill, East of Onyx',
    Longitude: -118.21793,
    MajorIncident: 'False',
    Name: 'Onyx Fire',
    Started: '2016-07-13T17:08:00Z',
    UniqueId: '0dc19167-07b3-45e6-9bad-ad070934616a'
  },
  {
    AcresBurned: 215,
    AdminUnit: 'Vandenberg Air Force Base',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/9/22/washington-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2016-09-27T14:00:00Z',
    Latitude: 34.75134,
    Location: 'off Washington Ave. and Airfield Rd, north of California Blvd',
    Longitude: -120.55297,
    MajorIncident: 'False',
    Name: 'Washington Fire',
    Started: '2016-09-22T14:20:00Z',
    UniqueId: '686e1300-65d3-4e07-8a88-e5952418649b'
  },
  {
    AcresBurned: 215,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/26/reservoir-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2016-06-28T20:00:00Z',
    Latitude: 39.12366,
    Location: 'Near Indian Valley Reservoir, 7 miles Southwest of Leesville',
    Longitude: -122.50373,
    MajorIncident: 'True',
    Name: 'Reservoir Fire',
    Started: '2016-06-26T16:00:00Z',
    UniqueId: '489cea9f-b3cb-4615-b412-5ac5724c3976'
  },
  {
    AcresBurned: 211,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/25/grant-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2016-06-26T07:00:00Z',
    Latitude: 37.74369,
    Location: 'In the Altamont Pass, 10 miles east of Livermore',
    Longitude: -121.58677,
    MajorIncident: 'False',
    Name: 'Grant Fire',
    Started: '2016-06-25T16:11:00Z',
    UniqueId: '3822b8a2-1a89-40e8-b239-840cfcda7a1c'
  },
  {
    AcresBurned: 210,
    AdminUnit: 'CAL FIRE Amador El-Dorado Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/17/camanche-fire/',
    Counties: 'Amador',
    CountyIds: 3,
    Extinguished: '2016-06-21T18:30:00Z',
    Latitude: 38.26874,
    Location: 'off Camanche Parkway North & Coal Mine Road, south of Ione',
    Longitude: -120.90265,
    MajorIncident: 'True',
    Name: 'Camanche Fire',
    Started: '2016-06-17T14:54:00Z',
    UniqueId: 'fef2ab8a-20d7-4dc3-b5c9-363aa1debef3'
  },
  {
    AcresBurned: 188,
    AdminUnit: 'CAL FIRE Fresno County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/11/big-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2016-07-13T17:30:00Z',
    Latitude: 36.92244,
    Location: 'off Watts Valley Rd. & Big Springs Ln, east of Clovis',
    Longitude: -119.39619,
    MajorIncident: 'False',
    Name: 'Big Fire',
    Started: '2016-07-11T14:30:00Z',
    UniqueId: '4cfb8712-1b45-4a2e-b0c9-6ed6ddde5657'
  },
  {
    AcresBurned: 176,
    AdminUnit: 'CAL FIRE Amador- El Dorado Unit / USFS El Dorado National Forest / Lake Valley Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/10/14/emerald-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2016-10-17T11:45:00Z',
    Latitude: 38.93449,
    Location: 'off Highway 89, near Cascade Lake and Emerald Bay.',
    Longitude: -120.10744,
    MajorIncident: 'True',
    Name: 'Emerald Fire',
    Started: '2016-10-14T01:28:00Z',
    UniqueId: '81ef7517-ab3c-4d1a-8ddd-b5d69404676f'
  },
  {
    AcresBurned: 173,
    AdminUnit: 'CAL FIRE Riverside County Fire Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/12/briggs-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2016-07-15T08:00:00Z',
    Latitude: 0,
    Location: 'off Briggs Rd & Louis Rd in Romoland',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Briggs Fire',
    Started: '2016-07-12T15:20:00Z',
    UniqueId: '89d10422-494e-4b60-8d52-07995447b12e'
  },
  {
    AcresBurned: 169,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/17/athens-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '2016-05-19T18:00:00Z',
    Latitude: 38.8390117,
    Location: 'Off Athens Ave & Industrial Blvd, south of Lincoln',
    Longitude: -121.3090268,
    MajorIncident: 'False',
    Name: 'Athens Fire',
    Started: '2016-05-17T15:06:00Z',
    UniqueId: 'e0de216a-9544-43ad-9b9f-bc05247f0550'
  },
  {
    AcresBurned: 158,
    AdminUnit: 'CAL FIRE / Fresno County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/3/sunny-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2016-09-06T18:15:00Z',
    Latitude: 36.84479,
    Location: 'off Sunnyslope Rd & Lakeside Ln near the Pine Flat Lake Reservoir',
    Longitude: -119.34487,
    MajorIncident: 'True',
    Name: 'Sunny Fire',
    Started: '2016-09-03T14:44:00Z',
    UniqueId: '63643257-f082-4928-bf0e-77a0417a4613'
  },
  {
    AcresBurned: 156,
    AdminUnit: 'LA County Fire Department/Angeles National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/5/23/wheatland-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2016-05-25T18:45:00Z',
    Latitude: 34.276,
    Location: 'Hwy 210 and Wheatland Ave, southeast of Lake View Terrace',
    Longitude: -118.354,
    MajorIncident: 'False',
    Name: 'Wheatland Fire',
    Started: '2016-05-23T14:15:00Z',
    UniqueId: 'ace1f464-7a70-4dcc-b8c5-d64fb1021d0e'
  },
  {
    AcresBurned: 151,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/4/28/hills-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2016-04-29T17:15:00Z',
    Latitude: 0,
    Location: 'four miles Northwest of Panoche and Interstate 5',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Hills Fire',
    Started: '2016-04-28T17:45:00Z',
    UniqueId: 'f12c92df-003f-42bc-9cb0-a15323f4166c'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'Stanislaus National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/9/13/old-fire/',
    Counties: 'Del Norte',
    CountyIds: 8,
    Extinguished: '2016-09-17T18:00:00Z',
    Latitude: 37.75972,
    Location: 'off Old Yosemite Rd, 8 miles east of Greeley Hill',
    Longitude: -120.029626,
    MajorIncident: 'False',
    Name: 'Old Fire',
    Started: '2016-09-13T13:55:00Z',
    UniqueId: 'f66ae0d0-837d-4ea9-a7ed-6a78d9bde940'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'Cleveland National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/8/31/holy-fire/',
    Counties: 'Orange',
    CountyIds: 30,
    Extinguished: '2016-09-05T06:55:00Z',
    Latitude: 33.6542,
    Location: 'off Trabuco Creek Rd near Holy Jim Trail',
    Longitude: -117.5221,
    MajorIncident: 'False',
    Name: 'Holy Fire',
    Started: '2016-08-31T04:10:00Z',
    UniqueId: 'd045584a-8838-4d64-91dc-3ebfbcd8e708'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/10/shedd-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2016-05-10T18:45:00Z',
    Latitude: 35.61961,
    Location: 'Wood Canyon Rd & Hwy 41',
    Longitude: -120.39993,
    MajorIncident: 'False',
    Name: 'Shedd Fire',
    Started: '2016-05-10T16:11:00Z',
    UniqueId: '1d76ca50-aa10-4f90-bd99-a80bcf2eacce'
  },
  {
    AcresBurned: 147,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/20/bird-fire/',
    Counties: 'San Joaquin',
    CountyIds: 39,
    Extinguished: '2016-08-20T18:45:00Z',
    Latitude: 37.62215,
    Location: 'off of Bird Rd & I-580, south of Tracy',
    Longitude: -121.36665,
    MajorIncident: 'False',
    Name: 'Bird Fire',
    Started: '2016-08-20T08:35:00Z',
    UniqueId: '86166c24-3a85-42e3-a53a-ebb1d935fb8a'
  },
  {
    AcresBurned: 145,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/4/frame-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2016-07-07T19:00:00Z',
    Latitude: 36.14161,
    Location: 'Hwy 198 and Frame Ln, 14 miles west of Coalinga',
    Longitude: -120.62048,
    MajorIncident: 'False',
    Name: 'Frame Fire',
    Started: '2016-07-04T17:15:00Z',
    UniqueId: 'e55dd16e-1712-4b97-a2f3-add0877b98cd'
  },
  {
    AcresBurned: 140,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/4/maze-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2016-08-04T20:00:00Z',
    Latitude: 0,
    Location: 'off of Maze & Kasson, west of Modesto',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Maze Fire',
    Started: '2016-08-04T15:45:00Z',
    UniqueId: '380634ff-2fe6-48b0-a1f6-97a889551d2f'
  },
  {
    AcresBurned: 139,
    AdminUnit: 'CAL FIRE Riverside County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/4/temecula-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2016-06-07T18:15:00Z',
    Latitude: 33.476894,
    Location: 'Off I-15 south of Temecula Parkway',
    Longitude: -117.140883,
    MajorIncident: 'True',
    Name: 'Temecula Fire',
    Started: '2016-06-04T11:40:00Z',
    UniqueId: '403e6185-c0e1-4b8f-a290-b50553a47b67'
  },
  {
    AcresBurned: 138,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/15/famoso-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2016-07-16T07:40:00Z',
    Latitude: 35.60748,
    Location: 'off Granite Rd & Famoso Rd, 15 miles east of Famoso',
    Longitude: -118.94811,
    MajorIncident: 'False',
    Name: 'Famoso Fire',
    Started: '2016-07-15T23:55:00Z',
    UniqueId: '73083049-8bc2-4444-911b-f3d0812fb70c'
  },
  {
    AcresBurned: 132,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/15/avocado-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2016-05-17T19:10:00Z',
    Latitude: 36.78769,
    Location: 'Off Piedra Rd near Kings River, 10 miles northeast of Sanger',
    Longitude: -119.38248,
    MajorIncident: 'False',
    Name: 'Avocado Fire',
    Started: '2016-05-15T16:38:00Z',
    UniqueId: 'f1769b9d-c522-4a0d-92a7-f9c8321b9f1d'
  },
  {
    AcresBurned: 130,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/22/bangor-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2016-09-23T10:30:00Z',
    Latitude: 39.4403,
    Location: 'off Oro-Bangor Highway & Swedes Flat, 7 miles SE of Oroville',
    Longitude: -121.42647,
    MajorIncident: 'False',
    Name: 'Bangor Fire',
    Started: '2016-09-22T11:45:00Z',
    UniqueId: 'b4940174-75d0-4f5e-b505-4a66c17a9157'
  },
  {
    AcresBurned: 123,
    AdminUnit: 'CAL FIRE Fresno County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/15/green-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2016-07-16T18:00:00Z',
    Latitude: 37.0099,
    Location: 'off Auberry Rd & White Thorne Rd, near Prather',
    Longitude: -119.5792,
    MajorIncident: 'True',
    Name: 'Green Fire',
    Started: '2016-07-15T16:45:00Z',
    UniqueId: 'a32de567-3d32-434a-9128-7947deaec3bb'
  },
  {
    AcresBurned: 122,
    AdminUnit: 'Inyo National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/8/5/rock-creek-fire/',
    Counties: 'Mono',
    CountyIds: 26,
    Extinguished: '2016-08-07T19:33:00Z',
    Latitude: 0,
    Location: 'southeast of Mammoth Lakes and a mile north of the community of Swall Meadows.',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Rock Creek Fire',
    Started: '2016-08-05T15:45:00Z',
    UniqueId: '0539e095-5108-4b9a-8736-65772440e9e8'
  },
  {
    AcresBurned: 120,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/7/coe-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2016-06-09T17:10:00Z',
    Latitude: 37.17072,
    Location: 'Henry W. Coe State Park, Del Puerto Canyon, 20 miles west of Gustine (Stanislaus Co.)',
    Longitude: -121.42238,
    MajorIncident: 'False',
    Name: 'Coe Fire',
    Started: '2016-06-07T16:30:00Z',
    UniqueId: '648cfdd4-f3f5-4faf-8ab1-a6f2cb5d9a6c'
  },
  {
    AcresBurned: 114,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/30/sierra-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2016-07-31T18:30:00Z',
    Latitude: 37.41896,
    Location: 'Off Sierra Rd & Calaveras Rd, Spring Valley',
    Longitude: -121.79669,
    MajorIncident: 'False',
    Name: 'Sierra Fire',
    Started: '2016-07-30T17:25:00Z',
    UniqueId: '4c88252e-34a5-4912-a590-2c4539866c62'
  },
  {
    AcresBurned: 112,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/20/coal-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2016-06-20T19:50:00Z',
    Latitude: 39.595,
    Location: 'Off Coal Canyon Rd & Hwy 70, north of Oroville',
    Longitude: -121.6008,
    MajorIncident: 'False',
    Name: 'Coal Fire',
    Started: '2016-06-20T16:38:00Z',
    UniqueId: '5f422963-a30c-4cda-9427-7a0e028b6039'
  },
  {
    AcresBurned: 103,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/4/broken-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2016-07-06T20:00:00Z',
    Latitude: 37.25601,
    Location: 'Hwy 41 and Hummingbird Ln, One mile east of Coarsgold',
    Longitude: -119.65776,
    MajorIncident: 'False',
    Name: 'Broken Fire',
    Started: '2016-07-04T11:53:00Z',
    UniqueId: '8e920d15-72f4-4e76-a3b4-22a364d6cf19'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/25/cow-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2016-09-25T13:15:00Z',
    Latitude: 40,
    Location: 'off Whitmore Road and Old Cow Creek Road',
    Longitude: -121.93923,
    MajorIncident: 'False',
    Name: 'Cow Fire',
    Started: '2016-09-25T07:15:00Z',
    UniqueId: '8a4c92b3-c1aa-41e0-aaed-999d73f0a418'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE San Mateo-Santa Clara Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/17/bailey-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2016-08-18T19:50:00Z',
    Latitude: 0,
    Location: 'Hwy 101 & Bailey Rd, South San Jose',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Bailey Fire',
    Started: '2016-08-17T15:19:00Z',
    UniqueId: '40dec759-8a09-439c-8c95-14b4a248c033'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/4/hart-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2016-08-07T20:15:00Z',
    Latitude: 35.24504,
    Location: 'off Hwy 58 and Hart Flat Rd, Tehachapi',
    Longitude: -118.60344,
    MajorIncident: 'False',
    Name: 'Hart Fire',
    Started: '2016-08-04T17:10:00Z',
    UniqueId: 'f645bf93-57a3-4fdf-9544-d255f8311dc9'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/3/diablo-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2016-08-04T07:45:00Z',
    Latitude: 0,
    Location: 'Off Diablo Grande Parkway and Morton Davis Circle, 9 miles SW of Patterson',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Diablo Fire',
    Started: '2016-08-03T16:08:00Z',
    UniqueId: 'e952af56-3233-4e53-b611-d437220ea750'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/22/bradley-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2016-07-23T08:45:00Z',
    Latitude: 35.85093,
    Location: 'off Highway 101 and San Antonio River, south of Bradley',
    Longitude: -120.81081,
    MajorIncident: 'False',
    Name: 'Bradley Fire',
    Started: '2016-07-22T15:15:00Z',
    UniqueId: '947aab39-3d8a-4841-8fc3-d129d8bbf6a3'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE San Diego',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/18/feather-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2016-07-20T13:45:00Z',
    Latitude: 32.9612,
    Location: 'off of El Capitan Truck Trail, south of Ramona',
    Longitude: -116.7945,
    MajorIncident: 'False',
    Name: 'Feather Fire',
    Started: '2016-07-18T13:08:00Z',
    UniqueId: 'd96a2f4f-8e4d-4534-abe2-d90530e2bbc3'
  },
  {
    AcresBurned: 95,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/9/mercury-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2016-07-10T19:30:00Z',
    Latitude: 5487,
    Location: 'off of New Idria Rd & Panoche Rd, south of Mercey Hot Springs',
    Longitude: -120.841536,
    MajorIncident: 'False',
    Name: 'Mercury Fire',
    Started: '2016-07-09T12:43:00Z',
    UniqueId: '2a04ab08-1412-4a3d-b6b2-7e5fc48f99e5'
  },
  {
    AcresBurned: 91,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/27/dunstone-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2016-05-27T17:00:00Z',
    Latitude: 39.33035,
    Location: 'La Porte Road at Dunstone Road, west of Bangor',
    Longitude: -121.78973,
    MajorIncident: 'False',
    Name: 'Dunstone Fire',
    Started: '2016-05-27T13:43:00Z',
    UniqueId: '5080eb51-53e5-4338-95ec-618efe2bd7d1'
  },
  {
    AcresBurned: 88,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/26/santos-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2016-08-30T18:40:00Z',
    Latitude: 39.79547,
    Location: 'off Hwy 32 at Santos Ranch Rd, south of Forest Ranch',
    Longitude: -121.71662,
    MajorIncident: 'True',
    Name: 'Santos Fire',
    Started: '2016-08-26T15:30:00Z',
    UniqueId: 'c55cc099-43f6-4a55-81b4-59ee03618511'
  },
  {
    AcresBurned: 88,
    AdminUnit: 'CAL FIRE Tehama-Glen Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/1/flores-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2016-07-01T17:45:00Z',
    Latitude: 40.07846,
    Location: 'Interstate 5 & Flores Ave, 5 miles south of Red Bluff',
    Longitude: -122.2071,
    MajorIncident: 'False',
    Name: 'Flores Fire',
    Started: '2016-07-01T13:54:00Z',
    UniqueId: 'f88a7291-9122-49fa-864d-b807fa360393'
  },
  {
    AcresBurned: 88,
    AdminUnit: 'CAL FIRE Nevada Yuba Placer Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/21/moore-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '2016-06-21T15:45:00Z',
    Latitude: 38.86804,
    Location: 'off Moore Rd and South Dowd Rd, west of Lincoln',
    Longitude: -121.37704,
    MajorIncident: 'False',
    Name: 'Moore Fire',
    Started: '2016-06-21T12:24:00Z',
    UniqueId: 'd570e949-a098-4af0-84a4-d70c4a0e89c9'
  },
  {
    AcresBurned: 87,
    AdminUnit: 'CAL FIRE Amador-Eldorado Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/10/scott-fire/',
    Counties: 'Sacramento',
    CountyIds: 34,
    Extinguished: '2016-07-11T06:35:00Z',
    Latitude: 38.517772,
    Location: 'off of Scotts Road and Latrobe Road, Rancho Murrieta',
    Longitude: -121.103642,
    MajorIncident: 'False',
    Name: 'Scott Fire',
    Started: '2016-07-10T15:30:00Z',
    UniqueId: 'fbe85bec-6399-442f-8a3f-ca4a25bb2b3b'
  },
  {
    AcresBurned: 86,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/27/frazier-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2016-06-29T17:00:00Z',
    Latitude: 35.70821,
    Location: 'off Nacimiento Lake Dr. and Frazier Rd.',
    Longitude: -120.82266,
    MajorIncident: 'False',
    Name: 'Frazier Fire',
    Started: '2016-06-27T12:07:00Z',
    UniqueId: '42fbaa73-e3c8-44ac-bf83-a576be6a804f'
  },
  {
    AcresBurned: 85,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/4/grub-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2016-08-06T19:50:00Z',
    Latitude: 37.3228,
    Location: 'off of Grub Gulch Road and Acton Grade Road, west of Oakhurst',
    Longitude: -119.7738,
    MajorIncident: 'False',
    Name: 'Grub Fire',
    Started: '2016-08-04T14:13:00Z',
    UniqueId: '8505d2db-7c6f-445e-9bff-407e99cac614'
  },
  {
    AcresBurned: 85,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/30/tulloch-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2016-06-01T19:45:00Z',
    Latitude: 37.927613,
    Location: 'off New Peoria Flat Road and Old Melones Road, west of Sonora',
    Longitude: -120.528836,
    MajorIncident: 'True',
    Name: 'Tulloch Fire',
    Started: '2016-05-30T15:10:00Z',
    UniqueId: 'ffec404e-dea9-4175-8c50-8f2b0ca3efdd'
  },
  {
    AcresBurned: 84,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/15/dunnigan-fire/',
    Counties: 'Yolo',
    CountyIds: 57,
    Extinguished: '2016-07-15T15:40:00Z',
    Latitude: 38.8866,
    Location: 'off County Road 86 & County Road 6, west of Dunnigan',
    Longitude: -122.04726,
    MajorIncident: 'False',
    Name: 'Dunnigan Fire',
    Started: '2016-07-15T14:00:00Z',
    UniqueId: 'b6b6ef56-0d7f-4c97-b072-74b712aa1e65'
  },
  {
    AcresBurned: 83,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/15/cheyenne-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2016-06-16T10:00:00Z',
    Latitude: 0,
    Location: 'off Cheyenne Way, south of Camanche Reservoir',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Cheyenne Fire',
    Started: '2016-06-15T12:46:00Z',
    UniqueId: 'a56880f1-16c0-4d23-8f5a-b9ac436694bb'
  },
  {
    AcresBurned: 83,
    AdminUnit: 'CAL FIRE San Benito Monterey Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/12/old-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2016-06-12T15:45:00Z',
    Latitude: 36.49914,
    Location: 'off Old Hernandez Road, five miles east of Pinnacles National Park',
    Longitude: -121.04993,
    MajorIncident: 'False',
    Name: 'Old Fire',
    Started: '2016-06-12T12:45:00Z',
    UniqueId: 'fb7d6492-444e-420c-9111-0f8999d3af04'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/3/baker-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2016-08-04T07:50:00Z',
    Latitude: 40.19611,
    Location: 'Off Baker Rd & Plymire Rd, 2 miles NW of Red Bluff',
    Longitude: -122.26736,
    MajorIncident: 'False',
    Name: 'Baker Fire',
    Started: '2016-08-03T17:27:00Z',
    UniqueId: '140161a1-ca06-448a-87f2-27e688b2d922'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/21/serpa-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2016-07-25T19:20:00Z',
    Latitude: 0,
    Location: 'off Hwy 41 northeast of Coarsegold',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Serpa Fire',
    Started: '2016-07-21T12:53:00Z',
    UniqueId: '3e9fd887-dc53-4d90-a8b4-492670fcab8f'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE Tehama Glenn Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/11/hoag-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2016-06-11T16:15:00Z',
    Latitude: 39.7947,
    Location: 'off Corning Road and Gaylord Avenue, east of Corning',
    Longitude: -121.857,
    MajorIncident: 'False',
    Name: 'Hoag Fire',
    Started: '2016-06-11T14:30:00Z',
    UniqueId: '10a8344d-e2c6-4585-8094-bbb30e48db8c'
  },
  {
    AcresBurned: 78,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/13/sherwood-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2016-07-15T14:00:00Z',
    Latitude: 36.92244,
    Location: 'near Lake Sherwood, southwest of Thousand Oaks',
    Longitude: -119.39619,
    MajorIncident: 'False',
    Name: 'Sherwood Fire',
    Started: '2016-07-13T15:52:00Z',
    UniqueId: '69b7a19e-7be7-43c1-8779-c7110b22f552'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit / Shasta Lake City Fire Department',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/10/lake-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2016-09-12T19:00:00Z',
    Latitude: 40.68192,
    Location: 'off of Lake Blvd south of Shasta Dam Blvd, Shasta Lake City',
    Longitude: -122.4096,
    MajorIncident: 'False',
    Name: 'Lake Fire',
    Started: '2016-09-10T15:45:00Z',
    UniqueId: '47ee7239-2bc9-4794-8582-982a92fdda9f'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'CAL FIRE Fresno-Kings unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/23/newmark-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2016-09-24T20:00:00Z',
    Latitude: 36.6543,
    Location: 'off Newmark Ave. and Fantz Ave., 3 miles southeast of Sanger',
    Longitude: -119.5327,
    MajorIncident: 'False',
    Name: 'Newmark Fire',
    Started: '2016-09-23T12:40:00Z',
    UniqueId: '2e8eb057-1d9a-41a7-ab9f-9b85ce3374c4'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/18/arroyo-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2016-06-20T18:15:00Z',
    Latitude: 36.2833,
    Location: 'Arroyo Seco Rd &  Elm Ave, E of Greenfield',
    Longitude: -121.3306,
    MajorIncident: 'False',
    Name: 'Arroyo Fire',
    Started: '2016-06-18T16:47:00Z',
    UniqueId: 'ae6a40fa-c0f3-460b-8e19-fbf4b5803bb8'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/31/pala-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2016-06-07T06:45:00Z',
    Latitude: 33.41639,
    Location: 'in the 38000 block of Pala Temecula Road, Temecula',
    Longitude: -117.08829,
    MajorIncident: 'True',
    Name: 'Pala Fire',
    Started: '2016-05-31T13:48:00Z',
    UniqueId: 'c88af25d-aff4-4b20-9c58-0b819c8ae99a'
  },
  {
    AcresBurned: 69,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/19/foothill-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2016-07-22T18:15:00Z',
    Latitude: 39.0863,
    Location: 'off Foothill Drive, community of Lucerne',
    Longitude: -122.7891,
    MajorIncident: 'True',
    Name: 'Foothill Fire',
    Started: '2016-07-19T17:16:00Z',
    UniqueId: '6a75dc36-9f37-4c3a-870d-345f94a8104c'
  },
  {
    AcresBurned: 65,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/10/10/creek-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2016-10-12T18:00:00Z',
    Latitude: 38.40958,
    Location: 'Dry Creek Road 3 miles west of Yountville',
    Longitude: -122.43172,
    MajorIncident: 'True',
    Name: 'Creek Fire',
    Started: '2016-10-10T16:13:00Z',
    UniqueId: '3135c367-1274-4cc4-9152-661f6fd7707e'
  },
  {
    AcresBurned: 61,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/6/11/cotton-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2016-06-12T12:30:00Z',
    Latitude: 35.77135,
    Location: 'off Highway 41, one mile east of the county line',
    Longitude: -120.251,
    MajorIncident: 'False',
    Name: 'Cotton Fire',
    Started: '2016-06-11T15:04:00Z',
    UniqueId: 'bae93037-2a91-4189-b256-3325cd2b6979'
  },
  {
    AcresBurned: 57,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit/Vacaville Fire Department',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/22/oak-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2016-07-22T16:07:00Z',
    Latitude: 38.33475,
    Location: 'off Cherry Glen Rd and Oak Canyon Ln, south of Vacaville',
    Longitude: -122.02564,
    MajorIncident: 'False',
    Name: 'Oak Fire',
    Started: '2016-07-22T13:01:00Z',
    UniqueId: 'dc7637b2-fa97-47c7-bbce-c0fd1a015592'
  },
  {
    AcresBurned: 57,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/21/baker-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2016-07-22T19:00:00Z',
    Latitude: 37.98171,
    Location: 'off Baker St & School St near Copperopolis',
    Longitude: -120.64241,
    MajorIncident: 'True',
    Name: 'Baker Fire',
    Started: '2016-07-21T15:06:00Z',
    UniqueId: '2dae3029-2d17-445a-9fac-e95345b179e0'
  },
  {
    AcresBurned: 56,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/19/mill-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2016-05-21T19:00:00Z',
    Latitude: 0,
    Location: 'Old Dump Road/T-3 Road, 2 miles east of Weed',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Mill Fire',
    Started: '2016-05-19T15:37:00Z',
    UniqueId: '89ca911c-b44f-40d4-b10e-0a7ae0ca33b7'
  },
  {
    AcresBurned: 52,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/23/lowe-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2016-06-24T18:20:00Z',
    Latitude: 36.1934,
    Location: 'East of King City',
    Longitude: -120.9293,
    MajorIncident: 'False',
    Name: 'Lowe Fire',
    Started: '2016-06-23T17:57:00Z',
    UniqueId: '61556003-7789-4b9e-8f16-5563624b4621'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/10/ruff-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2016-09-15T09:10:00Z',
    Latitude: 39.7299,
    Location: 'off of Hwy 101 and Woodruff Rd, north of Laytonville',
    Longitude: -123.5044,
    MajorIncident: 'False',
    Name: 'Ruff Fire',
    Started: '2016-09-10T14:06:00Z',
    UniqueId: '2a2e0af5-24d7-4903-bab4-3705f5d788fb'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'San Bernardino County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/7/spring-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2016-09-09T06:00:00Z',
    Latitude: 34.3183,
    Location: 'off of Hwy 138 & Los Flores Rd, south of Hesperia',
    Longitude: -117.3189,
    MajorIncident: 'False',
    Name: 'Spring Fire',
    Started: '2016-09-07T16:53:00Z',
    UniqueId: '324a3c48-efcc-4385-ab87-baf0b5e29b5d'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/22/storksbill-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2016-07-23T18:00:00Z',
    Latitude: 38.79549,
    Location: 'off Storksbill Rd in Pilot Hill',
    Longitude: -121.00299,
    MajorIncident: 'True',
    Name: 'Storksbill Fire',
    Started: '2016-07-22T13:15:00Z',
    UniqueId: 'f273dffb-e1eb-48dc-b0f9-908857e78095'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/4/28/casitas-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2016-04-30T07:00:00Z',
    Latitude: 0,
    Location: 'near Casitas Vista and Ventura Avenue, south of Casitas Springs',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Casitas Fire',
    Started: '2016-04-28T19:00:00Z',
    UniqueId: '867bead0-b6a5-4ec4-a4de-83af2e854cd1'
  },
  {
    AcresBurned: 49,
    AdminUnit: 'CAL FIRE Butte County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/21/70-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2016-06-21T16:30:00Z',
    Latitude: 39.43351,
    Location: 'off Highway 70 at Palermo Rd.',
    Longitude: -121.6051,
    MajorIncident: 'False',
    Name: '70 Fire',
    Started: '2016-06-21T15:09:00Z',
    UniqueId: '6b542aff-fa1b-46fc-b3da-26c1afdbc446'
  },
  {
    AcresBurned: 47,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit / Grass Valley Fire Department',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/17/auburn-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2016-09-20T18:00:00Z',
    Latitude: 39.20427,
    Location: 'Off South Auburn Street and Whiting Street, Grass Valley',
    Longitude: -121.05948,
    MajorIncident: 'False',
    Name: 'Auburn Fire',
    Started: '2016-09-17T13:40:00Z',
    UniqueId: '1f8b3267-c3bd-43f5-9733-2b30c97d45ee'
  },
  {
    AcresBurned: 47,
    AdminUnit: 'Orange County Fire Authority',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/26/laguna-fire/',
    Counties: 'Orange',
    CountyIds: 30,
    Extinguished: '2016-06-29T18:30:00Z',
    Latitude: 33.57872,
    Location: 'n Laguna Coast Wilderness Park, 2½ miles northeast of Laguna Beach',
    Longitude: -117.77395,
    MajorIncident: 'False',
    Name: 'Laguna Fire',
    Started: '2016-06-26T13:10:00Z',
    UniqueId: 'c27c5212-1891-4105-86ee-9f97016ef159'
  },
  {
    AcresBurned: 45,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/23/bell-fire/',
    Counties: 'Amador',
    CountyIds: 3,
    Extinguished: '2016-09-25T17:45:00Z',
    Latitude: 38.5212,
    Location: 'off Hwy 49 and Bell Road, 4 miles north of Plymouth',
    Longitude: -120.8416,
    MajorIncident: 'True',
    Name: 'Bell Fire',
    Started: '2016-09-23T13:12:00Z',
    UniqueId: '0bf08653-1441-4e73-b24b-1296afb12b45'
  },
  {
    AcresBurned: 45,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/9/kugelman-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2016-08-10T17:00:00Z',
    Latitude: 36.09974,
    Location: 'off of Kugelman St and Hwy 53, community of Lower Lake',
    Longitude: -120.51057,
    MajorIncident: 'False',
    Name: 'Kugelman Fire',
    Started: '2016-08-09T17:30:00Z',
    UniqueId: '28b9dc5f-f9c0-41fb-81d6-8db562122f00'
  },
  {
    AcresBurned: 45,
    AdminUnit: 'Ventura County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/1/kuehner-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2016-07-01T19:50:00Z',
    Latitude: 34.27619,
    Location: 'off Hwy 118 at Rocky Peak Rd, NE Simi Valley',
    Longitude: -118.63264,
    MajorIncident: 'False',
    Name: 'Kuehner Fire',
    Started: '2016-07-01T14:00:00Z',
    UniqueId: '174608a2-14fd-4278-9811-cb7e5e5a3883'
  },
  {
    AcresBurned: 43,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/21/paskenta-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2016-06-21T13:00:00Z',
    Latitude: 39.93965,
    Location: 'off Paskenta Rd & Boggs and Chaplin Rd, 18 miles west of Corning',
    Longitude: -122.40142,
    MajorIncident: 'False',
    Name: 'Paskenta Fire',
    Started: '2016-06-21T10:26:00Z',
    UniqueId: 'b1b2a50c-c131-4be2-9398-8adee38c1c19'
  },
  {
    AcresBurned: 43,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/30/walker-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2016-06-04T17:00:00Z',
    Latitude: 0,
    Location: 'Jacobs Road, community of Caliente',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Walker Fire',
    Started: '2016-05-30T17:57:00Z',
    UniqueId: 'b5699308-b26c-4e76-9954-219b58468d8e'
  },
  {
    AcresBurned: 42,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/30/dockery-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2016-08-01T19:40:00Z',
    Latitude: 0,
    Location: 'off Hwy 36E & County Rd A1, west of Susanville',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Dockery Fire',
    Started: '2016-07-30T16:25:00Z',
    UniqueId: '17a944b9-c8b8-4486-8d71-89d713bd538b'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Amador- El Dorado Unit / Sac Metro Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/11/boys-fire/',
    Counties: 'Sacramento',
    CountyIds: 34,
    Extinguished: '2016-09-12T19:00:00Z',
    Latitude: 38.558,
    Location: 'off of Boys Ranch Road and Scott Road, northwest of Rancho Murieta',
    Longitude: -121.1309,
    MajorIncident: 'False',
    Name: 'Boys Fire',
    Started: '2016-09-11T11:25:00Z',
    UniqueId: '2d2aa30d-5c3f-4f46-97eb-54b63bec7f3a'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Riverside Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/28/evergreen-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2016-08-29T15:00:00Z',
    Latitude: 0,
    Location: 'off Evergreen Street in Lakeland Village near Lake Elsinore',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Evergreen Fire',
    Started: '2016-08-28T15:23:00Z',
    UniqueId: 'c531ed84-0c29-4d31-94cf-f48d71d96eed'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/24/franklin-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2016-07-24T19:00:00Z',
    Latitude: 38.01264,
    Location: 'Cummings Skyway & Franklin Canyon, 6 miles southeast of Rodeo',
    Longitude: -122.1885,
    MajorIncident: 'False',
    Name: 'Franklin Fire',
    Started: '2016-07-24T16:30:00Z',
    UniqueId: '416155ea-f8ff-43cf-abf0-e888584bf5bc'
  },
  {
    AcresBurned: 38,
    AdminUnit: 'Tahoe National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/9/7/phoenix-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '1969-12-31T16:00:00Z',
    Latitude: 39.39051,
    Location: 'west of Fordyce Lake near Soda Springs',
    Longitude: -120.51887,
    MajorIncident: 'False',
    Name: 'Phoenix Fire',
    Started: '2016-09-07T15:09:00Z',
    UniqueId: 'af8f8070-a3d6-4ca2-8e2b-6da1049a5bea'
  },
  {
    AcresBurned: 38,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/29/fork-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2016-07-31T18:55:00Z',
    Latitude: 37.24006,
    Location: 'Off Mammoth Pool Rd & Douglas Ranger Station Rd, east of North Fork',
    Longitude: -119.4741,
    MajorIncident: 'False',
    Name: 'Fork Fire',
    Started: '2016-07-29T17:55:00Z',
    UniqueId: '7066c984-1420-4c59-b175-9536da4c5d14'
  },
  {
    AcresBurned: 36,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/30/mina-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2016-08-31T07:15:00Z',
    Latitude: 39.8748511,
    Location: 'off Mina Rd & Trinity County Line, 12 miles northeast of Covelo',
    Longitude: -123.4267011,
    MajorIncident: 'False',
    Name: 'Mina Fire',
    Started: '2016-08-30T13:35:00Z',
    UniqueId: 'b44c3b1e-b243-455e-9ca9-9a1b5570e003'
  },
  {
    AcresBurned: 36,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/9/knoxville-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2016-08-10T17:00:00Z',
    Latitude: 38.68403,
    Location: 'Berryessa Knoxville Rd & East Side Rd, north of Lake Berryessa',
    Longitude: -122.26015,
    MajorIncident: 'False',
    Name: 'Knoxville Fire',
    Started: '2016-08-09T18:50:00Z',
    UniqueId: 'ef4185e8-9b3a-421f-9fae-a0b954b0b3c0'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/10/gopher-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2016-08-11T18:30:00Z',
    Latitude: 33.22558,
    Location: 'I-15 & Lawrence Welk Drive, Gopher Canyon',
    Longitude: -117.14547,
    MajorIncident: 'False',
    Name: 'Gopher Fire',
    Started: '2016-08-10T09:14:00Z',
    UniqueId: '4f623d67-d74b-4e8f-92f4-ed728970e20e'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/9/mountain-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2016-08-10T17:00:00Z',
    Latitude: 40.61213,
    Location: 'Near Iron Mountain Road, south of Keswick',
    Longitude: -122.47091,
    MajorIncident: 'False',
    Name: 'Mountain Fire',
    Started: '2016-08-09T12:14:00Z',
    UniqueId: '93995926-26b0-4158-9f93-fec263f40b47'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/28/neal-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2016-07-29T15:10:00Z',
    Latitude: 0,
    Location: 'Off Neal Rd east of Hwy 99e, south of Chico',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Neal Fire',
    Started: '2016-07-28T14:27:00Z',
    UniqueId: 'fe371090-80be-43fe-9d40-761fe436de7e'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE Tuolumne Calaveras Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/12/stagecoach-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2016-07-13T19:00:00Z',
    Latitude: 37.96311,
    Location: 'off Stagecoach Rd and Hwy 4, south of Copperopolis',
    Longitude: -120.67335,
    MajorIncident: 'False',
    Name: 'Stagecoach Fire',
    Started: '2016-07-12T15:19:00Z',
    UniqueId: 'eb9d05b5-7578-44bf-9eb1-3ddba425ff20'
  },
  {
    AcresBurned: 33,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/27/campo-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2016-06-30T07:00:00Z',
    Latitude: 38.22017,
    Location: 'off Campo Seco and Chili Camp Road, near Burson',
    Longitude: -120.8678,
    MajorIncident: 'False',
    Name: 'Campo Fire',
    Started: '2016-06-27T18:00:00Z',
    UniqueId: '2225d427-97d7-4d71-a83a-814f38a1c947'
  },
  {
    AcresBurned: 32,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/12/moffett-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2016-09-13T18:30:00Z',
    Latitude: 41.6314,
    Location: 'off of Moffett Creek Rd and Luce Gulch Rd, northeast of Fort Jones',
    Longitude: -122.7933,
    MajorIncident: 'False',
    Name: 'Moffett Fire',
    Started: '2016-09-12T16:28:00Z',
    UniqueId: 'ed16bf52-f886-4384-b841-2e755234aa29'
  },
  {
    AcresBurned: 32,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/30/frymire-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2016-08-01T08:05:00Z',
    Latitude: 37.81434,
    Location: 'Off Frymire Rd & Morrison Rd, east of Oakdale',
    Longitude: -120.69521,
    MajorIncident: 'False',
    Name: 'Frymire Fire',
    Started: '2016-07-30T17:25:00Z',
    UniqueId: 'f4026428-ad5a-42c7-b68e-959554a31343'
  },
  {
    AcresBurned: 32,
    AdminUnit: 'CAL FIRE Amador El-Dorado',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/3/clay-fire/',
    Counties: 'Sacramento',
    CountyIds: 34,
    Extinguished: '2016-06-03T19:55:00Z',
    Latitude: 38.3131,
    Location: 'off Highway 104 and Clay East Road near Herald',
    Longitude: -121.06452,
    MajorIncident: 'False',
    Name: 'Clay Fire',
    Started: '2016-06-03T16:57:00Z',
    UniqueId: 'c5d590f0-97fe-4ac3-987d-ebceed6dbfc2'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/16/old-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2016-09-19T18:30:00Z',
    Latitude: 39.8851,
    Location: 'Off of Old Chico Canyon, west of Forest Ranch',
    Longitude: -121.6998,
    MajorIncident: 'False',
    Name: 'Old Fire',
    Started: '2016-09-16T23:28:00Z',
    UniqueId: '69e1a36d-21ab-4feb-b31c-dbfac4bf62d1'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE San Bernardino Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/1/lone-pine-fire/',
    Counties: 'Inyo',
    CountyIds: 14,
    Extinguished: '2016-07-02T20:00:00Z',
    Latitude: 36.58972,
    Location: 'Whitney Portal Rd. and OlivasRanch Rd., 3 miles West of Lone Pine',
    Longitude: -118.15589,
    MajorIncident: 'False',
    Name: 'Lone Pine Fire',
    Started: '2016-07-01T12:56:00Z',
    UniqueId: '6f07d935-7d64-4be8-8e96-d34384686bf8'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE San Benito Monterey Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/3/hidden-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2016-06-03T17:30:00Z',
    Latitude: 36.80296,
    Location: 'off Hidden Valley Rd & Cienega Rd, southwest of Hollister',
    Longitude: -121.40304,
    MajorIncident: 'False',
    Name: 'Hidden Fire',
    Started: '2016-06-03T17:39:00Z',
    UniqueId: 'a757d4f9-2aa1-44c8-b986-ac00ca2fafdd'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/29/70-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2016-05-29T19:53:00Z',
    Latitude: 39.624017,
    Location: 'Hwy 70 between Clark Rd and Wheelock Rd',
    Longitude: -121.595093,
    MajorIncident: 'True',
    Name: '70 Fire',
    Started: '2016-05-29T16:51:00Z',
    UniqueId: '6227f4ad-3e40-4f3b-b210-3e55483e1e84'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/4/24/taglio-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2016-04-24T15:30:00Z',
    Latitude: 37.2171,
    Location: 'I-5 & Taglio Road, east of Gustine',
    Longitude: -121.08036,
    MajorIncident: 'False',
    Name: 'Taglio Fire',
    Started: '2016-04-24T11:10:00Z',
    UniqueId: '7106ba43-100b-41f9-acbf-9fb9e9ab9ef7'
  },
  {
    AcresBurned: 28,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/11/13/gopher-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2016-11-14T18:00:00Z',
    Latitude: 33.254355,
    Location: 'Off Gopher Canyon & Interstate 15',
    Longitude: -117.158475,
    MajorIncident: 'False',
    Name: 'Gopher Fire',
    Started: '2016-11-13T11:14:00Z',
    UniqueId: '6f600260-2bdb-4f53-9d1a-eab8afb3a11a'
  },
  {
    AcresBurned: 28,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/22/rock-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2016-07-24T14:30:00Z',
    Latitude: 33.00056,
    Location: 'off Highway 67 & Rockhouse Road, near Ramona',
    Longitude: -116.9571,
    MajorIncident: 'True',
    Name: 'Rock Fire',
    Started: '2016-07-22T14:47:00Z',
    UniqueId: '0b655a9d-94b3-4095-acfd-d40ac8347318'
  },
  {
    AcresBurned: 26,
    AdminUnit: 'CAL FIRE Amador - El Dorado Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/5/deer-fire/',
    Counties: 'Amador',
    CountyIds: 3,
    Extinguished: '2016-08-06T10:06:00Z',
    Latitude: 38.2581,
    Location: 'off of Deer Ridge Lane and Buena Vista Road, north of Valley Springs',
    Longitude: -120.8657,
    MajorIncident: 'True',
    Name: 'Deer Fire',
    Started: '2016-08-05T13:49:00Z',
    UniqueId: '38fe21ed-2019-4be9-abdf-bf46ac5f59e3'
  },
  {
    AcresBurned: 26,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/19/bailey-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2016-07-20T09:00:00Z',
    Latitude: 41.96191,
    Location: 'Hwy 5 at Bailey Hill, 2 mi southeast of Hilt',
    Longitude: -122.59328,
    MajorIncident: 'False',
    Name: 'Bailey Fire',
    Started: '2016-07-19T14:09:00Z',
    UniqueId: 'be2805af-a801-4ca9-b9e7-14f3b896097e'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/9/1/oak-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2016-09-02T06:55:00Z',
    Latitude: 37.11831,
    Location: 'Off Oak Glen Ave, 2 miles west of Morgan Hill',
    Longitude: -121.69784,
    MajorIncident: 'False',
    Name: 'Oak Fire',
    Started: '2016-09-01T14:36:00Z',
    UniqueId: 'e935ecb3-5eba-43f8-ae02-624b3d5bc03a'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/12/oak-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2016-08-14T19:50:00Z',
    Latitude: 37.06531,
    Location: 'off Uvas Rd & Watsonville Rd. west of Morgan Hill',
    Longitude: -121.68577,
    MajorIncident: 'False',
    Name: 'Oak Fire',
    Started: '2016-08-12T16:00:00Z',
    UniqueId: 'b82b0e22-4155-43dd-ac33-1da015b6d3d2'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'El Dorado National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/8/6/alder-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2016-08-07T19:18:00Z',
    Latitude: 0,
    Location: 'off of Hwy 50 at Riverton, west of Kyburz',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Alder Fire',
    Started: '2016-08-06T15:00:00Z',
    UniqueId: 'd15f161e-b69d-4e4e-9e8c-da869ebc805f'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/29/north-branch-extension-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2016-07-31T18:50:00Z',
    Latitude: 0,
    Location: 'Off Ogulin Rd & Highway 53, Clearlake Oaks',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'North Branch Extension Fire',
    Started: '2016-07-29T14:55:00Z',
    UniqueId: 'bff80dce-32ca-4aa1-a542-f1ee5b9affc1'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Amador El-Dorado',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/3/aukum-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2016-06-04T15:30:00Z',
    Latitude: 38.64107,
    Location: 'off Mount Aukum Road & Grizzly Flat Road',
    Longitude: -120.6955,
    MajorIncident: 'True',
    Name: 'Aukum Fire',
    Started: '2016-06-03T12:41:00Z',
    UniqueId: 'f2b5faf1-9ff0-48b7-8151-25880262bec1'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/12/bryson-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2016-05-12T20:45:00Z',
    Latitude: 35.8378273,
    Location: 'Bryson-Hesperia Rd & Interlake Rd, west of Bradley',
    Longitude: -121.0381507,
    MajorIncident: 'False',
    Name: 'Bryson Fire',
    Started: '2016-05-12T14:13:00Z',
    UniqueId: 'afaa2efe-d946-4ff9-93c2-459aad31b908'
  },
  {
    AcresBurned: 24,
    AdminUnit: 'CAL FIRE Shasta Trinity Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/6/11/keswick-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2016-06-12T15:00:00Z',
    Latitude: 40.61388,
    Location: 'near Keswick Dam Road x Iron Mountain Road N/W of Redding',
    Longitude: -122.46777,
    MajorIncident: 'False',
    Name: 'Keswick Fire',
    Started: '2016-06-11T16:02:00Z',
    UniqueId: '20e4887c-b772-460d-98be-d60f39171aeb'
  },
  {
    AcresBurned: 23,
    AdminUnit: 'CAL FIRE Humboldt-Del Norte',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/11/stafford-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2016-08-16T08:45:00Z',
    Latitude: 40.4572,
    Location: 'Community of Stafford, 7 miles south of Fortuna',
    Longitude: -124.05804,
    MajorIncident: 'False',
    Name: 'Stafford Fire',
    Started: '2016-08-11T14:57:00Z',
    UniqueId: 'bc2fd9c2-da5c-4cd7-bbec-9daf2143a196'
  },
  {
    AcresBurned: 23,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/21/table-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2016-07-22T12:00:00Z',
    Latitude: 41.71847,
    Location: 'Table Rock Rd & Harry Cash Rd, Montague',
    Longitude: -122.36924,
    MajorIncident: 'False',
    Name: 'Table Fire',
    Started: '2016-07-21T20:30:00Z',
    UniqueId: '5d276af0-17d5-47d5-8f0e-86756d91b5c6'
  },
  {
    AcresBurned: 21,
    AdminUnit: 'CAL FIRE Humboldt-Del Norte',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/12/summit-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2016-08-19T08:30:00Z',
    Latitude: 40.9878,
    Location: 'Three Creeks Summit and Bair Rd. 8 miles west of Willow Creek',
    Longitude: -123.77832,
    MajorIncident: 'False',
    Name: 'Summit Fire',
    Started: '2016-08-12T17:23:00Z',
    UniqueId: '861bfbd3-ce1c-46bd-a32b-2848b7399119'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/9/3/ken-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2016-09-04T18:55:00Z',
    Latitude: 34.25858,
    Location: 'Off I-15 Between Kenwood and Blue Cut in the Cajon Pass',
    Longitude: -117.4415,
    MajorIncident: 'False',
    Name: 'Ken Fire',
    Started: '2016-09-03T21:51:00Z',
    UniqueId: '383c3df6-a1eb-40fd-b798-41481dff679a'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/30/mockingbird-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2016-08-31T07:05:00Z',
    Latitude: 39.1408865,
    Location: 'Off Hwy 29 & Mockingbird Lane, Upper Lake',
    Longitude: -122.9148951,
    MajorIncident: 'False',
    Name: 'Mockingbird Fire',
    Started: '2016-08-30T16:54:00Z',
    UniqueId: '1780f987-76f9-4a82-81bd-6cb914758eec'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/12/edison-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2016-05-13T22:30:00Z',
    Latitude: 0,
    Location: 'North of Ventura',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Edison Fire',
    Started: '2016-05-12T14:13:00Z',
    UniqueId: '5ae9ec04-a2f4-4e18-8f6b-99c939eed64d'
  },
  {
    AcresBurned: 19,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/8/30/willow-fire/',
    Counties: 'Amador',
    CountyIds: 3,
    Extinguished: '2016-08-31T07:05:00Z',
    Latitude: 0,
    Location: 'Off Highway 124 & Willow Creek Rd, 4 miles east of Ione',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Willow Fire',
    Started: '2016-08-30T16:52:00Z',
    UniqueId: 'fa8a5b87-9f71-4b68-bd14-b751844d5676'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'Ventura County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/11/shelter-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2016-07-12T10:30:00Z',
    Latitude: 33.11645,
    Location: 'off Volcan Mountain, north of Julian',
    Longitude: -116.58542,
    MajorIncident: 'False',
    Name: 'Shelter Fire',
    Started: '2016-07-11T12:58:00Z',
    UniqueId: '7ebdcc3e-f402-4ab7-88d4-82d99d59b019'
  },
  {
    AcresBurned: 11,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/7/25/collier-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2016-07-26T19:25:00Z',
    Latitude: 0,
    Location: 'Off Collier Dr & Humboldt Dr, Rancho Tehama',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Collier Fire',
    Started: '2016-07-25T16:55:00Z',
    UniqueId: 'd35cfa9a-0087-4b24-ad22-6a738e633771'
  },
  {
    AcresBurned: 11,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2016,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2016/5/25/fiddler-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2016-05-25T20:00:00Z',
    Latitude: 0,
    Location: 'off Fiddler Rd and Straight Arrow Rd, 8 miles east of Ono',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Fiddler Fire',
    Started: '2016-05-25T16:51:00Z',
    UniqueId: '0e493de0-b544-4b10-a229-ea9da56bf621'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'Sequoia National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/10/20/jacobson-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2016-12-19T13:30:00Z',
    Latitude: 36.217,
    Location: 'Jacobson Drainage in the Golden Trout Wilderness',
    Longitude: -118.551,
    MajorIncident: 'False',
    Name: 'Jacobson Fire',
    Started: '2016-10-20T17:00:00Z',
    UniqueId: '2458cd6c-82d6-43ef-b509-706e3af69451'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Stanislaus National Forest',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/8/18/mokelumne-fire/',
    Counties: 'Alpine',
    CountyIds: 2,
    Extinguished: '2016-08-30T12:05:00Z',
    Latitude: 38.57554,
    Location: 'Mokelumne Wilderness',
    Longitude: -120.00606,
    MajorIncident: 'False',
    Name: 'Mokelumne Fire',
    Started: '2016-08-18T12:05:00Z',
    UniqueId: '5823867d-c458-4673-858f-0ded99b6121f'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Los Angeles Fire Department',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/7/22/sand-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2016-08-09T17:15:00Z',
    Latitude: 0,
    Location: 'near 14 Fwy & Sand Canyon Rd, Santa Clarita',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Sand Fire',
    Started: '2016-07-22T14:11:00Z',
    UniqueId: 'bb4feaa5-4afc-47fb-82b3-c3aed84c3c31'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Bureau of Land Management',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/6/4/soda-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2016-06-19T08:30:00Z',
    Latitude: 35.01382,
    Location: 'Off Soda Lake Road north of Cuyama',
    Longitude: -119.58206,
    MajorIncident: 'False',
    Name: 'Soda Fire',
    Started: '2016-06-04T17:46:00Z',
    UniqueId: '5c86c26b-e6c0-4e47-90b7-bc5da3885ebe'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Los Angeles County Fire Department',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/6/4/old-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2016-06-13T12:30:00Z',
    Latitude: 0,
    Location: 'off of Old Topanga Canyon Road and Mulholland Hwy, Calabasas',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Old Fire',
    Started: '2016-06-04T16:09:00Z',
    UniqueId: 'd0ffe734-daf1-4446-af7d-4f8fde2802b7'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Bureau of Land Management',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/6/1/chimney-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2016-06-19T18:00:00Z',
    Latitude: 35.84883,
    Location: '15 miles northeast of Kernville',
    Longitude: -118.08591,
    MajorIncident: 'False',
    Name: 'Chimney Fire',
    Started: '2016-06-01T15:35:00Z',
    UniqueId: '6afa1ccf-e1b6-492b-bcaa-9189cd3487aa'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Los Angeles County Fire',
    ArchiveYear: 2016,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2016/4/19/gorman-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2016-04-19T15:30:00Z',
    Latitude: 34.6888731,
    Location: 'off northbound Interstate 5 at Gorman Creek',
    Longitude: -118.7892593,
    MajorIncident: 'False',
    Name: 'Gorman Fire',
    Started: '2016-04-19T13:09:00Z',
    UniqueId: '2c77fa07-73e6-45fe-a527-5bd526bdef41'
  },
  // {
  //   AcresBurned: 281893,
  //   AdminUnit: 'US Forest Service - Los Padres National Forest',
  //   ArchiveYear: 2017,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2017/12/4/thomas-fire/',
  //   Counties: 'Santa Barbara',
  //   CountyIds: 4256,
  //   Extinguished: '2019-03-14T11:24:00Z',
  //   Latitude: 34.41521,
  //   Location: 'Hwy 150 and Hwy 126, north of Santa Paula',
  //   Longitude: -119.09124,
  //   MajorIncident: 'True',
  //   Name: 'Thomas Fire',
  //   Started: '2017-12-04T18:28:00Z',
  //   UniqueId: 'd28bc34e-73a8-454d-9e55-dea7bdd40bee'
  // },
  {
    AcresBurned: 281893,
    AdminUnit: 'US Forest Service - Los Padres National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/12/4/thomas-fire/',
    Counties: 'Ventura',
    CountyIds: 4256,
    Extinguished: '2019-03-14T11:24:00Z',
    Latitude: 34.41521,
    Location: 'Hwy 150 and Hwy 126, north of Santa Paula',
    Longitude: -119.09124,
    MajorIncident: 'True',
    Name: 'Thomas Fire',
    Started: '2017-12-04T18:28:00Z',
    UniqueId: 'd28bc34e-73a8-454d-9e55-dea7bdd40bee'
  },
  {
    AcresBurned: 83733,
    AdminUnit: 'Bureau of Land Management',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/11/long-valley-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2018-01-09T11:52:00Z',
    Latitude: 40.07045,
    Location: 'off Hwy 395 and Cowboy Joe Rd, 3 miles north of Doyle',
    Longitude: -120.14013,
    MajorIncident: 'False',
    Name: 'Long Valley Fire',
    Started: '2017-07-11T14:15:00Z',
    UniqueId: 'f7b03fae-de58-4674-9f4f-d3e9d2762d84'
  },
  {
    AcresBurned: 83120,
    AdminUnit: 'Modoc National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/24/modoc-july-complex/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2018-01-09T12:05:00Z',
    Latitude: 0,
    Location: 'throughout Modoc County',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Modoc July Complex',
    Started: '2017-07-24T12:00:00Z',
    UniqueId: '8caf9d17-d9c3-42e4-a622-30799080c4b9'
  },
  {
    AcresBurned: 81826,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/16/detwiler-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2018-01-09T11:57:00Z',
    Latitude: 37.61757,
    Location: 'Detwiler Rd and Hunters Valley Rd, 2 miles east of Lake McClure',
    Longitude: -120.21321,
    MajorIncident: 'True',
    Name: 'Detwiler Fire',
    Started: '2017-07-16T15:56:00Z',
    UniqueId: '9feb25c4-d3ae-4f78-9fc9-a1ad2b308e42'
  },
  {
    AcresBurned: 78698,
    AdminUnit: 'Klamath National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/15/eclipse-complex/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T12:43:00Z',
    Latitude: 41.841,
    Location: '5 miles W of Happy Camp, CA',
    Longitude: -123.474,
    MajorIncident: 'False',
    Name: 'Eclipse Complex',
    Started: '2017-08-15T07:55:00Z',
    UniqueId: '490ae25d-c3d8-4a90-9e75-0ad85e0f629f'
  },
  // {
  //   AcresBurned: 56556,
  //   AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
  //   ArchiveYear: 2017,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2017/10/8/nuns-adobe-norrbom-pressley-partrick-fires-oakmont-central-lnu-complex/',
  //   Counties: 'Napa',
  //   CountyIds: 2849,
  //   Extinguished: '2018-02-09T09:30:00Z',
  //   Latitude: 38.4041,
  //   Location: 'Hwy 12, north of Glen Ellen',
  //   Longitude: -122.5209,
  //   MajorIncident: 'True',
  //   Name: 'Nuns / Adobe / Norrbom/ Pressley / Partrick Fires / Oakmont (Central LNU Complex)',
  //   Started: '2017-10-08T22:00:00Z',
  //   UniqueId: 'be79d28c-767d-4a0d-b168-e86a5842004f'
  // },
  {
    AcresBurned: 56556,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/8/nuns-adobe-norrbom-pressley-partrick-fires-oakmont-central-lnu-complex/',
    Counties: 'Sonoma',
    CountyIds: 2849,
    Extinguished: '2018-02-09T09:30:00Z',
    Latitude: 38.4041,
    Location: 'Hwy 12, north of Glen Ellen',
    Longitude: -122.5209,
    MajorIncident: 'True',
    Name: 'Nuns / Adobe / Norrbom/ Pressley / Partrick Fires / Oakmont (Central LNU Complex)',
    Started: '2017-10-08T22:00:00Z',
    UniqueId: 'be79d28c-767d-4a0d-b168-e86a5842004f'
  },
  // {
  //   AcresBurned: 51624,
  //   AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
  //   ArchiveYear: 2017,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2017/10/8/atlas-fire-southern-lnu-complex/',
  //   Counties: 'Napa',
  //   CountyIds: 2848,
  //   Extinguished: '2018-02-09T09:37:00Z',
  //   Latitude: 38.39206,
  //   Location: 'Off of Altas Peak Rd, south of Lake Berryessa',
  //   Longitude: -122.24367,
  //   MajorIncident: 'True',
  //   Name: 'Atlas Fire (Southern LNU Complex)',
  //   Started: '2017-10-08T21:52:00Z',
  //   UniqueId: '676946dc-1b38-4a09-9bbe-9ce638cfed52'
  // },
  {
    AcresBurned: 51624,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/8/atlas-fire-southern-lnu-complex/',
    Counties: 'Solano',
    CountyIds: 2848,
    Extinguished: '2018-02-09T09:37:00Z',
    Latitude: 38.39206,
    Location: 'Off of Altas Peak Rd, south of Lake Berryessa',
    Longitude: -122.24367,
    MajorIncident: 'True',
    Name: 'Atlas Fire (Southern LNU Complex)',
    Started: '2017-10-08T21:52:00Z',
    UniqueId: '676946dc-1b38-4a09-9bbe-9ce638cfed52'
  },
  {
    AcresBurned: 48889,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/9/garza-fire/',
    Counties: 'Kings',
    CountyIds: 16,
    Extinguished: '2018-01-09T11:51:00Z',
    Latitude: 35.93273,
    Location: 'Tar Canyon Road, near Avenal',
    Longitude: -120.20014,
    MajorIncident: 'True',
    Name: 'Garza Fire',
    Started: '2017-07-09T15:10:00Z',
    UniqueId: '6ee351a7-9382-48bc-a161-b417f7560ff9'
  },
  {
    AcresBurned: 39715,
    AdminUnit: 'Rogue River-Siskiyou National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/14/miller-complex/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T12:42:00Z',
    Latitude: 42.039,
    Location: '17 miles east of Cave Junction, Oregon',
    Longitude: -123.218,
    MajorIncident: 'False',
    Name: 'Miller Complex',
    Started: '2017-08-14T14:00:00Z',
    UniqueId: 'd43c681d-b57e-47e6-a6ad-e3ed08de9ff7'
  },
  // {
  //   AcresBurned: 36807,
  //   AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
  //   ArchiveYear: 2017,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2017/10/8/tubbs-fire-central-lnu-complex/',
  //   Counties: 'Napa',
  //   CountyIds: 2849,
  //   Extinguished: '2018-02-09T09:27:00Z',
  //   Latitude: 38.60895,
  //   Location: 'off of Hwy 128 and Bennett Ln, Calistoga',
  //   Longitude: -122.62879,
  //   MajorIncident: 'True',
  //   Name: 'Tubbs Fire (Central LNU Complex)',
  //   Started: '2017-10-08T21:45:00Z',
  //   UniqueId: '82c2aafa-ef04-49f0-a172-0dfa8a15582e'
  // },
  {
    AcresBurned: 36807,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/8/tubbs-fire-central-lnu-complex/',
    Counties: 'Sonoma',
    CountyIds: 2849,
    Extinguished: '2018-02-09T09:27:00Z',
    Latitude: 38.60895,
    Location: 'off of Hwy 128 and Bennett Ln, Calistoga',
    Longitude: -122.62879,
    MajorIncident: 'True',
    Name: 'Tubbs Fire (Central LNU Complex)',
    Started: '2017-10-08T21:45:00Z',
    UniqueId: '82c2aafa-ef04-49f0-a172-0dfa8a15582e'
  },
  {
    AcresBurned: 36556,
    AdminUnit: 'CAL FIRE Tulare Unit / USFS - Sequoia National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/29/pier-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2018-01-09T12:47:00Z',
    Latitude: 36.15356,
    Location: 'Highway 190, east of Springville',
    Longitude: -118.74103,
    MajorIncident: 'True',
    Name: 'Pier Fire',
    Started: '2017-08-29T08:29:00Z',
    UniqueId: 'c8ebf0c1-e560-4e22-a946-129af8699dfb'
  },
  {
    AcresBurned: 36523,
    AdminUnit: 'CAL FIRE Mendocinio Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/8/redwood-valley-fire-mendocino-lake-complex/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2018-02-09T08:56:00Z',
    Latitude: 39.24873,
    Location: 'North of Hwy 20, west of Mendocino National Forest, south of Black Bart',
    Longitude: -123.16635,
    MajorIncident: 'True',
    Name: 'Redwood Valley Fire (Mendocino Lake Complex)',
    Started: '2017-10-08T23:36:00Z',
    UniqueId: 'c229ea5c-2ebd-4f80-892e-fc5da8a1eeea'
  },
  {
    AcresBurned: 28687,
    AdminUnit: 'Unified Command: CAL FIRE San Luis Obispo Unit / Santa Barbara County / Los Padres National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/6/alamo-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T11:46:00Z',
    Latitude: 35.0179,
    Location: 'Off Highway 166 near Twitchell Reservoir',
    Longitude: -120.3223,
    MajorIncident: 'True',
    Name: 'Alamo Fire',
    Started: '2017-07-06T15:44:00Z',
    UniqueId: '5a43b164-04d0-46ea-992e-ea5aa283305f'
  },
  {
    AcresBurned: 27276,
    AdminUnit: 'Six Rivers National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/26/orleans-complex/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T12:07:00Z',
    Latitude: 41.59,
    Location: 'About 18 miles northwest of Orleans, California in Siskiyou County.',
    Longitude: -123.501,
    MajorIncident: 'False',
    Name: 'Orleans Complex',
    Started: '2017-07-26T18:00:00Z',
    UniqueId: '51bf0e2a-7f1f-4fe1-aeaa-70510ad42d0e'
  },
  {
    AcresBurned: 21846,
    AdminUnit: 'Shasta-Trinity National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/30/helena-fork-fire/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2018-01-09T12:49:00Z',
    Latitude: 40.76025,
    Location: 'Hwy 299 near town of Helena, Junction City',
    Longitude: -123.10003,
    MajorIncident: 'False',
    Name: 'Helena - Fork Fire',
    Started: '2017-08-30T18:00:00Z',
    UniqueId: '220a986e-6d2c-4893-9473-232d1e1abf0c'
  },
  {
    AcresBurned: 18900,
    AdminUnit: 'USFS - Sequoia National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/9/27/lion-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2018-01-09T13:27:00Z',
    Latitude: 36.27138,
    Location: 'Golden Trout Wilderness near Lion Meadow.',
    Longitude: -118.48555,
    MajorIncident: 'False',
    Name: 'Lion Fire',
    Started: '2017-09-27T14:00:00Z',
    UniqueId: 'f2e55878-e387-412b-a067-dadc649bed43'
  },
  {
    AcresBurned: 18618,
    AdminUnit: 'BLM Northern California District',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/30/r-4-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2018-01-09T12:48:00Z',
    Latitude: 40.69573,
    Location: '23 miles east-southeast of Madeline',
    Longitude: -119.93499,
    MajorIncident: 'False',
    Name: 'R-4 Fire',
    Started: '2017-08-30T08:30:00Z',
    UniqueId: '49757269-445f-4525-8698-858d8e0a5398'
  },
  {
    AcresBurned: 18430,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/8/whittier-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2018-01-09T11:49:00Z',
    Latitude: 34.55096,
    Location: 'Lake Cachuma area, south of Hwy 154',
    Longitude: -119.9494,
    MajorIncident: 'False',
    Name: 'Whittier Fire',
    Started: '2017-07-08T13:43:00Z',
    UniqueId: 'dfd1e0d9-42b5-436a-aa83-ffcbbb7a6145'
  },
  {
    AcresBurned: 17357,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/9/pocket-fire-central-lnu-complex/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2018-02-09T09:32:00Z',
    Latitude: 38.76549,
    Location: 'off of Pocket Ranch Rd and Ridge Ranch Rd, Geyserville',
    Longitude: -122.90939,
    MajorIncident: 'True',
    Name: 'Pocket Fire (Central LNU Complex)',
    Started: '2017-10-09T03:30:00Z',
    UniqueId: '0de36981-b31f-45c7-befd-1596f982e7db'
  },
  {
    AcresBurned: 16031,
    AdminUnit: 'Sequoia National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/6/24/schaeffer-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2018-01-09T11:01:00Z',
    Latitude: 0,
    Location: 'Within the 2002 McNally wildfire burn area (17 miles north of Kernville)',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Schaeffer Fire',
    Started: '2017-06-24T16:16:00Z',
    UniqueId: '0624b038-7a97-4294-a7b5-074e3dfa4fb7'
  },
  {
    AcresBurned: 15619,
    AdminUnit: 'Angeles National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/12/5/creek-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2018-08-06T10:52:00Z',
    Latitude: 34.31283,
    Location: 'Kagel Canyon Rd, north of Lake View terrace',
    Longitude: -118.35863,
    MajorIncident: 'True',
    Name: 'Creek Fire',
    Started: '2017-12-05T03:44:00Z',
    UniqueId: 'a245b55b-3eb7-49dd-9a5e-909d53854055'
  },
  {
    AcresBurned: 13417,
    AdminUnit: 'Shasta Trinity National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/9/12/buck-fire/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2018-01-09T13:21:00Z',
    Latitude: 40.2275,
    Location: 'Black Rock Mountain, North Portion of Yolla BollyWilderness',
    Longitude: -123.03583,
    MajorIncident: 'False',
    Name: 'Buck Fire',
    Started: '2017-09-12T17:42:00Z',
    UniqueId: '7cc06465-bf2a-4df2-a68d-5f330e1cea42'
  },
  {
    AcresBurned: 12407,
    AdminUnit: 'USFS - Sierra National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/29/railroad-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2018-01-09T12:46:00Z',
    Latitude: 37.44663,
    Location: 'Highway 41, south of Fish Camp',
    Longitude: -119.64622,
    MajorIncident: 'False',
    Name: 'Railroad Fire',
    Started: '2017-08-29T12:19:00Z',
    UniqueId: '9989e07d-5125-472d-9601-0d7158b13073'
  },
  {
    AcresBurned: 10343,
    AdminUnit: 'CAL FIRE/Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/18/elm-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T10:04:00Z',
    Latitude: 36.12089,
    Location: 'off of Hwy 198 & Fire Stone, south of Coalinga',
    Longitude: -120.37116,
    MajorIncident: 'True',
    Name: 'Elm Fire',
    Started: '2017-05-18T13:11:00Z',
    UniqueId: '65062933-27cf-48d7-8e4c-9a7ac78e65ff'
  },
  {
    AcresBurned: 9989,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/8/cascade-fire-wind-complex/',
    Counties: 'Yuba',
    CountyIds: 58,
    Extinguished: '2018-02-09T09:39:00Z',
    Latitude: 39.32198,
    Location: 'Cascade Way and Marysville Rd, north of Collins Lake',
    Longitude: -121.4021,
    MajorIncident: 'True',
    Name: 'Cascade Fire (Wind Complex)',
    Started: '2017-10-08T23:03:00Z',
    UniqueId: '608ed849-d1ec-4b0d-a477-d1b8e9c7e6dd'
  },
  {
    AcresBurned: 9217,
    AdminUnit: 'Unified Command: CAL FIRE, Orange County, Anaheim City and Orange City',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/9/canyon-2-fire/',
    Counties: 'Orange',
    CountyIds: 30,
    Extinguished: '2018-04-05T10:47:00Z',
    Latitude: 33.87041,
    Location: 'Off of East Santa Ana Canyon Rd, west of Gypsum Canyon',
    Longitude: -117.70975,
    MajorIncident: 'True',
    Name: 'Canyon 2 Fire',
    Started: '2017-10-09T09:51:00Z',
    UniqueId: '969c721c-5f27-41d4-9a94-ffa12e351204'
  },
  {
    AcresBurned: 8925,
    AdminUnit: 'Bureau of Land Management - Owens Valley District',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/29/slinkard-fire/',
    Counties: 'Mono',
    CountyIds: 26,
    Extinguished: '2018-01-09T12:47:00Z',
    Latitude: 38.655,
    Location: 'West of Hwy 395, north of Hwy 89, south of Topaz',
    Longitude: -119.55425,
    MajorIncident: 'False',
    Name: 'Slinkard Fire',
    Started: '2017-08-29T15:15:00Z',
    UniqueId: '71ea2924-bc37-44f4-b454-47eff22e426c'
  },
  {
    AcresBurned: 8417,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/8/cherokee-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-02-09T09:48:00Z',
    Latitude: 39.62496,
    Location: 'off Cherokee Road and Zonalea Lane, Oroville',
    Longitude: -121.52966,
    MajorIncident: 'True',
    Name: 'Cherokee Fire',
    Started: '2017-10-08T21:45:00Z',
    UniqueId: 'adf929a5-d508-4f69-8845-8fa1df8d4f95'
  },
  {
    AcresBurned: 8094,
    AdminUnit: 'Yosemite National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/1/empire-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2018-01-09T12:16:00Z',
    Latitude: 37.644,
    Location: '1 Mile South of Bridalveil Campground in Yosemite',
    Longitude: -119.618,
    MajorIncident: 'False',
    Name: 'Empire Fire',
    Started: '2017-08-01T08:45:00Z',
    UniqueId: '2995e2b3-f18d-44ec-952f-9f148b8354d9'
  },
  {
    AcresBurned: 7697,
    AdminUnit: 'Modoc National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/3/parker-2-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2018-01-09T12:18:00Z',
    Latitude: 41.466,
    Location: 'southwest of Cedarville',
    Longitude: -120.321,
    MajorIncident: 'False',
    Name: 'Parker 2 Fire',
    Started: '2017-08-03T14:00:00Z',
    UniqueId: '3e005fd9-11a4-4145-a71f-8a4cf9a1341a'
  },
  {
    AcresBurned: 7194,
    AdminUnit: 'LA City, Burbank Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/9/1/la-tuna-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2018-01-09T12:49:00Z',
    Latitude: 34.22957,
    Location: 'Lowell Ave and I-210, Verdugo Hills, Los Angeles City',
    Longitude: -118.2674,
    MajorIncident: 'False',
    Name: 'La Tuna Fire',
    Started: '2017-09-01T13:26:00Z',
    UniqueId: 'c2bf9820-7e90-43c4-bd3d-1b26ef7ada51'
  },
  {
    AcresBurned: 7000,
    AdminUnit: 'Yosemite National Park',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/14/south-fork-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2018-01-09T12:39:00Z',
    Latitude: 37.538,
    Location: 'off Wawona Rd, east of Wawona',
    Longitude: -119.598,
    MajorIncident: 'False',
    Name: 'South Fork Fire',
    Started: '2017-08-14T14:28:00Z',
    UniqueId: 'b02ec4f1-ac5c-4b22-b7fa-5834af16d807'
  },
  {
    AcresBurned: 6309,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/26/manzanita-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T11:08:00Z',
    Latitude: 33.530045,
    Location: 'Hwy 79 North, Lambs Canyon south of Dump Road, south of Beaumont',
    Longitude: -116.594422,
    MajorIncident: 'False',
    Name: 'Manzanita Fire',
    Started: '2017-06-26T15:10:00Z',
    UniqueId: 'ca0c9a5f-7a1a-4903-b790-6eb3e85e7e64'
  },
  {
    AcresBurned: 6151,
    AdminUnit: 'CAL FIRE/Butte County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/9/laporte-fire-wind-complex/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-02-09T09:50:00Z',
    Latitude: 39.39455,
    Location: 'La Porte Rd and Oro Bangor Hwy, Bangor',
    Longitude: -121.40613,
    MajorIncident: 'True',
    Name: 'LaPorte Fire (Wind Complex)',
    Started: '2017-10-09T00:57:00Z',
    UniqueId: '4ca0e06c-4e6e-4e00-a4a4-6813e3200bd5'
  },
  {
    AcresBurned: 6049,
    AdminUnit: 'Unified Command: CAL FIRE, Los Angeles County Fire, Ventura County Fire, Los Angeles County Sheriff\'s Office, and Ventura County Sheriff\'s Office',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/12/5/rye-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2018-01-18T09:58:00Z',
    Latitude: 34.45283,
    Location: 'along Rye Canyon Loop, west Valencia',
    Longitude: -118.58188,
    MajorIncident: 'True',
    Name: 'Rye Fire',
    Started: '2017-12-05T11:31:00Z',
    UniqueId: '1e11fa40-e850-45d2-b65e-05aadc9f02f1'
  },
  {
    AcresBurned: 6042,
    AdminUnit: 'Bureau of Land Mangement',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/29/mud-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2018-01-09T12:47:00Z',
    Latitude: 40.43962,
    Location: 'Little Mud Flat, 18 miles northeast of Susanville',
    Longitude: -120.22215,
    MajorIncident: 'False',
    Name: 'Mud Fire',
    Started: '2017-08-29T14:36:00Z',
    UniqueId: 'b77ff66d-d8ee-49c9-bd0f-92a4350a095a'
  },
  {
    AcresBurned: 6033,
    AdminUnit: 'CAL FIRE Butte County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/7/wall-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-01-09T11:47:00Z',
    Latitude: 39.45352,
    Location: 'Chinese Wall Rd, north of Bangor',
    Longitude: -121.41222,
    MajorIncident: 'True',
    Name: 'Wall Fire',
    Started: '2017-07-07T14:52:00Z',
    UniqueId: '8816f0da-0818-499a-9ff6-ba4fd56ca7c8'
  },
  {
    AcresBurned: 5738,
    AdminUnit: 'CAL FIRE Fresno Kings Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/4/20/jayne-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T09:51:00Z',
    Latitude: 36.07228,
    Location: 'Off of Hwy 33 and Lost Hills south of Coalinga',
    Longitude: -120.26561,
    MajorIncident: 'True',
    Name: 'Jayne Fire',
    Started: '2017-04-20T15:40:00Z',
    UniqueId: '0cacf259-1ba3-4e8c-a938-feaab2655c4b'
  },
  {
    AcresBurned: 5247,
    AdminUnit: 'Stanislaus National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/31/summit-complex/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2018-01-09T12:15:00Z',
    Latitude: 38.329,
    Location: 'The Summit Complex consists of 3 fires burning on the Summit Ranger District of the Stanislaus National Forest.',
    Longitude: -119.782,
    MajorIncident: 'False',
    Name: 'Summit Complex',
    Started: '2017-07-31T13:44:00Z',
    UniqueId: '68328f20-5aed-404d-8c29-81b4b69e8439'
  },
  {
    AcresBurned: 4736,
    AdminUnit: 'Six Rivers National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/7/ruth-complex/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2018-01-09T12:27:00Z',
    Latitude: 40.17598,
    Location: 'Dutchman Rd, east of Zenia',
    Longitude: -123.36882,
    MajorIncident: 'False',
    Name: 'Ruth Complex',
    Started: '2017-08-07T22:30:00Z',
    UniqueId: '9eb07177-e62a-4f5a-adeb-e95508e31959'
  },
  {
    AcresBurned: 4310,
    AdminUnit: 'U.S. Forest Service - Plumas National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/29/minerva-fire/',
    Counties: 'Plumas',
    CountyIds: 32,
    Extinguished: '2018-01-09T12:08:00Z',
    Latitude: 39.9034,
    Location: 'Forest Road 24N26, 3 miles southwest of Quincy (Plumas County)',
    Longitude: -120.9761,
    MajorIncident: 'False',
    Name: 'Minerva Fire',
    Started: '2017-07-29T18:55:00Z',
    UniqueId: 'a95302d3-8574-4900-9d2a-daa33c55b70e'
  },
  {
    AcresBurned: 4100,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/12/7/lilac-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T13:47:00Z',
    Latitude: 33.3237,
    Location: 'Old Hwy 395 at Dulin Road, Bonsall',
    Longitude: -117.163,
    MajorIncident: 'True',
    Name: 'Lilac Fire',
    Started: '2017-12-07T11:15:00Z',
    UniqueId: 'fc4fcd00-8eee-43e5-b77f-bbd0c1669744'
  },
  {
    AcresBurned: 4016,
    AdminUnit: 'CAL FIRE / Butte County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/29/ponderosa-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-08-30T15:27:00Z',
    Latitude: 39.57701,
    Location: 'Ponderosa way and Lumpkin road, 2 miles NW of Forbestown',
    Longitude: -121.30209,
    MajorIncident: 'False',
    Name: 'Ponderosa Fire',
    Started: '2017-08-29T13:16:00Z',
    UniqueId: '7c9253af-4c43-41bb-b1de-44af15e0d83e'
  },
  {
    AcresBurned: 3874,
    AdminUnit: 'CAL FIRE Riverside Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/2/palmer-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T12:50:00Z',
    Latitude: 33.97471,
    Location: 'San Timoteo Canyon Road / Fisherman\'s Retreat, Beaumont',
    Longitude: -117.09984,
    MajorIncident: 'True',
    Name: 'Palmer Fire',
    Started: '2017-09-02T13:33:00Z',
    UniqueId: 'cfa04438-152b-4f4b-a712-4343af8c7fcf'
  },
  {
    AcresBurned: 3142,
    AdminUnit: 'Six Rivers National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/7/young-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T12:26:00Z',
    Latitude: 41.853,
    Location: 'Siskiyou Wilderness, Six Rivers NF',
    Longitude: -123.676,
    MajorIncident: 'False',
    Name: 'Young Fire',
    Started: '2017-08-07T17:45:00Z',
    UniqueId: '687e2987-2306-477b-bbaf-0d5465eb1e7c'
  },
  {
    AcresBurned: 2940,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/7/hawk-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T11:46:00Z',
    Latitude: 35.77896,
    Location: 'Hwy 155, north of Bakersfield',
    Longitude: -118.89627,
    MajorIncident: 'False',
    Name: 'Hawk Fire',
    Started: '2017-07-07T09:18:00Z',
    UniqueId: '1652d79a-f4fc-4151-a0d1-1b7366730f47'
  },
  {
    AcresBurned: 2662,
    AdminUnit: 'CAL FIRE Riverside / USFS / Orange County Fire Authority / Anaheim Fire / Corona Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/25/canyon-fire/',
    Counties: 'Orange',
    CountyIds: 30,
    Extinguished: '2018-03-28T11:36:00Z',
    Latitude: 33.8668,
    Location: 'CA-91 and Cole Canyon, City of Anaheim',
    Longitude: -117.68598,
    MajorIncident: 'False',
    Name: 'Canyon Fire',
    Started: '2017-09-25T13:03:00Z',
    UniqueId: '0176a674-c102-4854-92af-7d09aa3e1430'
  },
  {
    AcresBurned: 2575,
    AdminUnit: 'Plumas National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/9/5/eureka-fire/',
    Counties: 'Plumas',
    CountyIds: 32,
    Extinguished: '2018-01-09T13:18:00Z',
    Latitude: 39.75312,
    Location: 'McRae Meadows',
    Longitude: -120.75485,
    MajorIncident: 'False',
    Name: 'Eureka Fire',
    Started: '2017-09-05T18:38:00Z',
    UniqueId: '47988f74-d4bd-4ddd-814e-22ebc2ca5ccf'
  },
  {
    AcresBurned: 2312,
    AdminUnit: 'Kings County',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/24/i-5-fire/',
    Counties: 'Kings',
    CountyIds: 16,
    Extinguished: '2018-01-09T12:44:00Z',
    Latitude: 36.05187,
    Location: 'off I-5 & Quebec Ave, north of Avenal',
    Longitude: -120.05404,
    MajorIncident: 'False',
    Name: 'I-5 Fire',
    Started: '2017-08-24T18:13:00Z',
    UniqueId: '2f2a4afd-06f1-4b57-b3f2-db8e3d9ac05c'
  },
  {
    AcresBurned: 2295,
    AdminUnit: 'Inyo National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/2/indian-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2018-01-09T12:17:00Z',
    Latitude: 36.257,
    Location: 'North of Jordan Hot Springs',
    Longitude: -118.296,
    MajorIncident: 'False',
    Name: 'Indian Fire',
    Started: '2017-08-02T18:00:00Z',
    UniqueId: '345f6faa-9946-418e-8a60-d5cb9efb3af4'
  },
  {
    AcresBurned: 2289,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/30/roadrunner-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2018-01-09T12:15:00Z',
    Latitude: 36.0226,
    Location: 'Road 268 & E. Teapot Dome Ave., 4 miles east of Porterville',
    Longitude: -118.94252,
    MajorIncident: 'False',
    Name: 'Roadrunner Fire',
    Started: '2017-07-30T17:43:00Z',
    UniqueId: 'eff9d678-293f-43aa-96af-c5cf3203b31f'
  },
  {
    AcresBurned: 2269,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/6/winters-fire/',
    Counties: 'Yolo',
    CountyIds: 57,
    Extinguished: '2018-01-09T11:45:00Z',
    Latitude: 38.49521,
    Location: 'Hwy 128 and Pleasant View Rd, south west of Winters',
    Longitude: -122.0251,
    MajorIncident: 'True',
    Name: 'Winters Fire',
    Started: '2017-07-06T12:41:00Z',
    UniqueId: 'a7509e35-3083-4306-bcce-ebf6d101b62a'
  },
  {
    AcresBurned: 2207,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/8/sulphur-fire-mendocino-lake-complex/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2018-02-09T09:29:00Z',
    Latitude: 39.01387,
    Location: 'off Hwy 20 and Sulphur Bank Road, Clearlake Oaks',
    Longitude: -122.64543,
    MajorIncident: 'True',
    Name: 'Sulphur Fire (Mendocino Lake Complex)',
    Started: '2017-10-08T23:59:00Z',
    UniqueId: '0f32c2db-7d28-4cf6-85b8-44b53899c8eb'
  },
  {
    AcresBurned: 2056,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/20/gate-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T10:06:00Z',
    Latitude: 32.65597,
    Location: 'off of Hwy 94 and Otay Truck Trail, northwest of Dulzura',
    Longitude: -116.80527,
    MajorIncident: 'True',
    Name: 'Gate Fire',
    Started: '2017-05-20T23:19:00Z',
    UniqueId: 'c4d0a25f-02f6-4877-a944-8f5d50bf2335'
  },
  {
    AcresBurned: 1868,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/9/adobe-fire-central-lnu-complex/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2018-01-09T13:33:00Z',
    Latitude: 0,
    Location: 'near Kenwood',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Adobe Fire (Central LNU Complex)',
    Started: '2017-10-09T01:00:00Z',
    UniqueId: '9a5c9879-2e18-41a4-88d6-2360203dae79'
  },
  // {
  //   AcresBurned: 1816,
  //   AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
  //   ArchiveYear: 2017,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2017/7/8/parkfield-fire/',
  //   Counties: 'Monterey',
  //   CountyIds: 2740,
  //   Extinguished: '2018-01-09T11:50:00Z',
  //   Latitude: 35.86949,
  //   Location: 'Vineyard Canyon Rd, west of Parkfield',
  //   Longitude: -120.57894,
  //   MajorIncident: 'False',
  //   Name: 'Parkfield Fire',
  //   Started: '2017-07-08T18:30:00Z',
  //   UniqueId: 'a21faf4f-3628-4e24-ac64-8471d9d12560'
  // },
  {
    AcresBurned: 1816,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/8/parkfield-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 2740,
    Extinguished: '2018-01-09T11:50:00Z',
    Latitude: 35.86949,
    Location: 'Vineyard Canyon Rd, west of Parkfield',
    Longitude: -120.57894,
    MajorIncident: 'False',
    Name: 'Parkfield Fire',
    Started: '2017-07-08T18:30:00Z',
    UniqueId: 'a21faf4f-3628-4e24-ac64-8471d9d12560'
  },
  {
    AcresBurned: 1800,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/12/wright-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2018-01-09T09:56:00Z',
    Latitude: 36.96655,
    Location: 'Hwy 152 and Arburura Road, southwest of Los Banos',
    Longitude: -120.89261,
    MajorIncident: 'False',
    Name: 'Wright Fire',
    Started: '2017-05-12T15:30:00Z',
    UniqueId: '63a81990-8521-409d-9c22-92d1c33e0353'
  },
  {
    AcresBurned: 1749,
    AdminUnit: 'Stanislaus National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/9/3/creek-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2018-01-09T12:50:00Z',
    Latitude: 38.12,
    Location: 'Bourland area of the Stanislaus National Forest',
    Longitude: -119.941,
    MajorIncident: 'False',
    Name: 'Creek Fire',
    Started: '2017-09-03T16:23:00Z',
    UniqueId: '7f33fd28-9a93-438b-84ca-0e57e7c441f4'
  },
  {
    AcresBurned: 1660,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/9/37-fire/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2018-01-09T13:34:00Z',
    Latitude: 38.14242,
    Location: 'Hwy 37 & Lakeville Highway',
    Longitude: -122.47301,
    MajorIncident: 'False',
    Name: '37 Fire',
    Started: '2017-10-09T14:00:00Z',
    UniqueId: 'fe6e94d7-7b47-4992-9a52-787e1fad8171'
  },
  {
    AcresBurned: 1649,
    AdminUnit: 'CAL FIRE / Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/17/park-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T11:58:00Z',
    Latitude: 35.95911,
    Location: 'Parkfield Rd and Hwy 198, 7 miles west of Coalinga',
    Longitude: -120.55579,
    MajorIncident: 'True',
    Name: 'Park Fire',
    Started: '2017-07-17T13:15:00Z',
    UniqueId: 'f44aec62-5d1d-422f-9ff9-dbef80e4e27f'
  },
  {
    AcresBurned: 1626,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/6/quail-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T11:45:00Z',
    Latitude: 35.59904,
    Location: 'off Hwy 65 and Famoso Road east of Famoso',
    Longitude: -119.08312,
    MajorIncident: 'False',
    Name: 'Quail Fire',
    Started: '2017-07-06T12:29:00Z',
    UniqueId: 'ea019efb-52d2-4f08-8d04-20b680e2361b'
  },
  {
    AcresBurned: 1598,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/26/hill-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T11:08:00Z',
    Latitude: 35.4025,
    Location: 'Park Hill Road and La Entrada, east of Santa Margarita',
    Longitude: -120.4992,
    MajorIncident: 'True',
    Name: 'Hill Fire',
    Started: '2017-06-26T15:27:00Z',
    UniqueId: '81b37451-57b5-4050-a54d-e9750f84a567'
  },
  {
    AcresBurned: 1538,
    AdminUnit: 'CAL FIRE / Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/2/derrick-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T11:41:00Z',
    Latitude: 36.269125,
    Location: 'off Los Gatos Creek Rd, west of Coalinga',
    Longitude: -120.620791,
    MajorIncident: 'True',
    Name: 'Derrick Fire',
    Started: '2017-07-02T22:28:00Z',
    UniqueId: 'e3e75be1-8dea-4022-975b-34a0f25b57c0'
  },
  {
    AcresBurned: 1522,
    AdminUnit: 'Sequoia National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/6/18/highway-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T10:41:00Z',
    Latitude: 35.53456,
    Location: 'Democrat, west of Lake Isabella',
    Longitude: -118.66733,
    MajorIncident: 'False',
    Name: 'Highway Fire',
    Started: '2017-06-18T14:22:00Z',
    UniqueId: '1b01181e-fbcb-4dc4-86ec-cfddc864cc34'
  },
  {
    AcresBurned: 1503,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/6/19/holcomb-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T11:00:00Z',
    Latitude: 34.2976,
    Location: 'off Highway 18 & Holcomb Valley Rd, east of Big Bear Lake',
    Longitude: -116.826,
    MajorIncident: 'False',
    Name: 'Holcomb Fire',
    Started: '2017-06-19T15:05:00Z',
    UniqueId: 'b5dd68e2-ec95-47cd-a126-d5f6f0f2b49a'
  },
  {
    AcresBurned: 1431,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/10/oakwood-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2018-01-09T10:30:00Z',
    Latitude: 37.0825,
    Location: 'Oakwood Road and Road 406, northeast of Madera',
    Longitude: -119.8011,
    MajorIncident: 'True',
    Name: 'Oakwood Fire',
    Started: '2017-06-10T13:19:00Z',
    UniqueId: 'd11a4f65-9523-40d8-989a-6603705e9638'
  },
  {
    AcresBurned: 1350,
    AdminUnit: 'Sequoia National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/30/garden-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T12:14:00Z',
    Latitude: 35.543,
    Location: '1/2 mile west of USFS Democrat Fire Station, Kern River Ranger District',
    Longitude: -118.654,
    MajorIncident: 'False',
    Name: 'Garden Fire',
    Started: '2017-07-30T16:17:00Z',
    UniqueId: '0f4499f5-846c-4791-994e-81df04fe691a'
  },
  {
    AcresBurned: 1350,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/4/30/opera-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T09:53:00Z',
    Latitude: 34.00566,
    Location: 'off Opera Loop & East Palmyrita Avenue, in Highgrove',
    Longitude: -117.30693,
    MajorIncident: 'False',
    Name: 'Opera Fire',
    Started: '2017-04-30T15:23:00Z',
    UniqueId: 'c254df3f-a241-4983-a880-e12944a9f7b2'
  },
  {
    AcresBurned: 1319,
    AdminUnit: 'Sequoia National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/9/1/caldwell-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T12:50:00Z',
    Latitude: 35.76,
    Location: 'Kernville Rd. x Sierra Way, 6 miles north of Lake Isabella',
    Longitude: -118.406,
    MajorIncident: 'False',
    Name: 'Caldwell Fire',
    Started: '2017-09-01T14:37:00Z',
    UniqueId: '340e471a-a37e-47dd-90da-6c9f35b7eb3b'
  },
  {
    AcresBurned: 1286,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/26/latrobe-fire/',
    Counties: 'Sacramento',
    CountyIds: 34,
    Extinguished: '2018-01-09T12:06:00Z',
    Latitude: 38.5181,
    Location: 'Off Latrobe Rd & Scott Rd, near Rancho Murieta',
    Longitude: -121.104,
    MajorIncident: 'False',
    Name: 'Latrobe Fire',
    Started: '2017-07-26T14:45:00Z',
    UniqueId: '8cf9e7dc-74b9-4b97-9a03-f523f3eff56f'
  },
  {
    AcresBurned: 1200,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/30/tarina-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T11:16:00Z',
    Latitude: 35.38298,
    Location: 'Breckenridge Road, 3 miles east of Bakersfield',
    Longitude: -118.80123,
    MajorIncident: 'False',
    Name: 'Tarina Fire',
    Started: '2017-06-30T13:49:00Z',
    UniqueId: '4ac3161f-79e7-494f-88e4-72a69ef1d96b'
  },
  {
    AcresBurned: 1088,
    AdminUnit: 'DOD - Camp Pendleton',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/10/17/buffalo-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T13:41:00Z',
    Latitude: 33.402411,
    Location: 'Range 600, Case Springs Road, Camp Pendleton',
    Longitude: -117.402445,
    MajorIncident: 'False',
    Name: 'Buffalo Fire',
    Started: '2017-10-17T10:19:00Z',
    UniqueId: '081c7307-b328-4b64-869a-dce8718bab11'
  },
  {
    AcresBurned: 1083,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/18/hudson-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T11:59:00Z',
    Latitude: 34.94373,
    Location: 'Hudson Ranch Rd. and Hwy 166, south of Maricopa',
    Longitude: -119.44751,
    MajorIncident: 'False',
    Name: 'Hudson Fire',
    Started: '2017-07-18T11:45:00Z',
    UniqueId: '27759042-9df3-4d57-951e-f5727bcf013f'
  },
  {
    AcresBurned: 1044,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/13/blaine-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T12:38:00Z',
    Latitude: 33.98212,
    Location: 'Blaine Rd and Terrace Dr',
    Longitude: -117.30819,
    MajorIncident: 'True',
    Name: 'Blaine Fire',
    Started: '2017-08-13T16:10:00Z',
    UniqueId: 'c57ff6c2-e5df-48c5-831c-1dbad73df5ef'
  },
  {
    AcresBurned: 1035,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit / Sierra National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/3/mission-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2018-01-09T13:18:00Z',
    Latitude: 37.21616,
    Location: 'Mission Dr. and Italian Bar Rd., 2 miles east of North Fork',
    Longitude: -119.48067,
    MajorIncident: 'True',
    Name: 'Mission Fire',
    Started: '2017-09-03T13:06:00Z',
    UniqueId: '297d6516-ce4f-407d-93f8-9669dc6fd392'
  },
  {
    AcresBurned: 1020,
    AdminUnit: 'Tahoe National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/6/chilcoot-fire/',
    Counties: 'Plumas',
    CountyIds: 32,
    Extinguished: '2018-01-09T12:20:00Z',
    Latitude: 39.75371,
    Location: 'Chilcoot Ave, Chilcoot',
    Longitude: -120.1397,
    MajorIncident: 'False',
    Name: 'Chilcoot Fire',
    Started: '2017-08-06T15:32:00Z',
    UniqueId: 'd3213d2a-4b10-4eef-b8df-bdebc5cd948f'
  },
  {
    AcresBurned: 1000,
    AdminUnit: 'Camp Pendleton Marine Base',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/5/25/range-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T10:17:00Z',
    Latitude: 33.34988,
    Location: 'Basilone Road X Las Pulgas Road',
    Longitude: -117.39818,
    MajorIncident: 'False',
    Name: 'Range Fire',
    Started: '2017-05-25T18:15:00Z',
    UniqueId: 'bd671dbd-dd3c-413e-b453-4002e382325d'
  },
  {
    AcresBurned: 995,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/12/berry-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2018-01-09T13:21:00Z',
    Latitude: 40.98352,
    Location: 'off of Baker Rd, east of Big Bend',
    Longitude: -121.81623,
    MajorIncident: 'True',
    Name: 'Berry Fire',
    Started: '2017-09-12T06:58:00Z',
    UniqueId: '4a015862-8ac1-4c91-aa4c-c9831630b75a'
  },
  {
    AcresBurned: 976,
    AdminUnit: 'Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/4/28/el-dorado-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T09:52:00Z',
    Latitude: 36.530836,
    Location: 'El Dorado Ave & Kamm Ave, northeast of Coalinga',
    Longitude: -120.206592,
    MajorIncident: 'False',
    Name: 'El Dorado Fire',
    Started: '2017-04-28T15:40:00Z',
    UniqueId: '17a7d561-bee7-454d-a0aa-ac450907f6fd'
  },
  {
    AcresBurned: 900,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/16/grade-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2018-01-09T11:56:00Z',
    Latitude: 39.30125,
    Location: 'Hwy 101, 5 miles northwest of Redwood Valley',
    Longitude: -123.28825,
    MajorIncident: 'True',
    Name: 'Grade Fire',
    Started: '2017-07-16T14:51:00Z',
    UniqueId: '95cd2f17-1278-4cc9-90f4-000e4eba415a'
  },
  {
    AcresBurned: 867,
    AdminUnit: 'Unified Command: CAL FIRE Nevada-Yuba-Placer Unit/Beale Air Force Base',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/20/beale-fire/',
    Counties: 'Yuba',
    CountyIds: 58,
    Extinguished: '2018-01-09T12:43:00Z',
    Latitude: 39.1234,
    Location: 'Chuck Yeager Road, Beale Air Force Base',
    Longitude: -121.32957,
    MajorIncident: 'False',
    Name: 'Beale Fire',
    Started: '2017-08-20T14:44:00Z',
    UniqueId: 'f31a117a-572a-4956-9797-ad08e3933bb7'
  },
  {
    AcresBurned: 866,
    AdminUnit: 'Cleveland National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/26/wildomar-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T13:45:00Z',
    Latitude: 33.60247,
    Location: 'S Main Divide Rd and Wildomar OHV Park, west of Wildomar City',
    Longitude: -117.34192,
    MajorIncident: 'False',
    Name: 'Wildomar Fire',
    Started: '2017-10-26T12:34:00Z',
    UniqueId: '561d4f1b-0827-48a9-8034-e783d2761945'
  },
  {
    AcresBurned: 859,
    AdminUnit: 'Plumas National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/6/poslin-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2018-01-09T12:21:00Z',
    Latitude: 39.888,
    Location: 'Scott Rd, 9 miles south of Doyle',
    Longitude: -120.066,
    MajorIncident: 'False',
    Name: 'Poslin Fire',
    Started: '2017-08-06T19:52:00Z',
    UniqueId: '06664fe1-c56c-4a00-833c-f9f3f6d6d18f'
  },
  {
    AcresBurned: 821,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/9/lobo-fire-wind-complex/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2018-02-09T09:51:00Z',
    Latitude: 39.24549,
    Location: 'near Lone Lobo Trail, Rough and Ready',
    Longitude: -121.12792,
    MajorIncident: 'True',
    Name: 'Lobo Fire (Wind Complex)',
    Started: '2017-10-09T00:01:00Z',
    UniqueId: '29c37ab7-3af9-458f-b6d3-72023a8c1046'
  },
  {
    AcresBurned: 800,
    AdminUnit: 'Unified Command LA County Fire and USFS',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/6/17/lake-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2018-01-09T10:34:00Z',
    Latitude: 34.55607,
    Location: 'North side of Castaic Lake',
    Longitude: -118.60703,
    MajorIncident: 'False',
    Name: 'Lake Fire',
    Started: '2017-06-17T13:55:00Z',
    UniqueId: 'c982daaa-a785-4dfc-a366-1950974028af'
  },
  {
    AcresBurned: 775,
    AdminUnit: 'CAL FIRE San Luis Obispo/Department of Defense-Camp Roberts',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/11/yankee-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T12:36:00Z',
    Latitude: 35.7908,
    Location: 'Field Rd and Perimeter Rd at Training Area Yankee 6 in Camp Roberts',
    Longitude: -120.77485,
    MajorIncident: 'False',
    Name: 'Yankee Fire',
    Started: '2017-08-11T16:06:00Z',
    UniqueId: 'e6308517-0b7c-4efb-9369-b9aa3fe3ad14'
  },
  {
    AcresBurned: 760,
    AdminUnit: 'LA County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/6/25/placerita-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2018-01-09T11:08:00Z',
    Latitude: 34.37443,
    Location: 'Off Hwy 14 & Placerita Canyon Rd, in Santa Clarita',
    Longitude: -118.49343,
    MajorIncident: 'False',
    Name: 'Placerita Fire',
    Started: '2017-06-25T12:47:00Z',
    UniqueId: 'c940ef85-44ce-4684-bce3-7cbbf180cefb'
  },
  {
    AcresBurned: 747,
    AdminUnit: 'Humboldt-Toiyabe National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/10/farad-fire/',
    Counties: 'Sierra',
    CountyIds: 46,
    Extinguished: '2018-01-09T11:51:00Z',
    Latitude: 39.439722,
    Location: 'Hwy 80 and State Boundary, 12 miles northeast of Truckee',
    Longitude: -120.027222,
    MajorIncident: 'False',
    Name: 'Farad Fire',
    Started: '2017-07-10T13:02:00Z',
    UniqueId: '61cc4072-7db6-4fd2-bc9a-652728780c67'
  },
  {
    AcresBurned: 690,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/29/jacksonville-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2018-01-09T12:09:00Z',
    Latitude: 37.905545,
    Location: 'Jacksonville Road, south of Jamestown',
    Longitude: -120.408135,
    MajorIncident: 'True',
    Name: 'Jacksonville Fire',
    Started: '2017-07-29T13:50:00Z',
    UniqueId: '51e42770-97b4-4204-af57-8ab56992eb71'
  },
  {
    AcresBurned: 680,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/3/peak-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2018-01-09T12:51:00Z',
    Latitude: 37.37397,
    Location: 'Indian Peak Rd and Usona Rd, 9 miles southeast of Mariposa',
    Longitude: -119.83556,
    MajorIncident: 'True',
    Name: 'Peak Fire',
    Started: '2017-09-03T13:10:00Z',
    UniqueId: 'c7a0a280-17c9-409b-85f9-fdda301b6ede'
  },
  {
    AcresBurned: 670,
    AdminUnit: 'USFS - San Bernardino National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/6/27/mart-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T11:09:00Z',
    Latitude: 34.14575,
    Location: 'Highland Ave and City Creek Road, Highland',
    Longitude: -117.17813,
    MajorIncident: 'False',
    Name: 'Mart Fire',
    Started: '2017-06-27T15:22:00Z',
    UniqueId: 'a3159a43-d38c-4655-9acf-371bc9a6213b'
  },
  {
    AcresBurned: 630,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/28/ben-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2018-01-09T11:10:00Z',
    Latitude: 37.3762,
    Location: 'off Ben Hur Road and Silver Bar Road',
    Longitude: -119.9646,
    MajorIncident: 'True',
    Name: 'Ben Fire',
    Started: '2017-06-28T15:49:00Z',
    UniqueId: 'd36387df-af2a-4b20-a94f-589fdccf67cd'
  },
  {
    AcresBurned: 562,
    AdminUnit: 'Modoc National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/6/28/battle-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2018-01-09T11:10:00Z',
    Latitude: 41.85763,
    Location: 'Hwy 139 south of Newell, east of Tule Lake',
    Longitude: -121.29581,
    MajorIncident: 'False',
    Name: 'Battle Fire',
    Started: '2017-06-28T13:50:00Z',
    UniqueId: 'a0ba8679-406a-491b-a20b-bba55d63bc5b'
  },
  {
    AcresBurned: 545,
    AdminUnit: 'CAL FIRE Riverside Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/14/mias-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T12:42:00Z',
    Latitude: 33.95036,
    Location: 'Misa Canyon Road and Bluff Street',
    Longitude: -116.88066,
    MajorIncident: 'True',
    Name: 'Mias Fire',
    Started: '2017-08-14T15:45:00Z',
    UniqueId: 'c3ad74dc-6842-463f-8808-05161a8ba570'
  },
  {
    AcresBurned: 530,
    AdminUnit: 'Bureau of Land Management Northern California District',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/6/w-2-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2018-01-09T12:20:00Z',
    Latitude: 41.11989,
    Location: 'Ash Valley, 6 miles west of Madeline',
    Longitude: -120.74968,
    MajorIncident: 'False',
    Name: 'W-2 Fire',
    Started: '2017-08-06T15:29:00Z',
    UniqueId: '93fe220b-0458-4e26-827c-93883093681e'
  },
  {
    AcresBurned: 506,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/20/ming-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T10:07:00Z',
    Latitude: 35.4605,
    Location: 'Round Mountain Road and Amaya Court, north of Lake Ming',
    Longitude: -118.85896,
    MajorIncident: 'False',
    Name: 'Ming Fire',
    Started: '2017-05-20T14:23:00Z',
    UniqueId: '39967485-2cf1-4f0e-9cf1-ccfd25f6e2bf'
  },
  {
    AcresBurned: 486,
    AdminUnit: 'Camp Pendleton Marine Base',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/5/19/deluz-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T10:06:00Z',
    Latitude: 33.3906,
    Location: 'Camp Pendleton, north of India Training Area',
    Longitude: -117.32348,
    MajorIncident: 'False',
    Name: 'Deluz Fire',
    Started: '2017-05-19T14:45:00Z',
    UniqueId: '3d595f75-d59e-4453-b25c-48207b02f529'
  },
  {
    AcresBurned: 469,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/5/fay-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T11:44:00Z',
    Latitude: 41.3975,
    Location: 'Highway 3 & Fay Lane, south of Etna',
    Longitude: -122.8428,
    MajorIncident: 'True',
    Name: 'Fay Fire',
    Started: '2017-07-05T11:05:00Z',
    UniqueId: 'b383e4bd-6815-4624-936c-be57715ce50e'
  },
  {
    AcresBurned: 460,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit / Los Padres National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/2/red-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T12:17:00Z',
    Latitude: 35.40357,
    Location: 'Off Hwy 58 & Red Hill Rd, east of Wilson Corner',
    Longitude: -120.28037,
    MajorIncident: 'False',
    Name: 'Red Fire',
    Started: '2017-08-02T10:15:00Z',
    UniqueId: 'a1554868-0f98-41d4-9132-1f0bbf10b22c'
  },
  {
    AcresBurned: 460,
    AdminUnit: 'Unified Command: CAL FIRE San Bernardino-Inyo-Mono Unit, USFS - San Bernardino National Forest and City of Highland',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/14/bridge-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-04-12T14:52:00Z',
    Latitude: 34.09773,
    Location: 'off Greenspot Rd and Santa Ana Canyon Rd, Highland',
    Longitude: -117.10567,
    MajorIncident: 'False',
    Name: 'Bridge Fire',
    Started: '2017-07-14T14:23:00Z',
    UniqueId: '1348f32a-510f-4ad3-971f-b75b9cf9f0c0'
  },
  {
    AcresBurned: 450,
    AdminUnit: 'CAL FIRE/Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/11/monterey-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T10:30:00Z',
    Latitude: 36.616986,
    Location: 'off South Monterey Ave. & W South Ave., near Tranquillity',
    Longitude: -120.369347,
    MajorIncident: 'False',
    Name: 'Monterey Fire',
    Started: '2017-06-11T17:15:00Z',
    UniqueId: 'a9d270c5-aacb-4dad-a34e-ab28a7192248'
  },
  {
    AcresBurned: 444,
    AdminUnit: 'Santa Barbara County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/29/rucker-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2018-01-09T13:28:00Z',
    Latitude: 34.67403,
    Location: 'Rucker Rd and Purisima Rd, 2 miles north east of Lompoc',
    Longitude: -120.4393,
    MajorIncident: 'False',
    Name: 'Rucker Fire',
    Started: '2017-09-29T14:42:00Z',
    UniqueId: 'f839c34f-de3b-4e79-9b4f-e3502557d32b'
  },
  {
    AcresBurned: 429,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/18/eastman-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2018-01-09T13:21:00Z',
    Latitude: 37.14624,
    Location: 'Road 29 & Road 26, southwest of Raymond',
    Longitude: -120.015509,
    MajorIncident: 'False',
    Name: 'Eastman Fire',
    Started: '2017-09-18T16:04:00Z',
    UniqueId: '32d7eab5-d948-4be0-af69-b233e311d2b9'
  },
  {
    AcresBurned: 426,
    AdminUnit: 'USFS - El Dorado National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/10/13/table-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2018-01-09T13:36:00Z',
    Latitude: 38.848,
    Location: '3 miles northeast of Ice House Reservoir',
    Longitude: -120.287,
    MajorIncident: 'False',
    Name: 'Table Fire',
    Started: '2017-10-13T13:16:00Z',
    UniqueId: '2725461a-6ad1-43fd-8b83-5e219df4d558'
  },
  {
    AcresBurned: 422,
    AdminUnit: 'Los Angeles City Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/12/6/skirball-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2018-01-23T08:11:00Z',
    Latitude: 34.09454,
    Location: 'N Sepulveda Blvd at I-405',
    Longitude: -118.48178,
    MajorIncident: 'True',
    Name: 'Skirball Fire',
    Started: '2017-12-06T06:31:00Z',
    UniqueId: '2aad53ef-d6c3-43dc-92e6-b2f9881ff161'
  },
  {
    AcresBurned: 416,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/20/elephant-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2018-01-09T12:02:00Z',
    Latitude: 36.22265,
    Location: 'off Strathmore Rd, community of Lindsay',
    Longitude: -119.06598,
    MajorIncident: 'False',
    Name: 'Elephant Fire',
    Started: '2017-07-20T19:16:00Z',
    UniqueId: '0d93e84b-8460-4d5d-946c-630ade76747d'
  },
  {
    AcresBurned: 410,
    AdminUnit: 'Modoc National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/13/dode-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2018-01-09T11:54:00Z',
    Latitude: 41.72163,
    Location: 'off Hwy 139, 7 miles North of Tionesta',
    Longitude: -121.30451,
    MajorIncident: 'False',
    Name: 'Dode Fire',
    Started: '2017-07-13T15:23:00Z',
    UniqueId: 'f09f75ff-d9fe-4a25-89d0-75dc98d1fe30'
  },
  {
    AcresBurned: 400,
    AdminUnit: 'Unified Command: CAL FIRE San Diego Unit, Alpine Fire Protection District and  Lakeside Fire Protection District',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/11/jennings-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T11:52:00Z',
    Latitude: 32.84796,
    Location: 'I-8 and Old Hwy 80, Community of Lakeside',
    Longitude: -116.85396,
    MajorIncident: 'True',
    Name: 'Jennings Fire',
    Started: '2017-07-11T13:45:00Z',
    UniqueId: '04b54dc3-10a2-4fdf-bfa6-60a1fe2b0f7d'
  },
  {
    AcresBurned: 400,
    AdminUnit: 'CAL FIRE/Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/10/sonoma-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T09:55:00Z',
    Latitude: 36.45491,
    Location: 'off Sonoma Ave & Cerini Ave, west of Helm',
    Longitude: -120.2445,
    MajorIncident: 'False',
    Name: 'Sonoma Fire',
    Started: '2017-05-10T15:27:00Z',
    UniqueId: 'eca1021e-dfea-4dec-8470-c0eb7e4d479b'
  },
  {
    AcresBurned: 392,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/30/pleasant-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2018-01-09T12:48:00Z',
    Latitude: 39.34292,
    Location: 'Off Hwy 49 & Pleasant Valley Rd, south of North San Juan',
    Longitude: -121.12004,
    MajorIncident: 'True',
    Name: 'Pleasant Fire',
    Started: '2017-08-30T15:38:00Z',
    UniqueId: 'f571f91e-bc07-450c-8822-3ecc61a27863'
  },
  {
    AcresBurned: 391,
    AdminUnit: 'CAL FIRE San Mateo-Santa Cruz Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/16/bear-fire/',
    Counties: 'Santa Cruz',
    CountyIds: 44,
    Extinguished: '2018-01-09T13:41:00Z',
    Latitude: 37.18356,
    Location: 'Bear Canyon Road and Deer Creek Road in Boulder Creek, CA',
    Longitude: -122.07012,
    MajorIncident: 'True',
    Name: 'Bear Fire',
    Started: '2017-10-16T22:30:00Z',
    UniqueId: 'b3627eac-9f2f-482a-81a6-681e60b5b24a'
  },
  {
    AcresBurned: 380,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/4/3/west-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2018-01-09T09:40:00Z',
    Latitude: 41.16716,
    Location: 'Likely, 15 Miles south of Alturas',
    Longitude: -120.58342,
    MajorIncident: 'False',
    Name: 'West Fire',
    Started: '2017-04-03T16:00:00Z',
    UniqueId: '31b0e75c-b0e2-4796-b8a7-efc49e4c59a5'
  },
  {
    AcresBurned: 370,
    AdminUnit: 'Humboldt - Toiyabe National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/11/13/chris-fire/',
    Counties: 'Mono',
    CountyIds: 26,
    Extinguished: '2018-01-09T13:46:00Z',
    Latitude: 38.46111,
    Location: 'Hwy 395, north of Hwy 108, Walker Watershed, south of Walker',
    Longitude: -119.48284,
    MajorIncident: 'False',
    Name: 'Chris Fire',
    Started: '2017-11-13T11:28:00Z',
    UniqueId: '23353f29-33d4-4a7b-b78e-66bc761a55c8'
  },
  {
    AcresBurned: 370,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/8/willow-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2018-01-09T11:48:00Z',
    Latitude: 38.02929,
    Location: 'Springwood Ct. & California St, Rodeo',
    Longitude: -122.25544,
    MajorIncident: 'False',
    Name: 'Willow Fire',
    Started: '2017-07-08T15:26:00Z',
    UniqueId: '2adaf964-e996-4e55-a616-ac42375ee156'
  },
  {
    AcresBurned: 357,
    AdminUnit: 'CAL FIRE / Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/23/creek-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T11:01:00Z',
    Latitude: 36.27306,
    Location: 'Off Los Gatos Creek Rd, west of Derrick',
    Longitude: -120.65185,
    MajorIncident: 'False',
    Name: 'Creek Fire',
    Started: '2017-06-23T16:00:00Z',
    UniqueId: '0ed54526-1296-4863-ae40-613ee456899d'
  },
  {
    AcresBurned: 340,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/9/stone-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T11:51:00Z',
    Latitude: 35.42433,
    Location: 'Huer Huero Road, east of Santa Margarita',
    Longitude: -120.47322,
    MajorIncident: 'True',
    Name: 'Stone Fire',
    Started: '2017-07-09T13:49:00Z',
    UniqueId: '743b2276-742e-4d25-be9b-60364ca880f6'
  },
  {
    AcresBurned: 339,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/7/dinely-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2018-01-09T10:28:00Z',
    Latitude: 36.45809,
    Location: 'off of Dinely Drive in Three Rivers, northeast of Lake Kaweah',
    Longitude: -118.87676,
    MajorIncident: 'True',
    Name: 'Dinely Fire',
    Started: '2017-06-07T11:55:00Z',
    UniqueId: '6802ed2f-5a5a-4a38-a236-e5a688639b6f'
  },
  {
    AcresBurned: 338,
    AdminUnit: 'CAL FIRE/Kern County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/10/rose-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T12:31:00Z',
    Latitude: 34.92907,
    Location: 'I-5 Freeway and Grapevine Rd, north of the Grapevine',
    Longitude: -118.9267,
    MajorIncident: 'True',
    Name: 'Rose Fire',
    Started: '2017-08-10T14:32:00Z',
    UniqueId: '09e74687-85e7-488f-a5c8-8a11f75ab7d8'
  },
  {
    AcresBurned: 325,
    AdminUnit: 'CAL FIRE San Bernardino Unit / San Bernardino National Forest / City of Yucaipa',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/3/bryant-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T12:18:00Z',
    Latitude: 34.08492,
    Location: 'Bryant Street at Hwy 38, City of Yucaipa',
    Longitude: -117.03826,
    MajorIncident: 'True',
    Name: 'Bryant Fire',
    Started: '2017-08-03T15:35:00Z',
    UniqueId: '093bdb67-4c14-402d-a034-3714b7125c49'
  },
  {
    AcresBurned: 319,
    AdminUnit: 'USFS - Six Rivers National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/19/marble-fire/',
    Counties: 'Del Norte',
    CountyIds: 8,
    Extinguished: '2018-01-09T12:01:00Z',
    Latitude: 41.478,
    Location: 'Orleans Rd, Six River National Forest',
    Longitude: -123.506,
    MajorIncident: 'False',
    Name: 'Marble Fire',
    Started: '2017-07-19T14:00:00Z',
    UniqueId: 'be5275b7-1472-4423-a9c8-0f2491179150'
  },
  {
    AcresBurned: 300,
    AdminUnit: 'Murrieta Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/12/7/liberty-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T13:47:00Z',
    Latitude: 33.59257,
    Location: 'Los Alamos Rd & Liberty Rd, city of Murrieta',
    Longitude: -117.14979,
    MajorIncident: 'False',
    Name: 'Liberty Fire',
    Started: '2017-12-07T13:14:00Z',
    UniqueId: 'e1a8e4f1-ba7c-431a-a8c4-069fa3d3d36c'
  },
  {
    AcresBurned: 288,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/15/bravo-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T09:58:00Z',
    Latitude: 35.41283,
    Location: 'Hwy 178 and Mira Monte Drive, 2 miles southeast of Lake Ming',
    Longitude: -118.84466,
    MajorIncident: 'False',
    Name: 'Bravo Fire',
    Started: '2017-05-15T14:05:00Z',
    UniqueId: '0fc2a05e-689f-4c7c-b2b4-a987840b4f2c'
  },
  {
    AcresBurned: 260,
    AdminUnit: 'San Bernardino County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/12/5/little-mountain-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T13:47:00Z',
    Latitude: 34.16564,
    Location: 'University Pkwy. and Varsity Ave., San Bernardino City',
    Longitude: -117.33334,
    MajorIncident: 'False',
    Name: 'Little Mountain Fire',
    Started: '2017-12-05T13:35:00Z',
    UniqueId: 'eb87224a-f7da-4432-84ca-03a706ee3bac'
  },
  {
    AcresBurned: 255,
    AdminUnit: 'Unified Command: CAL FIRE San Diego County Fire Authority and Cleveland National Forest - USFS',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/22/lost-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-04-12T14:52:00Z',
    Latitude: 33.34659,
    Location: 'off of Hwy 79, 4 miles north of Warner Springs',
    Longitude: -116.66107,
    MajorIncident: 'False',
    Name: 'Lost Fire',
    Started: '2017-07-22T15:00:00Z',
    UniqueId: '918e4e6c-7814-42ed-9cd5-aa11d29367da'
  },
  {
    AcresBurned: 245,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/20/huasna-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T13:23:00Z',
    Latitude: 35.12269,
    Location: 'Huasna Townsite Rd & Huasna Rd, Huasna',
    Longitude: -120.39387,
    MajorIncident: 'True',
    Name: 'Huasna Fire',
    Started: '2017-09-20T13:41:00Z',
    UniqueId: 'c64e288e-d258-45e0-8357-b7a7289c0b92'
  },
  {
    AcresBurned: 237,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/19/murphy-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T13:23:00Z',
    Latitude: 36.24653,
    Location: 'Hwy 33 & Shell Rd, north of Coalinga',
    Longitude: -120.31598,
    MajorIncident: 'False',
    Name: 'Murphy Fire',
    Started: '2017-09-19T19:47:00Z',
    UniqueId: 'a8567989-a0c5-4c31-9012-82f99d76129f'
  },
  {
    AcresBurned: 236,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/30/largo-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2018-01-09T12:14:00Z',
    Latitude: 38.538332,
    Location: 'South Shingle Rd at Michigan Bar Rd, northeast of Rancho Murieta',
    Longitude: -121.039267,
    MajorIncident: 'False',
    Name: 'Largo Fire',
    Started: '2017-07-30T01:45:00Z',
    UniqueId: 'fd0a69a3-91d5-422b-bab4-dc6a4b0de134'
  },
  {
    AcresBurned: 231,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/8/deer-complex/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2018-01-09T11:48:00Z',
    Latitude: 37.87808,
    Location: 'Deer Valley Road & Marsh Creek Road, west of Brentwood',
    Longitude: -121.78677,
    MajorIncident: 'False',
    Name: 'Deer Complex',
    Started: '2017-07-08T02:20:00Z',
    UniqueId: '248bba19-4fdf-4285-a210-1334454ad80a'
  },
  {
    AcresBurned: 225,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/2/spring-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2018-01-09T11:17:00Z',
    Latitude: 37.4591,
    Location: 'off Hwy 49 and Allred Road, south of Mariposa',
    Longitude: -119.921,
    MajorIncident: 'True',
    Name: 'Spring Fire',
    Started: '2017-07-02T13:36:00Z',
    UniqueId: '3980fbbb-d17b-4deb-83a4-9af2290b5272'
  },
  {
    AcresBurned: 225,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/18/camp-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T10:03:00Z',
    Latitude: 35.34541,
    Location: 'off of Hwy 1 & Range Rd, northeast of San Luis Obispo',
    Longitude: -120.76464,
    MajorIncident: 'False',
    Name: 'Camp Fire',
    Started: '2017-05-18T08:48:00Z',
    UniqueId: '048c085b-3162-4906-beef-7aa2ba1b868d'
  },
  {
    AcresBurned: 225,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/15/arrow-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T09:57:00Z',
    Latitude: 35.21177,
    Location: 'off of Soda Lake',
    Longitude: -119.87525,
    MajorIncident: 'False',
    Name: 'Arrow Fire',
    Started: '2017-05-15T13:58:00Z',
    UniqueId: '5b3329f4-1e37-4b5a-9ed6-6f8d74f495c3'
  },
  {
    AcresBurned: 206,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/10/bodfish-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T10:29:00Z',
    Latitude: 35.59804,
    Location: '5 miles south of Lake Isabella',
    Longitude: -118.47939,
    MajorIncident: 'False',
    Name: 'Bodfish Fire',
    Started: '2017-06-10T12:17:00Z',
    UniqueId: '2ef06870-3602-4f1a-878d-962f7259ad46'
  },
  {
    AcresBurned: 205,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/4/eagle-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T11:44:00Z',
    Latitude: 33.85323,
    Location: 'Off Tin Mine Rd & La Sierra Ave, near Lake Mathews',
    Longitude: -117.48195,
    MajorIncident: 'False',
    Name: 'Eagle Fire',
    Started: '2017-07-04T16:55:00Z',
    UniqueId: '60770d23-70db-46f1-a19a-a23eaa409125'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'Mendocino National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/9/12/skeleton-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2018-01-09T13:20:00Z',
    Latitude: 39.44543,
    Location: 'Skeleton Glade, 5 miles east of Lake Pillsbury',
    Longitude: -122.85194,
    MajorIncident: 'False',
    Name: 'Skeleton Fire',
    Started: '2017-09-12T14:36:00Z',
    UniqueId: '089f95f8-8834-4cc6-87c7-15cb1aeca7b8'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'California National Guard',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/22/range-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2018-01-09T12:44:00Z',
    Latitude: 37.72543,
    Location: 'Range Road and Cromwell Avenue, Camp Parks Dublin, National Guard Reserve Forces Training Center',
    Longitude: -121.90516,
    MajorIncident: 'False',
    Name: 'Range Fire',
    Started: '2017-08-22T14:00:00Z',
    UniqueId: '89b5d4db-ce4e-43b9-8618-f89088d35ee1'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/21/eclipse-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T12:43:00Z',
    Latitude: 32.65003,
    Location: 'Royal Willie Road and La Posta Road, Community of Campo',
    Longitude: -116.42907,
    MajorIncident: 'True',
    Name: 'Eclipse Fire',
    Started: '2017-08-21T14:00:00Z',
    UniqueId: '2f1b8cff-f7d6-4459-866b-7c84bd531dcc'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/31/rose-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T12:15:00Z',
    Latitude: 33.689092,
    Location: 'Off Amorose St, in the community of Lake Elsinore',
    Longitude: -117.396404,
    MajorIncident: 'False',
    Name: 'Rose Fire',
    Started: '2017-07-31T14:22:00Z',
    UniqueId: '3dcf54bc-89f5-41b3-b797-5dcdf0e629e8'
  },
  {
    AcresBurned: 194,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/26/tehama-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2018-01-09T13:46:00Z',
    Latitude: 40.02261,
    Location: 'North Rim of the Mill Creek drainage, east of Los Molinos',
    Longitude: -121.91425,
    MajorIncident: 'False',
    Name: 'Tehama Fire',
    Started: '2017-10-26T20:00:00Z',
    UniqueId: '09425074-8348-4fbc-b95d-4939750f9345'
  },
  {
    AcresBurned: 190,
    AdminUnit: 'Santa Barbara County',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/20/wasioja-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2018-01-09T10:07:00Z',
    Latitude: 34.9465,
    Location: 'Wasioja Road and Hwy 166, east of New Cuyama',
    Longitude: -119.8036,
    MajorIncident: 'False',
    Name: 'Wasioja Fire',
    Started: '2017-05-20T17:54:00Z',
    UniqueId: '06b43461-94d0-4379-a1d6-fd26ba93ceea'
  },
  {
    AcresBurned: 186,
    AdminUnit: 'Plumas National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/20/toll-fire/',
    Counties: 'Plumas',
    CountyIds: 32,
    Extinguished: '2018-01-09T12:43:00Z',
    Latitude: 39.9864,
    Location: 'Tollgate Creek and Oakland Camp Road, north of Quincy',
    Longitude: -120.89746,
    MajorIncident: 'False',
    Name: 'Toll Fire',
    Started: '2017-08-20T16:26:00Z',
    UniqueId: '3becdf3e-b110-41ab-86ce-645e041d296f'
  },
  {
    AcresBurned: 186,
    AdminUnit: 'CAL FIRE Fresno Unit / Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/11/wild-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T10:30:00Z',
    Latitude: 36.704679,
    Location: 'Jensen Ave at Ohio Ave, Mendota',
    Longitude: -120.405077,
    MajorIncident: 'False',
    Name: 'Wild Fire',
    Started: '2017-06-11T10:46:00Z',
    UniqueId: 'a8e4aa40-5e2a-4fd8-a858-d673576cda73'
  },
  {
    AcresBurned: 184,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/15/rolling-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-04-03T10:46:00Z',
    Latitude: 35.3091,
    Location: 'Bena Road, east of Bakersfield',
    Longitude: -118.701,
    MajorIncident: 'False',
    Name: 'Rolling Fire',
    Started: '2017-10-15T17:11:00Z',
    UniqueId: '733028fc-bf0a-4737-878b-78a29c9ee2ee'
  },
  {
    AcresBurned: 183,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/12/quarry-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T13:36:00Z',
    Latitude: 35.19008,
    Location: 'off Hwy 223, east of Arvin',
    Longitude: -118.76152,
    MajorIncident: 'False',
    Name: 'Quarry Fire',
    Started: '2017-10-12T10:42:00Z',
    UniqueId: 'ec27a3bd-959b-48f3-872e-2c87047dbae2'
  },
  {
    AcresBurned: 180,
    AdminUnit: 'CAL FIRE Shasta-Trintiy Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/18/laverne-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2018-01-09T12:01:00Z',
    Latitude: 40.47106,
    Location: 'off of Laverne Ln & Saddle Trail, 6 miles southeast of Redding',
    Longitude: -122.43608,
    MajorIncident: 'True',
    Name: 'Laverne Fire',
    Started: '2017-07-18T12:39:00Z',
    UniqueId: '3c61a039-cf71-40da-89e9-bcc5a62e2c1a'
  },
  {
    AcresBurned: 170,
    AdminUnit: 'Unified Command: CAL FIRE San Bernardino-Inyo-Mono Unit / San Bernardino County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/23/high-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T12:04:00Z',
    Latitude: 34.41204,
    Location: 'off High Rd & Santa Rosa Rd, Lucerne Valley',
    Longitude: -117.03031,
    MajorIncident: 'True',
    Name: 'High Fire',
    Started: '2017-07-23T15:53:00Z',
    UniqueId: '1d8a8aaf-f294-46e1-8224-6ea3e8c39634'
  },
  {
    AcresBurned: 168,
    AdminUnit: 'CAL FIRE Riverside Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/19/hills-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T12:43:00Z',
    Latitude: 33.87679,
    Location: 'Lambs Canyon Road and Gilman Springs Road, Community of Gilman Springs',
    Longitude: -117.00258,
    MajorIncident: 'False',
    Name: 'Hills Fire',
    Started: '2017-08-19T16:31:00Z',
    UniqueId: 'a1b6ff5e-0533-408c-b02a-3061f60fb263'
  },
  {
    AcresBurned: 168,
    AdminUnit: 'USFS - Humboldt-Toiyabe National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/6/19/evans-fire/',
    Counties: 'Sierra',
    CountyIds: 46,
    Extinguished: '2018-01-09T11:00:00Z',
    Latitude: 39.71101,
    Location: 'Off Highway 395 & Scott Rd, east of Loyalton',
    Longitude: -120.02325,
    MajorIncident: 'False',
    Name: 'Evans Fire',
    Started: '2017-06-19T21:41:00Z',
    UniqueId: '5882937b-ffce-43af-9e0a-00dcddde214a'
  },
  {
    AcresBurned: 166,
    AdminUnit: 'CAL FIRE / Butte County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/10/honcut-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-01-09T11:52:00Z',
    Latitude: 39.37192,
    Location: 'off of Palermo Honcut Hwy, Honcut',
    Longitude: -121.53865,
    MajorIncident: 'False',
    Name: 'Honcut Fire',
    Started: '2017-07-10T14:45:00Z',
    UniqueId: '79fd7b45-381a-4819-9dc7-f80a98010809'
  },
  {
    AcresBurned: 157,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/26/peg-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2018-01-09T12:44:00Z',
    Latitude: 40.80968,
    Location: 'off Termo Grasshopper Rd., northwest of Ravendale',
    Longitude: -120.48641,
    MajorIncident: 'False',
    Name: 'Peg Fire',
    Started: '2017-08-26T12:35:00Z',
    UniqueId: 'bfc6b8e4-8021-44ca-8f92-58c724682ba1'
  },
  {
    AcresBurned: 157,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/7/26-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2018-01-09T10:28:00Z',
    Latitude: 37.12759,
    Location: 'off of Road 29, north of Ave 26, east of Chowchilla',
    Longitude: -120.0193,
    MajorIncident: 'False',
    Name: '26 Fire',
    Started: '2017-06-07T21:00:00Z',
    UniqueId: 'f62bd692-7aae-4e46-8284-239150acced0'
  },
  {
    AcresBurned: 155,
    AdminUnit: 'Unified Command: Alameda County Fireand CAL FIRE Santa Clara Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/19/corral-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2018-04-05T10:48:00Z',
    Latitude: 37.63358,
    Location: 'Off Corral Hollow Road, South of Tracy',
    Longitude: -121.49925,
    MajorIncident: 'False',
    Name: 'Corral Fire',
    Started: '2017-09-19T14:05:00Z',
    UniqueId: '19ada70e-4932-449c-8483-d65685995487'
  },
  {
    AcresBurned: 155,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/29/hill-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T12:12:00Z',
    Latitude: 41.9808,
    Location: 'Lakeview Dr. at Lake Ridge Rd., Pleasant Valley, 3 miles west of Dorris',
    Longitude: -121.9741,
    MajorIncident: 'False',
    Name: 'Hill Fire',
    Started: '2017-07-29T16:33:00Z',
    UniqueId: 'e9862c12-da9f-4205-9993-91a3b1437de4'
  },
  {
    AcresBurned: 153,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/18/smiley-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:46:00Z',
    Latitude: 33.98639,
    Location: 'Reche Canyon Road near Haugen Drive, north of Moreno Valley',
    Longitude: -117.21314,
    MajorIncident: 'False',
    Name: 'Smiley Fire',
    Started: '2017-06-18T15:10:00Z',
    UniqueId: '54bad310-3a96-4019-b64d-61d00c559e6c'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'CAL FIRE/Butte County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/9/honey-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-01-09T13:34:00Z',
    Latitude: 39.74679,
    Location: 'Honey Run Rd & Merlin Ln, southwest of Paradise',
    Longitude: -121.67261,
    MajorIncident: 'True',
    Name: 'Honey Fire',
    Started: '2017-10-09T15:05:00Z',
    UniqueId: '579d5d2a-0e51-4058-92c7-37abd7fe4aad'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'CAL FIRE San Luis Obispo unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/24/olive-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T12:05:00Z',
    Latitude: 35.7751,
    Location: 'Highway 41 Northeast of Highway 46',
    Longitude: -120.23656,
    MajorIncident: 'True',
    Name: 'Olive Fire',
    Started: '2017-07-24T14:43:00Z',
    UniqueId: '907cd7cd-cc26-4529-a9f8-cee1e1560086'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/14/lucy-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T10:33:00Z',
    Latitude: 35.6871,
    Location: 'off of Lucy Brown Rd, south of Hwy 41',
    Longitude: -120.3187,
    MajorIncident: 'False',
    Name: 'Lucy Fire',
    Started: '2017-06-14T11:44:00Z',
    UniqueId: '1c51deff-5b43-4f54-8acc-a682f830815a'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'Madera County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/17/41-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2018-01-09T10:01:00Z',
    Latitude: 36.90967,
    Location: 'off of Hwy 41 and Ave 11, north of Fresno',
    Longitude: -119.79315,
    MajorIncident: 'False',
    Name: '41 Fire',
    Started: '2017-05-17T15:30:00Z',
    UniqueId: '9a555129-982b-486f-a333-c96b3f9c4d2e'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'USFS - San Bernardino National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/4/30/tower-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T09:53:00Z',
    Latitude: 34.30104,
    Location: 'Cleghorn Road, east of I-15, north of the community of Devore',
    Longitude: -117.45646,
    MajorIncident: 'False',
    Name: 'Tower Fire',
    Started: '2017-04-30T16:03:00Z',
    UniqueId: '45699833-fa34-4eed-9520-8c8019426122'
  },
  {
    AcresBurned: 148,
    AdminUnit: 'Six Rivers National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/10/14/river-fire/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2018-01-09T13:36:00Z',
    Latitude: 40.46836,
    Location: 'off of County Line Creek Rd, near the community of Mad River',
    Longitude: -123.51619,
    MajorIncident: 'False',
    Name: 'River Fire',
    Started: '2017-10-14T16:00:00Z',
    UniqueId: 'eb8b50ba-b6bc-4668-b3f1-dcdbfbe71b17'
  },
  {
    AcresBurned: 146,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/19/grape-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2018-01-09T13:22:00Z',
    Latitude: 39.02482,
    Location: 'Off Hwy 101 & Crawford Ranch Rd, Hopland',
    Longitude: -123.1362,
    MajorIncident: 'True',
    Name: 'Grape Fire',
    Started: '2017-09-19T13:02:00Z',
    UniqueId: 'efa1dc61-85e3-4fb6-b6f6-04c3845d9ca6'
  },
  {
    AcresBurned: 143,
    AdminUnit: 'CAL FIRE / Butte County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/28/soda-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-01-09T13:27:00Z',
    Latitude: 40.07613,
    Location: 'Humboldt Rd and Soda Springs Rd, 14 miles NE Forest Ranch',
    Longitude: -121.56858,
    MajorIncident: 'False',
    Name: 'Soda Fire',
    Started: '2017-09-28T14:46:00Z',
    UniqueId: '01202971-a157-41f8-91cc-cf7c3b8f9473'
  },
  {
    AcresBurned: 140,
    AdminUnit: 'CAL FIRE Amador - El Dorado Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/26/ranch-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2018-01-09T12:06:00Z',
    Latitude: 38.559707,
    Location: 'Ranch Camp Rd, Mt. Aukum',
    Longitude: -120.70013,
    MajorIncident: 'True',
    Name: 'Ranch Fire',
    Started: '2017-07-26T13:58:00Z',
    UniqueId: '2fd950a8-fadb-467c-ab59-88e7ea007738'
  },
  {
    AcresBurned: 136,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/17/french-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2018-01-09T13:21:00Z',
    Latitude: 38.5758,
    Location: 'off French Creek Rd near Bonnetti Rd, south of the community of Shingle Springs',
    Longitude: -120.915,
    MajorIncident: 'True',
    Name: 'French Fire',
    Started: '2017-09-17T15:18:00Z',
    UniqueId: 'f7a51800-b219-428c-aef0-ee5fa5de4d64'
  },
  {
    AcresBurned: 135,
    AdminUnit: 'Los Angles County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/28/gorman-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2018-01-09T12:07:00Z',
    Latitude: 34.792882,
    Location: 'Gorman School Rd at I-5, Gorman, Los Angeles County',
    Longitude: -118.851943,
    MajorIncident: 'False',
    Name: 'Gorman Fire',
    Started: '2017-07-28T15:25:00Z',
    UniqueId: 'ce6fb2ba-9799-4b36-a64f-8bf02392d6ee'
  },
  {
    AcresBurned: 135,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/13/king-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2018-01-09T10:32:00Z',
    Latitude: 35.8556,
    Location: 'Off of Hot Springs Road, west of the community of California Hot Springs',
    Longitude: -118.74542,
    MajorIncident: 'True',
    Name: 'King Fire',
    Started: '2017-06-13T17:00:00Z',
    UniqueId: '5f0c7697-7be3-49af-b98c-f5789e3ca6f9'
  },
  {
    AcresBurned: 134,
    AdminUnit: 'CAL FIRE / Butte County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/16/skyway-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-01-09T10:34:00Z',
    Latitude: 39.69717,
    Location: 'off Skyway and Hwy 99, east of Chico',
    Longitude: -121.75417,
    MajorIncident: 'False',
    Name: 'Skyway Fire',
    Started: '2017-06-16T09:27:00Z',
    UniqueId: 'a2d42b3a-32a4-4b57-a8c2-91e5d046bbb6'
  },
  {
    AcresBurned: 130,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/9/point-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2018-01-09T13:33:00Z',
    Latitude: 38.40234,
    Location: 'Hwy 26 and Higdon Rd., West Point',
    Longitude: -120.52953,
    MajorIncident: 'True',
    Name: 'Point Fire',
    Started: '2017-10-09T01:10:00Z',
    UniqueId: 'f30518d1-83ef-440c-8058-d4189bfedab7'
  },
  {
    AcresBurned: 130,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/1/border-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T12:50:00Z',
    Latitude: 32.6001,
    Location: 'near Hwy 94/Marron Valley Rd in the community of Dulzura.',
    Longitude: -116.76997,
    MajorIncident: 'True',
    Name: 'Border Fire',
    Started: '2017-09-01T04:20:00Z',
    UniqueId: '10a447c8-708f-44a3-8679-251500c761d6'
  },
  {
    AcresBurned: 130,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/2/olive-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T09:54:00Z',
    Latitude: 35.78286,
    Location: 'Off Highway 41, north of Cholame',
    Longitude: -120.22647,
    MajorIncident: 'False',
    Name: 'Olive Fire',
    Started: '2017-05-02T14:32:00Z',
    UniqueId: '87d7fb46-00f9-4bae-ba35-a7ef8e58a70e'
  },
  {
    AcresBurned: 128,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/1/oak-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2018-01-09T11:16:00Z',
    Latitude: 40.69554,
    Location: 'off Oak Run Rd and Pierce Hollow Rd, east of Redding',
    Longitude: -122.0122,
    MajorIncident: 'False',
    Name: 'Oak Fire',
    Started: '2017-07-01T00:48:00Z',
    UniqueId: '2b043a7e-234c-43f7-852c-21fcb9ddc200'
  },
  {
    AcresBurned: 126,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/4/29/tumey-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T09:52:00Z',
    Latitude: 36.5355,
    Location: 'Panoche Rd, 5 miles west of I-5',
    Longitude: -120.6585,
    MajorIncident: 'False',
    Name: 'Tumey Fire',
    Started: '2017-04-29T17:15:00Z',
    UniqueId: 'd804eebf-71de-46de-90c2-cdf0694d27e3'
  },
  {
    AcresBurned: 125,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/13/coronado-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2018-01-09T12:40:00Z',
    Latitude: 37.62823,
    Location: 'Merced Falls Rd and Coronado Rd in Lake McClure',
    Longitude: -120.30046,
    MajorIncident: 'False',
    Name: 'Coronado Fire',
    Started: '2017-08-13T16:23:00Z',
    UniqueId: '8779fe43-665b-4643-a730-6344c44018c7'
  },
  {
    AcresBurned: 124,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/30/twist-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2018-01-09T12:14:00Z',
    Latitude: 37.90014,
    Location: 'Twist Road south of Algerine Road, Jamestown',
    Longitude: -120.36005,
    MajorIncident: 'False',
    Name: 'Twist Fire',
    Started: '2017-07-30T16:28:00Z',
    UniqueId: '1f8c73d1-2cb8-4e98-bd44-d6dccd601c7e'
  },
  {
    AcresBurned: 122,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/4/stewart-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T12:19:00Z',
    Latitude: 34.009026,
    Location: 'Stewart Rd at Woodson Rd in Moreno Valley',
    Longitude: -117.239099,
    MajorIncident: 'False',
    Name: 'Stewart Fire',
    Started: '2017-08-04T14:25:00Z',
    UniqueId: '58d62aeb-29f5-45f5-93ac-a657b0708149'
  },
  {
    AcresBurned: 120,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/3/margarita-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T12:50:00Z',
    Latitude: 35.31886,
    Location: 'Santa Margarita Lake Rd. and W. Pozo Rd., 7 miles SE of Santa Margarita',
    Longitude: -120.50886,
    MajorIncident: 'False',
    Name: 'Margarita Fire',
    Started: '2017-09-03T16:59:00Z',
    UniqueId: '17cd878b-0d5d-49ff-b205-7e0203908f4c'
  },
  {
    AcresBurned: 120,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/25/lamb-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:16:00Z',
    Latitude: 33.88287,
    Location: 'Lamb Canyon & Dump Road, north of Hemet',
    Longitude: -116.99651,
    MajorIncident: 'False',
    Name: 'Lamb Fire',
    Started: '2017-05-25T14:48:00Z',
    UniqueId: '45a205f4-bcd2-44bd-886b-26260c686ce7'
  },
  {
    AcresBurned: 117,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/17/maria-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2018-01-09T11:58:00Z',
    Latitude: 38.29113,
    Location: 'Jesus Maria Road and Music Gulch Road, Mokelumne Hill',
    Longitude: -120.62177,
    MajorIncident: 'True',
    Name: 'Maria Fire',
    Started: '2017-07-17T12:55:00Z',
    UniqueId: '2f9f1bf9-6188-46a2-b91f-f212cdd21528'
  },
  {
    AcresBurned: 116,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/17/fallon-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2018-01-09T13:41:00Z',
    Latitude: 37.7393,
    Location: 'off Fallon Road 3 miles East of Dublin',
    Longitude: -121.85663,
    MajorIncident: 'False',
    Name: 'Fallon Fire',
    Started: '2017-10-17T14:00:00Z',
    UniqueId: 'e8c7f247-bc31-4e5b-bf71-fe903366d9e5'
  },
  {
    AcresBurned: 114,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/11/canyon-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2018-01-09T12:35:00Z',
    Latitude: 38.49336,
    Location: 'Hwy 128 and Sage Canyon Rd near Lake Berryessa',
    Longitude: -122.2483,
    MajorIncident: 'True',
    Name: 'Canyon Fire',
    Started: '2017-08-11T12:57:00Z',
    UniqueId: '4b885d8c-8951-46c5-a3d1-520cfd0ac964'
  },
  {
    AcresBurned: 111,
    AdminUnit: 'CAL FIRE / Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/26/flat-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T12:45:00Z',
    Latitude: 36.93332,
    Location: 'Oak Flat Lane and Sales Creek Rd., 5 miles south of Tollhouse',
    Longitude: -119.43376,
    MajorIncident: 'False',
    Name: 'Flat Fire',
    Started: '2017-08-26T14:31:00Z',
    UniqueId: '90473f02-6572-4a9b-9451-1a18a4bee1ed'
  },
  {
    AcresBurned: 111,
    AdminUnit: 'CAL FIRE / Butte County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/22/lone-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-01-09T11:01:00Z',
    Latitude: 39.38416,
    Location: 'Lone Tree Rd & Cox Ln, south of Oroville',
    Longitude: -121.5786,
    MajorIncident: 'False',
    Name: 'Lone Fire',
    Started: '2017-06-22T11:10:00Z',
    UniqueId: '1b1ba02e-9db3-4224-9d8d-06d5df529f16'
  },
  {
    AcresBurned: 105,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/26/poly-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T13:26:00Z',
    Latitude: 35.3024,
    Location: 'near Cal Poly',
    Longitude: -120.65279,
    MajorIncident: 'False',
    Name: 'Poly Fire',
    Started: '2017-09-26T15:30:00Z',
    UniqueId: 'cb3599f6-751d-4072-8db1-6e366ac603c9'
  },
  {
    AcresBurned: 105,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/15/canyon-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:33:00Z',
    Latitude: 33.950382,
    Location: 'Banning',
    Longitude: -116.884446,
    MajorIncident: 'False',
    Name: 'Canyon Fire',
    Started: '2017-06-15T11:36:00Z',
    UniqueId: '380df891-161a-44c7-a244-d7dda9d5fd32'
  },
  {
    AcresBurned: 103,
    AdminUnit: 'Unified Command: CAL FIRE/Butte County and Chico Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/19/humboldt-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-04-12T14:52:00Z',
    Latitude: 39.76243,
    Location: 'Humboldt Rd & Hwy 32, 2 miles east of Chico',
    Longitude: -121.74121,
    MajorIncident: 'False',
    Name: 'Humboldt Fire',
    Started: '2017-07-19T16:02:00Z',
    UniqueId: '510c877d-b80b-423f-b7e0-4276ce646f4a'
  },
  {
    AcresBurned: 102,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/30/coalinga-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T12:48:00Z',
    Latitude: 36.36113,
    Location: 'Mendota Road and Interstate 5, 12 miles north of Coalinga',
    Longitude: -120.32685,
    MajorIncident: 'False',
    Name: 'Coalinga Fire',
    Started: '2017-08-30T16:51:00Z',
    UniqueId: '4adae6c4-71c9-46d1-9743-e04f186b2c3e'
  },
  {
    AcresBurned: 101,
    AdminUnit: 'San Jose Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/11/lariat-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2018-01-09T11:53:00Z',
    Latitude: 37.39801,
    Location: 'Lariat Lane and Claitor Way, 6 miles northeast of San Jose',
    Longitude: -121.8179,
    MajorIncident: 'False',
    Name: 'Lariat Fire',
    Started: '2017-07-11T16:51:00Z',
    UniqueId: '580ce9d9-b8dc-4dc1-9f10-11bf48df9492'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/21/church-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T13:41:00Z',
    Latitude: 32.64962,
    Location: 'off Highway 94 and Church Rd, Campo Indian Reservation',
    Longitude: -116.37345,
    MajorIncident: 'False',
    Name: 'Church Fire',
    Started: '2017-10-21T13:04:00Z',
    UniqueId: '773795d8-5801-4f7c-a2fe-3f8d0ae18f51'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/14/oakmont-fire-central-lnu-complex/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2018-04-05T12:01:00Z',
    Latitude: 38.46123,
    Location: 'east side of Highway 12 near the Oakmont community',
    Longitude: -122.58152,
    MajorIncident: 'True',
    Name: 'Oakmont Fire (Central LNU Complex)',
    Started: '2017-10-14T20:35:00Z',
    UniqueId: '3f481060-1106-4857-8ac3-374a68763922'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE Sonoma Lake Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/14/long-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2018-01-09T13:38:00Z',
    Latitude: 39.0199,
    Location: 'off Hwy 20 & Long Valley Rd, 5 miles east of Clearlake Oaks',
    Longitude: -122.57487,
    MajorIncident: 'False',
    Name: 'Long Fire',
    Started: '2017-10-14T05:00:00Z',
    UniqueId: 'a7ecc679-7fbc-4370-9a55-8e17bf262a2e'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/2/timm-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2018-01-09T13:29:00Z',
    Latitude: 38.43658,
    Location: 'Timm Rd and Peaceful Glen Rd, 5 miles north of Vacaville',
    Longitude: -121.97233,
    MajorIncident: 'False',
    Name: 'Timm Fire',
    Started: '2017-10-02T09:37:00Z',
    UniqueId: '03d74bbd-627c-47af-a2e9-5351e6e16f6a'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE Santa Clara Unit/Gilroy Fire Dept',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/3/bally-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2018-01-09T12:50:00Z',
    Latitude: 36.99092,
    Location: 'Ballybunion Ct, Gilroy',
    Longitude: -121.59899,
    MajorIncident: 'False',
    Name: 'Bally Fire',
    Started: '2017-09-03T19:17:00Z',
    UniqueId: '7b02d757-4f96-4616-99d5-04e4eaa34440'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/3/parkfield-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T12:51:00Z',
    Latitude: 36.09486,
    Location: 'Hwy 198 and Mineral Springs Rd., 9 miles west of Coalinga',
    Longitude: -120.52189,
    MajorIncident: 'False',
    Name: 'Parkfield Fire',
    Started: '2017-09-03T09:23:00Z',
    UniqueId: 'a983c540-b47c-4250-a65d-c5d3d76c9b3b'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/11/tilton-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2018-01-09T12:39:00Z',
    Latitude: 37.14653,
    Location: 'Hale Ave and Tilton Ave in Morgan Hill',
    Longitude: -121.68165,
    MajorIncident: 'False',
    Name: 'Tilton Fire',
    Started: '2017-08-11T14:55:00Z',
    UniqueId: 'a8ab00de-6074-45a0-9e3d-f43b090e8346'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/31/mile-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T12:16:00Z',
    Latitude: 34.19076,
    Location: 'Hwy 18 x Old Waterman Canyon Rd., 1 mile south of Crestline',
    Longitude: -117.26969,
    MajorIncident: 'False',
    Name: 'Mile Fire',
    Started: '2017-07-31T14:44:00Z',
    UniqueId: '32a79e9b-8ce3-477e-b698-2eb16ef66aac'
  },
  {
    AcresBurned: 99,
    AdminUnit: 'CAL FIRE San Bernardino Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/11/29/oak-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T13:46:00Z',
    Latitude: 34.035344,
    Location: 'Off Oak Glen Rd and Pine Bench Rd, east of Oak Glen',
    Longitude: -116.940661,
    MajorIncident: 'False',
    Name: 'Oak Fire',
    Started: '2017-11-29T12:19:00Z',
    UniqueId: '666b3951-76ce-4351-abc6-3e0518d44901'
  },
  {
    AcresBurned: 92,
    AdminUnit: 'CAL FIRE/Riverside County Fire/San Bernardino National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/7/reed-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T12:23:00Z',
    Latitude: 33.57139,
    Location: 'Reed Valley Rd. and Forest Route 7S04 in Aguanga',
    Longitude: -116.8247,
    MajorIncident: 'True',
    Name: 'Reed Fire',
    Started: '2017-08-07T14:14:00Z',
    UniqueId: 'ab009bd1-6784-4fda-a931-532520742a8b'
  },
  {
    AcresBurned: 91,
    AdminUnit: 'CAL FIRE/Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/5/auberry-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T11:45:00Z',
    Latitude: 36.95104,
    Location: 'off Auberry Rd, north of Clovis',
    Longitude: -119.65621,
    MajorIncident: 'True',
    Name: 'Auberry Fire',
    Started: '2017-07-05T15:40:00Z',
    UniqueId: '89f34aa8-eaf3-4d19-8ef0-005102e82831'
  },
  {
    AcresBurned: 91,
    AdminUnit: 'CAL FIRE/Butte County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/6/wilbur-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-01-09T10:27:00Z',
    Latitude: 39.52499,
    Location: 'Wilbur rd, north of Oroville Dam blvd',
    Longitude: -121.64897,
    MajorIncident: 'False',
    Name: 'Wilbur Fire',
    Started: '2017-06-06T12:43:00Z',
    UniqueId: '549222c5-1be6-4453-896a-caebd19b0bee'
  },
  {
    AcresBurned: 90,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/7/daulton-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2018-01-09T11:46:00Z',
    Latitude: 37.09773,
    Location: 'Road 29 and Ave 24, near Daulton',
    Longitude: -120.02027,
    MajorIncident: 'False',
    Name: 'Daulton Fire',
    Started: '2017-07-07T10:00:00Z',
    UniqueId: 'eeef101a-3a50-4407-8e6d-cd80d0d07599'
  },
  {
    AcresBurned: 87,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/6/ridge-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2018-01-09T13:29:00Z',
    Latitude: 39.15016,
    Location: 'Bartlett Springs, community of Clearlake',
    Longitude: -122.576,
    MajorIncident: 'True',
    Name: 'Ridge Fire',
    Started: '2017-10-06T14:38:00Z',
    UniqueId: '2049dbb6-1a87-4d9d-abde-092d35072934'
  },
  {
    AcresBurned: 86,
    AdminUnit: 'Ventura County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/24/vista-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2018-01-09T13:45:00Z',
    Latitude: 34.34949,
    Location: 'off Hwy 33 & Casitas Vista Rd',
    Longitude: -119.30918,
    MajorIncident: 'False',
    Name: 'Vista Fire',
    Started: '2017-10-24T14:44:00Z',
    UniqueId: 'fc8f89b5-988a-4a23-b9e3-333cc690363e'
  },
  {
    AcresBurned: 85,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/31/marlborough-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T12:49:00Z',
    Latitude: 117.337331,
    Location: 'Marlborough ave and Northgate street',
    Longitude: 34.015742,
    MajorIncident: 'False',
    Name: 'Marlborough Fire',
    Started: '2017-08-31T10:13:00Z',
    UniqueId: '7bc10ea0-55b4-40bd-8eca-36ec10106528'
  },
  {
    AcresBurned: 85,
    AdminUnit: 'CAL FIRE Humboldt-Del Norte Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/3/saw-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2018-01-09T12:17:00Z',
    Latitude: 40.11794,
    Location: 'Off Alderpoint Rd & Lower Sawmill Rd, east of Garberville',
    Longitude: -123.76099,
    MajorIncident: 'False',
    Name: 'Saw Fire',
    Started: '2017-08-03T11:58:00Z',
    UniqueId: 'dd6c5dfb-e5f5-4c1b-ab7f-aa9f3a4f60fc'
  },
  {
    AcresBurned: 85,
    AdminUnit: 'USFS - San Bernardino National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/22/dollar-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T12:03:00Z',
    Latitude: 34.20152,
    Location: 'off Hwy 330 & Old City Creek Rd, southwest of Running Springs',
    Longitude: -117.14466,
    MajorIncident: 'False',
    Name: 'Dollar Fire',
    Started: '2017-07-22T13:35:00Z',
    UniqueId: '84c8a735-9e8f-4310-84ab-39079ad1ea14'
  },
  {
    AcresBurned: 85,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/29/ranch-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2018-01-09T11:11:00Z',
    Latitude: 37.3344,
    Location: 'Off Grant Road, Mt. Hamilton, east of San Jose',
    Longitude: -121.71752,
    MajorIncident: 'False',
    Name: 'Ranch Fire',
    Started: '2017-06-29T13:56:00Z',
    UniqueId: '5da65d7f-cc75-4c0c-b221-1a1e3000a120'
  },
  {
    AcresBurned: 82,
    AdminUnit: 'CAL FIRE San Benito-Monterey',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/7/country-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2018-01-09T12:27:00Z',
    Latitude: 35.86596,
    Location: 'Portuguese Canyon Rd. at Cross Country Rd. southeast of Bradley',
    Longitude: -120.64584,
    MajorIncident: 'False',
    Name: 'Country Fire',
    Started: '2017-08-07T18:08:00Z',
    UniqueId: 'e65c3e0b-08d9-43cf-b1ac-8e57d5f407fc'
  },
  {
    AcresBurned: 81,
    AdminUnit: 'Camp Pendleton - Cleveland National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/10/13/loma-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T13:38:00Z',
    Latitude: 33.38613,
    Location: 'Loma Range 217, Camp Pendleton',
    Longitude: -117.46709,
    MajorIncident: 'False',
    Name: 'Loma Fire',
    Started: '2017-10-13T15:40:00Z',
    UniqueId: 'd12bbce8-5acb-43ef-a259-4fbaf90d32ff'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'Bureau of Indian Affairs',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/12/28/holiday-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2018-01-09T13:49:00Z',
    Latitude: 38.869036,
    Location: 'off Hwy 395, south of Gardnerville in Nevada',
    Longitude: -119.61865,
    MajorIncident: 'False',
    Name: 'Holiday Fire',
    Started: '2017-12-28T20:51:00Z',
    UniqueId: 'd20645f2-81b9-450f-abc1-433b81bd7fea'
  },
  {
    AcresBurned: 79,
    AdminUnit: 'Plumas National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/3/mills-file/',
    Counties: 'Plumas',
    CountyIds: 32,
    Extinguished: '2018-01-09T13:18:00Z',
    Latitude: 40.13278,
    Location: 'Hwy 89, ¼ mile north of Crescent Mills',
    Longitude: -120.9204,
    MajorIncident: 'False',
    Name: 'Mills File',
    Started: '2017-09-03T20:32:00Z',
    UniqueId: 'ba20d998-185c-48ac-8006-15aadf4d3106'
  },
  {
    AcresBurned: 79,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/31/fountain-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2018-01-09T10:23:00Z',
    Latitude: 35.89423,
    Location: 'off Avenue 56 & Road 256, 2 miles east of Ducor',
    Longitude: -119.00334,
    MajorIncident: 'False',
    Name: 'Fountain Fire',
    Started: '2017-05-31T11:30:00Z',
    UniqueId: '92d70dc0-19af-4c87-ab01-8c7051caab73'
  },
  {
    AcresBurned: 78,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/23/castro-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2018-01-09T12:04:00Z',
    Latitude: 36.96607,
    Location: 'off Castro Valley Rd. &  Hwy 101,  southwest of Gilroy',
    Longitude: -121.55552,
    MajorIncident: 'False',
    Name: 'Castro Fire',
    Started: '2017-07-23T16:07:00Z',
    UniqueId: 'e8ebb6f2-16f5-4342-bce1-d36ff9c9422c'
  },
  {
    AcresBurned: 78,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/4/spring-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2018-01-09T10:25:00Z',
    Latitude: 40.38944,
    Location: 'off of Spring Branch Rd, 7 miles east of Cottonwood',
    Longitude: -122.13088,
    MajorIncident: 'False',
    Name: 'Spring Fire',
    Started: '2017-06-04T16:22:00Z',
    UniqueId: '80f2c7d1-d28d-43d0-97a3-ff53cc991a8c'
  },
  {
    AcresBurned: 76,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/9/mccourtney-fire-wind-complex/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2018-02-09T09:52:00Z',
    Latitude: 39.19325,
    Location: 'McCourtney Rd and Hwy 20, Grass Valley',
    Longitude: -121.08406,
    MajorIncident: 'True',
    Name: 'McCourtney Fire (Wind Complex)',
    Started: '2017-10-09T00:00:00Z',
    UniqueId: '9a2b8ac1-41f4-4f98-a4e1-9b5ddee37251'
  },
  {
    AcresBurned: 76,
    AdminUnit: 'CALFIRE/Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/11/tivy-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T10:31:00Z',
    Latitude: 36.8005,
    Location: 'near Tivy Mountain',
    Longitude: -119.35901,
    MajorIncident: 'False',
    Name: 'Tivy Fire',
    Started: '2017-06-11T22:45:00Z',
    UniqueId: '0956bfcb-8915-4163-b4ed-4f3a6ab32895'
  },
  {
    AcresBurned: 74,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/26/linne-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T13:26:00Z',
    Latitude: 35.5956,
    Location: 'Linne Rd x Geneseo Rd, east of Paso Robles',
    Longitude: -120.56068,
    MajorIncident: 'False',
    Name: 'Linne Fire',
    Started: '2017-09-26T16:45:00Z',
    UniqueId: '98bf51ea-bf23-40a3-b95e-4b795baced3e'
  },
  {
    AcresBurned: 74,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/8/axel-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2018-01-09T11:50:00Z',
    Latitude: 38.7803,
    Location: 'Axel Ct & Barrister Ct, Rescue',
    Longitude: -120.97111,
    MajorIncident: 'True',
    Name: 'Axel Fire',
    Started: '2017-07-08T16:38:00Z',
    UniqueId: 'f75027cb-2526-4524-989f-71d0d56353ec'
  },
  {
    AcresBurned: 74,
    AdminUnit: 'Unified Command -  CAL FIRE San Bernardino Unit / Redlands Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/7/bryant-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T11:47:00Z',
    Latitude: 34.07612,
    Location: 'Hwy 38, west of Bryant St.',
    Longitude: -117.06765,
    MajorIncident: 'False',
    Name: 'Bryant Fire',
    Started: '2017-07-07T15:45:00Z',
    UniqueId: '67c20627-e6cb-4900-9f40-01e8da154a53'
  },
  {
    AcresBurned: 73,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/13/lynch-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T13:37:00Z',
    Latitude: 35.78616,
    Location: 'Lynch Canyon Road and Interlake Road, north of Lake Nacimiento',
    Longitude: -120.96514,
    MajorIncident: 'False',
    Name: 'Lynch Fire',
    Started: '2017-10-13T12:14:00Z',
    UniqueId: '92a8a466-061b-430a-87f9-3b5192947578'
  },
  {
    AcresBurned: 72,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/18/ellis-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T12:01:00Z',
    Latitude: 33.75526,
    Location: 'off of Mc Pherson Road, Perris',
    Longitude: -117.25075,
    MajorIncident: 'False',
    Name: 'Ellis Fire',
    Started: '2017-07-18T15:34:00Z',
    UniqueId: '244961af-65d5-472b-972f-e02df96e9ccb'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/2/camatta-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T12:17:00Z',
    Latitude: 35.4403,
    Location: 'Hwy 58 near Camatta Creek Rd, east of Santa Margarita',
    Longitude: -120.2913,
    MajorIncident: 'False',
    Name: 'Camatta Fire',
    Started: '2017-08-02T10:33:00Z',
    UniqueId: '47dd7f12-4141-473e-b2c1-2e625df3b784'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/17/sand-fire/',
    Counties: 'Colusa',
    CountyIds: 6,
    Extinguished: '2018-01-09T11:58:00Z',
    Latitude: 39.01224,
    Location: 'Sand Creek Rd, west of Arbuckle',
    Longitude: -122.20127,
    MajorIncident: 'True',
    Name: 'Sand Fire',
    Started: '2017-07-17T13:17:00Z',
    UniqueId: '0726d9f7-2baa-4652-b1d6-cbab45783f64'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/10/felipe-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2018-01-09T11:52:00Z',
    Latitude: 37.25014,
    Location: 'San Felipe Road and Metcalf Road, 8 miles northeast of Morgan Hill',
    Longitude: -121.68562,
    MajorIncident: 'False',
    Name: 'Felipe Fire',
    Started: '2017-07-10T15:54:00Z',
    UniqueId: '9a1a4247-479d-46ff-99cc-4251c5e333fa'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/19/manning-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T10:05:00Z',
    Latitude: 36.60736,
    Location: 'Interstate 5 and Manning Avenue, north of Coalinga',
    Longitude: -120.5828,
    MajorIncident: 'False',
    Name: 'Manning Fire',
    Started: '2017-05-19T23:28:00Z',
    UniqueId: 'b3fc6dff-f13a-41c4-b7f3-e9e960a941d5'
  },
  {
    AcresBurned: 69,
    AdminUnit: 'CAL FIRE / Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/27/hill-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T12:46:00Z',
    Latitude: 36.7279,
    Location: 'Hwy 180 from Hills Valley to Ruth Hill',
    Longitude: -119.28241,
    MajorIncident: 'False',
    Name: 'Hill Fire',
    Started: '2017-08-27T18:47:00Z',
    UniqueId: '386b7562-fe70-490b-a92c-a3c21eece0c2'
  },
  {
    AcresBurned: 68,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/1/clay-fire/',
    Counties: 'Sacramento',
    CountyIds: 34,
    Extinguished: '2018-01-09T10:22:00Z',
    Latitude: 38.33707,
    Location: 'off Clay East Rd, east of Herald',
    Longitude: -121.11113,
    MajorIncident: 'False',
    Name: 'Clay Fire',
    Started: '2017-06-01T15:38:00Z',
    UniqueId: 'bf3148c5-75dd-4f79-8b3b-c5b483065b47'
  },
  {
    AcresBurned: 67,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/4/river-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2018-01-09T10:26:00Z',
    Latitude: 40.03392,
    Location: 'east of Hwy 395, Doyle',
    Longitude: -120.1064,
    MajorIncident: 'False',
    Name: 'River Fire',
    Started: '2017-06-04T16:12:00Z',
    UniqueId: 'b02f2513-9359-45e2-9971-08f7b1f0dc0f'
  },
  {
    AcresBurned: 65,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/21/orange-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2018-01-09T10:59:00Z',
    Latitude: 37.82934,
    Location: 'Off Sonora Rd & Orange Blossom Rd, east of Oakdale',
    Longitude: -120.68992,
    MajorIncident: 'False',
    Name: 'Orange Fire',
    Started: '2017-06-21T14:45:00Z',
    UniqueId: '8740caa0-f86c-4103-b830-0435b9933a2b'
  },
  {
    AcresBurned: 63,
    AdminUnit: 'Riverside County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/28/placentia-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T12:07:00Z',
    Latitude: 33.81976,
    Location: 'Placentia Ave. at Eureka St, Nuevo',
    Longitude: -117.18552,
    MajorIncident: 'False',
    Name: 'Placentia Fire',
    Started: '2017-07-28T18:11:00Z',
    UniqueId: 'ee20b421-06cd-40d2-a22c-0f9e8ddeee71'
  },
  {
    AcresBurned: 63,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/15/westfall-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2018-01-09T10:33:00Z',
    Latitude: 37.36914,
    Location: 'west of  Westfall Road and north of Whiterock Road',
    Longitude: -120.0088,
    MajorIncident: 'False',
    Name: 'Westfall Fire',
    Started: '2017-06-15T07:30:00Z',
    UniqueId: '1dfae538-fd95-4454-865d-3d74e4b56665'
  },
  {
    AcresBurned: 62,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/26/montezuma-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T12:44:00Z',
    Latitude: 33.20988,
    Location: 'Montezuma Valley Rd., near the Community of Borrego Springs.',
    Longitude: -116.46989,
    MajorIncident: 'False',
    Name: 'Montezuma Fire',
    Started: '2017-08-26T11:30:00Z',
    UniqueId: '1f8d9fe1-e644-4f53-88ae-4418cc0b4451'
  },
  {
    AcresBurned: 62,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/8/bottle-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2018-01-09T12:28:00Z',
    Latitude: 38.94599,
    Location: 'Bottle Rock Rd and Highway 29 in Kelseyville',
    Longitude: -122.81135,
    MajorIncident: 'True',
    Name: 'Bottle Fire',
    Started: '2017-08-08T16:40:00Z',
    UniqueId: '21714c67-dc5a-4d86-8794-79d85f87b71b'
  },
  {
    AcresBurned: 62,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/8/lake-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2018-01-09T11:48:00Z',
    Latitude: 37.64898,
    Location: 'Off Hwy 132 & Lake Rd',
    Longitude: -120.4925,
    MajorIncident: 'False',
    Name: 'Lake Fire',
    Started: '2017-07-08T11:00:00Z',
    UniqueId: 'b3a6b47f-105b-4f66-b12a-76c563457a5d'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/18/bolla-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2018-01-09T10:35:00Z',
    Latitude: 40.32063,
    Location: 'Hwy 36 West, off Tedoc Roadd, west of Platina',
    Longitude: -122.83208,
    MajorIncident: 'False',
    Name: 'Bolla Fire',
    Started: '2017-06-18T07:15:00Z',
    UniqueId: 'ffb57bcc-80f7-4299-bfcf-c9be3b66d5ff'
  },
  {
    AcresBurned: 59,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/17/fox-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2018-01-09T11:59:00Z',
    Latitude: 36.18815,
    Location: 'off Balch Park Rd & Bear Creek Dr, 4 miles north of Springville',
    Longitude: -118.78928,
    MajorIncident: 'False',
    Name: 'Fox Fire',
    Started: '2017-07-17T15:32:00Z',
    UniqueId: '80844950-65c8-44ec-b63a-7e51412fea0c'
  },
  {
    AcresBurned: 59,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/12/quail-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2018-01-09T11:53:00Z',
    Latitude: 38.18303,
    Location: 'Quail Oaks Rd. and Oak Hill Dr. near Valley Springs',
    Longitude: -120.85322,
    MajorIncident: 'True',
    Name: 'Quail Fire',
    Started: '2017-07-12T13:10:00Z',
    UniqueId: '6f9581fa-7c8a-45d1-988d-0a299fc15d62'
  },
  {
    AcresBurned: 58,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/11/silver-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T13:36:00Z',
    Latitude: 36.7528,
    Location: 'Elwood Road and Silver Lane, northwest of Squaw Valley',
    Longitude: -119.2288,
    MajorIncident: 'True',
    Name: 'Silver Fire',
    Started: '2017-10-11T15:59:00Z',
    UniqueId: '46d1ec10-be8e-474a-b98f-ba7cd3521ccd'
  },
  {
    AcresBurned: 58,
    AdminUnit: 'USFS - Mendocino National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/9/12/slides-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2018-01-09T13:20:00Z',
    Latitude: 39.42604,
    Location: 'Elk Mountain Rd, west of Lake Pillsbury',
    Longitude: -123.03344,
    MajorIncident: 'False',
    Name: 'Slides Fire',
    Started: '2017-09-12T16:08:00Z',
    UniqueId: 'ab08cb64-67c4-4e7d-8081-b5574131f755'
  },
  {
    AcresBurned: 58,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/18/hogback-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2018-01-09T12:01:00Z',
    Latitude: 36.64404,
    Location: 'off of Hogback Rd and Whitaker Forest Dr, Badger',
    Longitude: -118.99944,
    MajorIncident: 'False',
    Name: 'Hogback Fire',
    Started: '2017-07-18T15:50:00Z',
    UniqueId: '7a317400-8838-4fd4-8c2f-b8c12add5d6a'
  },
  {
    AcresBurned: 58,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/7/tower-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T11:48:00Z',
    Latitude: 35.346,
    Location: 'off northbound Hwy 101, near the Cuesta Grade',
    Longitude: -120.62825,
    MajorIncident: 'False',
    Name: 'Tower Fire',
    Started: '2017-07-07T16:23:00Z',
    UniqueId: 'effeee13-51d7-4cf2-a62f-93b47b34605a'
  },
  {
    AcresBurned: 57,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/28/live-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2018-01-09T12:07:00Z',
    Latitude: 40.1583,
    Location: 'Live Oak Road, Community of Ridgway, west of Red Bluff',
    Longitude: -122.3209,
    MajorIncident: 'False',
    Name: 'Live Fire',
    Started: '2017-07-28T13:24:00Z',
    UniqueId: 'a3bd6249-555a-4ee1-99c0-69333d71bdfb'
  },
  {
    AcresBurned: 57,
    AdminUnit: 'CAL FIRE / Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/4/freedom-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T11:43:00Z',
    Latitude: 36.81476,
    Location: 'Ashland and Riverbend Ave, Sanger City',
    Longitude: -119.51592,
    MajorIncident: 'False',
    Name: 'Freedom Fire',
    Started: '2017-07-04T13:21:00Z',
    UniqueId: '36d953e8-265f-4b05-831e-42eb2298b208'
  },
  {
    AcresBurned: 56,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/18/bogus-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T10:59:00Z',
    Latitude: 41.93006,
    Location: 'Ager Beswick Rd. and Crest Ln. south of Copco Lake',
    Longitude: -122.36545,
    MajorIncident: 'False',
    Name: 'Bogus Fire',
    Started: '2017-06-18T15:45:00Z',
    UniqueId: 'f173524a-ae01-47f5-942d-5e90c2b96469'
  },
  {
    AcresBurned: 55,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/23/estate-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2018-01-09T13:23:00Z',
    Latitude: 38.4446,
    Location: 'Estate Rd & John Wayne Rd, north of Vacaville',
    Longitude: -122.0041,
    MajorIncident: 'True',
    Name: 'Estate Fire',
    Started: '2017-09-23T11:05:00Z',
    UniqueId: 'c9009967-c0c1-47d3-b2eb-47b2d7a5da0e'
  },
  {
    AcresBurned: 55,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/29/owens-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T12:47:00Z',
    Latitude: 41.99483,
    Location: 'off of Owens Rd and Hwy 97, northeast of Dorris',
    Longitude: -121.90077,
    MajorIncident: 'False',
    Name: 'Owens Fire',
    Started: '2017-08-29T15:39:00Z',
    UniqueId: '62b8a6af-700a-4c93-85d5-a9b85a30faf5'
  },
  {
    AcresBurned: 55,
    AdminUnit: 'Los Angeles County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/6/29/topanga-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2018-01-09T11:11:00Z',
    Latitude: 34.03941,
    Location: 'Off Topanga Canyon & Pacific Coast Hwy in Malibu',
    Longitude: -118.58624,
    MajorIncident: 'False',
    Name: 'Topanga Fire',
    Started: '2017-06-29T15:09:00Z',
    UniqueId: 'd1ec9e43-04bd-4926-8362-5e04afe39c90'
  },
  {
    AcresBurned: 54,
    AdminUnit: 'Shasta-Trinity National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/28/bradley-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T12:46:00Z',
    Latitude: 41.222,
    Location: 'West of Dunsmuir',
    Longitude: -122.292,
    MajorIncident: 'False',
    Name: 'Bradley Fire',
    Started: '2017-08-28T22:00:00Z',
    UniqueId: '59fae761-fd49-4f06-a2e9-1495c00eb7e9'
  },
  {
    AcresBurned: 54,
    AdminUnit: 'Shasta-Trinity National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/28/bradley-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T12:46:00Z',
    Latitude: 41.222,
    Location: 'Bradley Ridge, City of Dunsmuir',
    Longitude: -122.27499,
    MajorIncident: 'False',
    Name: 'Bradley Fire',
    Started: '2017-08-28T21:38:00Z',
    UniqueId: 'f8cd3b44-ec6b-4338-9edc-ebd879a8aafc'
  },
  {
    AcresBurned: 54,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/21/quimby-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2018-01-09T11:00:00Z',
    Latitude: 37.33454,
    Location: 'Off Quimby Rd, west of Grant Ranch Park, East San Jose',
    Longitude: -121.76323,
    MajorIncident: 'False',
    Name: 'Quimby Fire',
    Started: '2017-06-21T18:02:00Z',
    UniqueId: 'd515cbcc-376e-4bc7-adea-189eff5a7735'
  },
  {
    AcresBurned: 51,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/26/weller-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2018-01-09T12:07:00Z',
    Latitude: 37.44485,
    Location: 'Weller Rd and Calaveras Rd, 3 miles east of Milpitas',
    Longitude: -121.84108,
    MajorIncident: 'False',
    Name: 'Weller Fire',
    Started: '2017-07-26T23:19:00Z',
    UniqueId: '7b95ce91-9581-4fe6-887d-ab1bf6420205'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/26/tank-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T13:45:00Z',
    Latitude: 35.21556,
    Location: 'Hwy 58 and Keene Ranch Rd, community of Keene',
    Longitude: -118.56578,
    MajorIncident: 'False',
    Name: 'Tank Fire',
    Started: '2017-10-26T11:55:00Z',
    UniqueId: 'fb042e0f-1aab-4ac4-9d09-947c9b9f14b6'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/23/extension-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T13:42:00Z',
    Latitude: 33.8826,
    Location: 'Lambs Canyon Road & Gilman Springs Road, Gilman Springs',
    Longitude: -117.00589,
    MajorIncident: 'False',
    Name: 'Extension Fire',
    Started: '2017-10-23T10:31:00Z',
    UniqueId: '33bf7f90-edd9-4bf7-a079-561d5dad25c9'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'Angeles National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/10/17/wilson-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2018-01-09T13:40:00Z',
    Latitude: 34.22551,
    Location: 'off Mount Wilson Circle near the Mount Wilson Observatory',
    Longitude: -118.05545,
    MajorIncident: 'False',
    Name: 'Wilson Fire',
    Started: '2017-10-17T03:43:00Z',
    UniqueId: 'dcd7fb2e-3a4f-427e-9b13-1d2bcb0e8ac6'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE San Mateo-Santa Cruz Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/11/skeggs-fire/',
    Counties: 'San Mateo',
    CountyIds: 41,
    Extinguished: '2018-01-09T13:20:00Z',
    Latitude: 37.41591,
    Location: 'Skyline Rd and Skeggs Point, 3 miles west of Woodside',
    Longitude: -122.3001,
    MajorIncident: 'True',
    Name: 'Skeggs Fire',
    Started: '2017-09-11T19:41:00Z',
    UniqueId: '81b26bc7-7d65-4591-9d27-4e698cab4f12'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'Kern County Fire Department / Sequoia National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/5/calgary-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T12:19:00Z',
    Latitude: 35.70639,
    Location: 'Old State Rd & Dollar Rd, Wofford Heights',
    Longitude: -118.47307,
    MajorIncident: 'False',
    Name: 'Calgary Fire',
    Started: '2017-08-05T13:16:00Z',
    UniqueId: 'e4834d78-fd4a-44b4-8669-52cbdc41113d'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'Santa Barbara County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/17/mesa-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2018-01-09T11:59:00Z',
    Latitude: 34.72379,
    Location: 'Zaca Station Road and Foxen Canyon Road, north of Los Olivos',
    Longitude: -120.13249,
    MajorIncident: 'False',
    Name: 'Mesa Fire',
    Started: '2017-07-17T14:55:00Z',
    UniqueId: 'a26038b9-df04-4ade-b918-0c4fb9a8dbcf'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/8/west-fire/',
    Counties: 'Yuba',
    CountyIds: 58,
    Extinguished: '2018-01-09T11:50:00Z',
    Latitude: 39.06308,
    Location: 'Camp Far West Rd & Wichita Way, east of Olivehurst',
    Longitude: -121.303,
    MajorIncident: 'False',
    Name: 'West Fire',
    Started: '2017-07-08T16:47:00Z',
    UniqueId: '5a52750e-30a0-4d26-a75b-58f79e1e24f4'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/4/grade-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2018-01-09T11:43:00Z',
    Latitude: 34.20599,
    Location: 'off Hwy 101 & Camarillo Springs Rd, Camarillo Springs',
    Longitude: -118.98603,
    MajorIncident: 'False',
    Name: 'Grade Fire',
    Started: '2017-07-04T14:45:00Z',
    UniqueId: 'f6970f10-0498-4f4c-8e0c-d4b7e4fbf888'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/3/lago-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T11:41:00Z',
    Latitude: 33.87739,
    Location: 'Lake Perris State Recreation Area, Moreno Valley (Riverside County)',
    Longitude: -117.16215,
    MajorIncident: 'False',
    Name: 'Lago Fire',
    Started: '2017-07-03T15:14:00Z',
    UniqueId: '2f97537a-1333-4dfc-b7a3-b7bf9400ffdd'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'MCI Camp Pendleton',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/6/13/douglas-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T10:32:00Z',
    Latitude: 33.23281,
    Location: 'Hwy. 76 & College Blvd., Oceanside, Camp Pendleton',
    Longitude: -117.29509,
    MajorIncident: 'False',
    Name: 'Douglas Fire',
    Started: '2017-06-13T14:31:00Z',
    UniqueId: '3fc7de4e-3a0f-45e9-be1f-801f88770883'
  },
  {
    AcresBurned: 48,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/20/power-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2018-01-09T13:23:00Z',
    Latitude: 36.94652,
    Location: 'off Arburua Road and I-5, southwest of Los Banos',
    Longitude: -120.90462,
    MajorIncident: 'False',
    Name: 'Power Fire',
    Started: '2017-09-20T21:07:00Z',
    UniqueId: 'e7cb239e-7d9e-440d-ba5a-c6881406ce95'
  },
  {
    AcresBurned: 48,
    AdminUnit: 'CAL FIRE Riverside Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/28/serenas-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:21:00Z',
    Latitude: 33.58577,
    Location: 'off Avenue 64 and Las Serenas Street',
    Longitude: -116.07429,
    MajorIncident: 'False',
    Name: 'Serenas Fire',
    Started: '2017-05-28T15:27:00Z',
    UniqueId: '2db503da-a7b2-47a6-92a6-697799eb63f1'
  },
  {
    AcresBurned: 47,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/11/25/bitterwater-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2018-01-09T13:46:00Z',
    Latitude: 36.38109,
    Location: 'Airline Hwy and Bitterwater Road',
    Longitude: -121.00391,
    MajorIncident: 'False',
    Name: 'Bitterwater Fire',
    Started: '2017-11-25T16:46:00Z',
    UniqueId: 'c265dfe8-6217-4a0d-9ea9-37be3b38baef'
  },
  {
    AcresBurned: 47,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/20/zenon-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T12:03:00Z',
    Latitude: 35.06472,
    Location: 'off Zenon Way, Nipomo',
    Longitude: -120.5634,
    MajorIncident: 'False',
    Name: 'Zenon Fire',
    Started: '2017-07-20T14:43:00Z',
    UniqueId: '7dd19215-986b-4365-a40d-2267b4a05de0'
  },
  {
    AcresBurned: 46,
    AdminUnit: 'CAL FIRE / USFS - Cleveland National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/27/canyon-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T12:45:00Z',
    Latitude: 33.6444,
    Location: 'Highway 74 and South Main Divide, 2 miles southwest of Lake Elsinore',
    Longitude: -117.3968,
    MajorIncident: 'False',
    Name: 'Canyon Fire',
    Started: '2017-08-27T14:51:00Z',
    UniqueId: '78754c68-2800-4c5d-aff0-ab0b399ab5ce'
  },
  {
    AcresBurned: 46,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/12/hidden-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T11:54:00Z',
    Latitude: 34.149,
    Location: 'Hwy 330, 1 mile north of Highland',
    Longitude: -117.189,
    MajorIncident: 'False',
    Name: 'Hidden Fire',
    Started: '2017-07-12T15:29:00Z',
    UniqueId: '826b4661-020b-425d-84ec-9426c39839e7'
  },
  {
    AcresBurned: 46,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/6/whitepine-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T10:27:00Z',
    Latitude: 41.8721,
    Location: 'Whitepine Road and Blue Heron Place, 10 miles east of Hornbrook',
    Longitude: -122.4571,
    MajorIncident: 'True',
    Name: 'Whitepine Fire',
    Started: '2017-06-06T16:38:00Z',
    UniqueId: 'f8b61fab-bd14-4e92-960a-d512693ea8e5'
  },
  {
    AcresBurned: 45,
    AdminUnit: 'City of Riverside Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/12/21/riverbottom-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T13:49:00Z',
    Latitude: 33.9885,
    Location: 'Mission Inn Ave. and Redwood Dr., Riverside',
    Longitude: -117.38417,
    MajorIncident: 'False',
    Name: 'Riverbottom Fire',
    Started: '2017-12-21T11:16:00Z',
    UniqueId: 'e32c7957-8f4f-4ec1-a0f6-98085a2a7e89'
  },
  {
    AcresBurned: 45,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/10/9/pozo-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T13:34:00Z',
    Latitude: 35.28738,
    Location: 'near 3055  West Pozo Rd',
    Longitude: -120.44448,
    MajorIncident: 'False',
    Name: 'Pozo Fire',
    Started: '2017-10-09T14:30:00Z',
    UniqueId: 'f8ce12e2-e7c1-4922-b584-63e4421d0598'
  },
  {
    AcresBurned: 45,
    AdminUnit: 'CAL FIRE Shasta-Trintiy Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/4/3/grace-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2018-01-09T09:41:00Z',
    Latitude: 40.48712,
    Location: 'Grace Resort Rd and Bluebush Way, 2 miles SE of the Community of Shingletown',
    Longitude: -121.85645,
    MajorIncident: 'False',
    Name: 'Grace Fire',
    Started: '2017-04-03T16:00:00Z',
    UniqueId: '95960fa6-58ba-4b4e-aeb2-ada97d699908'
  },
  {
    AcresBurned: 44,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/27/mines-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2018-01-09T12:45:00Z',
    Latitude: 37.56181,
    Location: 'Mines Road and Crane Ridge Road, 8 miles S of Livermore',
    Longitude: -121.56425,
    MajorIncident: 'False',
    Name: 'Mines Fire',
    Started: '2017-08-27T17:45:00Z',
    UniqueId: '399dba2c-02c1-4756-a76d-1198d0e838ed'
  },
  {
    AcresBurned: 43,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/11/2/roser-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2018-01-09T13:46:00Z',
    Latitude: 39.81517,
    Location: 'Roser Rd & Sour Grass Rd, 6 miles NW of Orland',
    Longitude: -122.28165,
    MajorIncident: 'False',
    Name: 'Roser Fire',
    Started: '2017-11-02T14:40:00Z',
    UniqueId: 'eadd73be-51ab-4078-91cc-04784be3f17f'
  },
  {
    AcresBurned: 43,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/11/pine-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2018-01-09T13:19:00Z',
    Latitude: 36.17297,
    Location: 'off of Hwy 198 and Pine Valley, east of San Lucas',
    Longitude: -120.87609,
    MajorIncident: 'False',
    Name: 'Pine Fire',
    Started: '2017-09-11T15:11:00Z',
    UniqueId: 'ed4e06ba-6d17-459a-831a-9b15a9bd116e'
  },
  {
    AcresBurned: 42,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/29/lockwood-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2018-01-09T11:11:00Z',
    Latitude: 35.96275,
    Location: 'off San Lucas Rd and Martinez Rd',
    Longitude: -121.08753,
    MajorIncident: 'False',
    Name: 'Lockwood Fire',
    Started: '2017-06-29T20:44:00Z',
    UniqueId: 'abe2311a-4ce6-4300-9716-4fb3fe538c75'
  },
  {
    AcresBurned: 42,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/24/paskenta-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2018-01-09T11:07:00Z',
    Latitude: 40.10282,
    Location: 'Off Paskenta Rd, west of Red Bluff',
    Longitude: -122.27379,
    MajorIncident: 'False',
    Name: 'Paskenta Fire',
    Started: '2017-06-24T11:15:00Z',
    UniqueId: '982c81ca-ebe5-4591-986d-1f3e2e4cc13c'
  },
  {
    AcresBurned: 42,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/3/jones-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2018-01-09T10:24:00Z',
    Latitude: 41.38247,
    Location: 'Off Hwy 395, south of Alturas',
    Longitude: -120.53443,
    MajorIncident: 'False',
    Name: 'Jones Fire',
    Started: '2017-06-03T13:09:00Z',
    UniqueId: '7967c729-4693-47a1-b1bc-1d82825ca8db'
  },
  {
    AcresBurned: 41,
    AdminUnit: 'Rogue-River-Siskiyou National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/13/ward-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T12:38:00Z',
    Latitude: 41.99279,
    Location: 'Wards Fork south of Donomore Meadows near the Oregon border.',
    Longitude: -122.9401,
    MajorIncident: 'False',
    Name: 'Ward Fire',
    Started: '2017-08-13T12:41:00Z',
    UniqueId: 'f0dbf1f5-9f21-4d11-a432-d32f7f18c412'
  },
  {
    AcresBurned: 41,
    AdminUnit: 'Los Angeles County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/29/stokes-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2018-01-09T11:11:00Z',
    Latitude: 34.10446,
    Location: 'Stokes Rd. and Mulholland Dr in Calabasas',
    Longitude: -118.70294,
    MajorIncident: 'False',
    Name: 'Stokes Fire',
    Started: '2017-06-29T15:45:00Z',
    UniqueId: '6f2f8dc0-b930-435e-a622-d3585dcac067'
  },
  {
    AcresBurned: 41,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/14/feed-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T09:57:00Z',
    Latitude: 35.05076,
    Location: 'Sabastian Rd and Wheeler, southeast of Arvin',
    Longitude: -118.90004,
    MajorIncident: 'False',
    Name: 'Feed Fire',
    Started: '2017-05-14T14:00:00Z',
    UniqueId: '9f416f37-a8ca-4127-a6b7-02626fd32e06'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE/Riverside County Fire and Riverside City Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/12/4/riverdale-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T13:47:00Z',
    Latitude: 33.96514,
    Location: 'Riverdale Place and Lakeview Ave, Santa Ana Riverbed',
    Longitude: -117.4764,
    MajorIncident: 'False',
    Name: 'Riverdale Fire',
    Started: '2017-12-04T12:26:00Z',
    UniqueId: 'c425ed8d-1aab-44c8-bc03-39675ad2b0d2'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/11/14/palm-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T13:46:00Z',
    Latitude: 33.90327,
    Location: 'Off Palm Dr & 20th Ave, Desert Hot Springs',
    Longitude: -116.50151,
    MajorIncident: 'False',
    Name: 'Palm Fire',
    Started: '2017-11-14T16:11:00Z',
    UniqueId: '60d9b4f4-7b48-4820-9adc-5be0b4353a5c'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'San Bernardino County Fire and Rancho Cucamonga Fire District',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/10/24/freeway-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T13:45:00Z',
    Latitude: 34.13534,
    Location: 'Interstate 15 and Interstate 210, Rancho Cucamonga',
    Longitude: -117.4982,
    MajorIncident: 'False',
    Name: 'Freeway Fire',
    Started: '2017-10-24T10:27:00Z',
    UniqueId: '50bd55cc-7c58-462d-a919-923b4bdcca15'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Shasta-Trintiy Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/8/jones-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2018-01-09T13:31:00Z',
    Latitude: 40.70627,
    Location: 'off of Argonaut Trail and Dry Creek Rd, Jones Valley',
    Longitude: -122.24199,
    MajorIncident: 'False',
    Name: 'Jones Fire',
    Started: '2017-10-08T04:53:00Z',
    UniqueId: '6ab80358-cb3c-4e2a-85da-0cd77003fc12'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/29/lakewood-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T13:29:00Z',
    Latitude: 35.59302,
    Location: 'Todd Ct and Brick Dr, east of Lake Isabella',
    Longitude: -118.46734,
    MajorIncident: 'False',
    Name: 'Lakewood Fire',
    Started: '2017-09-29T15:58:00Z',
    UniqueId: '62a5257e-a841-4f7a-ae19-52aa89570bd9'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'Six Rivers National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/9/12/hole-fire/',
    Counties: 'Del Norte',
    CountyIds: 8,
    Extinguished: '2018-01-09T13:20:00Z',
    Latitude: 41.98128,
    Location: 'off Low Divide Rd, west of Rockland',
    Longitude: -124.01168,
    MajorIncident: 'False',
    Name: 'Hole Fire',
    Started: '2017-09-12T12:45:00Z',
    UniqueId: '59d6fc84-0d58-4e29-b910-1993dba51b3a'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'Shasta Trinity National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/28/translator-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2018-01-09T12:46:00Z',
    Latitude: 41.02705,
    Location: 'Tish Tang Road and Hostler, Hoopa',
    Longitude: -123.63721,
    MajorIncident: 'False',
    Name: 'Translator Fire',
    Started: '2017-08-28T08:01:00Z',
    UniqueId: '18a2b3d6-d86e-4147-ab42-d45b8792e98a'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/26/vestal-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2018-01-09T12:45:00Z',
    Latitude: 40.29831,
    Location: 'Hwy 36 and Vestal Road, west of Red Bluff',
    Longitude: -122.70449,
    MajorIncident: 'False',
    Name: 'Vestal Fire',
    Started: '2017-08-26T15:03:00Z',
    UniqueId: 'becd0762-0e22-4c54-a1c5-3ecd3660dd70'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/17/murphy-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2018-01-09T11:59:00Z',
    Latitude: 38.86056,
    Location: 'Hwy 29 and Agua Dulce, 3 miles south of Lower lake',
    Longitude: -122.62382,
    MajorIncident: 'False',
    Name: 'Murphy Fire',
    Started: '2017-07-17T14:44:00Z',
    UniqueId: '1ba1f29a-5281-4f53-857d-106ae5e7db84'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'Monterey County Regional Fire District',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/16/reservation-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2018-01-09T11:56:00Z',
    Latitude: 36.66684,
    Location: 'off Reservation Rd and Blanco Rd, east of the city of Marina',
    Longitude: -121.74826,
    MajorIncident: 'False',
    Name: 'Reservation Fire',
    Started: '2017-07-16T11:17:00Z',
    UniqueId: '13dedbc3-8b85-4f64-b3db-89ed81ed4f1d'
  },
  {
    AcresBurned: 39,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/19/table-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2018-03-26T10:49:00Z',
    Latitude: 37.896778,
    Location: 'On Table Mountain, west of Table Mountain Road and Chicken Ranch Road, Jamestown',
    Longitude: -120.504134,
    MajorIncident: 'False',
    Name: 'Table Fire',
    Started: '2017-09-19T00:22:00Z',
    UniqueId: '38c666cb-6545-428f-985d-a2589dfb3700'
  },
  {
    AcresBurned: 39,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/24/spenceville-fire/',
    Counties: 'Yuba',
    CountyIds: 58,
    Extinguished: '2018-01-09T12:05:00Z',
    Latitude: 39.06522,
    Location: 'Spenceville Rd & Monarch Trail Dr, Wheatland',
    Longitude: -121.3519,
    MajorIncident: 'True',
    Name: 'Spenceville Fire',
    Started: '2017-07-24T14:56:00Z',
    UniqueId: 'ebcee501-5709-4382-8eab-d8595ba6606d'
  },
  {
    AcresBurned: 39,
    AdminUnit: 'Vallejo City Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/6/22/toll-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2018-01-09T11:01:00Z',
    Latitude: 38.07481,
    Location: 'off of I-80 and Sonoma Blvd,  Vallejo',
    Longitude: -122.23004,
    MajorIncident: 'False',
    Name: 'Toll Fire',
    Started: '2017-06-22T13:08:00Z',
    UniqueId: '949e577d-86c2-4def-b25a-c24aa014f4d9'
  },
  {
    AcresBurned: 38,
    AdminUnit: 'Marin County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/27/pine-fire/',
    Counties: 'Marin',
    CountyIds: 21,
    Extinguished: '2018-01-09T11:09:00Z',
    Latitude: 37.9775,
    Location: 'off San Geronimo Ridge Road and Pine Mountain Fire Road, south of Woodacre',
    Longitude: -122.65749,
    MajorIncident: 'False',
    Name: 'Pine Fire',
    Started: '2017-06-27T10:39:00Z',
    UniqueId: '243567d6-2692-4978-88f5-1bbfc7b818a6'
  },
  {
    AcresBurned: 38,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/11/red-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2018-01-09T10:31:00Z',
    Latitude: 37.85137,
    Location: 'Red Hills Road & Six Bit Gulch Road, 2 miles southwest of Chinese Camp',
    Longitude: -120.45268,
    MajorIncident: 'False',
    Name: 'Red Fire',
    Started: '2017-06-11T18:49:00Z',
    UniqueId: '5d521085-d92f-4664-b17b-732783658daa'
  },
  {
    AcresBurned: 37,
    AdminUnit: 'Shasta-Trinity National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/10/31/bridge-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2018-01-09T13:46:00Z',
    Latitude: 40.774,
    Location: 'I-5 and Turntable Bay, 7 miles NE of Shasta Lake',
    Longitude: -122.309,
    MajorIncident: 'False',
    Name: 'Bridge Fire',
    Started: '2017-10-31T11:22:00Z',
    UniqueId: '2ca11d45-8139-4c16-8af0-880d99b21e82'
  },
  {
    AcresBurned: 36,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/7/banderilla-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2018-01-09T11:48:00Z',
    Latitude: 37.65963,
    Location: 'Banderilla Dr & Hidalgo St, north of Hayward',
    Longitude: -120.34802,
    MajorIncident: 'False',
    Name: 'Banderilla Fire',
    Started: '2017-07-07T15:50:00Z',
    UniqueId: '932a3f2f-6c0e-42a6-b357-f333774b4ea8'
  },
  {
    AcresBurned: 36,
    AdminUnit: 'CAL FIRE San Diego Unit / Cleveland National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/25/black-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T11:07:00Z',
    Latitude: 33.1683,
    Location: 'Off Black Canyon Rd & Mesa Grande Rd, Ramona',
    Longitude: -116.77342,
    MajorIncident: 'False',
    Name: 'Black Fire',
    Started: '2017-06-25T12:09:00Z',
    UniqueId: '49a9074c-c30b-4042-9ffd-1a10f9d9bf1d'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/29/melba-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T13:28:00Z',
    Latitude: 33.74925,
    Location: 'Hy 74 and Melba Avenue',
    Longitude: -117.10301,
    MajorIncident: 'False',
    Name: 'Melba Fire',
    Started: '2017-09-29T18:01:00Z',
    UniqueId: '58533f37-ed81-4ac4-89e9-b4088684d9e7'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'Marin County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/12/spaletta-fire/',
    Counties: 'Marin',
    CountyIds: 21,
    Extinguished: '2018-01-09T11:54:00Z',
    Latitude: 38.08055,
    Location: 'Point Reyes - Petaluma Road, Petaluma',
    Longitude: -122.77846,
    MajorIncident: 'False',
    Name: 'Spaletta Fire',
    Started: '2017-07-12T16:15:00Z',
    UniqueId: 'bf2e0a34-e600-4e21-9135-168e28c2893d'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/4/jurupa-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T11:43:00Z',
    Latitude: 33.99316,
    Location: 'Off Van Buren Bl & Jurupa Rd in Jurupa Valley',
    Longitude: -117.48405,
    MajorIncident: 'False',
    Name: 'Jurupa Fire',
    Started: '2017-07-04T15:20:00Z',
    UniqueId: '252345dd-886b-4bd2-90b9-161727a2fc2d'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/27/latrobe-fire/',
    Counties: 'Sacramento',
    CountyIds: 34,
    Extinguished: '2018-01-09T11:09:00Z',
    Latitude: 38.45822,
    Location: 'off Hwy 16 & Latrobe Rd, east of White Rock (Sacramento County)',
    Longitude: -120.92162,
    MajorIncident: 'False',
    Name: 'Latrobe Fire',
    Started: '2017-06-27T07:39:00Z',
    UniqueId: '4f0ff7c1-7c96-4f68-87e8-be4466945c2b'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/9/breckenridge-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T10:29:00Z',
    Latitude: 35.37351,
    Location: 'Breckenridge Rd and Comanche Dr., 5 miles east of Bakersfield',
    Longitude: -118.84134,
    MajorIncident: 'False',
    Name: 'Breckenridge Fire',
    Started: '2017-06-09T04:53:00Z',
    UniqueId: 'b11adfe0-b74d-4321-b1bd-3fc0b8f0929b'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE/ Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/21/smiley-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:07:00Z',
    Latitude: 33.96419,
    Location: 'Reche Canyon Road and Smiley Boulevard',
    Longitude: -117.20507,
    MajorIncident: 'False',
    Name: 'Smiley Fire',
    Started: '2017-05-21T16:12:00Z',
    UniqueId: '54ddf2ef-28b0-4c34-bfe0-1d084f4f57e2'
  },
  {
    AcresBurned: 34,
    AdminUnit: 'Unified Command: CAL FIRE / San Bernardino County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/12/5/meyers-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T13:47:00Z',
    Latitude: 34.21829,
    Location: 'near the Hwy 15 and Hwy 215 junction, near Glen Helen Regional Park',
    Longitude: -117.40625,
    MajorIncident: 'False',
    Name: 'Meyers Fire',
    Started: '2017-12-05T13:28:00Z',
    UniqueId: 'c5783ba0-227e-4ff6-9d7d-61532ccd469b'
  },
  {
    AcresBurned: 34,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/10/ellie-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T13:19:00Z',
    Latitude: 33.73547,
    Location: 'Ellie Way and El Toro Road, Lake Elsinore',
    Longitude: -117.33364,
    MajorIncident: 'False',
    Name: 'Ellie Fire',
    Started: '2017-09-10T13:49:00Z',
    UniqueId: '99a7ed51-e64a-4aa9-b8ba-6a9ae4752db0'
  },
  {
    AcresBurned: 34,
    AdminUnit: 'CAL FIRE/Humboldt-Del Norte Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/31/miller-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2018-01-09T12:49:00Z',
    Latitude: 40.03697,
    Location: 'Miller Ranch road x Bell Springs road, 10 miles NE Leggett',
    Longitude: -123.64214,
    MajorIncident: 'False',
    Name: 'Miller Fire',
    Started: '2017-08-31T13:57:00Z',
    UniqueId: '62a6c794-97db-4b57-9033-958bcf2e5a99'
  },
  {
    AcresBurned: 34,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/4/valley-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2018-01-09T11:42:00Z',
    Latitude: 36.85596,
    Location: 'Off Santa Ana Valley Rd & Douglas Dr, Hollister',
    Longitude: -121.30983,
    MajorIncident: 'False',
    Name: 'Valley Fire',
    Started: '2017-07-04T13:21:00Z',
    UniqueId: '9668cfe5-b636-4147-bce1-da8e8b3fb5c2'
  },
  {
    AcresBurned: 33,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/7/christmas-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T11:46:00Z',
    Latitude: 33.763304,
    Location: 'off Christmas Tree Ln & Santa Rosa Mine Rd, in Good Meadow',
    Longitude: -117.314994,
    MajorIncident: 'False',
    Name: 'Christmas Fire',
    Started: '2017-07-07T12:56:00Z',
    UniqueId: 'bc89aab5-5f30-46a2-9881-6dbae22893b6'
  },
  {
    AcresBurned: 33,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/13/valley-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:32:00Z',
    Latitude: 33.584036,
    Location: 'San Ignacio Road and East Benton Road, Temecula',
    Longitude: -116.972036,
    MajorIncident: 'False',
    Name: 'Valley Fire',
    Started: '2017-06-13T12:00:00Z',
    UniqueId: '67ba6e61-b5ca-48f4-8e56-9cedeaeb65ea'
  },
  {
    AcresBurned: 33,
    AdminUnit: 'Kern County Fire Department, CAL FIRE and Bureau of Land Management',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/4/creek-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T10:24:00Z',
    Latitude: 35.60633,
    Location: 'off Erskine Creek Rd and Pasadena Ln, southwest of Lake Isabella',
    Longitude: -118.4642,
    MajorIncident: 'False',
    Name: 'Creek Fire',
    Started: '2017-06-04T22:11:00Z',
    UniqueId: '46c4f0c2-6760-4e42-ac2f-ec25c2486628'
  },
  {
    AcresBurned: 32,
    AdminUnit: 'Shasta-Trinity National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/2/sandy-fire/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2018-01-09T12:16:00Z',
    Latitude: 40.804,
    Location: 'North of Hwy 299, west of Del Loma',
    Longitude: -123.375,
    MajorIncident: 'False',
    Name: 'Sandy Fire',
    Started: '2017-08-02T11:13:00Z',
    UniqueId: '5ef75bbf-adba-424a-bef3-a5efed5b5e2c'
  },
  {
    AcresBurned: 32,
    AdminUnit: 'Shasta-Trinity National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/2/sandy-fire/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2018-01-09T12:17:00Z',
    Latitude: 40.79902,
    Location: 'Sandy Bar, Hwy 299, 4 miles east of Burnt Ranch',
    Longitude: -123.39253,
    MajorIncident: 'False',
    Name: 'Sandy Fire',
    Started: '2017-08-02T08:30:00Z',
    UniqueId: '5367822f-b489-4da5-b90e-c5b2c8abf318'
  },
  {
    AcresBurned: 32,
    AdminUnit: 'CALFIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/13/washington-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T11:54:00Z',
    Latitude: 33.62613,
    Location: 'Field Drive & Patterson Road, Community of Winchester',
    Longitude: -117.07975,
    MajorIncident: 'False',
    Name: 'Washington Fire',
    Started: '2017-07-13T10:28:00Z',
    UniqueId: 'bfa2d3e8-2ede-423f-b7db-f8e6f44a3c82'
  },
  {
    AcresBurned: 32,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/16/shore-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2018-01-09T10:34:00Z',
    Latitude: 35.90092,
    Location: 'Jolon Rd and Frudden Rd, near Lockwood',
    Longitude: -120.93371,
    MajorIncident: 'True',
    Name: 'Shore Fire',
    Started: '2017-06-16T15:49:00Z',
    UniqueId: '7cae5704-9ba2-487c-a48b-bb440c95da6e'
  },
  {
    AcresBurned: 32,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/11/pleyto-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2018-01-09T10:30:00Z',
    Latitude: 35.902149,
    Location: 'New Pleyto Road cross of Stern st, Lockwood',
    Longitude: -120.983684,
    MajorIncident: 'False',
    Name: 'Pleyto Fire',
    Started: '2017-06-11T18:12:00Z',
    UniqueId: 'f32d4562-5032-4645-ac8f-afb3fab4c704'
  },
  {
    AcresBurned: 31,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/15/york-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2018-01-09T13:40:00Z',
    Latitude: 36.5858,
    Location: 'off York Road and S Boundary Road, east of Monterey',
    Longitude: -121.80377,
    MajorIncident: 'False',
    Name: 'York Fire',
    Started: '2017-10-15T14:55:00Z',
    UniqueId: 'c58da6fd-a2e2-4706-9a2e-ee03884c714d'
  },
  {
    AcresBurned: 31,
    AdminUnit: 'CAL FIRE / Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/23/juniper-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T12:44:00Z',
    Latitude: 36.099681,
    Location: 'off of Highway 198 west of Parsons Road, Coalinga',
    Longitude: -120.443545,
    MajorIncident: 'False',
    Name: 'Juniper Fire',
    Started: '2017-08-23T13:28:00Z',
    UniqueId: '83d87ff0-be6c-46fa-ab96-b9845d5d4edc'
  },
  {
    AcresBurned: 31,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/12/hub-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T09:55:00Z',
    Latitude: 35.60001,
    Location: 'Red Hill Road and Schick Road, 2 miles east of Lake Isabella',
    Longitude: -118.4683,
    MajorIncident: 'False',
    Name: 'Hub Fire',
    Started: '2017-05-12T05:05:00Z',
    UniqueId: '5115a26e-e8e8-42cd-9aeb-f5c41efd770a'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'Los Angeles County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/31/castaic-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2018-03-22T16:34:00Z',
    Latitude: 34.52055,
    Location: 'I-5, north of Hughes Rd., 2 miles north of Lake Hughes',
    Longitude: -118.62882,
    MajorIncident: 'False',
    Name: 'Castaic Fire',
    Started: '2017-08-31T16:32:00Z',
    UniqueId: '1e9d7aca-8862-4dff-a8af-5f687afdfda0'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Humboldt-Del Norte Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/3/blocksburg-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2018-01-09T12:18:00Z',
    Latitude: 40.27582,
    Location: 'Off Alderpoint Rd and Cemetery Rd, Blocksburg',
    Longitude: -123.64281,
    MajorIncident: 'False',
    Name: 'Blocksburg Fire',
    Started: '2017-08-03T16:41:00Z',
    UniqueId: 'e1582691-805c-4627-b20b-e5e8ba110f20'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/3/timber-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T11:42:00Z',
    Latitude: 33.96896,
    Location: 'off Moreno Beach Dr & Locust, north of Moreno Valley',
    Longitude: -117.25411,
    MajorIncident: 'False',
    Name: 'Timber Fire',
    Started: '2017-07-03T19:31:00Z',
    UniqueId: 'b51d7a8d-f768-453e-abb4-665b74998b21'
  },
  {
    AcresBurned: 29,
    AdminUnit: 'USFS - El Dorado National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/10/10/ice-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2018-01-09T13:35:00Z',
    Latitude: 38.77921,
    Location: 'off Ice House Road and US-50, east of Riverton, 13 miles east of Camino',
    Longitude: -120.46234,
    MajorIncident: 'False',
    Name: 'Ice Fire',
    Started: '2017-10-10T15:36:00Z',
    UniqueId: '0e9f14ae-01d5-4fbe-85a0-d0967233dc90'
  },
  {
    AcresBurned: 29,
    AdminUnit: 'CAL FIRE Tehema-Glenn Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/8/benson-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2018-01-09T11:51:00Z',
    Latitude: 40.29118,
    Location: 'Benson Rd, Bowman., 11 miles northwest of Red Bluff',
    Longitude: -122.42606,
    MajorIncident: 'False',
    Name: 'Benson Fire',
    Started: '2017-07-08T18:58:00Z',
    UniqueId: 'de1788c0-2996-40cf-9f76-2920b210d6a9'
  },
  {
    AcresBurned: 28,
    AdminUnit: 'CAL FIRE / Butte County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/25/32-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-01-09T13:24:00Z',
    Latitude: 39.8255,
    Location: 'Hwy 32 and Humboldt Road, 5 miles northeast of Chico',
    Longitude: -121.7127,
    MajorIncident: 'False',
    Name: '32 Fire',
    Started: '2017-09-25T11:03:00Z',
    UniqueId: 'cf38fe5e-29ca-498d-bc9c-d3f2fd8ff883'
  },
  {
    AcresBurned: 28,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/30/4-4-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2018-01-09T12:48:00Z',
    Latitude: 41.4844,
    Location: '4 miles east of Dorris Reservoir, east of Alturas',
    Longitude: -120.36659,
    MajorIncident: 'False',
    Name: '4-4 Fire',
    Started: '2017-08-30T11:38:00Z',
    UniqueId: '5e01dba8-3d59-41a6-ba60-d78d874eba42'
  },
  {
    AcresBurned: 28,
    AdminUnit: 'CAL FIRE Humboldt-Del Norte Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/26/shore-fire/',
    Counties: 'Del Norte',
    CountyIds: 8,
    Extinguished: '2018-01-09T11:08:00Z',
    Latitude: 41.93323,
    Location: 'in Tolowa Dunes State Park, 3 miles west of Smith River (Del Norte County)',
    Longitude: -124.19629,
    MajorIncident: 'False',
    Name: 'Shore Fire',
    Started: '2017-06-26T21:30:00Z',
    UniqueId: '2c00a509-af87-418f-b888-edc8ec450f1f'
  },
  {
    AcresBurned: 28,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/15/nuevo-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:33:00Z',
    Latitude: 33.79925,
    Location: 'Hansen Avenue and Nuevo Road in Nuevo',
    Longitude: -117.11659,
    MajorIncident: 'False',
    Name: 'Nuevo Fire',
    Started: '2017-06-15T15:51:00Z',
    UniqueId: '57b7776f-bae7-4b14-b94c-65806e002a88'
  },
  {
    AcresBurned: 27,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/30/4-10-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2018-01-09T12:48:00Z',
    Latitude: 41.64469,
    Location: 'off Highway 395 and County Road 118, 16 miles north of Alturas.',
    Longitude: -120.31814,
    MajorIncident: 'True',
    Name: '4-10 Fire',
    Started: '2017-08-30T14:50:00Z',
    UniqueId: '182f71e9-0f85-4cb0-8711-ee14c0b6b8f8'
  },
  {
    AcresBurned: 27,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/3/vernon-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:24:00Z',
    Latitude: 33.82165,
    Location: 'Off Soboba Road in San Jacinto',
    Longitude: -116.96079,
    MajorIncident: 'False',
    Name: 'Vernon Fire',
    Started: '2017-06-03T12:09:00Z',
    UniqueId: 'b0ffe2e4-ae61-4ad9-b1cc-bf31ff254d8d'
  },
  {
    AcresBurned: 26,
    AdminUnit: 'Wheatland Fire Protection District',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/26/jasper-fire/',
    Counties: 'Yuba',
    CountyIds: 58,
    Extinguished: '2018-01-09T13:25:00Z',
    Latitude: 39.03168,
    Location: 'Jasper lane and Levee road, 1 mile NE of Wheatland',
    Longitude: -121.40947,
    MajorIncident: 'False',
    Name: 'Jasper Fire',
    Started: '2017-09-26T15:20:00Z',
    UniqueId: 'ab42234a-7930-4636-8af5-3fc11ca8b34d'
  },
  {
    AcresBurned: 26,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/18/trellis-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:59:00Z',
    Latitude: 33.71025,
    Location: 'State Highway 74 near Trellis Lane',
    Longitude: -117.31924,
    MajorIncident: 'False',
    Name: 'Trellis Fire',
    Started: '2017-06-18T16:03:00Z',
    UniqueId: 'bfa879b5-b526-4114-9137-51d3ea3ad336'
  },
  {
    AcresBurned: 26,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/1/fairview-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:23:00Z',
    Latitude: 33.94788,
    Location: 'Fairview Road & Old Morongo Road, west of Desert Hot Springs',
    Longitude: -116.59719,
    MajorIncident: 'False',
    Name: 'Fairview Fire',
    Started: '2017-06-01T16:12:00Z',
    UniqueId: '663d291c-7ba8-415d-9cab-58d41a886cfd'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/15/wilson-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T13:40:00Z',
    Latitude: 33.18716,
    Location: 'at Wilson Road, east of San Felipe',
    Longitude: -116.50897,
    MajorIncident: 'False',
    Name: 'Wilson Fire',
    Started: '2017-10-15T14:05:00Z',
    UniqueId: 'd720af5d-af7c-4052-92b3-fced863cb675'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/23/cove-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T13:23:00Z',
    Latitude: 35.76343,
    Location: 'Lynch Canyon Rd & Lakeview Rd, northwest of Lake Nacimiento',
    Longitude: -121.04445,
    MajorIncident: 'False',
    Name: 'Cove Fire',
    Started: '2017-09-23T15:40:00Z',
    UniqueId: '92fc9725-ac49-4632-8bbf-e299483940b8'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE / San Diego County Fire Authority',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/7/border-9-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T13:19:00Z',
    Latitude: 32.59252,
    Location: '1 mile west of Tecate Port Of Entry in Potrero',
    Longitude: -116.61609,
    MajorIncident: 'False',
    Name: 'Border 9 Fire',
    Started: '2017-09-07T15:41:00Z',
    UniqueId: 'd0b51e42-5558-47c9-8617-34f6f977ab79'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/1/hopper-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2018-01-09T12:49:00Z',
    Latitude: 40.71923,
    Location: 'Oak Run Road and Hopper Lane, Oak Run',
    Longitude: -122.02525,
    MajorIncident: 'False',
    Name: 'Hopper Fire',
    Started: '2017-09-01T11:21:00Z',
    UniqueId: '406e30d2-2ac0-4c0b-998c-761adde20177'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/27/sloane-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T11:09:00Z',
    Latitude: 32.7789,
    Location: 'off Sloane Canyon Road at Dehesa Road, east of El Cajon',
    Longitude: -116.8516,
    MajorIncident: 'False',
    Name: 'Sloane Fire',
    Started: '2017-06-27T09:38:00Z',
    UniqueId: '7696644d-0908-4149-8d6e-aa50c1233d67'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'Madera County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/18/road-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2018-01-09T10:35:00Z',
    Latitude: 37.02081,
    Location: 'Road 400 and Road 33, 7 miles east of Madera',
    Longitude: -119.95136,
    MajorIncident: 'False',
    Name: 'Road Fire',
    Started: '2017-06-18T14:04:00Z',
    UniqueId: 'b3695ebc-e761-4577-8439-6330bed36594'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'Los Angeles County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/3/5-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2018-01-09T10:24:00Z',
    Latitude: 34.29931,
    Location: 'I-5, North of Lake Hughes Rd, Community of Cataic',
    Longitude: -118.37539,
    MajorIncident: 'False',
    Name: '5 Fire',
    Started: '2017-06-03T15:39:00Z',
    UniqueId: '14e249f0-f21c-4d2f-bc5f-68d5d177e849'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/24/ribbonwood-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T10:10:00Z',
    Latitude: 32.679,
    Location: 'Off of Ribbonwood Road and Interstate 8, east of El Cajon',
    Longitude: -116.29296,
    MajorIncident: 'False',
    Name: 'Ribbonwood Fire',
    Started: '2017-05-24T15:30:00Z',
    UniqueId: '9b9bf8b4-8378-46e5-a760-67e89e2279e2'
  },
  {
    AcresBurned: 23,
    AdminUnit: 'CAL FIRE/ Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/10/portola-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T13:32:00Z',
    Latitude: 33.50488,
    Location: 'De Portola Road east of Pauba Road, Temecula',
    Longitude: -117.02132,
    MajorIncident: 'False',
    Name: 'Portola Fire',
    Started: '2017-10-10T14:57:00Z',
    UniqueId: '61e9a1f4-a263-47a0-93ee-64b52ebd92a9'
  },
  {
    AcresBurned: 22,
    AdminUnit: 'Oakland City Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/9/26/edwards-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2018-01-09T13:25:00Z',
    Latitude: 37.77982,
    Location: 'Edwards Ave and Mountain Blvd, 6 miles southeast of Oakland',
    Longitude: -122.169,
    MajorIncident: 'False',
    Name: 'Edwards Fire',
    Started: '2017-09-26T12:22:00Z',
    UniqueId: 'c4f61042-d1ef-4d00-956d-785368ee34ca'
  },
  {
    AcresBurned: 22,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/5/gold-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2018-01-09T11:44:00Z',
    Latitude: 38.20176,
    Location: 'off Gold Strike Road and Cemetery Lane, San Andreas',
    Longitude: -120.67848,
    MajorIncident: 'False',
    Name: 'Gold Fire',
    Started: '2017-07-05T16:56:00Z',
    UniqueId: '7d77d3d1-40b5-40ab-8a53-2550f2001094'
  },
  {
    AcresBurned: 22,
    AdminUnit: 'Sonoma-Lake Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/13/refuge-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2018-01-09T10:31:00Z',
    Latitude: 38.68347,
    Location: 'Knoxville Rd and Eastside Rd, north end of Lake Berryessa',
    Longitude: -122.2654,
    MajorIncident: 'True',
    Name: 'Refuge Fire',
    Started: '2017-06-13T10:18:00Z',
    UniqueId: '7d9de7fd-f95d-4edb-bda6-804b734eedc8'
  },
  {
    AcresBurned: 21,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/20/soda-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T13:42:00Z',
    Latitude: 35.41112,
    Location: 'Off Soda Lake Rd, Carrizo Plains area',
    Longitude: -120.00353,
    MajorIncident: 'False',
    Name: 'Soda Fire',
    Started: '2017-10-20T12:13:00Z',
    UniqueId: '494792db-3107-4323-b176-fde4c58cd647'
  },
  {
    AcresBurned: 21,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/5/mule-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2018-01-09T13:19:00Z',
    Latitude: 39.01748,
    Location: 'Off Hwy 20 and Mule Skinner Road, east of Clearlake',
    Longitude: -122.49327,
    MajorIncident: 'False',
    Name: 'Mule Fire',
    Started: '2017-09-05T14:55:00Z',
    UniqueId: '180ea977-b5c2-483d-b9f4-c2f8b8b05ebe'
  },
  {
    AcresBurned: 21,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/5/globe-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2018-01-09T11:44:00Z',
    Latitude: 36.10858,
    Location: 'Globe Dr, Springville',
    Longitude: -118.81979,
    MajorIncident: 'False',
    Name: 'Globe Fire',
    Started: '2017-07-05T08:24:00Z',
    UniqueId: '0a664214-c090-4889-8439-06836f89d830'
  },
  {
    AcresBurned: 21,
    AdminUnit: 'CAL FIRE/Butte County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/22/highway-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-01-09T11:00:00Z',
    Latitude: 39.364,
    Location: 'off of Hwy 99 & Schlaf Dr, east of Lake Oroville',
    Longitude: -121.4143,
    MajorIncident: 'False',
    Name: 'Highway Fire',
    Started: '2017-06-22T09:49:00Z',
    UniqueId: '981484d0-711c-4a7b-9adc-23c9b29f9fae'
  },
  {
    AcresBurned: 21,
    AdminUnit: 'CAL FIRE Shasta_Trintiy Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/13/platina-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2018-01-09T10:32:00Z',
    Latitude: 0,
    Location: 'Platina Road, 12 Miles West of Ono',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Platina Fire',
    Started: '2017-06-13T12:47:00Z',
    UniqueId: '2d09e106-116c-4a9f-a3de-dae03df6de6a'
  },
  {
    AcresBurned: 21,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/22/bitterwater-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2018-01-09T10:07:00Z',
    Latitude: 36.35578,
    Location: 'Bitterwater Rd X Hwy 25, east of King City',
    Longitude: -120.99552,
    MajorIncident: 'False',
    Name: 'Bitterwater Fire',
    Started: '2017-05-22T04:50:00Z',
    UniqueId: 'f5ef2d0f-66a7-4d75-a9e8-03c42524d723'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Humboldt-Del Norte Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/8/blue-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2018-01-09T13:30:00Z',
    Latitude: 40.88516,
    Location: 'off of Blue Lake Blvd and Hwy 299,  east of Eureka',
    Longitude: -123.96844,
    MajorIncident: 'True',
    Name: 'Blue Fire',
    Started: '2017-10-08T16:40:00Z',
    UniqueId: 'e2c1718a-40e5-4139-a379-011c77f021bd'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/7/fort-fire/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2018-01-09T13:30:00Z',
    Latitude: 38.51937,
    Location: 'Fort Ross Rd and Hwy 1, north of Jenner',
    Longitude: -123.24713,
    MajorIncident: 'False',
    Name: 'Fort Fire',
    Started: '2017-10-07T20:00:00Z',
    UniqueId: 'fc87e089-36dc-4314-8321-7d91e7eead21'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/3/36-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2018-01-09T13:29:00Z',
    Latitude: 40.20077,
    Location: 'off Hwy 36W and Monroe St., West Red Bluff',
    Longitude: -122.24731,
    MajorIncident: 'False',
    Name: '36 Fire',
    Started: '2017-10-03T16:22:00Z',
    UniqueId: 'bc12dbf6-db36-4dcf-86d6-84d3beb14cad'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/1/falls-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2018-01-09T12:16:00Z',
    Latitude: 37.65986,
    Location: 'Off Merced Falls Rd, northwest of Lake McClure',
    Longitude: -120.31157,
    MajorIncident: 'False',
    Name: 'Falls Fire',
    Started: '2017-08-01T16:33:00Z',
    UniqueId: '09f55a45-f261-492f-b496-8744d878ef57'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'San Bernardino National Forest - USFS',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/22/seine-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T12:03:00Z',
    Latitude: 34.139,
    Location: 'off Piedmont Drive and Seine Avenue, Highland',
    Longitude: -117.199,
    MajorIncident: 'False',
    Name: 'Seine Fire',
    Started: '2017-07-22T15:49:00Z',
    UniqueId: 'a441e39a-1be1-4be5-8c07-b32bc6f07df0'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/17/range-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2018-01-09T11:58:00Z',
    Latitude: 39.13207,
    Location: 'on Cow Mountain, west of Ukiah',
    Longitude: -123.10227,
    MajorIncident: 'True',
    Name: 'Range Fire',
    Started: '2017-07-17T12:37:00Z',
    UniqueId: '7f742021-ea49-4de5-89a2-f5b9d05d6bbb'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/13/reed-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:32:00Z',
    Latitude: 33.52584,
    Location: 'off Reed Valley Road, north of Wilson Valley Road, Community of Aguanga',
    Longitude: -116.85226,
    MajorIncident: 'False',
    Name: 'Reed Fire',
    Started: '2017-06-13T17:21:00Z',
    UniqueId: '338af3e2-098b-4d1b-8f98-6020b212b68f'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/5/fish-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2018-01-09T10:26:00Z',
    Latitude: 37.86549,
    Location: 'Hwy 24, Orinda',
    Longitude: -122.2102,
    MajorIncident: 'False',
    Name: 'Fish Fire',
    Started: '2017-06-05T13:17:00Z',
    UniqueId: '304c7c4c-140e-40f4-ac9f-36926c07e5fc'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE/Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/18/city-fire/',
    Counties: 'Kings',
    CountyIds: 16,
    Extinguished: '2018-01-09T10:04:00Z',
    Latitude: 35.983,
    Location: 'off of Hwy 41 & I-5, south of Kettleman City',
    Longitude: -119.91508,
    MajorIncident: 'False',
    Name: 'City Fire',
    Started: '2017-05-18T12:54:00Z',
    UniqueId: '3fce8146-ff21-4399-9a94-f37124b34331'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/14/nacimiento-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2018-01-09T09:56:00Z',
    Latitude: 35.77082,
    Location: 'Off Nacimiento Lake Drive and Bee Rock Rd., near Bradley',
    Longitude: -120.92482,
    MajorIncident: 'False',
    Name: 'Nacimiento Fire',
    Started: '2017-05-14T12:00:00Z',
    UniqueId: '1423af4f-16d5-4f19-a01d-fc3ebc124201'
  },
  {
    AcresBurned: 19,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/12/13/longhorn-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T13:49:00Z',
    Latitude: 33.88994,
    Location: 'off Shirleon Road and Old Banning and Idyllwild Road, Banning area',
    Longitude: -116.91023,
    MajorIncident: 'False',
    Name: 'Longhorn Fire',
    Started: '2017-12-13T15:27:00Z',
    UniqueId: 'd3f8db86-9947-4a4e-9113-0d7e4806417f'
  },
  {
    AcresBurned: 19,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/10/garden-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2018-01-09T13:33:00Z',
    Latitude: 39.06414,
    Location: 'off Wolf Road and Garden Bar Rd, northwest of Higgins Corner',
    Longitude: -121.13737,
    MajorIncident: 'False',
    Name: 'Garden Fire',
    Started: '2017-10-10T12:30:00Z',
    UniqueId: '11392e98-1571-4405-8f9c-d347caca28ce'
  },
  {
    AcresBurned: 19,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/13/nuevo-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T12:38:00Z',
    Latitude: 33.797216,
    Location: 'Nuevo Road and Montgomery Road',
    Longitude: -117.124538,
    MajorIncident: 'False',
    Name: 'Nuevo Fire',
    Started: '2017-08-13T13:34:00Z',
    UniqueId: 'bae69034-3bf6-48c3-a642-d0242cf090f9'
  },
  {
    AcresBurned: 19,
    AdminUnit: 'Six Rivers National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/1/sway-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2018-01-09T12:16:00Z',
    Latitude: 40.39799,
    Location: 'Swayback Ridge, 5 southwest of Mad River',
    Longitude: -123.57562,
    MajorIncident: 'False',
    Name: 'Sway Fire',
    Started: '2017-08-01T10:23:00Z',
    UniqueId: '82689e99-9158-4403-b8c5-bababc3c81f6'
  },
  {
    AcresBurned: 19,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/18/willms-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2018-01-09T12:01:00Z',
    Latitude: 37.81827,
    Location: '10 miles east of Oakdale',
    Longitude: -120.65764,
    MajorIncident: 'False',
    Name: 'Willms Fire',
    Started: '2017-07-18T22:39:00Z',
    UniqueId: '1eef0c21-122b-4522-80d1-edf08c82c777'
  },
  {
    AcresBurned: 19,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/26/king-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T11:08:00Z',
    Latitude: 40.703775,
    Location: 'off Campus Dr. and Moonlit Oaks Ave. in Yreka',
    Longitude: -122.645079,
    MajorIncident: 'True',
    Name: 'King Fire',
    Started: '2017-06-26T12:30:00Z',
    UniqueId: '91d07ea9-cf5f-489c-aa4f-97fa6c0fb8a4'
  },
  {
    AcresBurned: 19,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/1/fay-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T09:54:00Z',
    Latitude: 35.71704,
    Location: 'Fay Ranch Rd, northeast of Lake Isabella',
    Longitude: -118.30601,
    MajorIncident: 'False',
    Name: 'Fay Fire',
    Started: '2017-05-01T12:44:00Z',
    UniqueId: 'f5237d47-f15b-4f4b-8b1c-6f11235f954d'
  },
  {
    AcresBurned: 18,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/27/bodega-fire/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2018-01-09T12:45:00Z',
    Latitude: 38.26294,
    Location: 'Bodega Ave and Nosecchi Rd., east of Petaluma',
    Longitude: -122.71998,
    MajorIncident: 'False',
    Name: 'Bodega Fire',
    Started: '2017-08-27T13:30:00Z',
    UniqueId: 'd83bfb8a-f1e6-4213-b514-89fc16d2eb72'
  },
  {
    AcresBurned: 18,
    AdminUnit: 'CAL FIRE / Butte County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/4/lakeland-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-01-09T11:43:00Z',
    Latitude: 39.53944,
    Location: 'Off Lakeland Blvd & Feather River, east of Oroville',
    Longitude: -121.54722,
    MajorIncident: 'False',
    Name: 'Lakeland Fire',
    Started: '2017-07-04T15:45:00Z',
    UniqueId: '6ae3d56e-0258-49f5-9e71-5b5abe141479'
  },
  {
    AcresBurned: 18,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/28/panoche-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T10:21:00Z',
    Latitude: 36.61332,
    Location: 'off Panoche Rd. 4 miles W of I-5 (Fresno County).',
    Longitude: -120.7109,
    MajorIncident: 'False',
    Name: 'Panoche Fire',
    Started: '2017-05-28T16:16:00Z',
    UniqueId: '21e9f99a-35a5-41cd-a44b-92363fbf5081'
  },
  {
    AcresBurned: 18,
    AdminUnit: 'CAL FIRE San Benito - Monterey Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/16/pine-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2018-01-09T09:58:00Z',
    Latitude: 36.1727,
    Location: 'off of Hwy 198 and Pine Valley Road, southwest of King City',
    Longitude: -120.86682,
    MajorIncident: 'False',
    Name: 'Pine Fire',
    Started: '2017-05-16T16:10:00Z',
    UniqueId: '75bb079a-1de8-4824-a933-e19f69948438'
  },
  {
    AcresBurned: 17,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/3/ramblin-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2018-01-09T13:29:00Z',
    Latitude: 37.41231,
    Location: 'Ramblin Road and Mount Lilac Road, 4 miles south of Bootjack',
    Longitude: -119.87465,
    MajorIncident: 'False',
    Name: 'Ramblin Fire',
    Started: '2017-10-03T11:44:00Z',
    UniqueId: '273d1f78-c432-46c0-8969-26c3f936cc65'
  },
  {
    AcresBurned: 17,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/17/corner-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2018-01-09T12:42:00Z',
    Latitude: 40.92602,
    Location: 'HWY 299 just south of HWY 89 near Cassel',
    Longitude: -121.5935,
    MajorIncident: 'True',
    Name: 'Corner Fire',
    Started: '2017-08-17T14:15:00Z',
    UniqueId: '1b49e4e3-7506-4bf4-b86f-fd3ca93fd85b'
  },
  {
    AcresBurned: 17,
    AdminUnit: 'CAL FIRE Shasta Trinity Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/29/sky-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2018-01-09T12:12:00Z',
    Latitude: 40.69259,
    Location: 'Blue Sky Road, east of Bella Vista',
    Longitude: -122.17384,
    MajorIncident: 'False',
    Name: 'Sky Fire',
    Started: '2017-07-29T17:29:00Z',
    UniqueId: '00a13d84-415e-4106-aa31-2e664ed9eabf'
  },
  {
    AcresBurned: 17,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/20/rocky-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T10:06:00Z',
    Latitude: 35.556667,
    Location: 'off of Rocky Creek Road and Old Abode Canyon Road, east of Atascadero',
    Longitude: -120.474,
    MajorIncident: 'False',
    Name: 'Rocky Fire',
    Started: '2017-05-20T13:11:00Z',
    UniqueId: 'fbc11fc4-573b-465f-a9ac-a879ee2cdda2'
  },
  {
    AcresBurned: 17,
    AdminUnit: 'CAL FIRE San Benito Monterey Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/17/lonoak-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2018-01-09T09:59:00Z',
    Latitude: 36.2771,
    Location: 'Lonoak Road and Airline Road, east of King City',
    Longitude: -120.94328,
    MajorIncident: 'True',
    Name: 'Lonoak Fire',
    Started: '2017-05-17T15:18:00Z',
    UniqueId: '2d12b95c-3f4e-41bc-a771-8ae2cb80b99e'
  },
  {
    AcresBurned: 17,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/14/canyon-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T09:56:00Z',
    Latitude: 33.88466,
    Location: 'Highway 79, south of Dump Road, Beaumont',
    Longitude: -116.99229,
    MajorIncident: 'False',
    Name: 'Canyon Fire',
    Started: '2017-05-14T12:51:00Z',
    UniqueId: '48c4b519-eaf5-4ae8-9470-31e8770a70ac'
  },
  {
    AcresBurned: 16,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/2/elk-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T10:23:00Z',
    Latitude: 35.188,
    Location: '4 miles south of Buttonwillow',
    Longitude: -119.2877,
    MajorIncident: 'False',
    Name: 'Elk Fire',
    Started: '2017-06-02T18:55:00Z',
    UniqueId: 'adf741f6-5416-41c5-af26-01240cc361cf'
  },
  {
    AcresBurned: 16,
    AdminUnit: 'CAL FIRE San Bernardino Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/29/matz-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T10:22:00Z',
    Latitude: 34.04412,
    Location: 'Big Morongo Canyon Preserve, Morongo Valley',
    Longitude: -116.55326,
    MajorIncident: 'False',
    Name: 'Matz Fire',
    Started: '2017-05-29T01:20:00Z',
    UniqueId: '524b1e23-8921-4195-812d-7ec8ee5020b7'
  },
  {
    AcresBurned: 16,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/28/rusty-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T10:17:00Z',
    Latitude: 36.96642,
    Location: 'off Millerton Rd. and Rusty Spur Ln., 10 miles N. of Clovis',
    Longitude: -119.58292,
    MajorIncident: 'False',
    Name: 'Rusty Fire',
    Started: '2017-05-28T07:49:00Z',
    UniqueId: '7272decf-0ae8-47aa-b46c-00fc4cd04816'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/10/paskenta-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2018-01-09T12:31:00Z',
    Latitude: 39.87983,
    Location: 'Round Valley Rd and Paskenta Rd in Paskenta',
    Longitude: -122.5415,
    MajorIncident: 'False',
    Name: 'Paskenta Fire',
    Started: '2017-08-10T17:24:00Z',
    UniqueId: 'a43d0b54-a91e-40ba-b121-2e0f067201b6'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE Nevada - Yuba - Placer Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/27/greenhorn-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2018-01-09T12:06:00Z',
    Latitude: 39.16826,
    Location: 'Greenhorn Access Rd, Rollins Lake (Nevada Co)',
    Longitude: -120.95498,
    MajorIncident: 'False',
    Name: 'Greenhorn Fire',
    Started: '2017-07-27T14:49:00Z',
    UniqueId: '77ab4672-c61f-488f-a165-acb40eeac713'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/17/centerville-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2018-01-09T11:58:00Z',
    Latitude: 41.45589,
    Location: 'County Road 60 and 54, Alturas',
    Longitude: -120.56933,
    MajorIncident: 'False',
    Name: 'Centerville Fire',
    Started: '2017-07-17T13:38:00Z',
    UniqueId: 'f568b94d-f388-4231-8aac-ac2572ca872d'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE San Benito-Monterey',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/28/alvarado-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2018-01-09T11:10:00Z',
    Latitude: 35.947,
    Location: 'Alvarado Rd and Wunpost in the community of Bradley',
    Longitude: -120.87492,
    MajorIncident: 'False',
    Name: 'Alvarado Fire',
    Started: '2017-06-28T09:30:00Z',
    UniqueId: 'c171dc75-9d35-4c58-b787-032067b16ae7'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/28/lombardi-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2018-01-09T10:21:00Z',
    Latitude: 38.19906,
    Location: 'off Hwy 26 and Hwy 12, 4 miles SW of Mokelumne Hill',
    Longitude: -120.83484,
    MajorIncident: 'False',
    Name: 'Lombardi Fire',
    Started: '2017-05-28T15:30:00Z',
    UniqueId: '42f21a81-e0a3-4b4d-b837-2e6e2efd75a4'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE Riverside Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/4/13/66-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T09:50:00Z',
    Latitude: 33.56777,
    Location: 'Avenue 66 and Hwy 111 near community of Mecca',
    Longitude: -116.08003,
    MajorIncident: 'False',
    Name: '66 Fire',
    Started: '2017-04-13T02:30:00Z',
    UniqueId: 'b12ae71e-c6c8-4eab-9aab-d17d1879a639'
  },
  {
    AcresBurned: 14,
    AdminUnit: 'Santa Barbara County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/12/16/drum-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2018-01-09T13:49:00Z',
    Latitude: 34.71796,
    Location: 'off Drum Canyon Rd, south of Los Alamos',
    Longitude: -120.27077,
    MajorIncident: 'False',
    Name: 'Drum Fire',
    Started: '2017-12-16T12:21:00Z',
    UniqueId: '64779f92-8353-4187-ae56-2b83eb66d7ca'
  },
  {
    AcresBurned: 14,
    AdminUnit: 'Santa Barbara County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/12/14/coast-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2018-01-09T13:49:00Z',
    Latitude: 34.605358,
    Location: 'off the 3500 Block of Highway 1, south east of Lompoc',
    Longitude: -120.414875,
    MajorIncident: 'False',
    Name: 'Coast Fire',
    Started: '2017-12-14T12:59:00Z',
    UniqueId: '2fa6f5ce-1c5b-4147-9f1f-9beb01c499af'
  },
  {
    AcresBurned: 14,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/2/desabla-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-01-09T11:17:00Z',
    Latitude: 39.8629,
    Location: 'off Desabla Powerhouse Rd and Humbug Rd, Desabla',
    Longitude: -121.6268,
    MajorIncident: 'False',
    Name: 'Desabla Fire',
    Started: '2017-07-02T13:43:00Z',
    UniqueId: '97d63e17-e546-49ae-add6-e3b5fa71cb4c'
  },
  {
    AcresBurned: 14,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/9/hog-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2018-01-09T10:29:00Z',
    Latitude: 35.80375,
    Location: 'Hog Canyon Rd & Ranchita Canyon Rd, southeast of Parkfield',
    Longitude: -120.52508,
    MajorIncident: 'False',
    Name: 'Hog Fire',
    Started: '2017-06-09T16:15:00Z',
    UniqueId: 'b9142a59-e3dd-4797-b6ed-c5c847b16f67'
  },
  {
    AcresBurned: 14,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/18/moraga-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:05:00Z',
    Latitude: 33.97155,
    Location: 'Avenue Juan Diaz and Riverside Drive, Jurupa Valley',
    Longitude: -117.44148,
    MajorIncident: 'False',
    Name: 'Moraga Fire',
    Started: '2017-05-18T17:25:00Z',
    UniqueId: '9348a031-c7b3-4165-890a-37a7eb7405db'
  },
  {
    AcresBurned: 13,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/18/milton-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2018-01-09T13:41:00Z',
    Latitude: 37.89532,
    Location: 'off Milton Road and Sonora Road north of Woodward Reservoir Park',
    Longitude: -120.84748,
    MajorIncident: 'False',
    Name: 'Milton Fire',
    Started: '2017-10-18T12:53:00Z',
    UniqueId: '6418a3f5-8f76-4b47-9a46-64af91838857'
  },
  {
    AcresBurned: 13,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/25/woodland-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2018-01-09T12:06:00Z',
    Latitude: 38.69775,
    Location: 'Woodland Court, Community of Oak Hill',
    Longitude: -120.73757,
    MajorIncident: 'False',
    Name: 'Woodland Fire',
    Started: '2017-07-25T14:13:00Z',
    UniqueId: '855e28e2-753b-4c36-bf39-27ace518776d'
  },
  {
    AcresBurned: 13,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/12/rosado-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2018-01-09T11:53:00Z',
    Latitude: 38.67474,
    Location: 'off Rosado Rd, El Dorado Hills',
    Longitude: -121.06088,
    MajorIncident: 'False',
    Name: 'Rosado Fire',
    Started: '2017-07-12T13:51:00Z',
    UniqueId: 'fd82cbd0-ec25-461c-aef1-4c0c92060348'
  },
  {
    AcresBurned: 13,
    AdminUnit: 'CAL FIRE San Bernardino Unit / San Bernardino National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/4/silver-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2018-01-09T11:42:00Z',
    Latitude: 34.304722,
    Location: 'Off Hwy 138 & Sawpit Canyon Rd, southwest of Silverwood Lake',
    Longitude: -117.3125,
    MajorIncident: 'False',
    Name: 'Silver Fire',
    Started: '2017-07-04T13:15:00Z',
    UniqueId: 'ed40ce35-7338-4f8b-a5ab-e94af6fa7e55'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE/Butte County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/12/pacific-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-01-09T13:21:00Z',
    Latitude: 39.44257,
    Location: 'off Pacific Heights Road, west of Palermo',
    Longitude: -121.60683,
    MajorIncident: 'False',
    Name: 'Pacific Fire',
    Started: '2017-09-12T17:24:00Z',
    UniqueId: 'ea832344-b0c6-4443-b5f0-457c462d911c'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/4/dehesa-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T10:25:00Z',
    Latitude: 0,
    Location: 'off of Dehesa Rd and Sloane Canyon Rd, Dehesa',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Dehesa Fire',
    Started: '2017-06-04T11:04:00Z',
    UniqueId: '07cb7d4c-a40e-4265-86df-9f3c3c1d6764'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/7/shandon-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T09:55:00Z',
    Latitude: 35.6879,
    Location: 'Off Lucy Brown Rd, in Shandon',
    Longitude: -120.3317,
    MajorIncident: 'False',
    Name: 'Shandon Fire',
    Started: '2017-05-07T16:41:00Z',
    UniqueId: 'c7e3bcbf-1065-4e45-a4a3-bf0b5ac6aa23'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/4/30/jameson-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T09:54:00Z',
    Latitude: 33.7866,
    Location: 'Jameson Rd and Clay Canyon Dr., south of Corona',
    Longitude: -117.5048,
    MajorIncident: 'False',
    Name: 'Jameson Fire',
    Started: '2017-04-30T19:43:00Z',
    UniqueId: '7fc71135-ee3b-443c-a859-90672936e0c1'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/12/31/taglio-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2018-01-09T10:05:00Z',
    Latitude: 37.21812,
    Location: 'Interstate 5 near Taglio Road, Gustine',
    Longitude: -121.07761,
    MajorIncident: 'False',
    Name: 'Taglio Fire',
    Started: '1969-12-31T16:00:00Z',
    UniqueId: 'fcb8579e-7469-4c9e-9eac-527264e6f26b'
  },
  {
    AcresBurned: 11,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/31/independence-fire/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2018-01-09T12:15:00Z',
    Latitude: 38.70289,
    Location: 'Independence Lane, 2 miles south of Geyserville',
    Longitude: -122.90217,
    MajorIncident: 'False',
    Name: 'Independence Fire',
    Started: '2017-07-31T23:17:00Z',
    UniqueId: '75fb489f-1e3e-4929-a6fb-a288416b96e0'
  },
  {
    AcresBurned: 11,
    AdminUnit: 'CAL FIRE Riverside Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/2/lisa-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T11:16:00Z',
    Latitude: 33.913089,
    Location: 'off Gilman Springs Rd and Alessandro Blvd., east of Moreno Valley',
    Longitude: -117.096233,
    MajorIncident: 'False',
    Name: 'Lisa Fire',
    Started: '2017-07-02T13:04:00Z',
    UniqueId: '64ef64a3-c8b0-48f1-8fec-9cacf8dfcd34'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/8/freeway-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2018-01-09T13:31:00Z',
    Latitude: 40.24789,
    Location: 'off of Jelly Ferry Rd and I-5, north of Red Bluff',
    Longitude: -122.255,
    MajorIncident: 'False',
    Name: 'Freeway Fire',
    Started: '2017-10-08T12:15:00Z',
    UniqueId: 'e3ed6829-5211-436a-8e32-ec617c3ebc83'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/20/dexter-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2018-01-09T13:23:00Z',
    Latitude: 37.76888,
    Location: 'Dexter Rd and Pine Lake Dr, 5 miles east of Coulterville',
    Longitude: -120.15846,
    MajorIncident: 'False',
    Name: 'Dexter Fire',
    Started: '2017-09-20T14:53:00Z',
    UniqueId: '04b4caff-a62d-465b-b9a7-81986f91c0c3'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE / Fresno County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/9/11/shaver-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2018-01-09T13:19:00Z',
    Latitude: 37.10067,
    Location: 'Indian Rock Rd and Musick Creek Lane, Community of Shaver Lake',
    Longitude: -119.32109,
    MajorIncident: 'False',
    Name: 'Shaver Fire',
    Started: '2017-09-11T10:00:00Z',
    UniqueId: 'e1a5b757-2bc1-440f-b3d1-06cd41171775'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/8/28/sandra-fire/',
    Counties: 'Amador',
    CountyIds: 3,
    Extinguished: '2018-01-09T12:46:00Z',
    Latitude: 38.34421,
    Location: 'Butte Mountain road, 3 miles east of Jackson',
    Longitude: -120.72274,
    MajorIncident: 'False',
    Name: 'Sandra Fire',
    Started: '2017-08-28T17:06:00Z',
    UniqueId: 'f3c1f59e-b0d5-4c14-976f-ae6c583b2224'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'Angeles National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/8/3/rincon-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2018-01-09T12:18:00Z',
    Latitude: 34.23925,
    Location: 'off Hwy 39 & East Fork Ave, north of Azusa',
    Longitude: -117.85182,
    MajorIncident: 'False',
    Name: 'Rincon Fire',
    Started: '2017-08-03T16:21:00Z',
    UniqueId: '9705ad0d-5bf1-4221-a7c3-3af6d99be3d0'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/21/grizzly-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2018-01-09T12:03:00Z',
    Latitude: 39.36902,
    Location: 'off of Grizzly Hill Rd & Turnagain Arm Rd, 8 miles northeast of Nevada City',
    Longitude: -120.97586,
    MajorIncident: 'False',
    Name: 'Grizzly Fire',
    Started: '2017-07-21T16:50:00Z',
    UniqueId: 'd9f83833-30c4-448d-b2ca-c5a63791b83d'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/15/north-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2018-01-09T11:56:00Z',
    Latitude: 40.48972,
    Location: 'Canyon Road and China Gulch, Happy Valley',
    Longitude: -122.38619,
    MajorIncident: 'True',
    Name: 'North Fire',
    Started: '2017-07-15T18:10:00Z',
    UniqueId: '2ec4e814-477b-47e7-a36b-4da26f94e277'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/13/navajo-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T11:54:00Z',
    Latitude: 33.77896,
    Location: 'West 7th Street and Park Avenue, Perris',
    Longitude: -117.24091,
    MajorIncident: 'False',
    Name: 'Navajo Fire',
    Started: '2017-07-13T14:14:00Z',
    UniqueId: 'e6626b0a-428c-442f-9ec5-591effef172d'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/12/rebie-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-01-09T11:53:00Z',
    Latitude: 39.50475,
    Location: 'Off Rebie way and Forbestown Rd, south east of Lake Oroville',
    Longitude: -121.33785,
    MajorIncident: 'True',
    Name: 'Rebie Fire',
    Started: '2017-07-12T13:55:00Z',
    UniqueId: '1be14ce2-5e9c-4cc2-89bf-f36cb1d1ccbd'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/3/canyon-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T11:41:00Z',
    Latitude: 33.91806,
    Location: 'Bolo Court and David Mountain Road, south of Beaumont',
    Longitude: -116.99321,
    MajorIncident: 'False',
    Name: 'Canyon Fire',
    Started: '2017-07-03T13:34:00Z',
    UniqueId: 'd4f1fc5e-b877-41ee-b491-8e92ded4984f'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/7/2/brewer-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2018-01-09T11:16:00Z',
    Latitude: 39.08382,
    Location: 'off Brewer Road and Conestoga Drive in Alta Sierra',
    Longitude: -121.06656,
    MajorIncident: 'False',
    Name: 'Brewer Fire',
    Started: '2017-07-02T12:41:00Z',
    UniqueId: 'c99fe9af-6d6b-435a-9084-2248905ad251'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/18/lambs-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:35:00Z',
    Latitude: 33.90965,
    Location: 'Manzanita Park and Roadrunner Dr., near Beaumont',
    Longitude: -116.9669,
    MajorIncident: 'False',
    Name: 'Lambs Fire',
    Started: '2017-06-18T12:28:00Z',
    UniqueId: '294c531a-3299-4038-baa8-c2a92d38d10a'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/16/springs-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:34:00Z',
    Latitude: 117.138741,
    Location: 'off Gilman Springs Road, south of Hwy 60 in Gilman Springs',
    Longitude: 33.939428,
    MajorIncident: 'False',
    Name: 'Springs Fire',
    Started: '2017-06-16T14:51:00Z',
    UniqueId: '0089929d-0b52-46fe-8982-b096b7616f30'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/5/pine-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T10:27:00Z',
    Latitude: 35.564124,
    Location: 'Pine Mountain Rd., 10 miles NE of Bakersfield',
    Longitude: -118.796513,
    MajorIncident: 'False',
    Name: 'Pine Fire',
    Started: '2017-06-05T14:02:00Z',
    UniqueId: '8bba8daf-8d47-43e7-8593-fdfa2dea5228'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/6/4/shirleon-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:26:00Z',
    Latitude: 33.87107,
    Location: 'Old Banning Idyllwild Road & Mount Edna Road, Banning',
    Longitude: -116.88097,
    MajorIncident: 'False',
    Name: 'Shirleon Fire',
    Started: '2017-06-04T16:48:00Z',
    UniqueId: '7ea6269d-6ba3-41e1-aff6-b4da1c6611d1'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/29/twenty-fire/',
    Counties: 'Yuba',
    CountyIds: 58,
    Extinguished: '2018-01-09T10:22:00Z',
    Latitude: 39.23205,
    Location: 'off Hwy 20 and Escheman Ln, East of Brown',
    Longitude: -121.376,
    MajorIncident: 'False',
    Name: 'Twenty Fire',
    Started: '2017-05-29T15:31:00Z',
    UniqueId: '67d31514-620f-49d1-b4bd-a3a92efd48ca'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/28/champagne-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2018-01-09T10:17:00Z',
    Latitude: 34.87128,
    Location: '10 miles West of Rosamond',
    Longitude: -118.35296,
    MajorIncident: 'False',
    Name: 'Champagne Fire',
    Started: '2017-05-28T10:59:00Z',
    UniqueId: '6fa64139-e5d1-4134-b012-5c1b272ac89a'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/5/23/moreno-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2018-01-09T10:08:00Z',
    Latitude: 33.94673,
    Location: 'Ironwood Avenue and Moreno Beach Drive',
    Longitude: -117.17773,
    MajorIncident: 'False',
    Name: 'Moreno Fire',
    Started: '2017-05-23T13:13:00Z',
    UniqueId: 'fccf2545-cab8-452e-829c-8379054831f0'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/4/24/soledad-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2018-01-09T09:51:00Z',
    Latitude: 36.44141,
    Location: 'Highway 101 & Front Street, north of Soledad',
    Longitude: -121.34695,
    MajorIncident: 'False',
    Name: 'Soledad Fire',
    Started: '2017-04-24T12:06:00Z',
    UniqueId: 'b8bdbd12-e3a2-49e0-8d65-7c18b8d584bf'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/9/pressley-fire-central-lnu-complex/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2018-01-09T13:34:00Z',
    Latitude: 38.36685,
    Location: 'east of Rohnert Park',
    Longitude: -122.64001,
    MajorIncident: 'True',
    Name: 'Pressley Fire (Central LNU Complex)',
    Started: '2017-10-09T01:30:00Z',
    UniqueId: '15b21d31-eadf-47bb-a030-20c531b3077b'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/10/8/partrick-fire-central-lnu-complex/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2018-01-09T13:33:00Z',
    Latitude: 38.31802,
    Location: 'off Partrick Rd, west of Napa',
    Longitude: -122.39052,
    MajorIncident: 'True',
    Name: 'Partrick Fire (Central LNU Complex)',
    Started: '2017-10-08T23:48:00Z',
    UniqueId: '36d55b1a-a2f4-4f40-b57c-48341bb2ace5'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Yosemite National Park',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/9/7/rattlesnake-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2018-01-09T13:19:00Z',
    Latitude: 37.73596,
    Location: 'Hwy 120 and Big Oak Flat Road near Foresta',
    Longitude: -119.78256,
    MajorIncident: 'False',
    Name: 'Rattlesnake Fire',
    Started: '2017-09-07T15:00:00Z',
    UniqueId: 'e21384c7-8060-4336-9a71-a006330d9939'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Klamath National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/25/clear-complex-merged-into-eclipse-complex/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T12:05:00Z',
    Latitude: 41.702,
    Location: 'Clear Creek Drainage, 7 miles southwest of Happy Camp (Siskiyou County)',
    Longitude: -123.508,
    MajorIncident: 'False',
    Name: 'Clear Complex (merged into Eclipse Complex)',
    Started: '2017-07-25T12:45:00Z',
    UniqueId: '5948001c-9c7b-4722-9fa4-9f0323886bc0'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Modoc National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/23/warner-mountain-lightning/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2018-01-09T12:04:00Z',
    Latitude: 41.338,
    Location: 'Warner Mountain Ranger District on the Modoc National Forest',
    Longitude: -120.304,
    MajorIncident: 'False',
    Name: 'Warner Mountain Lightning',
    Started: '2017-07-23T00:00:00Z',
    UniqueId: '42f93f6b-0ada-4267-8e6e-4674055ed9c8'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'City of Orland Fire Department',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/19/creek-fire/',
    Counties: 'Glenn',
    CountyIds: 11,
    Extinguished: '2018-01-09T12:02:00Z',
    Latitude: 39.75425,
    Location: 'Stony Creek, Orland',
    Longitude: -122.17657,
    MajorIncident: 'False',
    Name: 'Creek Fire',
    Started: '2017-07-19T17:30:00Z',
    UniqueId: '47c9e99d-ad11-497f-8238-cfd815423262'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Lassen National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/6/antelope-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2018-01-09T11:45:00Z',
    Latitude: 40.6361,
    Location: '10 Miles west of Eagle Lake, Lassen National Forest',
    Longitude: -120.9643,
    MajorIncident: 'False',
    Name: 'Antelope Fire',
    Started: '2017-07-06T13:00:00Z',
    UniqueId: 'b4eb0b95-1a93-46a5-91f4-5c2b4c7b943c'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Klamath National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/7/4/klamath-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T11:43:00Z',
    Latitude: 41.86609,
    Location: 'Off Hwy 96 & Dutch Creek Rd, east of Oak Knoll',
    Longitude: -122.73031,
    MajorIncident: 'False',
    Name: 'Klamath Fire',
    Started: '2017-07-04T15:21:00Z',
    UniqueId: '1be87788-1bd9-4e97-b92a-63b41fe8abf1'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Camp Pendleton Marine Corps Base',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/6/28/cristianitos-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2018-01-09T11:10:00Z',
    Latitude: 33.43513,
    Location: 'off Cristianitos Rd. and Talega Rd.',
    Longitude: -117.58252,
    MajorIncident: 'False',
    Name: 'Cristianitos Fire',
    Started: '2017-06-28T17:56:00Z',
    UniqueId: '47e76098-389e-4747-9e89-7ebdc963a485'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'CAL FIRE Siskiyou Unit / Klamath National Forest',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/6/25/salmon-august-complex/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2018-01-09T11:07:00Z',
    Latitude: 41.841,
    Location: '14 miles west of Etna, California in the Marble Mountain Wilderness',
    Longitude: -123.474,
    MajorIncident: 'False',
    Name: 'Salmon-August Complex',
    Started: '2017-06-25T17:00:00Z',
    UniqueId: 'c35027fa-3bc5-423f-a32e-e03b134a102e'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Tulare County',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/6/23/king-incident/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2018-01-09T11:01:00Z',
    Latitude: 36.51912,
    Location: 'Hwy 201 & Rd 36, Community of Kings River',
    Longitude: -119.50606,
    MajorIncident: 'False',
    Name: 'King Incident',
    Started: '2017-06-23T22:32:00Z',
    UniqueId: 'e1fdc15a-5737-4c69-ab9a-7f43d6b4aab8'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Department of Defense - Camp Roberts',
    ArchiveYear: 2017,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2017/5/19/range-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2018-01-09T10:05:00Z',
    Latitude: 35.85253,
    Location: 'off of San Antonio Drive and Hwy 101, Camp Roberts',
    Longitude: -120.80411,
    MajorIncident: 'False',
    Name: 'Range Fire',
    Started: '2017-05-19T13:10:00Z',
    UniqueId: '5bfc7c8f-0d7f-4b14-903b-00014014c14b'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'Unified Command',
    ArchiveYear: 2017,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2017/2/7/oroville-spillway/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-01-09T09:24:00Z',
    Latitude: 39.51158,
    Location: 'Oroville Dam, Canyon Dr. & Oroville Dam Rd, Oroville, CA 95966',
    Longitude: -121.55633,
    MajorIncident: 'True',
    Name: 'Oroville Spillway',
    Started: '2017-02-07T14:00:00Z',
    UniqueId: 'afb8c00c-ef91-4544-90ce-54722be124af'
  },
  // {
  //   AcresBurned: 410203,
  //   AdminUnit: 'USFS Mendocino National Forest',
  //   ArchiveYear: 2018,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2018/7/27/ranch-fire-mendocino-complex/',
  //   Counties: 'Colusa',
  //   CountyIds: 6111723,
  //   Extinguished: '2019-01-04T09:33:00Z',
  //   Latitude: 39.243283,
  //   Location: 'off Highway 20 near Potter Valley, northeast of Ukiah',
  //   Longitude: -123.103367,
  //   MajorIncident: 'True',
  //   Name: 'Ranch Fire (Mendocino Complex)',
  //   Started: '2018-07-27T12:05:00Z',
  //   UniqueId: '90b0daf7-5d84-42d9-bb35-bb78d4faf950'
  // },
  // {
  //   AcresBurned: 410203,
  //   AdminUnit: 'USFS Mendocino National Forest',
  //   ArchiveYear: 2018,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2018/7/27/ranch-fire-mendocino-complex/',
  //   Counties: 'Glenn',
  //   CountyIds: 6111723,
  //   Extinguished: '2019-01-04T09:33:00Z',
  //   Latitude: 39.243283,
  //   Location: 'off Highway 20 near Potter Valley, northeast of Ukiah',
  //   Longitude: -123.103367,
  //   MajorIncident: 'True',
  //   Name: 'Ranch Fire (Mendocino Complex)',
  //   Started: '2018-07-27T12:05:00Z',
  //   UniqueId: '90b0daf7-5d84-42d9-bb35-bb78d4faf950'
  // },
  // {
  //   AcresBurned: 410203,
  //   AdminUnit: 'USFS Mendocino National Forest',
  //   ArchiveYear: 2018,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2018/7/27/ranch-fire-mendocino-complex/',
  //   Counties: 'Lake',
  //   CountyIds: 6111723,
  //   Extinguished: '2019-01-04T09:33:00Z',
  //   Latitude: 39.243283,
  //   Location: 'off Highway 20 near Potter Valley, northeast of Ukiah',
  //   Longitude: -123.103367,
  //   MajorIncident: 'True',
  //   Name: 'Ranch Fire (Mendocino Complex)',
  //   Started: '2018-07-27T12:05:00Z',
  //   UniqueId: '90b0daf7-5d84-42d9-bb35-bb78d4faf950'
  // },
  {
    AcresBurned: 410203,
    AdminUnit: 'USFS Mendocino National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/27/ranch-fire-mendocino-complex/',
    Counties: 'Mendocino',
    CountyIds: 6111723,
    Extinguished: '2019-01-04T09:33:00Z',
    Latitude: 39.243283,
    Location: 'off Highway 20 near Potter Valley, northeast of Ukiah',
    Longitude: -123.103367,
    MajorIncident: 'True',
    Name: 'Ranch Fire (Mendocino Complex)',
    Started: '2018-07-27T12:05:00Z',
    UniqueId: '90b0daf7-5d84-42d9-bb35-bb78d4faf950'
  },
  // {
  //   AcresBurned: 229651,
  //   AdminUnit: 'Unified Command: CAL FIRE Shasta-Trinity Unit, US Forest Service and NPS Whiskeytown National Recreation Area',
  //   ArchiveYear: 2018,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2018/7/23/carr-fire/',
  //   Counties: 'Shasta',
  //   CountyIds: 4553,
  //   Extinguished: '2019-01-04T09:37:00Z',
  //   Latitude: 40.65428,
  //   Location: 'Hwy 299 and Carr Powerhouse Rd, Whiskeytown',
  //   Longitude: -122.62357,
  //   MajorIncident: 'True',
  //   Name: 'Carr Fire',
  //   Started: '2018-07-23T13:15:00Z',
  //   UniqueId: '240b1f55-0f4e-448d-a4ce-3ecfec7a6c9d'
  // },
  {
    AcresBurned: 229651,
    AdminUnit: 'Unified Command: CAL FIRE Shasta-Trinity Unit, US Forest Service and NPS Whiskeytown National Recreation Area',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/23/carr-fire/',
    Counties: 'Trinity',
    CountyIds: 4553,
    Extinguished: '2019-01-04T09:37:00Z',
    Latitude: 40.65428,
    Location: 'Hwy 299 and Carr Powerhouse Rd, Whiskeytown',
    Longitude: -122.62357,
    MajorIncident: 'True',
    Name: 'Carr Fire',
    Started: '2018-07-23T13:15:00Z',
    UniqueId: '240b1f55-0f4e-448d-a4ce-3ecfec7a6c9d'
  },
  {
    AcresBurned: 153336,
    AdminUnit: 'Unified Command: CAL FIRE, Butte County Sheriff Department, Paradise Police Department, USFS',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/11/8/camp-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2018-11-25T08:00:00Z',
    Latitude: 39.8134,
    Location: 'Pulga Road at Camp Creek Road near Jarbo Gap',
    Longitude: -121.4347,
    MajorIncident: 'True',
    Name: 'Camp Fire',
    Started: '2018-11-08T06:33:00Z',
    UniqueId: '75dafe80-f18a-4a4a-9a37-4b564c5f6014'
  },
  // {
  //   AcresBurned: 96949,
  //   AdminUnit: 'Ventura County Fire Dept. and Los Angeles County Fire Dept.',
  //   ArchiveYear: 2018,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2018/11/8/woolsey-fire/',
  //   Counties: 'Los Angeles',
  //   CountyIds: 1956,
  //   Extinguished: '2019-01-04T08:42:00Z',
  //   Latitude: 34.235,
  //   Location: 'E Street and Alfa Road Rd, South of Simi Valley',
  //   Longitude: -118.70128,
  //   MajorIncident: 'True',
  //   Name: 'Woolsey Fire',
  //   Started: '2018-11-08T14:24:00Z',
  //   UniqueId: '92d7aeea-7abf-47a4-bf76-a4fe0fac65c6'
  // },
  {
    AcresBurned: 96949,
    AdminUnit: 'Ventura County Fire Dept. and Los Angeles County Fire Dept.',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/11/8/woolsey-fire/',
    Counties: 'Ventura',
    CountyIds: 1956,
    Extinguished: '2019-01-04T08:42:00Z',
    Latitude: 34.235,
    Location: 'E Street and Alfa Road Rd, South of Simi Valley',
    Longitude: -118.70128,
    MajorIncident: 'True',
    Name: 'Woolsey Fire',
    Started: '2018-11-08T14:24:00Z',
    UniqueId: '92d7aeea-7abf-47a4-bf76-a4fe0fac65c6'
  },
  {
    AcresBurned: 96901,
    AdminUnit: 'USFS Sierra National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/7/13/ferguson-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2019-01-04T09:48:00Z',
    Latitude: 37.6549,
    Location: 'Highway 140 and Hite Cove, near El Portal',
    Longitude: -119.88581,
    MajorIncident: 'False',
    Name: 'Ferguson Fire',
    Started: '2018-07-13T21:36:00Z',
    UniqueId: '29d15973-a999-409e-adf4-486854df44ed'
  },
  // {
  //   AcresBurned: 90288,
  //   AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
  //   ArchiveYear: 2018,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2018/6/30/county-fire/',
  //   Counties: 'Napa',
  //   CountyIds: 2857,
  //   Extinguished: '2019-01-04T09:57:00Z',
  //   Latitude: 38.80583,
  //   Location: 'east of Lake Berryessa',
  //   Longitude: -122.18183,
  //   MajorIncident: 'True',
  //   Name: 'County Fire',
  //   Started: '2018-06-30T14:12:00Z',
  //   UniqueId: '97ff14e8-6d08-4214-ad3b-847fa3a0e84a'
  // },
  {
    AcresBurned: 90288,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/30/county-fire/',
    Counties: 'Yolo',
    CountyIds: 2857,
    Extinguished: '2019-01-04T09:57:00Z',
    Latitude: 38.80583,
    Location: 'east of Lake Berryessa',
    Longitude: -122.18183,
    MajorIncident: 'True',
    Name: 'County Fire',
    Started: '2018-06-30T14:12:00Z',
    UniqueId: '97ff14e8-6d08-4214-ad3b-847fa3a0e84a'
  },
  // {
  //   AcresBurned: 63311,
  //   AdminUnit: 'USFS Shasta-Trinity National Forest',
  //   ArchiveYear: 2018,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2018/9/5/delta-fire/',
  //   Counties: 'Shasta',
  //   CountyIds: 4553,
  //   Extinguished: '2019-01-04T09:07:00Z',
  //   Latitude: 40.9425,
  //   Location: 'I-5 and Lamoine, 2 miles NW of Lakehead',
  //   Longitude: -122.43,
  //   MajorIncident: 'False',
  //   Name: 'Delta Fire',
  //   Started: '2018-09-05T12:51:00Z',
  //   UniqueId: 'ba818380-4001-46a2-ac04-d5f322cdf3b9'
  // },
  {
    AcresBurned: 63311,
    AdminUnit: 'USFS Shasta-Trinity National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/5/delta-fire/',
    Counties: 'Trinity',
    CountyIds: 4553,
    Extinguished: '2019-01-04T09:07:00Z',
    Latitude: 40.9425,
    Location: 'I-5 and Lamoine, 2 miles NW of Lakehead',
    Longitude: -122.43,
    MajorIncident: 'False',
    Name: 'Delta Fire',
    Started: '2018-09-05T12:51:00Z',
    UniqueId: 'ba818380-4001-46a2-ac04-d5f322cdf3b9'
  },
  // {
  //   AcresBurned: 48920,
  //   AdminUnit: 'Unified command: CAL FIRE Mendocino Unit and USFS Mendocino National Forest',
  //   ArchiveYear: 2018,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2018/7/27/river-fire-mendocino-complex/',
  //   Counties: 'Colusa',
  //   CountyIds: 61723,
  //   Extinguished: '2019-01-04T09:18:00Z',
  //   Latitude: 39.04786,
  //   Location: 'Old River Rd, near Mile Marker Post 7.9, Hopland',
  //   Longitude: -123.11971,
  //   MajorIncident: 'True',
  //   Name: 'River Fire (Mendocino Complex)',
  //   Started: '2018-07-27T13:01:00Z',
  //   UniqueId: 'af30fe23-6cfd-4fd6-b2d9-91648eeae814'
  // },
  // {
  //   AcresBurned: 48920,
  //   AdminUnit: 'Unified command: CAL FIRE Mendocino Unit and USFS Mendocino National Forest',
  //   ArchiveYear: 2018,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2018/7/27/river-fire-mendocino-complex/',
  //   Counties: 'Lake',
  //   CountyIds: 61723,
  //   Extinguished: '2019-01-04T09:18:00Z',
  //   Latitude: 39.04786,
  //   Location: 'Old River Rd, near Mile Marker Post 7.9, Hopland',
  //   Longitude: -123.11971,
  //   MajorIncident: 'True',
  //   Name: 'River Fire (Mendocino Complex)',
  //   Started: '2018-07-27T13:01:00Z',
  //   UniqueId: 'af30fe23-6cfd-4fd6-b2d9-91648eeae814'
  // },
  {
    AcresBurned: 48920,
    AdminUnit: 'Unified command: CAL FIRE Mendocino Unit and USFS Mendocino National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/27/river-fire-mendocino-complex/',
    Counties: 'Mendocino',
    CountyIds: 61723,
    Extinguished: '2019-01-04T09:18:00Z',
    Latitude: 39.04786,
    Location: 'Old River Rd, near Mile Marker Post 7.9, Hopland',
    Longitude: -123.11971,
    MajorIncident: 'True',
    Name: 'River Fire (Mendocino Complex)',
    Started: '2018-07-27T13:01:00Z',
    UniqueId: 'af30fe23-6cfd-4fd6-b2d9-91648eeae814'
  },
  {
    AcresBurned: 46150,
    AdminUnit: 'USFS Shasta-Trinity National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/8/9/hirz-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-01-04T09:21:00Z',
    Latitude: 40.896,
    Location: 'off Gilman and Moore Creek Campground, east of Lakehead',
    Longitude: -122.219,
    MajorIncident: 'True',
    Name: 'Hirz Fire',
    Started: '2018-08-09T01:55:00Z',
    UniqueId: 'cb647b06-1772-4d65-8087-0b841fcfb502'
  },
  {
    AcresBurned: 39387,
    AdminUnit: 'Modoc National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/8/15/stone-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2019-01-04T09:20:00Z',
    Latitude: 41.38544,
    Location: 'Big Canyon, 10 miles SW of Canby',
    Longitude: -121.04386,
    MajorIncident: 'False',
    Name: 'Stone Fire',
    Started: '2018-08-15T18:05:00Z',
    UniqueId: '58e6dde2-eeae-4a9e-be1e-bfd654d4405b'
  },
  {
    AcresBurned: 38008,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/5/klamathon-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-01-04T09:55:00Z',
    Latitude: 41.893332,
    Location: 'off Klamathon Road and Copco Road, south of Hornbrook',
    Longitude: -122.534655,
    MajorIncident: 'True',
    Name: 'Klamathon Fire',
    Started: '2018-07-05T12:31:00Z',
    UniqueId: 'd7e7eaca-5716-48b3-bd34-37acea282634'
  },
  {
    AcresBurned: 36450,
    AdminUnit: 'Stanislaus National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/8/1/donnell-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2019-01-04T09:26:00Z',
    Latitude: 38.349,
    Location: 'Near Hwy 108, Donnell Lake area in the Carson Iceburg Wilderness',
    Longitude: -119.929,
    MajorIncident: 'False',
    Name: 'Donnell Fire',
    Started: '2018-08-01T17:48:00Z',
    UniqueId: 'c62fc5e2-2340-49b7-b3d8-b883a266827f'
  },
  {
    AcresBurned: 23136,
    AdminUnit: 'Cleveland National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/8/6/holy-fire/',
    Counties: 'Orange',
    CountyIds: 30,
    Extinguished: '2019-01-04T09:23:00Z',
    Latitude: 33.69888,
    Location: 'Holy Jim Canyon, west of N. Main Divide',
    Longitude: -117.52055,
    MajorIncident: 'False',
    Name: 'Holy Fire',
    Started: '2018-08-06T13:20:00Z',
    UniqueId: '5b9e5ea7-1f63-46dd-aabd-8cf407c6f4ba'
  },
  {
    AcresBurned: 18703,
    AdminUnit: 'Unified Command: CAL FIRE and USFS Lassen National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/27/whaleback-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-01-04T09:32:00Z',
    Latitude: 40.633536,
    Location: 'off Whaleback Mountain and Antelope Valley Road, West of Spaulding',
    Longitude: -120.868091,
    MajorIncident: 'False',
    Name: 'Whaleback Fire',
    Started: '2018-07-27T13:32:00Z',
    UniqueId: '684ded31-5a60-4c05-bbdb-2fb913ca0041'
  },
  {
    AcresBurned: 15185,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/23/pawnee-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2019-01-04T10:01:00Z',
    Latitude: 39.0674,
    Location: 'Pawnee Rd & New Long Valley Rd, northeast of Clearlake Oaks',
    Longitude: -122.59848,
    MajorIncident: 'True',
    Name: 'Pawnee Fire',
    Started: '2018-06-23T17:21:00Z',
    UniqueId: '25574325-cf1d-4191-bc3d-c50ed0a15f9c'
  },
  {
    AcresBurned: 13139,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/7/25/cranston-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T09:36:00Z',
    Latitude: 0,
    Location: 'off Highway 74 and Control Road, east of Hemet',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Cranston Fire',
    Started: '2018-07-25T11:41:00Z',
    UniqueId: '999bb931-4f26-4234-bb47-2f0d5b5f6263'
  },
  {
    AcresBurned: 12300,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/29/waverly-fire/',
    Counties: 'San Joaquin',
    CountyIds: 39,
    Extinguished: '2019-01-04T09:58:00Z',
    Latitude: 38.052055,
    Location: 'off North Waverly Road and North Shelton Road, east of Linden',
    Longitude: -120.945482,
    MajorIncident: 'False',
    Name: 'Waverly Fire',
    Started: '2018-06-29T15:11:00Z',
    UniqueId: '4efc7855-ecbf-4507-8435-399e23a91fef'
  },
  {
    AcresBurned: 6974,
    AdminUnit: 'Humboldt-Toiyabe National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/9/4/boot-fire/',
    Counties: 'Mono',
    CountyIds: 26,
    Extinguished: '2019-01-04T09:09:00Z',
    Latitude: 38.347395,
    Location: 'Hwy 395 & Hwy 108, Sonora Junction',
    Longitude: -119.45186,
    MajorIncident: 'False',
    Name: 'Boot Fire',
    Started: '2018-09-04T14:26:00Z',
    UniqueId: 'a81f5149-5ac2-48de-a189-609e46f5fad8'
  },
  {
    AcresBurned: 4564,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/15/planada-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2019-01-04T10:06:00Z',
    Latitude: 37.39339,
    Location: 'off Doug Road and Bonner Road, north of the community of Planada',
    Longitude: -120.34207,
    MajorIncident: 'False',
    Name: 'Planada Fire',
    Started: '2018-06-15T10:34:00Z',
    UniqueId: '3de50f18-061e-40f4-8ee4-8a3d3ef25fb1'
  },
  {
    AcresBurned: 4531,
    AdminUnit: 'Unified Command: CAL FIRE, Ventura County Fire, Ventura Sheriff Dept, LA County Fire, LA City Fire, LA Sherriff Dept, LA Police Dept',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/11/8/hill-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2019-01-04T08:43:00Z',
    Latitude: 34.22685,
    Location: 'Hill Canyon Rd and Santa Rosa Rd, Santa Rosa Valley',
    Longitude: -118.93444,
    MajorIncident: 'True',
    Name: 'Hill Fire',
    Started: '2018-11-08T14:03:00Z',
    UniqueId: 'bc95da49-28a0-4e56-88d9-72e7455063c0'
  },
  {
    AcresBurned: 4500,
    AdminUnit: 'Suisun Fire Protection District',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/10/7/branscombe-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2019-01-04T08:57:00Z',
    Latitude: 0,
    Location: 'Branscombe Road south of Hwy 12, Suisun City',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Branscombe Fire',
    Started: '2018-10-07T13:00:00Z',
    UniqueId: '0f754948-aba7-4423-b8f6-079f68d4d294'
  },
  {
    AcresBurned: 4064,
    AdminUnit: 'Sierra National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/11/lions-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2019-01-04T10:03:00Z',
    Latitude: 37.571,
    Location: 'near the Lion Point area in the Ansel Adams Wilderness',
    Longitude: -119.118,
    MajorIncident: 'False',
    Name: 'Lions Fire',
    Started: '2018-06-11T12:00:00Z',
    UniqueId: 'b17eb5bf-c44a-4e13-99d0-bbdf5e8f8f67'
  },
  {
    AcresBurned: 3889,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/10/7/sun-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-01-04T08:57:00Z',
    Latitude: 40.22027778,
    Location: 'Hwy 36 and Sunriver Road, east of Red Bluff',
    Longitude: -122.18,
    MajorIncident: 'True',
    Name: 'Sun Fire',
    Started: '2018-10-07T12:51:00Z',
    UniqueId: '8f633ae7-b5f0-455f-a60e-13d9566e5844'
  },
  {
    AcresBurned: 3716,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/23/lane-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-01-04T10:02:00Z',
    Latitude: 40.35068,
    Location: 'Off Hwy 36 in Paynes Creek',
    Longitude: -121.77867,
    MajorIncident: 'True',
    Name: 'Lane Fire',
    Started: '2018-06-23T11:38:00Z',
    UniqueId: '299d84d9-ff65-4669-bcd7-cb5abb191c75'
  },
  {
    AcresBurned: 3674,
    AdminUnit: 'Hoopa Valley Tribe',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/8/16/mill-creek-1-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2019-01-04T09:17:00Z',
    Latitude: 41.07944,
    Location: 'Hwy 96 & Mill Creek Road, northeast of the Town of Hoopa',
    Longitude: -123.688056,
    MajorIncident: 'False',
    Name: 'Mill Creek 1 Fire',
    Started: '2018-08-16T09:18:00Z',
    UniqueId: 'd3ead5e1-12bb-4d27-8c1d-c723c0747265'
  },
  {
    AcresBurned: 3380,
    AdminUnit: 'US Forest Service - Angeles National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/9/22/charlie-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2019-01-04T09:03:00Z',
    Latitude: 34.48229,
    Location: 'Charlie Canyon Rd  and Tapia Canyon Rd, Castaic',
    Longitude: -118.60858,
    MajorIncident: 'False',
    Name: 'Charlie Fire',
    Started: '2018-09-22T14:30:00Z',
    UniqueId: '4fa2e1e0-a920-4991-beb6-3c080b6c1500'
  },
  {
    AcresBurned: 2995,
    AdminUnit: 'Kings County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/8/6/five-fire/',
    Counties: 'Kings',
    CountyIds: 16,
    Extinguished: '2019-01-04T09:23:00Z',
    Latitude: 35.97896,
    Location: 'off Interstate 5 and Milham Rd, Kettleman Hills area',
    Longitude: -119.98329,
    MajorIncident: 'False',
    Name: 'Five Fire',
    Started: '2018-08-06T17:29:00Z',
    UniqueId: '0ba9a90d-6615-4fa8-9a10-3efb660437ca'
  },
  {
    AcresBurned: 2956,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/9/apple-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-01-04T10:10:00Z',
    Latitude: 39.94355,
    Location: 'Off Apple Rd & Paskenta Rd, west of Corning',
    Longitude: -122.3571,
    MajorIncident: 'True',
    Name: 'Apple Fire',
    Started: '2018-06-09T14:10:00Z',
    UniqueId: '22fc8e84-ae8e-4a10-a9f3-828464616253'
  },
  {
    AcresBurned: 2950,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/3/tarina-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2019-01-04T09:26:00Z',
    Latitude: 35.37444,
    Location: 'Breckenridge Rd & Comanche Dr, east of Bakersfield',
    Longitude: -118.83556,
    MajorIncident: 'False',
    Name: 'Tarina Fire',
    Started: '2018-08-03T14:48:00Z',
    UniqueId: '676aa48b-d962-4026-a354-db047f14233f'
  },
  {
    AcresBurned: 2883,
    AdminUnit: 'Inyo National Forest Service',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/7/8/georges-fire/',
    Counties: 'Inyo',
    CountyIds: 14,
    Extinguished: '2019-01-04T09:54:00Z',
    Latitude: 36.6734,
    Location: 'off Hogback and Whitney Portal Road, Alabama Hills',
    Longitude: -118.21881,
    MajorIncident: 'True',
    Name: 'Georges Fire',
    Started: '2018-07-08T13:36:00Z',
    UniqueId: '09395db0-1c76-43c3-a3db-d18081b31a35'
  },
  {
    AcresBurned: 2490,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/8/snell-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2019-01-04T09:06:00Z',
    Latitude: 38.69601,
    Location: 'off Butts Canyon Rd and Snell Valley Rd, southeast of Middletown',
    Longitude: -122.44468,
    MajorIncident: 'True',
    Name: 'Snell Fire',
    Started: '2018-09-08T14:29:00Z',
    UniqueId: 'db2344ac-f195-4f94-8999-e8c8ebb4a7a2'
  },
  {
    AcresBurned: 2290,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/9/chrome-fire/',
    Counties: 'Glenn',
    CountyIds: 11,
    Extinguished: '2019-01-04T10:09:00Z',
    Latitude: 39.64978,
    Location: 'Hwy 162 and Forest Hwy 7, north of Elk Creek',
    Longitude: -122.58218,
    MajorIncident: 'True',
    Name: 'Chrome Fire',
    Started: '2018-06-09T15:32:00Z',
    UniqueId: '1d926fc4-0f23-47dd-a750-5e7fac4ad416'
  },
  {
    AcresBurned: 2225,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/6/turkey-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2019-01-04T09:23:00Z',
    Latitude: 35.847778,
    Location: 'near Highway 46 and Turkey Flats, near Parkfield',
    Longitude: -120.343056,
    MajorIncident: 'False',
    Name: 'Turkey Fire',
    Started: '2018-08-06T12:59:00Z',
    UniqueId: 'c7152819-8f07-489c-a219-b58bed82733e'
  },
  {
    AcresBurned: 2162,
    AdminUnit: 'Unified Command: CAL FIRE Sonoma-Lake-Napa Unit, Solano County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/10/nelson-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2019-01-04T09:20:00Z',
    Latitude: 38.431278,
    Location: 'Nelson Rd and Cherry Glen Rd, Vacaville',
    Longitude: -122.043747,
    MajorIncident: 'True',
    Name: 'Nelson Fire',
    Started: '2018-08-10T16:57:00Z',
    UniqueId: '2ce8de99-7e66-4de8-9426-48a4fc8500ac'
  },
  {
    AcresBurned: 2100,
    AdminUnit: 'BLM Northern District (NOD)',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/7/13/eagle-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2019-01-04T09:46:00Z',
    Latitude: 41.29363,
    Location: 'County Rd 40/ County Rd1, South West of Eagleville',
    Longitude: -120.11461,
    MajorIncident: 'False',
    Name: 'Eagle Fire',
    Started: '2018-07-13T22:03:00Z',
    UniqueId: '656c37d9-6876-47ba-bf8e-ec6c351c3595'
  },
  {
    AcresBurned: 2070,
    AdminUnit: 'Unified Command: CAL FIRE San Bernardino Unit and Inyo County Sheriff\'s Office',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/2/18/pleasant-fire/',
    Counties: 'Inyo',
    CountyIds: 14,
    Extinguished: '2019-01-03T09:43:00Z',
    Latitude: 37.40208,
    Location: 'Pleasant Valley Dam Road and Hwy 395, north of Bishop',
    Longitude: -118.50235,
    MajorIncident: 'True',
    Name: 'Pleasant Fire',
    Started: '2018-02-18T14:12:00Z',
    UniqueId: '3d866877-330a-4a14-b5bd-48675955af64'
  },
  {
    AcresBurned: 1900,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/9/hat-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-01-04T09:21:00Z',
    Latitude: 40.99344,
    Location: 'Hwy 299 east and Fish Hatchery rd, northeast of Burney',
    Longitude: -121.52225,
    MajorIncident: 'True',
    Name: 'Hat Fire',
    Started: '2018-08-09T14:34:00Z',
    UniqueId: 'ce93c72c-eb9c-4176-a2b6-7750a4a6bb20'
  },
  {
    AcresBurned: 1756,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/2/nees-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2019-01-04T10:26:00Z',
    Latitude: 36.85156,
    Location: 'Interstate 5 and W Nees Ave. south of Los Banos',
    Longitude: -120.77206,
    MajorIncident: 'False',
    Name: 'Nees Fire',
    Started: '2018-05-02T16:00:00Z',
    UniqueId: '92c441f3-4729-4ba5-890f-fb7693725275'
  },
  {
    AcresBurned: 1751,
    AdminUnit: 'Shasta-Trinity National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/9/4/kerlin-fire/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2019-01-04T09:08:00Z',
    Latitude: 40.616251,
    Location: 'Kerlin Creek, west of Hyampom',
    Longitude: -123.52019,
    MajorIncident: 'False',
    Name: 'Kerlin Fire',
    Started: '2018-09-04T15:20:00Z',
    UniqueId: '3506eaf5-e815-4a7f-9c52-816fe5eee7d5'
  },
  {
    AcresBurned: 1678,
    AdminUnit: 'Unified Command: CAL FIRE and City of Redding Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/24/creek-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-01-04T10:01:00Z',
    Latitude: 40.50318,
    Location: 'Clear Creek Rd & American Rd, west of Redding',
    Longitude: -122.42308,
    MajorIncident: 'True',
    Name: 'Creek Fire',
    Started: '2018-06-24T12:29:00Z',
    UniqueId: 'b900fe52-8900-4578-9745-58036920a1ab'
  },
  {
    AcresBurned: 1500,
    AdminUnit: 'Suisun City Fire Protection District',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/11/8/nurse-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2019-01-04T08:47:00Z',
    Latitude: 38.21396,
    Location: 'off Highway 12 and Nurse Blue Road, Suisun City',
    Longitude: -121.9424,
    MajorIncident: 'False',
    Name: 'Nurse Fire',
    Started: '2018-11-08T13:28:00Z',
    UniqueId: 'b8fe54be-15a8-4088-b0bb-16992df93a7e'
  },
  {
    AcresBurned: 1500,
    AdminUnit: 'Camp Roberts',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/20/yankee-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-01-04T10:03:00Z',
    Latitude: 35.73629,
    Location: 'E. Perimeter Rd, Yankee training area, Camp Roberts Military Reservation',
    Longitude: -120.75593,
    MajorIncident: 'False',
    Name: 'Yankee Fire',
    Started: '2018-06-20T18:22:00Z',
    UniqueId: 'd963ff00-9c98-4bc6-a3b3-4856d8192e87'
  },
  {
    AcresBurned: 1352,
    AdminUnit: 'Unified Command: US Forest Service and Los Angeles County FD',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/4/stone-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2019-01-04T10:15:00Z',
    Latitude: 34.5486,
    Location: 'off Anthony Road and Hierba Road, North of Agua Dulce',
    Longitude: -118.31138,
    MajorIncident: 'False',
    Name: 'Stone Fire',
    Started: '2018-06-04T12:40:00Z',
    UniqueId: '5340807b-1be1-4894-b446-c81c46456641'
  },
  {
    AcresBurned: 1350,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/7/6/valley-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2019-01-04T09:55:00Z',
    Latitude: 34.095568,
    Location: 'Valley of the Falls Dr & Service Road 1S08',
    Longitude: -116.958806,
    MajorIncident: 'True',
    Name: 'Valley Fire',
    Started: '2018-07-06T13:29:00Z',
    UniqueId: 'b90be7b6-e9ec-4a18-a910-957f700c6ed6'
  },
  {
    AcresBurned: 1314,
    AdminUnit: 'CAL FIRE San Benito-Monterey',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/4/airline-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2019-01-04T10:15:00Z',
    Latitude: 36.40755,
    Location: 'Coalinga and Airline Highway',
    Longitude: -120.99322,
    MajorIncident: 'True',
    Name: 'Airline Fire',
    Started: '2018-06-04T17:01:00Z',
    UniqueId: 'df2538f9-20c9-4d40-9a64-9d6334b6f7d6'
  },
  {
    AcresBurned: 1265,
    AdminUnit: 'Unified Command: CAL FIRE San Bernardino Unit, Cal Trans, and Inyo County Sheriff\'s Office',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/4/19/moffat-fire/',
    Counties: 'Inyo',
    CountyIds: 14,
    Extinguished: '2019-01-03T13:09:00Z',
    Latitude: 36.71537,
    Location: 'Highway 395 and Moffat Ranch Road, north of Lone Pine',
    Longitude: -118.08449,
    MajorIncident: 'True',
    Name: 'Moffat Fire',
    Started: '2018-04-19T10:28:00Z',
    UniqueId: 'a339b368-ec58-463e-9a26-9af37c938f49'
  },
  {
    AcresBurned: 1261,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/17/patterson-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T10:24:00Z',
    Latitude: 33.62924,
    Location: 'off Rawson Road and Royal Netherlands Road, south of Winchester',
    Longitude: -117.05992,
    MajorIncident: 'False',
    Name: 'Patterson Fire',
    Started: '2018-05-17T14:19:00Z',
    UniqueId: '693a86e6-8985-4e70-8ba8-869786ff538b'
  },
  {
    AcresBurned: 1200,
    AdminUnit: 'Sutter County Fire Protection District',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/7/31/butte-fire/',
    Counties: 'Sutter',
    CountyIds: 51,
    Extinguished: '2019-01-04T09:28:00Z',
    Latitude: 39.186144,
    Location: 'Pass Road and W Butte Road, 9 miles northwest of Yuba City',
    Longitude: -121.792885,
    MajorIncident: 'False',
    Name: 'Butte Fire',
    Started: '2018-07-31T17:34:00Z',
    UniqueId: 'ea58640a-7837-4d93-a145-96e48b7df8ee'
  },
  {
    AcresBurned: 1120,
    AdminUnit: 'Tahoe National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/9/3/north-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '2019-01-04T09:10:00Z',
    Latitude: 39.268611,
    Location: 'North Fork Campground, south of Emigrant Gap',
    Longitude: -120.658333,
    MajorIncident: 'True',
    Name: 'North Fire',
    Started: '2018-09-03T16:38:00Z',
    UniqueId: 'd8235a76-7b43-4e23-8f60-dc308c250fab'
  },
  {
    AcresBurned: 1014,
    AdminUnit: 'USFS Los Padres National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/8/19/front-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2019-01-04T09:16:00Z',
    Latitude: 35.11416667,
    Location: 'off Highway 166 and Sierra Madre Road',
    Longitude: -120.09222222,
    MajorIncident: 'False',
    Name: 'Front Fire',
    Started: '2018-08-19T13:37:00Z',
    UniqueId: '8dd81979-48ba-48db-bb24-e4f1bf85d262'
  },
  {
    AcresBurned: 993,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/27/breckenridge-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2019-01-04T09:32:00Z',
    Latitude: 35.387408,
    Location: 'off Breckenridge Road and Tarina Ct, east of Bakersfield',
    Longitude: -118.817934,
    MajorIncident: 'False',
    Name: 'Breckenridge Fire',
    Started: '2018-07-27T16:12:00Z',
    UniqueId: '53a9be88-6d10-483e-8dc7-59cb84326ab8'
  },
  {
    AcresBurned: 972,
    AdminUnit: 'USFS Mendocino National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/7/31/eel-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2019-01-04T09:29:00Z',
    Latitude: 39.82877,
    Location: 'off Indian Dick Road and Mendocino Pass Road, east of Covelo',
    Longitude: -123.08489,
    MajorIncident: 'False',
    Name: 'Eel Fire',
    Started: '2018-07-31T15:28:00Z',
    UniqueId: 'fa745e18-be7a-42e0-b3c7-30333ddcf3aa'
  },
  {
    AcresBurned: 962,
    AdminUnit: 'Chico City Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/12/stoney-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-01-04T09:48:00Z',
    Latitude: 39.77124,
    Location: 'Bidwell Park, Upper Park Rd, Chico',
    Longitude: -121.76859,
    MajorIncident: 'True',
    Name: 'Stoney Fire',
    Started: '2018-07-12T22:45:00Z',
    UniqueId: '3c17be70-66f8-4df2-97be-873fe924d99c'
  },
  {
    AcresBurned: 856,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/9/dale-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-01-04T09:52:00Z',
    Latitude: 40.33682,
    Location: 'off Hwy 36 and Manton Rd, 10 miles NE of Red Bluff',
    Longitude: -121.93908,
    MajorIncident: 'False',
    Name: 'Dale Fire',
    Started: '2018-07-09T18:30:00Z',
    UniqueId: '3b576efa-90b7-4b87-983d-b38630e10576'
  },
  {
    AcresBurned: 825,
    AdminUnit: 'CAL FIRE Amador - El Dorado Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/6/irish-fire/',
    Counties: 'Amador',
    CountyIds: 3,
    Extinguished: '2019-01-04T09:54:00Z',
    Latitude: 38.42623,
    Location: 'off Irish Ridge Road and Carbondale Road, southeast of Plymouth',
    Longitude: -120.95408,
    MajorIncident: 'True',
    Name: 'Irish Fire',
    Started: '2018-07-06T14:42:00Z',
    UniqueId: 'be804253-e994-4f40-9e07-5c215533231c'
  },
  {
    AcresBurned: 822,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/18/eighty-eight-fire/',
    Counties: 'Yolo',
    CountyIds: 57,
    Extinguished: '2019-01-04T09:40:00Z',
    Latitude: 38.59694444,
    Location: 'off County Road 88 and County Road 29, north of Winters',
    Longitude: -121.99388889,
    MajorIncident: 'False',
    Name: 'Eighty Eight Fire',
    Started: '2018-07-18T14:24:00Z',
    UniqueId: 'e51ff5f0-09d5-42f3-8bed-c1c6eb85d245'
  },
  {
    AcresBurned: 700,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/1/sunset-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '2019-01-04T09:28:00Z',
    Latitude: 38.82426,
    Location: 'off Sunset Blvd. West and South Brewer Rd, northwest of Roseville',
    Longitude: -121.451307,
    MajorIncident: 'False',
    Name: 'Sunset Fire',
    Started: '2018-08-01T13:11:00Z',
    UniqueId: '4f3f4f66-871c-4d50-bd3f-f641210552c9'
  },
  {
    AcresBurned: 668,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/15/river-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2019-01-04T09:19:00Z',
    Latitude: 35.79012,
    Location: 'Old Stage Rd and White River Rd, southeast of Porterville',
    Longitude: -118.7393,
    MajorIncident: 'False',
    Name: 'River Fire',
    Started: '2018-08-15T17:14:00Z',
    UniqueId: 'b83feee5-a799-4481-bd25-1d4cc3befd7d'
  },
  {
    AcresBurned: 650,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/11/gulch-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2019-01-04T09:20:00Z',
    Latitude: 36.00912,
    Location: 'Dead Mans Gulch Rd and Sargents Rd, south of San Ardo',
    Longitude: -120.82226,
    MajorIncident: 'False',
    Name: 'Gulch Fire',
    Started: '2018-08-11T14:12:00Z',
    UniqueId: '3bb731cc-eb21-421f-b5f5-4949346dc316'
  },
  {
    AcresBurned: 646,
    AdminUnit: 'Northern California District Bureau of Land Management',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/14/tumbleweed-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-01-04T10:06:00Z',
    Latitude: 40.3768,
    Location: 'off Highway 395 Southeast of Litchfield, East of Susanville',
    Longitude: -120.36403,
    MajorIncident: 'False',
    Name: 'Tumbleweed Fire',
    Started: '2018-06-14T17:45:00Z',
    UniqueId: 'b307b3b5-529a-4dd0-ad30-e678180a6174'
  },
  {
    AcresBurned: 640,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/8/grant-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-01-04T09:53:00Z',
    Latitude: 37.75646,
    Location: 'off I580 and Grantline Rd, Altamont Area',
    Longitude: -121.60646,
    MajorIncident: 'True',
    Name: 'Grant Fire',
    Started: '2018-07-08T17:38:00Z',
    UniqueId: 'd0e1cdc0-9dea-467a-8ae8-040e0f94178d'
  },
  {
    AcresBurned: 573,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/8/tulloch-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2019-01-04T09:06:00Z',
    Latitude: 37.83388,
    Location: 'Hwy 108 and Tulloch Road, east of Oakdale',
    Longitude: -120.61746,
    MajorIncident: 'False',
    Name: 'Tulloch Fire',
    Started: '2018-09-08T13:34:00Z',
    UniqueId: '849ad1a0-472b-4cc6-a513-030491fa1ffb'
  },
  {
    AcresBurned: 550,
    AdminUnit: 'CAL FIRE Butte Unit/Butte County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/10/30/june-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-01-04T08:50:00Z',
    Latitude: 39.36529,
    Location: 'Four Junes Way and Palermo, south of Palermo',
    Longitude: -121.51707,
    MajorIncident: 'False',
    Name: 'June Fire',
    Started: '2018-10-30T14:46:00Z',
    UniqueId: '7ee82e4f-f5e8-4278-b4e7-e82c390b395e'
  },
  {
    AcresBurned: 513,
    AdminUnit: 'CAL FIRE San Benito-Monterey',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/4/eastern-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2019-01-04T10:14:00Z',
    Latitude: 36.378333,
    Location: 'Coalinga Road, east of Bitterwater',
    Longitude: -120.901167,
    MajorIncident: 'True',
    Name: 'Eastern Fire',
    Started: '2018-06-04T17:30:00Z',
    UniqueId: '5228fabc-64f6-4ccf-aedc-dc1e781277a6'
  },
  {
    AcresBurned: 504,
    AdminUnit: 'Unified Command: CAL FIRE San Diego, Alpine Fire District and Cleveland National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/6/west-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T09:55:00Z',
    Latitude: 32.833674,
    Location: 'off I-8 & West Willows Rd, Community of Alpine',
    Longitude: -116.7311,
    MajorIncident: 'True',
    Name: 'West Fire',
    Started: '2018-07-06T23:39:00Z',
    UniqueId: '2a1c14d1-2a88-4564-bd09-585e09ffc9a7'
  },
  {
    AcresBurned: 484,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/30/grant-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-01-04T10:20:00Z',
    Latitude: 37.75375,
    Location: 'near Grant Line Rd and Mountain House Rd, Altamont Area',
    Longitude: -121.57918,
    MajorIncident: 'False',
    Name: 'Grant Fire',
    Started: '2018-05-30T13:21:00Z',
    UniqueId: '503cf916-4f56-4be7-8083-730122f686dc'
  },
  {
    AcresBurned: 441,
    AdminUnit: 'CAL FIRE Lassen Modoc Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/27/hyatt-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-01-04T09:59:00Z',
    Latitude: 40.316137,
    Location: 'Hyatt Ln and Standish Buntingville Rd, 5 miles east of Janesville',
    Longitude: -120.45053,
    MajorIncident: 'False',
    Name: 'Hyatt Fire',
    Started: '2018-06-27T15:09:00Z',
    UniqueId: '218619b5-ad0c-4238-8e31-ab6d98932a73'
  },
  {
    AcresBurned: 400,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/13/metz-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2019-01-04T09:04:00Z',
    Latitude: 36.35502,
    Location: 'Metz Road and Topo Road, east of Greenfield',
    Longitude: -121.1563,
    MajorIncident: 'False',
    Name: 'Metz Fire',
    Started: '2018-09-13T15:37:00Z',
    UniqueId: '7fc0b9c8-dec7-430d-9790-1bbebae404eb'
  },
  {
    AcresBurned: 375,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/26/san-ardo/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2019-06-21T08:51:41Z',
    Latitude: 35.95515,
    Location: 'Sargents Canyon and Deadman Gulch, San Ardo Oil Fields',
    Longitude: -120.86256,
    MajorIncident: 'False',
    Name: 'San Ardo',
    Started: '2018-06-26T07:11:00Z',
    UniqueId: '8811a5f8-b99a-454a-9af5-6753579c8d45'
  },
  {
    AcresBurned: 367,
    AdminUnit: 'USFS Sequoia National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/8/18/call-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2019-01-04T09:16:00Z',
    Latitude: 35.51777778,
    Location: 'off Cow Flat Road and Highway 178, west of Lake Isabella',
    Longitude: -118.6525,
    MajorIncident: 'False',
    Name: 'Call Fire',
    Started: '2018-08-18T15:17:00Z',
    UniqueId: '5eab06a3-5deb-4934-98a7-7c42eb86cbf9'
  },
  {
    AcresBurned: 365,
    AdminUnit: 'Unified Command: CAL FIRE San Diego County Fire Authority and San Diego County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/27/pasqual-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T09:32:00Z',
    Latitude: 33.07892,
    Location: 'San Pasqual Valley Rd, west of Ramona',
    Longitude: -116.91845,
    MajorIncident: 'True',
    Name: 'Pasqual Fire',
    Started: '2018-07-27T13:28:00Z',
    UniqueId: '2b56b06d-46d6-43f2-b474-2598dd163e82'
  },
  {
    AcresBurned: 360,
    AdminUnit: 'CAL FIRE Madera Mariposa Merced Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/22/oak-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2019-01-04T09:03:00Z',
    Latitude: 37.38789,
    Location: 'Lonesome Oak Ln and Bissett Station Rd, Ahwahnee',
    Longitude: -119.68912,
    MajorIncident: 'True',
    Name: 'Oak Fire',
    Started: '2018-09-22T15:44:00Z',
    UniqueId: '6b6dff76-8fab-4852-a71c-e735f87bd6fa'
  },
  {
    AcresBurned: 347,
    AdminUnit: 'CAL FIRE Butte Unit - Butte County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/26/shippee-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-01-04T09:59:00Z',
    Latitude: 39.59872,
    Location: 'Midway Road and Esquon Road , 4 miles SE  of Durham',
    Longitude: -121.78208,
    MajorIncident: 'False',
    Name: 'Shippee Fire',
    Started: '2018-06-26T12:56:00Z',
    UniqueId: 'a3ba8fc0-37f7-4c1a-9386-627d3369a03e'
  },
  {
    AcresBurned: 338,
    AdminUnit: 'Inyo National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/7/31/owens-fire/',
    Counties: 'Inyo',
    CountyIds: 14,
    Extinguished: '2019-01-04T09:29:00Z',
    Latitude: 37.735461,
    Location: 'Owens River Rd & Indiana Summit Rd, north of Mammoth Lakes',
    Longitude: -118.970443,
    MajorIncident: 'False',
    Name: 'Owens Fire',
    Started: '2018-07-31T15:07:00Z',
    UniqueId: '574b0b35-4c66-44ac-8797-3eadf09e495d'
  },
  {
    AcresBurned: 328,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/23/bascom-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-01-04T10:02:00Z',
    Latitude: 40.52909,
    Location: 'Off Bascom Rd & Hwy 44, in Millville',
    Longitude: -122.17457,
    MajorIncident: 'False',
    Name: 'Bascom Fire',
    Started: '2018-06-23T12:54:00Z',
    UniqueId: '9fe34773-10d3-419a-a6f5-4ddb2d43a145'
  },
  {
    AcresBurned: 320,
    AdminUnit: 'Unified Command: CAL FIRE Santa Clara Unit and Milpitas Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/22/country-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-01-04T09:37:00Z',
    Latitude: 37.449425,
    Location: 'County Club Rd & N Park Victoria Rd in Milpitas',
    Longitude: -121.88807,
    MajorIncident: 'True',
    Name: 'Country Fire',
    Started: '2018-07-22T13:06:00Z',
    UniqueId: '0dd9bca6-35b9-4a75-8f3b-a5e57e1b90e7'
  },
  {
    AcresBurned: 316,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/4/shingle-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2019-01-04T09:56:00Z',
    Latitude: 38.539806,
    Location: 'off South Shingle Road and Latrobe Road, west of Latrobe',
    Longitude: -121.059979,
    MajorIncident: 'False',
    Name: 'Shingle Fire',
    Started: '2018-07-04T17:09:00Z',
    UniqueId: '29a5f777-bea5-411e-9139-fe0d094616b0'
  },
  {
    AcresBurned: 300,
    AdminUnit: 'CAL FIRE Shasta Trinity Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/28/flat-fire/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2019-01-04T09:59:00Z',
    Latitude: 40.60402,
    Location: 'Reading Creek Road, SE of Douglas City',
    Longitude: -122.9144,
    MajorIncident: 'True',
    Name: 'Flat Fire',
    Started: '2018-06-28T18:01:00Z',
    UniqueId: '70ff3ebc-0d1f-43eb-ab56-1ff13fe9c9e3'
  },
  {
    AcresBurned: 300,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/4/oneals-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2019-01-04T10:14:00Z',
    Latitude: 37.10181,
    Location: 'Road 210 and Road 200, Oneal',
    Longitude: -119.623981,
    MajorIncident: 'False',
    Name: 'ONeals Fire',
    Started: '2018-06-04T17:44:00Z',
    UniqueId: '9662b158-b17f-4386-867a-3afa5ea28929'
  },
  {
    AcresBurned: 300,
    AdminUnit: 'Department of Defense - Camp Pendleton',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/5/4/alpha-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T10:26:00Z',
    Latitude: 33.389425,
    Location: 'Basilone Rd and San Juan Rd, Camp Pendleton Marine Corps Base',
    Longitude: -117.502405,
    MajorIncident: 'False',
    Name: 'Alpha Fire',
    Started: '2018-05-04T11:44:00Z',
    UniqueId: '32708961-025a-4bf7-88c1-8cd91bbc3cce'
  },
  {
    AcresBurned: 293,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/16/twisselman-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2019-01-04T10:25:00Z',
    Latitude: 0,
    Location: 'Twisselman Road and Kecks Road, west of Highway 33',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Twisselman Fire',
    Started: '2018-05-16T16:30:00Z',
    UniqueId: '82aa9789-b558-46a0-ae5d-683e18423b17'
  },
  {
    AcresBurned: 290,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/6/south-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2019-01-04T09:23:00Z',
    Latitude: 38.061298,
    Location: 'Near Milton Road and South Gulch Road, Rancho Calaveras',
    Longitude: -120.872244,
    MajorIncident: 'False',
    Name: 'South Fire',
    Started: '2018-08-06T16:26:00Z',
    UniqueId: 'a1e73f5c-68e2-4109-b741-046eb7349265'
  },
  {
    AcresBurned: 289,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/23/eastman-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2019-01-04T09:15:00Z',
    Latitude: 37.197039,
    Location: 'Road 29 & Road 607, southwest of Eastman Lake',
    Longitude: -120.002619,
    MajorIncident: 'False',
    Name: 'Eastman Fire',
    Started: '2018-08-23T15:40:00Z',
    UniqueId: 'eeb859ef-dc44-48e2-a2d7-dce44bc47d01'
  },
  {
    AcresBurned: 282,
    AdminUnit: 'Unified Command: CAL FIRE/Riverside County Fire Department and Corona City Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/19/skyline-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T09:39:00Z',
    Latitude: 33.836101,
    Location: 'off Skyline Drive and Burrero Way, in an unincorporated county area west of Corona Cit',
    Longitude: -117.607577,
    MajorIncident: 'False',
    Name: 'Skyline Fire',
    Started: '2018-07-19T17:22:00Z',
    UniqueId: '022bee6b-1559-4792-a2d2-014d3adfecad'
  },
  {
    AcresBurned: 278,
    AdminUnit: 'CAL FIRE San Benito-Monterey',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/11/panoche-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2019-01-04T09:49:00Z',
    Latitude: 36.65351,
    Location: 'off Panoche Road, 2 miles north of CAL FIRE Antelope Station, southeast of Hollister',
    Longitude: -121.0454,
    MajorIncident: 'False',
    Name: 'Panoche Fire',
    Started: '2018-07-11T16:40:00Z',
    UniqueId: '68957772-711e-4874-99f2-2b9267dbe725'
  },
  {
    AcresBurned: 268,
    AdminUnit: 'Unified Command: CAL FIRE and Contra Costa County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/29/valley-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-01-04T09:58:00Z',
    Latitude: 37.94714,
    Location: 'Ygnaciao Valley Road and Cowell Road, Concord',
    Longitude: -121.9921,
    MajorIncident: 'False',
    Name: 'Valley Fire',
    Started: '2018-06-29T16:06:00Z',
    UniqueId: '53770321-4d20-4db9-bfad-754f9eeabc2b'
  },
  {
    AcresBurned: 268,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/23/stoll-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-01-04T10:02:00Z',
    Latitude: 40.18395,
    Location: 'Stoll Rd & Baker Rd, west of Red Bluff',
    Longitude: -122.27574,
    MajorIncident: 'True',
    Name: 'Stoll Fire',
    Started: '2018-06-23T12:52:00Z',
    UniqueId: '72999057-198b-4cd2-a316-2e854ef9a7f8'
  },
  {
    AcresBurned: 265,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/6/recycle-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T10:11:00Z',
    Latitude: 32.63046,
    Location: 'Off Hwy 94 and Campo Truck Trail, Campo',
    Longitude: -116.46674,
    MajorIncident: 'True',
    Name: 'Recycle Fire',
    Started: '2018-06-06T09:46:00Z',
    UniqueId: '9ededdf0-b250-49ec-999d-eb988dab08a9'
  },
  {
    AcresBurned: 261,
    AdminUnit: 'Lassen National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/9/28/wilson-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-01-04T08:59:00Z',
    Latitude: 40.34256,
    Location: 'Wilson Lake Rd and Lost Creek Rd, 10 miles NW of Chester',
    Longitude: -121.43025,
    MajorIncident: 'False',
    Name: 'Wilson Fire',
    Started: '2018-09-28T13:08:00Z',
    UniqueId: 'd0ae0a7f-dd7b-4cb1-8f4a-2a784a17d6d4'
  },
  {
    AcresBurned: 260,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/26/fox-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-01-04T10:00:00Z',
    Latitude: 35.33916,
    Location: 'Camp San Luis Obispo Range Echo, 3 miles NW of San Luis Obispo',
    Longitude: -120.71488,
    MajorIncident: 'False',
    Name: 'Fox Fire',
    Started: '2018-06-26T11:16:00Z',
    UniqueId: '91b94b02-cd05-471a-a4e7-5168d56c46ba'
  },
  {
    AcresBurned: 258,
    AdminUnit: 'Channel Islands National Park',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/3/27/santa-cruz-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2019-01-03T09:44:00Z',
    Latitude: 34.0232,
    Location: 'Channel Islands National Park, Santa Cruz Island',
    Longitude: -119.76576,
    MajorIncident: 'False',
    Name: 'Santa Cruz Fire',
    Started: '2018-03-27T14:45:00Z',
    UniqueId: 'f87005f7-c31b-4135-989a-ee5611626b3c'
  },
  {
    AcresBurned: 250,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/9/rangeland-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T09:21:00Z',
    Latitude: 33.076239,
    Location: 'off Rangeland Road and Highway 78 in Ramona',
    Longitude: -116.902985,
    MajorIncident: 'False',
    Name: 'Rangeland Fire',
    Started: '2018-08-09T13:09:00Z',
    UniqueId: '8dddf572-84de-4b20-b740-f5c7847cec3b'
  },
  {
    AcresBurned: 247,
    AdminUnit: 'Unified Command: CAL FIRE Santa Clara Unit & East Contra Costa Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/25/marsh-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-01-04T09:34:00Z',
    Latitude: 37.89612,
    Location: 'Marsh Creek Rd and  Bragdon way, east of Mount Diablo',
    Longitude: -121.85847,
    MajorIncident: 'True',
    Name: 'Marsh Fire',
    Started: '2018-07-25T14:41:00Z',
    UniqueId: 'df681456-a50e-4400-a95a-77533a0978ba'
  },
  {
    AcresBurned: 224,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/15/steamboat-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-01-04T09:44:00Z',
    Latitude: 41.70877,
    Location: 'Shasta Valley Wildlife Area, 4 miles south east of Montague',
    Longitude: -122.47293,
    MajorIncident: 'True',
    Name: 'Steamboat Fire',
    Started: '2018-07-15T09:58:00Z',
    UniqueId: '052acbfd-0552-47ac-8be7-6f79b4aecf0e'
  },
  {
    AcresBurned: 215,
    AdminUnit: 'Klamath National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/7/1/petersburg-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-01-04T09:56:00Z',
    Latitude: 41.085,
    Location: 'Petersburg and Caribou Creek Rd 3 MI SW of Cecilville',
    Longitude: -123.051,
    MajorIncident: 'False',
    Name: 'Petersburg Fire',
    Started: '2018-07-01T18:13:00Z',
    UniqueId: '6103c099-a3eb-481e-8a76-1296f5fdb25d'
  },
  {
    AcresBurned: 215,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/12/beaver-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2019-01-04T10:07:00Z',
    Latitude: 36.37532,
    Location: 'off Coalinga Highway and Airline Highway, East of King City',
    Longitude: -120.862579,
    MajorIncident: 'False',
    Name: 'Beaver Fire',
    Started: '2018-06-12T15:06:00Z',
    UniqueId: 'b3ab43c4-6f73-4ccc-a3ca-f2c54959f8b1'
  },
  {
    AcresBurned: 207,
    AdminUnit: 'CAL FIRE San Diego Fire Authority',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/28/rock-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T09:31:00Z',
    Latitude: 33.41476,
    Location: 'Rock Mountain Dr. and Sandia Creek Dr. in the community of Fallbrook.',
    Longitude: -117.24044,
    MajorIncident: 'True',
    Name: 'Rock Fire',
    Started: '2018-07-28T15:14:00Z',
    UniqueId: 'e3406861-3e7f-4a4b-b16d-6004f3edc5e6'
  },
  {
    AcresBurned: 205,
    AdminUnit: 'Bureau of Indian Affairs - CAL FIRE / Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/26/ribbon-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T09:33:00Z',
    Latitude: 33.571763,
    Location: 'Highway 74 and Ribbonwood Dr. near Pinyon',
    Longitude: -116.500058,
    MajorIncident: 'False',
    Name: 'Ribbon Fire',
    Started: '2018-07-26T10:12:00Z',
    UniqueId: '1f942827-c242-49a1-bccd-f2375be91ad9'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/12/water-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2019-01-04T09:06:00Z',
    Latitude: 34.91482,
    Location: 'southbound I-5, south of Grapevine Rd.',
    Longitude: -118.92485,
    MajorIncident: 'False',
    Name: 'Water Fire',
    Started: '2018-09-12T11:25:00Z',
    UniqueId: 'f694c74c-adad-459c-b357-4cd2f10f16df'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/7/bear-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2019-01-04T10:10:00Z',
    Latitude: 37.33924,
    Location: 'Cunningham Road and Hwy 140, Planda',
    Longitude: -120.24315,
    MajorIncident: 'False',
    Name: 'Bear Fire',
    Started: '2018-06-07T18:04:00Z',
    UniqueId: 'cdd46073-0336-4003-8a06-161947985987'
  },
  {
    AcresBurned: 191,
    AdminUnit: 'CAL FIRE Butte Unit/Butte County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/4/par-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-01-04T09:56:00Z',
    Latitude: 39.491737,
    Location: 'off Par Four Way and Highway 162, west of the City of Oroville',
    Longitude: -121.637759,
    MajorIncident: 'False',
    Name: 'Par Fire',
    Started: '2018-07-04T13:30:00Z',
    UniqueId: 'cbf84797-7cc2-40a4-8157-d74c89792e9e'
  },
  {
    AcresBurned: 186,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/11/12/peak-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2019-01-04T08:46:00Z',
    Latitude: 34.26734825,
    Location: 'off Highway 118 and Rocky Peak Road, east of Simi Valley',
    Longitude: -118.64381589,
    MajorIncident: 'False',
    Name: 'Peak Fire',
    Started: '2018-11-12T10:06:00Z',
    UniqueId: 'c3b66e33-ef00-4874-a29b-b36640c16122'
  },
  {
    AcresBurned: 185,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/17/dinosaur-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2019-01-04T10:04:00Z',
    Latitude: 37.05876,
    Location: 'off Dinosaur Road and Highway 152, Santa Nella',
    Longitude: -121.176354,
    MajorIncident: 'False',
    Name: 'Dinosaur Fire',
    Started: '2018-06-17T15:09:00Z',
    UniqueId: 'fc911680-49a8-454b-be0f-d78cd957bd29'
  },
  {
    AcresBurned: 175,
    AdminUnit: 'Los Angeles County',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/9/south-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2019-01-04T10:08:00Z',
    Latitude: 37.97638,
    Location: 'I-5 and Calgrove Blvd, Santa Clarita',
    Longitude: -122.5275,
    MajorIncident: 'False',
    Name: 'South Fire',
    Started: '2018-06-09T14:45:00Z',
    UniqueId: 'd6d4d085-1c3b-4ee5-bd2a-dd3779797e97'
  },
  {
    AcresBurned: 175,
    AdminUnit: 'Orange County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/2/aliso-fire/',
    Counties: 'Orange',
    CountyIds: 30,
    Extinguished: '2019-01-04T10:19:00Z',
    Latitude: 33.55132,
    Location: 'Aliso Woods Canyon Park, Community of Aliso Viejo',
    Longitude: -117.72044,
    MajorIncident: 'False',
    Name: 'Aliso Fire',
    Started: '2018-06-02T13:07:00Z',
    UniqueId: '105b65f3-7e99-4cd6-8b0a-f78004c041eb'
  },
  {
    AcresBurned: 172,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/9/1/ogilvy-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2019-01-04T09:12:00Z',
    Latitude: 34.576944,
    Location: 'Pie Canyon Rd and Mono-Alamar Rd, NE of Gibraltar Reservoir',
    Longitude: -119.61416,
    MajorIncident: 'False',
    Name: 'Ogilvy Fire',
    Started: '2018-09-01T14:22:00Z',
    UniqueId: 'c9001401-a2b0-4cae-9e03-e60509342a53'
  },
  {
    AcresBurned: 170,
    AdminUnit: 'Tehama County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/23/sierra-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-01-04T10:02:00Z',
    Latitude: 40.12791,
    Location: 'Off Casale Rd & Reading Rd, south of Red Bluff',
    Longitude: -122.19792,
    MajorIncident: 'False',
    Name: 'Sierra Fire',
    Started: '2018-06-23T13:15:00Z',
    UniqueId: '75ad696c-b094-4919-89e3-f879361f5151'
  },
  {
    AcresBurned: 167,
    AdminUnit: 'CAL FIRE San Benito - Monterey Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/10/13/priest-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2019-01-04T08:54:00Z',
    Latitude: 36.18401,
    Location: 'Hwy 198 & Priest Valley Rd, east of San Lucas',
    Longitude: -120.69955,
    MajorIncident: 'False',
    Name: 'Priest Fire',
    Started: '2018-10-13T14:43:00Z',
    UniqueId: '8a79c31d-0df0-4448-a855-b04cfc384825'
  },
  {
    AcresBurned: 167,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit / Lassen National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/24/roxie-fire-formerly-1-1-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-01-04T09:35:00Z',
    Latitude: 40.34822,
    Location: 'Roxie Peconom Campground, west of Willard Cr, 10 mi west of Susanville',
    Longitude: -120.82497,
    MajorIncident: 'True',
    Name: 'Roxie Fire (Formerly 1-1 Fire)',
    Started: '2018-07-24T16:02:00Z',
    UniqueId: 'a18ed51c-1083-4f48-ab1b-6ae0c5454073'
  },
  {
    AcresBurned: 166,
    AdminUnit: 'Angeles National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/9/9/fork-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2019-01-04T09:05:00Z',
    Latitude: 34.2325,
    Location: 'East Fork Rd & San Gabriel Canyon Rd, Azusa',
    Longitude: -117.846111,
    MajorIncident: 'False',
    Name: 'Fork Fire',
    Started: '2018-09-09T12:10:00Z',
    UniqueId: '9bffc947-2f15-4486-98df-9a632b2038a7'
  },
  {
    AcresBurned: 163,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/24/flat-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2019-01-04T10:01:00Z',
    Latitude: 37.80785,
    Location: 'Hwy 49 & Marshes Flat Rd, in the Community of Moccasin',
    Longitude: -120.30187,
    MajorIncident: 'True',
    Name: 'Flat Fire',
    Started: '2018-06-24T13:54:00Z',
    UniqueId: '28d55249-7c63-4213-a7b4-c0796dbb18ca'
  },
  {
    AcresBurned: 160,
    AdminUnit: 'Solano County Fire Protection District',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/10/12/winters-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2019-01-04T08:55:00Z',
    Latitude: 38.45673,
    Location: 'Winters Rd & Allendale Rd, south of Winters',
    Longitude: -121.94658,
    MajorIncident: 'False',
    Name: 'Winters Fire',
    Started: '2018-10-12T11:21:00Z',
    UniqueId: 'e9c8c0aa-4d21-4f09-9858-890ea163d580'
  },
  {
    AcresBurned: 155,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/19/gorge-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-01-04T09:16:00Z',
    Latitude: 40.36888889,
    Location: 'off Highway 36 west and Beegum Gorge road, Platina area',
    Longitude: -122.89055556,
    MajorIncident: 'False',
    Name: 'Gorge Fire',
    Started: '2018-08-19T07:32:00Z',
    UniqueId: '5dbbbc9f-deec-4c33-a172-19614492d860'
  },
  {
    AcresBurned: 155,
    AdminUnit: 'Orange County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/11/santiago-fire/',
    Counties: 'Orange',
    CountyIds: 30,
    Extinguished: '2019-01-04T10:08:00Z',
    Latitude: 33.787838,
    Location: 'off Highway 241 and Santiago Canyon Road',
    Longitude: -117.746625,
    MajorIncident: 'False',
    Name: 'Santiago Fire',
    Started: '2018-06-11T17:04:00Z',
    UniqueId: '96781eb8-6146-4b96-a5cb-7457defea461'
  },
  {
    AcresBurned: 154,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/12/euclid-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T10:07:00Z',
    Latitude: 33.925862,
    Location: 'off Highway 71 south of Euclid Avenue in Chino',
    Longitude: -117.654299,
    MajorIncident: 'False',
    Name: 'Euclid Fire',
    Started: '2018-06-12T14:22:00Z',
    UniqueId: 'e1c9dae5-a2d8-4c97-8e6d-65937ade5e79'
  },
  {
    AcresBurned: 152,
    AdminUnit: 'Marin County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/10/irving-fire/',
    Counties: 'Marin',
    CountyIds: 21,
    Extinguished: '2019-01-04T09:05:00Z',
    Latitude: 38.02447,
    Location: 'Samuel P Taylor State Park, northwest of the Community of Lagunitas',
    Longitude: -122.727,
    MajorIncident: 'True',
    Name: 'Irving Fire',
    Started: '2018-09-10T19:00:00Z',
    UniqueId: '65689d5f-910c-4e00-9bf3-e5626cd1361c'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/11/15/briggs-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2019-01-04T08:44:00Z',
    Latitude: 34.30166667,
    Location: 'off Shell Road and Orr Road, Santa Paula',
    Longitude: -119.09916667,
    MajorIncident: 'False',
    Name: 'Briggs Fire',
    Started: '2018-11-15T01:39:00Z',
    UniqueId: 'c003df4f-d19c-4e21-a90f-81d3f14aaf99'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'Fort Hunter Liggett Military Reservation',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/10/2/nacimiento-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2019-01-04T08:57:00Z',
    Latitude: 35.97677,
    Location: 'Nacimiento Fergusson Rd, west of Jolon',
    Longitude: -121.24898,
    MajorIncident: 'False',
    Name: 'Nacimiento Fire',
    Started: '2018-10-02T12:32:00Z',
    UniqueId: '9d69b6cb-1dee-43df-83ca-b2b5485006d7'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/4/sliger-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2019-01-04T09:09:00Z',
    Latitude: 38.94388,
    Location: 'Sliger Mine Rd and Hida Way, northwest of Georgetown',
    Longitude: -120.92611,
    MajorIncident: 'True',
    Name: 'Sliger Fire',
    Started: '2018-09-04T15:03:00Z',
    UniqueId: '94e0a869-04f6-4265-9c1f-c53fbdde98ad'
  },
  {
    AcresBurned: 147,
    AdminUnit: 'Rialto Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/11/13/sierra-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2019-01-04T08:45:00Z',
    Latitude: 34.18075,
    Location: 'off Sierra Ave and Riverside Ave',
    Longitude: -117.43184,
    MajorIncident: 'False',
    Name: 'Sierra Fire',
    Started: '2018-11-13T08:19:00Z',
    UniqueId: 'd18da394-5ed4-4004-8dea-600e15d398e4'
  },
  {
    AcresBurned: 136,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/5/parrots-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2019-01-04T09:24:00Z',
    Latitude: 38.08424,
    Location: 'Parrots Ferry Rd x Camp 9 Rd, South of the community of Vallecito',
    Longitude: -120.46078,
    MajorIncident: 'False',
    Name: 'Parrots Fire',
    Started: '2018-08-05T04:19:00Z',
    UniqueId: '190306eb-357b-40d2-9871-92cdd8784332'
  },
  {
    AcresBurned: 135,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/28/steele-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2019-01-04T09:30:00Z',
    Latitude: 38.51943,
    Location: 'off Arroyo Grande Drive and Steele Canyon Road, Capell',
    Longitude: -122.18353,
    MajorIncident: 'True',
    Name: 'Steele Fire',
    Started: '2018-07-28T16:30:00Z',
    UniqueId: '2410754e-b988-4f4f-b7ee-21f954c2bbf2'
  },
  {
    AcresBurned: 128,
    AdminUnit: 'Los Angeles County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/23/pico-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2019-01-04T09:37:00Z',
    Latitude: 34.38039,
    Location: 'off West Pico Canyon Rd and Potrero Canyon Rd, Stevenson Ranch area',
    Longitude: -118.60441,
    MajorIncident: 'False',
    Name: 'Pico Fire',
    Started: '2018-07-23T12:55:00Z',
    UniqueId: '6e0b516c-9da1-4ff7-a0ce-3251b2cbabb9'
  },
  {
    AcresBurned: 127,
    AdminUnit: 'Mendocino National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/1/open-fire/',
    Counties: 'Glenn',
    CountyIds: 11,
    Extinguished: '2019-01-04T10:19:00Z',
    Latitude: 39.46543,
    Location: 'Open Ridge, NW of Dry Creek Hill, 11 miles SW of Elk Creek',
    Longitude: -122.65582,
    MajorIncident: 'False',
    Name: 'Open Fire',
    Started: '2018-06-01T15:20:00Z',
    UniqueId: '3db90629-694f-43d7-b46a-6378f6bc1472'
  },
  {
    AcresBurned: 127,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/9/shastina-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-01-04T10:25:00Z',
    Latitude: 41.65935,
    Location: 'west of Rancho Hills, community of Lake Shastina, north of Weed',
    Longitude: -122.48556,
    MajorIncident: 'False',
    Name: 'Shastina Fire',
    Started: '2018-05-09T18:11:00Z',
    UniqueId: 'e84f2881-743c-4e36-863d-ddb37c2540d3'
  },
  {
    AcresBurned: 125,
    AdminUnit: 'San Bernardino National Forest/San Bernardino County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/8/31/sterling/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2019-01-04T09:12:00Z',
    Latitude: 34.15475,
    Location: 'Sterling Ave and Foothill Dr, City of San Bernardino',
    Longitude: -117.244366,
    MajorIncident: 'False',
    Name: 'Sterling',
    Started: '2018-08-31T17:58:00Z',
    UniqueId: '0683b4a7-6a8c-4339-abc1-dfbe64dcb5a1'
  },
  {
    AcresBurned: 120,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/10/24/market-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2019-01-04T08:51:00Z',
    Latitude: 36.47766,
    Location: 'Road 208 and Avenue 380, 5 miles north of Woodlake',
    Longitude: -119.10433,
    MajorIncident: 'False',
    Name: 'Market Fire',
    Started: '2018-10-24T12:18:00Z',
    UniqueId: '87760805-5b1a-486e-91c4-590557929182'
  },
  {
    AcresBurned: 117,
    AdminUnit: 'USFS Plumas National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/8/7/murphy-fire/',
    Counties: 'Plumas',
    CountyIds: 32,
    Extinguished: '2019-01-04T09:22:00Z',
    Latitude: 39.996944,
    Location: 'off Hwy 70 near Chips Creek, west of Belden',
    Longitude: -121.27,
    MajorIncident: 'False',
    Name: 'Murphy Fire',
    Started: '2018-08-07T02:11:00Z',
    UniqueId: 'b9f703f7-18bb-4845-a480-ce7d63b5f57a'
  },
  {
    AcresBurned: 116,
    AdminUnit: 'CAL FIRE San Benito-Monterey',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/12/idria-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2019-01-04T09:49:00Z',
    Latitude: 36.59036,
    Location: 'Panoche Rd and New Idria Rd, west of San Joaquin',
    Longitude: -120.82355,
    MajorIncident: 'False',
    Name: 'Idria Fire',
    Started: '2018-07-12T12:57:00Z',
    UniqueId: 'a0b16523-d6f9-4a21-809d-4f2bdbc2bea7'
  },
  {
    AcresBurned: 116,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/6/bridle-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-01-04T09:54:00Z',
    Latitude: 37.06367,
    Location: 'off Bridal Path Drive and Butch Drive, east of Gilroy',
    Longitude: -121.53586,
    MajorIncident: 'False',
    Name: 'Bridle Fire',
    Started: '2018-07-06T10:40:00Z',
    UniqueId: '8d5856ff-4cd4-4b88-afb0-c6df08f548a8'
  },
  {
    AcresBurned: 115,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/18/wheeler-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2019-01-04T10:04:00Z',
    Latitude: 37.707234,
    Location: 'Wheeler Gulch & Hwy 49 South, southwest of Coulterville',
    Longitude: -120.199162,
    MajorIncident: 'True',
    Name: 'Wheeler Fire',
    Started: '2018-06-18T12:30:00Z',
    UniqueId: '8f98a50c-fac6-4dcd-844f-76c49891f0f6'
  },
  {
    AcresBurned: 114,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/16/pine-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2019-01-04T09:17:00Z',
    Latitude: 35.56888889,
    Location: 'off Pine Mountain Road and Granite Road, north of Bakersfield',
    Longitude: -118.80138889,
    MajorIncident: 'False',
    Name: 'Pine Fire',
    Started: '2018-08-16T16:06:00Z',
    UniqueId: '471980a3-9ffb-4b1f-8e51-eabb9736b51b'
  },
  {
    AcresBurned: 113,
    AdminUnit: 'Santa Barbara County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/6/holiday-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2019-01-04T09:54:00Z',
    Latitude: 34.463889,
    Location: 'off north Fairview Ave and Holiday Hill Road, City of Goleta',
    Longitude: -119.831389,
    MajorIncident: 'True',
    Name: 'Holiday Fire',
    Started: '2018-07-06T20:40:00Z',
    UniqueId: '76725105-a814-4e8d-bd5b-d0f2f1879dae'
  },
  {
    AcresBurned: 110,
    AdminUnit: 'Santa Barbara County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/20/windmill-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2019-01-04T09:38:00Z',
    Latitude: 34.62412,
    Location: 'Highway 246, west of Buellton',
    Longitude: -120.22298,
    MajorIncident: 'False',
    Name: 'Windmill Fire',
    Started: '2018-07-20T14:23:00Z',
    UniqueId: '389e3075-51b9-45a8-ab9a-a75b03225c8d'
  },
  {
    AcresBurned: 108,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/26/cobble-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2019-01-04T10:22:00Z',
    Latitude: 36.75581,
    Location: 'Cobblestone Lane and Thernal Road, Tivy Valley',
    Longitude: -119.42172,
    MajorIncident: 'False',
    Name: 'Cobble Fire',
    Started: '2018-05-26T14:52:00Z',
    UniqueId: '737f9bb2-5a43-4730-94c1-4031bce6d626'
  },
  {
    AcresBurned: 106,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/1/western-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2019-01-04T09:26:00Z',
    Latitude: 38.8802,
    Location: 'Off Highway 101, south of Hopland',
    Longitude: -123.0496,
    MajorIncident: 'False',
    Name: 'Western Fire',
    Started: '2018-08-01T15:53:00Z',
    UniqueId: '9d63cbd8-7dbf-4b2d-918d-036e3a282d2d'
  },
  {
    AcresBurned: 103,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/26/cache-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2019-01-04T09:14:00Z',
    Latitude: 39.02017,
    Location: 'Hwy 20 and New Long Valley Rd, Clear Lake Oaks',
    Longitude: -122.57496,
    MajorIncident: 'False',
    Name: 'Cache Fire',
    Started: '2018-08-26T18:04:00Z',
    UniqueId: 'ef9c8f82-8607-4c53-9bdd-5196e6a1071c'
  },
  {
    AcresBurned: 103,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/18/jelly-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-01-04T10:24:00Z',
    Latitude: 40.31759,
    Location: 'Off Jellysferry Rd, north of Red Bluff',
    Longitude: -122.21032,
    MajorIncident: 'False',
    Name: 'Jelly Fire',
    Started: '2018-05-18T16:37:00Z',
    UniqueId: 'e1ab6577-7ce9-4b19-bb29-68b5bdd699b6'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'San Diego Fire-Rescue Department',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/8/13/cloverdale-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T09:19:00Z',
    Latitude: 33.0971179,
    Location: 'off San Pasqual Valley Rd, near Escondido.',
    Longitude: -117.0242529,
    MajorIncident: 'False',
    Name: 'Cloverdale Fire',
    Started: '2018-08-13T14:58:00Z',
    UniqueId: '791a3a00-2c51-4679-b4b7-27cc77ec699d'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/27/balch-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2019-01-04T09:33:00Z',
    Latitude: 36.21634,
    Location: 'off Balch Park Road and Yokohl Drive, northeast of Porterville',
    Longitude: -118.82989,
    MajorIncident: 'False',
    Name: 'Balch Fire',
    Started: '2018-07-27T12:14:00Z',
    UniqueId: 'e775e724-0a1b-4156-a477-623031c09b0e'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/7/6/box-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2019-01-04T09:55:00Z',
    Latitude: 34.22526,
    Location: 'off Interstate 15 and Kenwood Ave, north of San Bernardino',
    Longitude: -117.40967,
    MajorIncident: 'False',
    Name: 'Box Fire',
    Started: '2018-07-06T09:36:00Z',
    UniqueId: '1a4aeaa6-7f90-420f-ad6b-6942658a7fee'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/24/water-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-01-04T10:22:00Z',
    Latitude: 35.56922,
    Location: 'Bitterwater Rd and Bitterwater Canyon Rd, California Valley Area',
    Longitude: -120.12441,
    MajorIncident: 'False',
    Name: 'Water Fire',
    Started: '2018-05-24T10:43:00Z',
    UniqueId: '31c47bb9-1913-463e-95e4-86e48fadfda6'
  },
  {
    AcresBurned: 96,
    AdminUnit: 'Fort Hunter Liggett',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/9/sam-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2019-01-04T10:08:00Z',
    Latitude: 35.9352,
    Location: 'Sam Jones and Jolon Rd, Fort Hunter Liggett',
    Longitude: -121.11936,
    MajorIncident: 'False',
    Name: 'Sam Fire',
    Started: '2018-06-09T15:31:00Z',
    UniqueId: '63e41793-2c9c-4dda-98e0-62b5069514a7'
  },
  {
    AcresBurned: 95,
    AdminUnit: 'CAL FIRE Kern County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/29/sheep-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2019-01-04T09:57:00Z',
    Latitude: 35.1234,
    Location: 'Comanche Point Rd, 3 miles south of Arvin',
    Longitude: -118.72905,
    MajorIncident: 'False',
    Name: 'Sheep Fire',
    Started: '2018-06-29T17:53:00Z',
    UniqueId: 'd7365a2a-a113-4693-92d3-152f52b0d743'
  },
  {
    AcresBurned: 90,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/5/peach-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2019-01-04T09:55:00Z',
    Latitude: 39.038859,
    Location: 'off Peachland Road and Highway 128, north of the Community of Boonville',
    Longitude: -123.38493,
    MajorIncident: 'False',
    Name: 'Peach Fire',
    Started: '2018-07-05T15:12:00Z',
    UniqueId: 'eabc7fc2-d02b-480a-9472-7c7677e812cb'
  },
  {
    AcresBurned: 89,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/15/3-16-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-01-04T09:42:00Z',
    Latitude: 40.94666,
    Location: 'near Little Valley',
    Longitude: -121.27049,
    MajorIncident: 'False',
    Name: '3-16 Fire',
    Started: '2018-07-15T18:54:00Z',
    UniqueId: '62b14189-aea8-4dcb-8702-a1dfc11abda7'
  },
  {
    AcresBurned: 88,
    AdminUnit: 'CAL FIRE Lassen - Modoc Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/11/8/horn-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-01-04T08:47:00Z',
    Latitude: 40.83116,
    Location: 'Horn Road and Mail Route Road, 9 miles southeast of Termo',
    Longitude: -120.19336,
    MajorIncident: 'False',
    Name: 'Horn Fire',
    Started: '2018-11-08T11:25:00Z',
    UniqueId: '79968306-21a9-465e-acbe-4ea715c70ab5'
  },
  {
    AcresBurned: 88,
    AdminUnit: 'USFS Sierra National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/8/27/redinger-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2019-01-04T09:13:00Z',
    Latitude: 37.179167,
    Location: 'Mammoth Road, 29 miles north of Clovis',
    Longitude: -119.431667,
    MajorIncident: 'False',
    Name: 'Redinger Fire',
    Started: '2018-08-27T23:19:00Z',
    UniqueId: 'f6555118-f01e-4524-a14d-e01303a482db'
  },
  {
    AcresBurned: 88,
    AdminUnit: 'CAL FIRE Mariposa-Madera-Merced Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/20/plaza-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2019-01-04T10:24:00Z',
    Latitude: 37.056944,
    Location: 'off Highway 33 and south of Highway 152',
    Longitude: -121.01638,
    MajorIncident: 'False',
    Name: 'Plaza Fire',
    Started: '2018-05-20T13:07:00Z',
    UniqueId: 'd77a050b-9928-49bf-92de-1159edddd07c'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/29/shandon-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-01-04T08:58:00Z',
    Latitude: -120.258,
    Location: 'Gillis Canyon Road and San Juan Road, east of Paso Robles',
    Longitude: -120.258,
    MajorIncident: 'False',
    Name: 'Shandon Fire',
    Started: '2018-09-29T09:30:00Z',
    UniqueId: '9c03d484-e442-4eaa-8a7b-99d6c769750a'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/9/spring-2-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2019-01-04T09:51:00Z',
    Latitude: 39.06715,
    Location: 'Pawnee Dr. and New Long Valley Dr., northeast of Clearlake',
    Longitude: -122.59789,
    MajorIncident: 'False',
    Name: 'Spring 2 Fire',
    Started: '2018-07-09T16:46:00Z',
    UniqueId: '78eabcbb-32b9-4438-ab84-8eb65c044db7'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/24/horse-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2019-01-04T10:01:00Z',
    Latitude: 37.95766,
    Location: 'Horseshoe Rd & Stagecoach Dr, near Copperopolis',
    Longitude: -120.68902,
    MajorIncident: 'True',
    Name: 'Horse Fire',
    Started: '2018-06-24T15:28:00Z',
    UniqueId: 'f2d02439-f682-47e7-b6e9-6e51ca068c86'
  },
  {
    AcresBurned: 77,
    AdminUnit: 'Santa Barbara County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/18/cruces-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2019-01-04T09:40:00Z',
    Latitude: 34.54305556,
    Location: 'off Highway 1 and Highway 101, North of Gaviota',
    Longitude: -120.31805556,
    MajorIncident: 'False',
    Name: 'Cruces Fire',
    Started: '2018-07-18T11:55:00Z',
    UniqueId: '756cceab-80e1-47af-8c85-9e650352b48e'
  },
  {
    AcresBurned: 76,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/28/silver-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-01-04T08:58:00Z',
    Latitude: 40.5939,
    Location: 'Oak Run Rd and Little Ridge Rd, Palo Cedro',
    Longitude: -122.17173,
    MajorIncident: 'True',
    Name: 'Silver Fire',
    Started: '2018-09-28T14:44:00Z',
    UniqueId: 'b181e69a-5864-44c1-b5b4-f4c5832a4539'
  },
  {
    AcresBurned: 76,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/27/anchor-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2019-01-04T09:59:00Z',
    Latitude: 36.696879,
    Location: 'Anchor Ave and Hills Valley Rd, north of Orange Cove',
    Longitude: -119.304499,
    MajorIncident: 'False',
    Name: 'Anchor Fire',
    Started: '2018-06-27T12:39:00Z',
    UniqueId: '595f6f52-a55b-40e7-8aa6-b409ff9a7a5b'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/4/stony-fire/',
    Counties: 'Colusa',
    CountyIds: 6,
    Extinguished: '2019-01-04T09:56:00Z',
    Latitude: 39.2976,
    Location: 'off Stonyford Road and Lake Park, west of Maxwell',
    Longitude: -122.512012,
    MajorIncident: 'True',
    Name: 'Stony Fire',
    Started: '2018-07-04T13:14:00Z',
    UniqueId: 'b4377461-c17b-41b1-8dc2-9722f8ead519'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/28/chrome-fire/',
    Counties: 'Glenn',
    CountyIds: 11,
    Extinguished: '2019-01-04T10:21:00Z',
    Latitude: 39.65578,
    Location: 'Hwy 162 and Forest Hwy 7, northwest of Elk Creek',
    Longitude: -122.58666,
    MajorIncident: 'False',
    Name: 'Chrome Fire',
    Started: '2018-05-28T17:33:00Z',
    UniqueId: '09f22e57-6058-4a87-972a-ece08f4527d4'
  },
  {
    AcresBurned: 73,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/4/28/main-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T10:26:00Z',
    Latitude: 33.67815,
    Location: 'Main Street and Interstate 15, City of Lake Elsinore',
    Longitude: -117.32281,
    MajorIncident: 'False',
    Name: 'Main Fire',
    Started: '2018-04-28T14:26:00Z',
    UniqueId: '8e840df1-b34b-44fd-8ade-0350a0113a81'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'Unitied Command: CAL FIRE & San Jose City Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/10/curie-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-01-04T09:50:00Z',
    Latitude: 37.22545,
    Location: 'Curie Dr and San Ignacio Ave, southeast of San Jose',
    Longitude: -121.79189,
    MajorIncident: 'False',
    Name: 'Curie Fire',
    Started: '2018-07-10T15:08:00Z',
    UniqueId: '01018620-8f10-4de0-a7e6-78cc9a77cc9a'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/29/tesla-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-01-04T09:57:00Z',
    Latitude: 37.66074,
    Location: 'Tesla Road and Reuss Road, east of Livermore',
    Longitude: -121.67144,
    MajorIncident: 'False',
    Name: 'Tesla Fire',
    Started: '2018-06-29T20:59:00Z',
    UniqueId: 'a4d4923c-cf9e-43a9-b62e-dc9c04f0ec24'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/13/spring-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-01-04T10:07:00Z',
    Latitude: 40.394073,
    Location: 'off Spring Branch Road and Jellys Ferry Road, northeast of Red Bluff',
    Longitude: -122.135924,
    MajorIncident: 'False',
    Name: 'Spring Fire',
    Started: '2018-06-13T21:06:00Z',
    UniqueId: '994876ff-2369-4a13-9642-d2dfbd372ac9'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'CAL FIRE/ Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/4/tornado-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T10:26:00Z',
    Latitude: 33.504964,
    Location: 'Via Santa Rosa near Via Tornado, southwest of Temecula',
    Longitude: -117.148204,
    MajorIncident: 'False',
    Name: 'Tornado Fire',
    Started: '2018-05-04T14:48:00Z',
    UniqueId: '57ef80d4-4674-4a3a-9fd6-3f1d792a1953'
  },
  {
    AcresBurned: 68,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/24/romero-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2019-01-04T10:00:00Z',
    Latitude: 37.08529,
    Location: 'Hwy 152 & Lower Cottonwood, west of Los Banos',
    Longitude: -121.09354,
    MajorIncident: 'False',
    Name: 'Romero Fire',
    Started: '2018-06-24T16:11:00Z',
    UniqueId: 'bda69d0e-716e-439e-9a18-49f44d449086'
  },
  {
    AcresBurned: 67,
    AdminUnit: 'CAL FIRE Amador - El Dorado Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/1/bumper-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2019-01-04T09:28:00Z',
    Latitude: 38.645,
    Location: 'Bumper Rd & China Hill Rd, east of Frenchtown',
    Longitude: -120.874167,
    MajorIncident: 'True',
    Name: 'Bumper Fire',
    Started: '2018-08-01T13:57:00Z',
    UniqueId: 'd8de1c4a-9b2c-46ad-aab4-3b2012571e4a'
  },
  {
    AcresBurned: 67,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/21/heart-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2019-01-04T09:37:00Z',
    Latitude: 39.279833,
    Location: 'Hwy 101 at mile marker 38, west of Redwood Valley (Mendocino County)',
    Longitude: -123.258319,
    MajorIncident: 'False',
    Name: 'Heart Fire',
    Started: '2018-07-21T16:22:00Z',
    UniqueId: 'fb7f7795-ede7-40cc-acf6-3ee6e761d0a9'
  },
  {
    AcresBurned: 66,
    AdminUnit: 'CAL FIRE Amador - El Dorado Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/1/omega-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2019-01-04T09:27:00Z',
    Latitude: 38.82128,
    Location: 'off Omega Lane and Alpha Circle, west of Pilot Hill',
    Longitude: -121.03918,
    MajorIncident: 'True',
    Name: 'Omega Fire',
    Started: '2018-08-01T14:40:00Z',
    UniqueId: '6e4ecf7a-2864-4fc6-85cb-9b2a0ac324df'
  },
  {
    AcresBurned: 64,
    AdminUnit: 'CAL FIRE San Benito-Monterey',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/4/panoche-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2019-01-04T10:13:00Z',
    Latitude: 36.64832,
    Location: 'Panoche Road, north of San Benito',
    Longitude: -121.03253,
    MajorIncident: 'False',
    Name: 'Panoche Fire',
    Started: '2018-06-04T23:17:00Z',
    UniqueId: '9f926d66-2cfa-4e3d-b4a3-4ea3b4b23698'
  },
  {
    AcresBurned: 63,
    AdminUnit: 'CAL FIRE Santa Clara Unit/San Jose City Fire & South Santa Clara County FPD',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/10/7/park-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-01-04T08:57:00Z',
    Latitude: 37.1769444,
    Location: 'Monterey Road and Coyote Creek Golf Drive, north of Morgan Hill',
    Longitude: -121.68694444,
    MajorIncident: 'False',
    Name: 'Park Fire',
    Started: '2018-10-07T12:57:00Z',
    UniqueId: 'f19a49b4-9d0f-4c61-83ea-9b4a741b0bef'
  },
  {
    AcresBurned: 63,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/20/highland-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-01-04T09:38:00Z',
    Latitude: 40.741186,
    Location: 'Highland Ridge Rd & Trinity Mt Rd, French Gulch',
    Longitude: -122.649626,
    MajorIncident: 'True',
    Name: 'Highland Fire',
    Started: '2018-07-20T13:26:00Z',
    UniqueId: '9626db35-9c2a-4431-8c91-00e0bba794fa'
  },
  {
    AcresBurned: 63,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/4/benton-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T09:56:00Z',
    Latitude: 33.56349,
    Location: 'off Benton Road and Crams Corner Drive in Anza',
    Longitude: -116.732032,
    MajorIncident: 'False',
    Name: 'Benton Fire',
    Started: '2018-07-04T14:20:00Z',
    UniqueId: '28599f05-c64d-49a5-be59-23879eecb980'
  },
  {
    AcresBurned: 63,
    AdminUnit: 'Klamath National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/27/cherry-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-01-04T09:59:00Z',
    Latitude: 41.83359,
    Location: 'Cherry Maple Road Klamath River, NW of Yreka, Klamath National Forest',
    Longitude: -122.99272,
    MajorIncident: 'False',
    Name: 'Cherry Fire',
    Started: '2018-06-27T19:46:00Z',
    UniqueId: '5aa13874-fb24-44f0-969a-d12dbc7edca8'
  },
  {
    AcresBurned: 63,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/29/stuhr-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2019-01-04T10:21:00Z',
    Latitude: 37.32744,
    Location: 'Interstate 5 and Stuhr Rd, South of Patterson',
    Longitude: -121.10903,
    MajorIncident: 'False',
    Name: 'Stuhr Fire',
    Started: '2018-05-29T12:58:00Z',
    UniqueId: 'e596a67e-177f-4db9-a2d6-dda7da1678fb'
  },
  {
    AcresBurned: 62,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/8/lebec-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2019-01-04T09:54:00Z',
    Latitude: 34.86022,
    Location: 'off Lebec Road and Lebec Oaks Road, North of Lebec',
    Longitude: -118.87881,
    MajorIncident: 'False',
    Name: 'Lebec Fire',
    Started: '2018-07-08T13:38:00Z',
    UniqueId: '22171870-baaf-480f-902a-45ec9282df35'
  },
  {
    AcresBurned: 62,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/23/canyon-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2019-01-04T10:01:00Z',
    Latitude: 34.53765,
    Location: 'North of Lake Piru',
    Longitude: -118.75495,
    MajorIncident: 'False',
    Name: 'Canyon Fire',
    Started: '2018-06-23T19:39:00Z',
    UniqueId: 'c8c8905e-4ff4-4563-8ad8-3838a8d0a3bb'
  },
  {
    AcresBurned: 62,
    AdminUnit: 'CAL FIRE Amador - El Dorado Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/11/liberty-fire/',
    Counties: 'San Joaquin',
    CountyIds: 39,
    Extinguished: '2019-01-04T10:08:00Z',
    Latitude: 38.24033,
    Location: 'off East Liberty Road',
    Longitude: -121.09199,
    MajorIncident: 'False',
    Name: 'Liberty Fire',
    Started: '2018-06-11T12:16:00Z',
    UniqueId: '7278467f-ca4a-47f1-b876-a6722b546f30'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'CAL FIRE Tehama - Glenn Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/11/5/adams-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-01-04T08:50:00Z',
    Latitude: 40.346652,
    Location: 'off Adams Road at Barr Lane, southwest of Cottonwood',
    Longitude: -122.308479,
    MajorIncident: 'False',
    Name: 'Adams Fire',
    Started: '2018-11-05T10:17:00Z',
    UniqueId: '8030a870-0453-48e0-b243-86dbae075434'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/30/grade-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2019-01-04T09:12:00Z',
    Latitude: 38.8275,
    Location: 'off Knoxville Road and Knoxville Devilhead Road, Knoxville',
    Longitude: -122.3625,
    MajorIncident: 'False',
    Name: 'Grade Fire',
    Started: '2018-08-30T15:44:00Z',
    UniqueId: 'c203606a-d2eb-4ba2-97cc-2ee7403432b1'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/15/raymond-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2019-01-04T10:06:00Z',
    Latitude: 37.14663,
    Location: 'off Road 407 and Road 600, Community of Raymond',
    Longitude: -119.91223,
    MajorIncident: 'False',
    Name: 'Raymond Fire',
    Started: '2018-06-15T11:46:00Z',
    UniqueId: '06ccdd6b-fd15-4cba-a9ed-6cb7c70327d9'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/14/creston-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-01-04T10:06:00Z',
    Latitude: 35.58354,
    Location: 'off Creston Road, east of Paso Robles',
    Longitude: -120.624135,
    MajorIncident: 'False',
    Name: 'Creston FIre',
    Started: '2018-06-14T17:23:00Z',
    UniqueId: 'f3d3e61e-4ab4-4155-a882-4e27de976659'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/13/vista-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-01-04T10:07:00Z',
    Latitude: 35.663607,
    Location: 'off Buena Vista Road, north of Paso Robles',
    Longitude: -120.670311,
    MajorIncident: 'False',
    Name: 'Vista Fire',
    Started: '2018-06-13T12:38:00Z',
    UniqueId: 'd886d8aa-00b7-41d7-b48f-665f5c6cf01e'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'Santa Barbara County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/17/happy-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2019-01-04T10:25:00Z',
    Latitude: 34.74245,
    Location: 'Alisos Canyon Rd, Santa Ynez, north of Santa Barbara',
    Longitude: -120.18236,
    MajorIncident: 'False',
    Name: 'Happy Fire',
    Started: '2018-05-17T12:53:00Z',
    UniqueId: '1a08a7d9-47b2-42ba-94c1-a2e15415b887'
  },
  {
    AcresBurned: 59,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/22/agua-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T10:23:00Z',
    Latitude: 33.35505,
    Location: 'Hwy 76 and Agua Tibia Ranch Rd, 7.5 miles east of I-15',
    Longitude: -117.03134,
    MajorIncident: 'False',
    Name: 'Agua Fire',
    Started: '2018-05-22T14:13:00Z',
    UniqueId: 'b9cd9a90-1983-4a0a-aad4-9c286382f158'
  },
  {
    AcresBurned: 58,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/10/19/camino-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-01-04T08:52:00Z',
    Latitude: 35.17693,
    Location: 'Off Lopez Drive east of Arroyo Grande',
    Longitude: -120.48861,
    MajorIncident: 'False',
    Name: 'Camino Fire',
    Started: '2018-10-19T14:10:00Z',
    UniqueId: 'a728d915-1c00-43b6-bd5b-228be34a38fe'
  },
  {
    AcresBurned: 56,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/15/3-10-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-01-04T09:44:00Z',
    Latitude: 40.95234,
    Location: 'Hwy 299 E and Little Valley Rd, Dixie Valley Peak, 16 miles east of Fall River Mills',
    Longitude: -121.21597,
    MajorIncident: 'False',
    Name: '3-10 Fire',
    Started: '2018-07-15T11:55:00Z',
    UniqueId: '8d7302b1-605f-404d-9641-a890720e8657'
  },
  {
    AcresBurned: 56,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/8/bruce-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-01-04T09:53:00Z',
    Latitude: 37.79718,
    Location: 'off Bruce Lane and Joseph Lane, east of San Ramon',
    Longitude: -121.85311,
    MajorIncident: 'False',
    Name: 'Bruce Fire',
    Started: '2018-07-08T16:45:00Z',
    UniqueId: '7e24911d-5dc9-4449-ba08-f718c094ac9e'
  },
  {
    AcresBurned: 56,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/23/experimental-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2019-01-04T10:23:00Z',
    Latitude: 37.0979,
    Location: 'Off Hwy 41 & Rd 406, south of ONeals',
    Longitude: -119.75307,
    MajorIncident: 'True',
    Name: 'Experimental Fire',
    Started: '2018-05-23T14:30:00Z',
    UniqueId: 'f163aa10-1dd9-4fd0-9e5b-fda78ef5bcc6'
  },
  {
    AcresBurned: 53,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/9/26/keenbrook-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2019-01-04T09:00:00Z',
    Latitude: 34.24138,
    Location: 'Cajon Blvd and Kenwood Ave, Devore',
    Longitude: -117.42431,
    MajorIncident: 'True',
    Name: 'Keenbrook Fire',
    Started: '2018-09-26T10:56:00Z',
    UniqueId: '2c41731e-1e13-494c-b7f7-928b89bb7d32'
  },
  {
    AcresBurned: 53,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/22/copper-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-01-04T09:03:00Z',
    Latitude: 40.33642,
    Location: 'McKenzie Meadows and Hwy 36, 15 miles west of Susanville',
    Longitude: -120.93005,
    MajorIncident: 'False',
    Name: 'Copper Fire',
    Started: '2018-09-22T14:41:00Z',
    UniqueId: 'b9d64431-d96d-413f-84df-ef3b381d3002'
  },
  {
    AcresBurned: 53,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/15/boyer-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2019-01-04T10:05:00Z',
    Latitude: 37.47677,
    Location: 'off Boyer Road and Fox Hollow Lane, Community of Bootjack',
    Longitude: -119.84299,
    MajorIncident: 'True',
    Name: 'Boyer Fire',
    Started: '2018-06-15T13:37:00Z',
    UniqueId: '42bd7e44-5bfa-4e25-961d-941a18bc00d0'
  },
  {
    AcresBurned: 52,
    AdminUnit: 'US Forest Service - Modoc National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/7/14/kelley-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2019-01-04T09:46:00Z',
    Latitude: 41.50105,
    Location: 'off Hwy 299 E & County Rd 74, west of Devils Garden Conservation Camp',
    Longitude: -120.61108,
    MajorIncident: 'False',
    Name: 'Kelley Fire',
    Started: '2018-07-14T20:46:00Z',
    UniqueId: '20495cc8-cb22-4fd1-9bc3-0b9c654d12a0'
  },
  {
    AcresBurned: 51,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/16/reservoir-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-01-04T09:04:00Z',
    Latitude: 35.30151,
    Location: 'off Reservoir Canyon Road and Highway 101, east of San Luis Obispo',
    Longitude: -120.64398,
    MajorIncident: 'False',
    Name: 'Reservoir Fire',
    Started: '2018-09-16T08:34:00Z',
    UniqueId: '6832f18a-6515-4436-bf3b-553bf6302de4'
  },
  {
    AcresBurned: 51,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/24/crestline-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-01-04T09:36:00Z',
    Latitude: 40.824,
    Location: 'Crest Line Dr and Hunt Rd, Montgomery Creek, west of Burney',
    Longitude: -121.90215,
    MajorIncident: 'True',
    Name: 'Crestline Fire',
    Started: '2018-07-24T15:24:00Z',
    UniqueId: '2fdf2c14-77b4-458c-96fc-bd883dec3ad3'
  },
  {
    AcresBurned: 51,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/10/hale-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-01-04T09:51:00Z',
    Latitude: 37.163594,
    Location: 'at Hale Ave and Monterey St. in Morgan Hill',
    Longitude: -121.702547,
    MajorIncident: 'False',
    Name: 'Hale Fire',
    Started: '2018-07-10T16:45:00Z',
    UniqueId: 'a125058d-abfe-4593-bd53-503ceea3f4f0'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/21/carder-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2019-01-04T09:38:00Z',
    Latitude: 38.91152,
    Location: 'Adobe Creek Rd & Peterson Ln, Kelseyville',
    Longitude: -122.86854,
    MajorIncident: 'True',
    Name: 'Carder Fire',
    Started: '2018-07-21T14:40:00Z',
    UniqueId: 'd7745759-07bd-40a7-a66c-003b174851b2'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/15/tuscan-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-01-04T09:43:00Z',
    Latitude: 40.27754,
    Location: 'Hwy 36 E and Tuscan Lookout Road, 7 miles NE of Red Bluff near Hog Lake',
    Longitude: -122.11375,
    MajorIncident: 'False',
    Name: 'Tuscan Fire',
    Started: '2018-07-15T17:15:00Z',
    UniqueId: '02ebd2cc-c4da-4508-92f6-30446d041ae9'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'Fort Hunter Liggett Military Base',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/2/7/haycamp-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2019-01-03T09:43:00Z',
    Latitude: 35.96689,
    Location: 'Nacimento Fergusson Road and Hayfork Road, west of the community of Lockwood',
    Longitude: -121.28185,
    MajorIncident: 'False',
    Name: 'Haycamp Fire',
    Started: '2018-02-07T15:53:00Z',
    UniqueId: '9d0be6f9-d61b-467d-be68-c8a48c0cf930'
  },
  {
    AcresBurned: 48,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/26/castro-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-01-04T09:14:00Z',
    Latitude: 37.69926,
    Location: 'I 580 and Paloverde Rd., Castro Valley',
    Longitude: -122.02805,
    MajorIncident: 'False',
    Name: 'Castro Fire',
    Started: '2018-08-26T14:23:00Z',
    UniqueId: 'a2fbfcae-d658-41f4-88c6-98239d08ff29'
  },
  {
    AcresBurned: 45,
    AdminUnit: 'Moraga-Olinda Fire District',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/7/2/buckingham-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-01-04T09:57:00Z',
    Latitude: 37.86339,
    Location: 'Buckingham Dr and Moraga Rd, southwest of Walnut Creek',
    Longitude: -122.12351,
    MajorIncident: 'False',
    Name: 'Buckingham Fire',
    Started: '2018-07-02T14:25:00Z',
    UniqueId: 'f7bacdf4-ba33-436a-ad94-549395286fc2'
  },
  {
    AcresBurned: 45,
    AdminUnit: 'Marin County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/12/31/bridge-fire/',
    Counties: 'Marin',
    CountyIds: 21,
    Extinguished: '2019-01-04T09:22:00Z',
    Latitude: 38.07135,
    Location: 'Platform Bridge Rd. and Point Reyes Station, northeast of Olema',
    Longitude: -122.76751,
    MajorIncident: 'False',
    Name: 'Bridge Fire',
    Started: '1969-12-31T16:00:00Z',
    UniqueId: '49232e73-c3ba-4dc3-b673-b973a918fa7c'
  },
  {
    AcresBurned: 43,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/19/simmons-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-01-04T09:40:00Z',
    Latitude: 39.57202,
    Location: 'Off Highway 162 & Simmons Rd, Lake Oroville',
    Longitude: -121.43131,
    MajorIncident: 'True',
    Name: 'Simmons Fire',
    Started: '2018-07-19T12:00:00Z',
    UniqueId: 'd56aeb11-09a3-4854-b422-9a1e41f18a51'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/23/martinez-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T09:36:00Z',
    Latitude: 33.56921,
    Location: 'Off Martinez Road & Avenue 66, Thermal',
    Longitude: -116.154398,
    MajorIncident: 'False',
    Name: 'Martinez Fire',
    Started: '2018-07-23T14:55:00Z',
    UniqueId: 'e18c9556-706f-4bb7-b908-e7b44293923d'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/19/ben-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2019-01-04T09:39:00Z',
    Latitude: 37.28365,
    Location: 'Ben Hur Rd & Preston Rd, south of Ben Hur',
    Longitude: -119.97546,
    MajorIncident: 'False',
    Name: 'Ben Fire',
    Started: '2018-07-19T13:07:00Z',
    UniqueId: 'e4c8aa24-e396-46d1-ae6e-bc9c7889967a'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'Unified Command: CAL FIRE Santa Clara Unit and San Ramon Valley Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/19/iron-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-01-04T10:04:00Z',
    Latitude: 37.779209,
    Location: 'off Montbretia Way and Ironwood, East of San Ramon',
    Longitude: -121.908976,
    MajorIncident: 'False',
    Name: 'Iron Fire',
    Started: '2018-06-19T15:19:00Z',
    UniqueId: '2bee561f-fd8f-44ad-9c25-ccdc671029bc'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'CAL FIRE Butte Unit/Butte County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/16/oregon-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-01-04T10:05:00Z',
    Latitude: 39.549167,
    Location: 'off Oregon Gulch Road, near View Lane, North of Oroville',
    Longitude: -121.521111,
    MajorIncident: 'False',
    Name: 'Oregon Fire',
    Started: '2018-06-16T11:47:00Z',
    UniqueId: '9b6b1707-4342-4b38-b4a2-1056c202a32a'
  },
  {
    AcresBurned: 39,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/25/hidden-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2019-01-04T09:35:00Z',
    Latitude: 36.796,
    Location: 'Hidden Valley Rd & Cienega Rd, south of Hollister',
    Longitude: -121.40604,
    MajorIncident: 'False',
    Name: 'Hidden Fire',
    Started: '2018-07-25T14:11:00Z',
    UniqueId: '708b3dde-3f1a-4813-8501-8a52bf3b1d9c'
  },
  {
    AcresBurned: 38,
    AdminUnit: 'Redding City Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/10/14/masonic-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-01-04T08:53:00Z',
    Latitude: 40.60866,
    Location: 'Lake Blvd & Masonic Ave, Redding',
    Longitude: -122.38366,
    MajorIncident: 'False',
    Name: 'Masonic Fire',
    Started: '2018-10-14T11:33:00Z',
    UniqueId: '83c539f5-64c1-4156-86e5-ac6cf4c947d5'
  },
  {
    AcresBurned: 38,
    AdminUnit: 'San Diego City Fire Dept.',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/3/adobe-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T10:16:00Z',
    Latitude: 32.78031,
    Location: 'I-8 and College Ave, San Diego City',
    Longitude: -117.06782,
    MajorIncident: 'False',
    Name: 'Adobe Fire',
    Started: '2018-06-03T16:16:00Z',
    UniqueId: '8efb9edc-dbe7-4824-9027-22993569f794'
  },
  {
    AcresBurned: 37,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/21/mustang-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-01-04T09:38:00Z',
    Latitude: 35.64917,
    Location: 'Paso Robles Rd & Adelaida Rd, west of Paso Robles',
    Longitude: -120.71907,
    MajorIncident: 'False',
    Name: 'Mustang Fire',
    Started: '2018-07-21T15:01:00Z',
    UniqueId: 'a710f41c-aa03-41e1-813f-a98812aea01b'
  },
  {
    AcresBurned: 37,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/3/martin-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-01-04T10:17:00Z',
    Latitude: 41.58233,
    Location: 'Martin Dr. and Stanton Drive, NE of Lake Shastina',
    Longitude: -122.33769,
    MajorIncident: 'False',
    Name: 'Martin Fire',
    Started: '2018-06-03T16:14:00Z',
    UniqueId: 'a9d772ae-90d9-4f8e-9fe7-342b4266dd52'
  },
  {
    AcresBurned: 36,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/2/ridge-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2019-01-04T09:11:00Z',
    Latitude: 38.981389,
    Location: 'Highland Springs Rd & Old Toll Rd, Kelseyville',
    Longitude: -122.97222,
    MajorIncident: 'False',
    Name: 'Ridge Fire',
    Started: '2018-09-02T14:02:00Z',
    UniqueId: '9b9b6d81-9590-48a0-a750-fc7da05bfecc'
  },
  {
    AcresBurned: 36,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/27/winchester-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T09:13:00Z',
    Latitude: 33.640051,
    Location: 'Hidden Falls Road, Winchester',
    Longitude: -117.085354,
    MajorIncident: 'False',
    Name: 'Winchester Fire',
    Started: '2018-08-27T10:49:00Z',
    UniqueId: 'e69be637-e9e9-4964-96ed-4d6a1a1c159d'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/11/8/brushy-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2019-01-04T08:49:00Z',
    Latitude: 39.62194,
    Location: 'near Dos Rios, off Highway 162, East of Highway 101 and West of Covelo',
    Longitude: -123.28774,
    MajorIncident: 'False',
    Name: 'Brushy Fire',
    Started: '2018-11-08T11:58:00Z',
    UniqueId: '10d67079-faa9-4034-a4d7-8346b450e7de'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/6/terra-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T09:23:00Z',
    Latitude: 33.759722,
    Location: 'off Terramor Road and Temescal Canyon Road, community of Temescal Valley',
    Longitude: -117.460278,
    MajorIncident: 'False',
    Name: 'Terra Fire',
    Started: '2018-08-06T14:19:00Z',
    UniqueId: 'dd114f40-6fcb-487b-931e-7a9107371daa'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/29/corner-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-01-04T09:29:00Z',
    Latitude: 40.95673,
    Location: 'Hwy 299 E & Hwy 89, east of Burney',
    Longitude: -121.6002,
    MajorIncident: 'False',
    Name: 'Corner Fire',
    Started: '2018-07-29T16:22:00Z',
    UniqueId: '46f35b6b-9c64-41e3-a7e2-f76dc6719145'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/3/fairview-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2019-01-04T10:17:00Z',
    Latitude: 36.83036,
    Location: 'Fairview Rd and John Smith Rd, City of Hollister',
    Longitude: -121.36446,
    MajorIncident: 'False',
    Name: 'Fairview Fire',
    Started: '2018-06-03T15:09:00Z',
    UniqueId: '39ace715-e375-4083-a05c-7fb7448e17b9'
  },
  {
    AcresBurned: 34,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/17/marcel-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2019-01-04T09:16:00Z',
    Latitude: 35.17156,
    Location: 'off Marcel Drive and Woodford-Tehachapi Road, west of Tehachapi',
    Longitude: -118.51651,
    MajorIncident: 'False',
    Name: 'Marcel Fire',
    Started: '2018-08-17T18:47:00Z',
    UniqueId: 'b03ec37e-8596-4e7e-8826-729957a794f8'
  },
  {
    AcresBurned: 34,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/25/patterson-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-01-04T09:34:00Z',
    Latitude: 37.71173,
    Location: 'Patterson Pass Road and Midway Rd, Altamont',
    Longitude: -121.55604,
    MajorIncident: 'False',
    Name: 'Patterson Fire',
    Started: '2018-07-25T16:05:00Z',
    UniqueId: 'f306893c-d6b5-4d68-a2a3-4a306822e041'
  },
  {
    AcresBurned: 34,
    AdminUnit: 'Sequoia Kings National Park',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/7/19/horse-creek-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2019-01-04T09:39:00Z',
    Latitude: 36.42638,
    Location: 'Mineral King Rd, Ash Mountain area',
    Longitude: -118.70443,
    MajorIncident: 'False',
    Name: 'Horse Creek Fire',
    Started: '2018-07-19T16:25:00Z',
    UniqueId: 'f6693336-817b-4424-8aea-1c966fae5e23'
  },
  {
    AcresBurned: 33,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/24/nimshew-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-01-04T09:01:00Z',
    Latitude: 39.84151,
    Location: 'Nimshew Rd & Centerville Rd, Magalia',
    Longitude: -121.62168,
    MajorIncident: 'True',
    Name: 'Nimshew Fire',
    Started: '2018-09-24T00:41:00Z',
    UniqueId: '9856efb8-4d41-4276-9d4e-a5b29d912996'
  },
  {
    AcresBurned: 33,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/14/lariat-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-01-04T09:46:00Z',
    Latitude: 40.00293,
    Location: 'off Oakridge Rd & Horseshoe Dr, Rancho Tehama, southwest of Red Bluff',
    Longitude: -122.44008,
    MajorIncident: 'False',
    Name: 'Lariat Fire',
    Started: '2018-07-14T20:40:00Z',
    UniqueId: '15d8c9e7-7029-4027-85d8-95f308f83790'
  },
  {
    AcresBurned: 33,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/30/creek-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2019-01-04T09:57:00Z',
    Latitude: 34.17711,
    Location: 'Hwy 330 and Old City Creek Rd, Community of Running Springs',
    Longitude: -117.15381,
    MajorIncident: 'False',
    Name: 'Creek Fire',
    Started: '2018-06-30T12:12:00Z',
    UniqueId: 'd4618db6-e417-4590-8c1f-9b5ace341bb3'
  },
  {
    AcresBurned: 33,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/2/18/wilcox-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2019-01-03T09:44:00Z',
    Latitude: 0,
    Location: 'Road 136 and Avenue 440, Community of Orosi',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Wilcox Fire',
    Started: '2018-02-18T13:45:00Z',
    UniqueId: '485eb9e1-80a1-4b95-a71e-8e43ccb1dd80'
  },
  {
    AcresBurned: 32,
    AdminUnit: 'Sierra National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/10/2/eagle-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2019-01-04T09:47:00Z',
    Latitude: 36.938674,
    Location: 'Bobs Flat Trail, 3 miles north of Trimmer',
    Longitude: -119.3127769,
    MajorIncident: 'False',
    Name: 'Eagle Fire',
    Started: '2018-10-02T15:45:00Z',
    UniqueId: '8c4b830f-be4f-4469-9448-f0e98ea1d189'
  },
  {
    AcresBurned: 32,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/25/country-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T09:15:00Z',
    Latitude: 33.97902,
    Location: 'off High Country Drive in Moreno Valley',
    Longitude: -117.20534,
    MajorIncident: 'False',
    Name: 'Country Fire',
    Started: '2018-08-25T11:58:00Z',
    UniqueId: '2bdeaf01-fe98-4f63-b2e8-4857815bc87c'
  },
  {
    AcresBurned: 32,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/15/3-18-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-01-04T09:42:00Z',
    Latitude: 41.08583,
    Location: 'Punkin Center Road and Juniper Road, 6 miles southwest of the Community of Bieber',
    Longitude: -121.05722,
    MajorIncident: 'False',
    Name: '3-18 Fire',
    Started: '2018-07-15T16:45:00Z',
    UniqueId: 'f141dba0-ae4b-4972-b926-81d1595d0917'
  },
  {
    AcresBurned: 32,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/16/creek-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2019-01-04T10:05:00Z',
    Latitude: 38.886518,
    Location: 'off Rocky Creek Road at Morgan Valley Rd, community of Lower Lake',
    Longitude: -122.476381,
    MajorIncident: 'False',
    Name: 'Creek Fire',
    Started: '2018-06-16T14:04:00Z',
    UniqueId: 'af251be5-4fa6-4ced-954c-a0e0aa34a517'
  },
  {
    AcresBurned: 31,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/8/vista-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-01-04T09:53:00Z',
    Latitude: 40.62693,
    Location: 'off Hwy 299 E and Deschutes Rd, Bella Vista',
    Longitude: -122.23449,
    MajorIncident: 'False',
    Name: 'Vista Fire',
    Started: '2018-07-08T14:41:00Z',
    UniqueId: '9636bdf4-8754-4745-80c8-90a5fcd90ec2'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/23/quimby-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-01-04T09:02:00Z',
    Latitude: 37.33563,
    Location: 'Quimby Rd & Borden Dr, East San Jose',
    Longitude: -121.75815,
    MajorIncident: 'False',
    Name: 'Quimby Fire',
    Started: '2018-09-23T16:23:00Z',
    UniqueId: '04100255-b014-4a69-92c2-5388c7f9b9d6'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'Contra Costa County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/8/17/alhambra-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-01-04T09:17:00Z',
    Latitude: 37.99618,
    Location: 'off Highway 4 and Alhambra Ave, Martinez',
    Longitude: -122.14097,
    MajorIncident: 'False',
    Name: 'Alhambra Fire',
    Started: '2018-08-17T19:19:00Z',
    UniqueId: 'f012f0ea-4102-47dc-9c6d-609ebac85142'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/4/creek-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-01-04T09:25:00Z',
    Latitude: 37.533026,
    Location: 'Welch Creek Rd and Geary Rd., southeast of Sunol',
    Longitude: -121.79733,
    MajorIncident: 'False',
    Name: 'Creek Fire',
    Started: '2018-08-04T17:32:00Z',
    UniqueId: '6bc7ef6f-2d81-4bdc-ab41-9db6af9d4abb'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Riverside Coounty',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/28/sobrante-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T09:30:00Z',
    Latitude: 33.85852,
    Location: 'El Sobrante Road at McAllister Street, Lake Matthews',
    Longitude: -117.43521,
    MajorIncident: 'False',
    Name: 'Sobrante Fire',
    Started: '2018-07-28T15:38:00Z',
    UniqueId: '45845135-0abc-4964-9038-db1e26fa9b22'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/21/rock-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-01-04T09:38:00Z',
    Latitude: 35.68539,
    Location: 'off Chimney Rock Rd and Gage Irving Rd, south of Lake Nacimiento (San Luis Obispo County)',
    Longitude: -120.95157,
    MajorIncident: 'False',
    Name: 'Rock Fire',
    Started: '2018-07-21T15:50:00Z',
    UniqueId: '5b5274df-2cb7-402e-b002-778cce00ac1d'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'Unified Command: CAL FIRE Amador-El Dorado Unit and Sacramento Metro Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/29/grant-fire/',
    Counties: 'Sacramento',
    CountyIds: 34,
    Extinguished: '2019-01-04T09:58:00Z',
    Latitude: 38.595865,
    Location: 'off Grant Line Rd and White Rock Rd, southwest of Folsom',
    Longitude: -121.17693,
    MajorIncident: 'False',
    Name: 'Grant Fire',
    Started: '2018-06-29T15:46:00Z',
    UniqueId: 'c8060137-4a83-479b-9f36-429a698aac06'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE / Fresno County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/4/12/aqueduct-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2019-01-03T09:46:00Z',
    Latitude: 35.92436,
    Location: '25th Ave & Ultica Ave, south of Kettleman City',
    Longitude: -119.94083,
    MajorIncident: 'False',
    Name: 'Aqueduct Fire',
    Started: '2018-04-12T14:30:00Z',
    UniqueId: 'a97e2077-2013-459a-baa7-276781503e3c'
  },
  {
    AcresBurned: 28,
    AdminUnit: 'CAL FIRE San Diego County Fire Authority',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/17/border-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T09:41:00Z',
    Latitude: 32.557566,
    Location: 'north of the Meixcan border and east of the Otay port of entry',
    Longitude: -116.8663,
    MajorIncident: 'False',
    Name: 'Border Fire',
    Started: '2018-07-17T14:05:00Z',
    UniqueId: '1dad019f-12c1-47a0-a20c-2408d942f1c4'
  },
  {
    AcresBurned: 27,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/19/ager-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-01-04T10:24:00Z',
    Latitude: 41.791859,
    Location: 'off Ager Road, northeast of Montague',
    Longitude: -122.513883,
    MajorIncident: 'False',
    Name: 'Ager Fire',
    Started: '2018-05-19T13:04:00Z',
    UniqueId: '454ed7a0-3e17-47a6-9ff1-7a629471df5c'
  },
  {
    AcresBurned: 26,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/18/white-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2019-01-04T10:24:00Z',
    Latitude: 35.826333,
    Location: 'off Road 272 and Avenue 2, east of Delano',
    Longitude: -118.9821,
    MajorIncident: 'False',
    Name: 'White Fire',
    Started: '2018-05-18T11:00:00Z',
    UniqueId: '0d030a31-8531-4172-88f1-08ac34c3d805'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'Soboba Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/9/14/soboba-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T09:04:00Z',
    Latitude: 33.80406,
    Location: 'off Soboba Rd. San Jacinto, northeast of San Jacinto City, Soboba',
    Longitude: -116.93188,
    MajorIncident: 'False',
    Name: 'Soboba Fire',
    Started: '2018-09-14T19:32:00Z',
    UniqueId: 'd5885e9d-1310-4f84-a658-d972d17ecad9'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/16/willow-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-01-04T10:05:00Z',
    Latitude: 38.015323,
    Location: 'off Willow Pass Road at Evora Road, Baypoint',
    Longitude: -121.998967,
    MajorIncident: 'False',
    Name: 'Willow Fire',
    Started: '2018-06-16T15:10:00Z',
    UniqueId: '0ffbb118-8070-4220-95a7-cdef27b0a7ae'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/29/vineyard-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-01-04T10:20:00Z',
    Latitude: 35.71859,
    Location: 'Estrella Rd and Airport Rd, North of Paso Robles',
    Longitude: -120.64028,
    MajorIncident: 'False',
    Name: 'Vineyard Fire',
    Started: '2018-05-29T13:11:00Z',
    UniqueId: '4b641aa9-e8b4-492e-a181-f1bad47c4d6d'
  },
  {
    AcresBurned: 24,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/3/kelsey-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2019-01-04T09:11:00Z',
    Latitude: 38.91842,
    Location: 'Kelsey Creek Rd & Conklin Ln, Kelseyville',
    Longitude: -122.85276,
    MajorIncident: 'True',
    Name: 'Kelsey Fire',
    Started: '2018-09-03T13:58:00Z',
    UniqueId: '1a3ccacd-e743-4a0b-97ab-4d99a133654e'
  },
  {
    AcresBurned: 23,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/22/land-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T09:15:00Z',
    Latitude: 33.946896,
    Location: 'Hwy 60 and Jack Rabbit Trail, Beaumont',
    Longitude: -117.066643,
    MajorIncident: 'False',
    Name: 'Land Fire',
    Started: '2018-08-22T13:45:00Z',
    UniqueId: 'f81830b2-ece2-4f59-87c7-fd43193bd996'
  },
  {
    AcresBurned: 23,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/2/glen-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-01-04T10:19:00Z',
    Latitude: 37.99113,
    Location: 'Glen Canyon Circle and  Chaparral Drive  SE of Pittsburg',
    Longitude: -121.86473,
    MajorIncident: 'False',
    Name: 'Glen Fire',
    Started: '2018-06-02T12:42:00Z',
    UniqueId: 'abe0e447-8977-406f-9e13-5514f4e954bc'
  },
  {
    AcresBurned: 23,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/1/plymire-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-01-04T10:19:00Z',
    Latitude: 40.201826,
    Location: 'Plymire Rd and Deer Valley Rd, West of Red Bluff',
    Longitude: -122.29388,
    MajorIncident: 'False',
    Name: 'Plymire Fire',
    Started: '2018-06-01T16:07:00Z',
    UniqueId: 'b48e83d3-eb05-47df-a198-185912d8190e'
  },
  {
    AcresBurned: 22,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/4/wagner-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '2019-01-04T09:24:00Z',
    Latitude: 37.69965,
    Location: 'Texas Hill Rd and Bondurant Mine Rd, east of Coulterville',
    Longitude: -120.0545,
    MajorIncident: 'False',
    Name: 'Wagner Fire',
    Started: '2018-08-04T13:57:00Z',
    UniqueId: 'deb9364c-ab73-4661-b287-2ffc1797296e'
  },
  {
    AcresBurned: 21,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/4/9/meadow-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-03T09:46:00Z',
    Latitude: 33.86439,
    Location: 'Tin Mine Rd, north of the Cajalco Expressway',
    Longitude: -117.48144,
    MajorIncident: 'False',
    Name: 'Meadow Fire',
    Started: '2018-04-09T18:18:00Z',
    UniqueId: '9a49cf24-0e41-4817-b0d0-966e7b5c7e77'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/11/15/morgan-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-01-04T08:44:00Z',
    Latitude: 37.81111,
    Location: 'Off Morgan Territory Rd & Storybook Ln, east of San Ramon',
    Longitude: -121.7944,
    MajorIncident: 'False',
    Name: 'Morgan Fire',
    Started: '2018-11-15T13:31:00Z',
    UniqueId: 'e83e7346-5b83-4e3a-845c-867fd84d17f0'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/11/14/niles-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-01-04T08:45:00Z',
    Latitude: 37.61158,
    Location: 'off Palomares Road Niles Canyon Road, northwest of Sunol',
    Longitude: -121.94182,
    MajorIncident: 'False',
    Name: 'Niles Fire',
    Started: '2018-11-14T14:56:00Z',
    UniqueId: '03f49769-b928-44a5-be82-236d3d341eba'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/25/church-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-01-04T09:33:00Z',
    Latitude: 37.07793,
    Location: 'Monterey Road and Church Ave, San Martin',
    Longitude: -121.600023,
    MajorIncident: 'False',
    Name: 'Church Fire',
    Started: '2018-07-25T16:14:00Z',
    UniqueId: '655b2bde-09c6-43b8-9cdb-43096bcf1155'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/17/vallecitos-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-01-04T10:04:00Z',
    Latitude: 37.627119,
    Location: 'off Vallecitos Road and Little Valley, south of Livermore',
    Longitude: -121.806775,
    MajorIncident: 'False',
    Name: 'Vallecitos Fire',
    Started: '2018-06-17T15:56:00Z',
    UniqueId: '1f49d4b1-f08f-4fce-8b55-48ff0e521a2f'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/14/bridle-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T10:06:00Z',
    Latitude: 33.524412,
    Location: 'off Crazy Horse Canyon Drive and Bridle Trail Road, Community of Aguanga',
    Longitude: -116.821724,
    MajorIncident: 'False',
    Name: 'Bridle Fire',
    Started: '2018-06-14T17:02:00Z',
    UniqueId: '764b9aac-411e-442d-a045-1bd02ec773c2'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/14/70-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-01-04T10:07:00Z',
    Latitude: 39.602703,
    Location: 'off Highway 70 at Table Mountain Road, north of Oroville',
    Longitude: -121.617698,
    MajorIncident: 'False',
    Name: '70 Fire',
    Started: '2018-06-14T15:18:00Z',
    UniqueId: '59b452f4-04fe-4251-8cf9-70dfc53ada0c'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'Los Angeles City Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/12/portola-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2019-01-04T10:07:00Z',
    Latitude: 34.110516,
    Location: 'off Westwanda Drive and Benedict Canyon Drive',
    Longitude: -118.427886,
    MajorIncident: 'False',
    Name: 'Portola Fire',
    Started: '2018-06-12T14:56:00Z',
    UniqueId: '7307857b-b127-4b3a-bf11-ee19d07e0736'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'USFS - Plumas National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/4/26/french-fire/',
    Counties: 'Plumas',
    CountyIds: 32,
    Extinguished: '2019-01-04T10:27:00Z',
    Latitude: 39.89075,
    Location: 'Frenchman Lake Rd., south of Frenchman Lake, 7 miles north of Chilcoot',
    Longitude: -120.18499,
    MajorIncident: 'False',
    Name: 'French Fire',
    Started: '2018-04-26T15:00:00Z',
    UniqueId: '508b3f52-3a8e-4572-99a9-73c28bbdfbef'
  },
  {
    AcresBurned: 18,
    AdminUnit: 'Unified Command: CAL FIRE and Camp Pendleton Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/5/9/jacques-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T10:26:00Z',
    Latitude: 33.40178,
    Location: 'De Luz Rd and Wisecarver fuel break, Camp Pendleton Marine Corps Base',
    Longitude: -117.27467,
    MajorIncident: 'False',
    Name: 'Jacques Fire',
    Started: '2018-05-09T22:00:00Z',
    UniqueId: 'f96cf1fb-78d6-4763-a754-23aac25a3b96'
  },
  {
    AcresBurned: 18,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/4/22/lago-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-03T13:10:00Z',
    Latitude: 33.88744,
    Location: 'Via Del Lago and Alta Calle, Lake Perris, Moreno Valley',
    Longitude: -117.16232,
    MajorIncident: 'False',
    Name: 'Lago Fire',
    Started: '2018-04-22T13:35:00Z',
    UniqueId: 'fb8c9354-384c-45ab-b209-4a0f6d234516'
  },
  {
    AcresBurned: 17,
    AdminUnit: 'CAL FIRE San Mateo - Santa Cruz Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/11/3/rincon-fire/',
    Counties: 'Santa Cruz',
    CountyIds: 44,
    Extinguished: '2019-01-04T08:50:00Z',
    Latitude: 37.0125,
    Location: 'off Highway 9 and Rincon Crossing, north of Santa Cruz',
    Longitude: -122.046,
    MajorIncident: 'True',
    Name: 'Rincon Fire',
    Started: '2018-11-03T21:28:00Z',
    UniqueId: '7d1f523d-6940-4b64-bc5a-7ecb5a63538a'
  },
  {
    AcresBurned: 17,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/17/china-fire/',
    Counties: 'Amador',
    CountyIds: 3,
    Extinguished: '2019-01-04T10:05:00Z',
    Latitude: 38.265645,
    Location: 'off China Gulch Road and Comanche Parkway North, Jackson Valley',
    Longitude: -120.892404,
    MajorIncident: 'False',
    Name: 'China Fire',
    Started: '2018-06-17T13:58:00Z',
    UniqueId: '43d24c96-7841-423f-9e14-bc9a7ff49416'
  },
  {
    AcresBurned: 17,
    AdminUnit: 'CAL FIRE/ Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/3/ethanac-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T10:17:00Z',
    Latitude: 33.742,
    Location: 'Highway 74 and Ethanac Rd, City of Perris',
    Longitude: -117.28189,
    MajorIncident: 'False',
    Name: 'Ethanac Fire',
    Started: '2018-06-03T14:17:00Z',
    UniqueId: '368fb83d-2660-4d9f-b6ad-0a2ef5de1e52'
  },
  {
    AcresBurned: 16,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/12/oak-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2019-01-04T09:19:00Z',
    Latitude: 39.10494,
    Location: 'off Oak Lane and Buck Mountain Road, south of Grass Valley',
    Longitude: -121.07039,
    MajorIncident: 'False',
    Name: 'Oak Fire',
    Started: '2018-08-12T14:20:00Z',
    UniqueId: 'b2695350-87ea-49f4-a579-ce0c4cf7f926'
  },
  {
    AcresBurned: 16,
    AdminUnit: 'CAL FIRE Humboldt-Del Norte Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/15/johnson-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2019-01-04T09:43:00Z',
    Latitude: 41.34453,
    Location: 'Highway 169 in Pecwan',
    Longitude: -123.85404,
    MajorIncident: 'False',
    Name: 'Johnson Fire',
    Started: '2018-07-15T16:14:00Z',
    UniqueId: '8c94a8f0-1d63-4ea7-88af-52fee196a9a6'
  },
  {
    AcresBurned: 16,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/27/keeler-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-01-04T10:22:00Z',
    Latitude: 37.21803,
    Location: 'Keeler Court and Santa Teresa Blvd., south of San Jose',
    Longitude: -121.76828,
    MajorIncident: 'False',
    Name: 'Keeler Fire',
    Started: '2018-05-27T17:05:00Z',
    UniqueId: '7f775329-242f-4211-b564-92f90062c227'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/10/10/iron-gate-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-01-04T08:55:00Z',
    Latitude: 41.94046,
    Location: '1 mile northwest of Iron Gate Dam',
    Longitude: -122.43933,
    MajorIncident: 'False',
    Name: 'Iron Gate Fire',
    Started: '2018-10-10T21:50:00Z',
    UniqueId: '28725d54-51bc-41f9-99ed-aca0396be12a'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'Modoc National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/9/2/essex-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2019-01-04T09:11:00Z',
    Latitude: 41.52123,
    Location: 'East of Essex Reservoir, northeast of Canby.',
    Longitude: -120.72362,
    MajorIncident: 'False',
    Name: 'Essex Fire',
    Started: '2018-09-02T14:53:00Z',
    UniqueId: 'e9d48e43-940e-4151-9ffb-20881d03c151'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE/ Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/4/woodchuck-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T10:26:00Z',
    Latitude: 33.467999,
    Location: 'Hwy 79 & Woodchuck Road, Temecula',
    Longitude: -117.003829,
    MajorIncident: 'False',
    Name: 'Woodchuck Fire',
    Started: '2018-05-04T18:53:00Z',
    UniqueId: '08a9481d-8742-4256-a419-2a59196e0a8d'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/4/15/tyler-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-03T09:46:00Z',
    Latitude: 33.711263,
    Location: 'Tyler Street and Vista Del Sur, Coachella, City of Coachella',
    Longitude: -116.164058,
    MajorIncident: 'True',
    Name: 'Tyler Fire',
    Started: '2018-04-15T04:38:00Z',
    UniqueId: '8b34406c-93b7-4a40-a832-2fc525876e59'
  },
  {
    AcresBurned: 14,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/6/casner-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T09:24:00Z',
    Latitude: 33.05737,
    Location: 'off Old Julian Highway and Creek Hollow, west of Ramona',
    Longitude: -116.77154,
    MajorIncident: 'False',
    Name: 'Casner Fire',
    Started: '2018-08-06T10:31:00Z',
    UniqueId: '775494c3-ae61-40aa-82b0-667a3ddcbdcc'
  },
  {
    AcresBurned: 14,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/17/camp-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-01-04T09:41:00Z',
    Latitude: 35.70086,
    Location: 'off Gage Irving Road, South Lake Nacimiento',
    Longitude: -120.97339,
    MajorIncident: 'False',
    Name: 'Camp Fire',
    Started: '2018-07-17T11:13:00Z',
    UniqueId: '0194a44a-0c12-4e47-a053-f3b9b2382858'
  },
  {
    AcresBurned: 14,
    AdminUnit: 'CAL FIRE Lassen-Modoc Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/14/3-2-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-01-04T09:45:00Z',
    Latitude: 39.99309,
    Location: 'off Homestead Ranch Road, southeast of Doyle',
    Longitude: -120.02137,
    MajorIncident: 'False',
    Name: '3-2 Fire',
    Started: '2018-07-14T15:00:00Z',
    UniqueId: 'b89ae0bb-4b8b-47f6-b7c6-5e689a265288'
  },
  {
    AcresBurned: 14,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/1/madison-fire/',
    Counties: 'Yolo',
    CountyIds: 57,
    Extinguished: '2019-01-04T10:20:00Z',
    Latitude: 38.64953,
    Location: 'County Road 25 and County Road 86A, community of Madison north of Winters',
    Longitude: -122.01762,
    MajorIncident: 'False',
    Name: 'Madison FIre',
    Started: '2018-06-01T13:31:00Z',
    UniqueId: '4235f934-ed24-425d-821c-46363dcb16e8'
  },
  {
    AcresBurned: 13,
    AdminUnit: 'Shasta Lake Fire Protection District',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/9/4/ranchera-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-01-04T09:08:00Z',
    Latitude: 40.678889,
    Location: 'Ranchera Road and Hill Boulevard, Shasta Lake City',
    Longitude: -122.400556,
    MajorIncident: 'False',
    Name: 'Ranchera Fire',
    Started: '2018-09-04T14:43:00Z',
    UniqueId: '20b57ee7-b0b7-47db-8a12-e5fcdb114459'
  },
  {
    AcresBurned: 13,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/20/cinnamon-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T09:39:00Z',
    Latitude: 33.04898,
    Location: 'Old Julian Way & Cinnamon Rock Rd, east of Ramona',
    Longitude: -116.78928,
    MajorIncident: 'True',
    Name: 'Cinnamon Fire',
    Started: '2018-07-20T13:07:00Z',
    UniqueId: '05fb81ea-7e85-4d0d-9587-64c907a45561'
  },
  {
    AcresBurned: 13,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/2/coldwell-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2019-01-04T10:18:00Z',
    Latitude: 36.10499,
    Location: 'Hwy 198 and Coldwell Ln, 10 miles west of Coalinga',
    Longitude: -120.55324,
    MajorIncident: 'False',
    Name: 'Coldwell Fire',
    Started: '2018-06-02T09:55:00Z',
    UniqueId: 'af8fe898-e4a6-4b9f-86a5-e6fc3226832b'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE Shasta - Trinity Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/10/14/tower-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-01-04T08:54:00Z',
    Latitude: 40.49618,
    Location: 'Cloverdale & Clear Creek, Near the community of Igo',
    Longitude: -122.51597,
    MajorIncident: 'False',
    Name: 'Tower Fire',
    Started: '2018-10-14T06:45:00Z',
    UniqueId: 'a8f54d41-fc8c-476c-9122-f1357aa166a0'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE Amador, El Dorado Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/9/20/meyers-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2019-01-04T09:03:00Z',
    Latitude: 38.7448,
    Location: 'Meyers Rd in Camino',
    Longitude: -120.65672,
    MajorIncident: 'True',
    Name: 'Meyers Fire',
    Started: '2018-09-20T12:39:00Z',
    UniqueId: '9ea41d38-ee7c-4394-9ea8-cbf33e788f13'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE San Bernardino Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/13/gray-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2019-01-04T09:47:00Z',
    Latitude: 34.171786,
    Location: 'Muscoy',
    Longitude: -117.35606,
    MajorIncident: 'False',
    Name: 'Gray Fire',
    Started: '2018-07-13T14:32:00Z',
    UniqueId: '8ff78ab4-378d-4e1b-9ba0-b90d8be07a06'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/10/school-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2019-01-04T09:50:00Z',
    Latitude: 37.22791,
    Location: 'in the area of Road 230 and Road 225, North Fork',
    Longitude: -119.50461,
    MajorIncident: 'False',
    Name: 'School Fire',
    Started: '2018-07-10T17:31:00Z',
    UniqueId: 'f5d14543-5d98-41ca-99f5-09c1197161b2'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'San Rafael Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/9/mission-fire/',
    Counties: 'Marin',
    CountyIds: 21,
    Extinguished: '2019-01-04T10:09:00Z',
    Latitude: 37.97638,
    Location: 'Mission Avenue and C Street, City of San Rafael',
    Longitude: -122.5275,
    MajorIncident: 'False',
    Name: 'Mission Fire',
    Started: '2018-06-09T15:30:00Z',
    UniqueId: '5adaf6fa-0c4a-43e4-bd32-baa089a7f0b2'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/5/vista-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T10:11:00Z',
    Latitude: 33.40769,
    Location: 'Vista Del Lago/Via Ranchitos, Fallbrook',
    Longitude: -117.22974,
    MajorIncident: 'False',
    Name: 'Vista Fire',
    Started: '2018-06-05T13:45:00Z',
    UniqueId: 'a43a2839-d85f-4152-ac07-4a29c31723cf'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/4/meamber-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-01-04T10:13:00Z',
    Latitude: 41.64805,
    Location: 'Meamber Creek Road, 8 miles west of Fort Jones',
    Longitude: -122.98442,
    MajorIncident: 'False',
    Name: 'Meamber Fire',
    Started: '2018-06-04T15:08:00Z',
    UniqueId: 'c48eaae5-afb4-472c-be65-7dfbb3c82f4d'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/3/resort-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-01-04T10:17:00Z',
    Latitude: 35.75737,
    Location: 'Lake Nacimiento, 10 miles west of Paso Robles',
    Longitude: -120.91793,
    MajorIncident: 'False',
    Name: 'Resort Fire',
    Started: '2018-06-03T16:11:00Z',
    UniqueId: '0fd4a4af-b243-4e88-b983-648d0c127f47'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/21/bellagio-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2019-01-04T10:23:00Z',
    Latitude: 38.16303,
    Location: 'American Canyon Rd, East of American Canyon',
    Longitude: -122.23059,
    MajorIncident: 'False',
    Name: 'Bellagio Fire',
    Started: '2018-05-21T11:56:00Z',
    UniqueId: '03b0e3c2-7b65-4a7b-b061-d297ebd267f4'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/14/grant-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-01-04T10:25:00Z',
    Latitude: 37.73835,
    Location: 'Grant Line Road and I-580, east of Livermore',
    Longitude: -121.6039,
    MajorIncident: 'False',
    Name: 'Grant Fire',
    Started: '2018-05-14T13:06:00Z',
    UniqueId: 'f78b2acd-fff2-413a-93d6-8479e138120b'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/10/volcan-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T10:25:00Z',
    Latitude: 33.12213,
    Location: 'Volcan Road and Farmer Road, north of the community of Julian',
    Longitude: -116.58759,
    MajorIncident: 'False',
    Name: 'Volcan Fire',
    Started: '2018-05-10T20:41:00Z',
    UniqueId: '81cf4d22-336d-4035-b2c3-5b5a8cf2fcc2'
  },
  {
    AcresBurned: 11,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/10/dark-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-01-04T09:51:00Z',
    Latitude: 39.66492,
    Location: 'south of Rich Gulch, near Lake Oroville',
    Longitude: -121.51772,
    MajorIncident: 'False',
    Name: 'Dark Fire',
    Started: '2018-07-10T12:42:00Z',
    UniqueId: 'c2dc8734-e165-4fa1-9a1a-f393516bd5a5'
  },
  {
    AcresBurned: 11,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/9/cornerstone-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2019-01-04T09:52:00Z',
    Latitude: 37.19817,
    Location: 'Cornerstone Court, Yosemite Lakes',
    Longitude: -119.80414,
    MajorIncident: 'False',
    Name: 'Cornerstone Fire',
    Started: '2018-07-09T17:54:00Z',
    UniqueId: 'dc55524d-c29f-4990-8f73-2974348c7fc7'
  },
  {
    AcresBurned: 11,
    AdminUnit: 'CAL FIRE/ Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/3/grande-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T10:18:00Z',
    Latitude: 33.47413,
    Location: 'Vuelta Grande Rd and Carancho Rd, Community of De Luz',
    Longitude: -117.31468,
    MajorIncident: 'False',
    Name: 'Grande Fire',
    Started: '2018-06-03T13:38:00Z',
    UniqueId: 'a0b7fa30-74d0-419f-927b-de29b0d00018'
  },
  {
    AcresBurned: 11,
    AdminUnit: 'CAL FIRE Shasta Trinity Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/3/27/rock-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-01-03T09:45:00Z',
    Latitude: 40.4635,
    Location: 'Rock Creek Rd, SE of Shingletown',
    Longitude: -121.77419,
    MajorIncident: 'False',
    Name: 'Rock Fire',
    Started: '2018-03-27T16:20:00Z',
    UniqueId: '958c8ac0-6111-4d29-b5ac-8ca0e7a2f484'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE San Mateo-Santa Cruz Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/11/16/bear-fire/',
    Counties: 'Santa Cruz',
    CountyIds: 44,
    Extinguished: '2019-01-04T08:44:00Z',
    Latitude: 37.12857,
    Location: 'off Bear Creek Road and Mayfair Road, Boulder Creek north of Santa Cruz',
    Longitude: -122.12036,
    MajorIncident: 'False',
    Name: 'Bear Fire',
    Started: '2018-11-16T11:01:00Z',
    UniqueId: 'b6fb27e6-073c-4092-b8a8-51e96be987a4'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Humboldt - Del Norte Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/11/12/green-hill-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2019-01-04T08:46:00Z',
    Latitude: 40.888785,
    Location: 'off Highway 299 in the area of Green Hill',
    Longitude: -124.001849,
    MajorIncident: 'False',
    Name: 'Green Hill Fire',
    Started: '2018-11-12T17:39:00Z',
    UniqueId: '116fabb6-7440-4d6d-aa89-668989c028db'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/10/15/powellton-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-01-04T08:52:00Z',
    Latitude: 39.93427,
    Location: 'Upper Powellton Rd and Skyway, north of Stirling City',
    Longitude: -121.54103,
    MajorIncident: 'False',
    Name: 'Powellton Fire',
    Started: '2018-10-15T11:57:00Z',
    UniqueId: 'b8dc21be-0807-4434-9536-45a4a660ed83'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/19/keller-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T09:16:00Z',
    Latitude: 33.627006,
    Location: 'off Scenic View Drive and Keller Road',
    Longitude: -117.171731,
    MajorIncident: 'False',
    Name: 'Keller Fire',
    Started: '2018-08-19T15:55:00Z',
    UniqueId: '23f8d2d9-0e9e-4f07-b830-8c02cf74b5d0'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Sonoma-Lake Napa Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/8/9/syar-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2019-01-04T09:20:00Z',
    Latitude: 38.27229,
    Location: 'Napa Vallejo Highway and Syar Industrial Way',
    Longitude: -122.26389,
    MajorIncident: 'False',
    Name: 'Syar Fire',
    Started: '2018-08-09T14:21:00Z',
    UniqueId: '1bdf7030-adc6-442f-ab31-d182e53b4a73'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/17/lott-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-01-04T09:40:00Z',
    Latitude: 41.632373,
    Location: 'off Lott Rd and Bunny Ln, 15 miles north of Weed',
    Longitude: -122.37985,
    MajorIncident: 'False',
    Name: 'Lott Fire',
    Started: '2018-07-17T19:03:00Z',
    UniqueId: '14207c18-f9a3-4a69-9f3a-d778d2f6960f'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE San Diego Unit / San Diego County Fire Authority',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/7/6/building-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T09:55:00Z',
    Latitude: 32.619855,
    Location: 'off Highway 94 and Community Building Road near Dulzura',
    Longitude: -116.764733,
    MajorIncident: 'False',
    Name: 'Building Fire',
    Started: '2018-07-06T10:11:00Z',
    UniqueId: '59c697e4-5083-4f45-b03a-ef580f6618dd'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Butte Unit/Butte County Fire Department',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/29/llano-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-01-04T09:58:00Z',
    Latitude: 39.6139,
    Location: 'at the Llano Seco Ranch, south of Chico',
    Longitude: -121.954098,
    MajorIncident: 'False',
    Name: 'Llano Fire',
    Started: '2018-06-29T11:44:00Z',
    UniqueId: '465ed1e1-89be-4556-b616-834b65746005'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/21/creek-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-01-04T10:03:00Z',
    Latitude: 35.05747,
    Location: 'Suey Creek Road & Crystal Springs, east of Nipomo',
    Longitude: -120.39295,
    MajorIncident: 'False',
    Name: 'Creek Fire',
    Started: '2018-06-21T16:45:00Z',
    UniqueId: 'd752892a-9bdf-4b91-83f0-2d3f94c3f370'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/19/ranchita-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2019-01-04T10:04:00Z',
    Latitude: 35.77017,
    Location: 'Ranchita Canyon Road, southwest of the town of Parkfield',
    Longitude: -120.57833,
    MajorIncident: 'False',
    Name: 'Ranchita Fire',
    Started: '2018-06-19T16:06:00Z',
    UniqueId: 'b2adde70-a40e-4b81-9f5f-8f6b96042af2'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'Schell-Vista Fire Protection District',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/5/pallet-fire/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2019-01-04T10:12:00Z',
    Latitude: 38.245151,
    Location: 'Hwy 12 and Broadway, Schellville',
    Longitude: -122.44408,
    MajorIncident: 'False',
    Name: 'Pallet Fire',
    Started: '2018-06-05T13:03:00Z',
    UniqueId: '6eed6c93-14f3-450a-80c8-65c5450a8cbd'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'San Miguel FPD',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/6/3/green-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-01-04T10:16:00Z',
    Latitude: 32.75072,
    Location: 'Greenwick Rd and Brabham St, Community of Rancho San Diego',
    Longitude: -116.92404,
    MajorIncident: 'False',
    Name: 'Green Fire',
    Started: '2018-06-03T18:23:00Z',
    UniqueId: '60041942-db7c-4c3d-8a94-151addbd9d20'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL Fire Tehama Glenn Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/3/black-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-01-04T10:18:00Z',
    Latitude: 39.80827,
    Location: 'Black Butte Lake and Newville Road west of Orland',
    Longitude: -122.3307,
    MajorIncident: 'False',
    Name: 'Black Fire',
    Started: '2018-06-03T08:55:00Z',
    UniqueId: '2d27a570-a8b0-4332-a40a-3afb8f2a575c'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE/Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/6/2/jardin-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T10:18:00Z',
    Latitude: 33.45014,
    Location: 'Calle Jardin  and Calle Uva, Temecula',
    Longitude: -117.22215,
    MajorIncident: 'False',
    Name: 'Jardin Fire',
    Started: '2018-06-02T15:53:00Z',
    UniqueId: 'c88bdcbd-2592-44d2-b44d-1c5a37593ffb'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/5/28/70th-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-01-04T10:21:00Z',
    Latitude: 33.53924,
    Location: 'Highway 86 Expressway and Avenue 70, Thermal',
    Longitude: -116.10231,
    MajorIncident: 'False',
    Name: '70th Fire',
    Started: '2018-05-28T07:23:00Z',
    UniqueId: '79dee087-3393-473f-aaa9-5d253cc5e1fa'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2018,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2018/11/29/honey-flooding/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-01-04T08:42:00Z',
    Latitude: 39.71217,
    Location: 'Lower Skyway and Lower Honey Run, Between Chico and Paradise',
    Longitude: -121.77385,
    MajorIncident: 'True',
    Name: 'Honey Flooding',
    Started: '2018-11-29T23:30:00Z',
    UniqueId: 'e6b8af54-15fb-42bb-8be9-f323c9d5cc78'
  },
  {
    AcresBurned: 0,
    AdminUnit: 'USFS - Shasta-Trinity National Forest',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/4/24/grape-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2019-01-03T15:23:00Z',
    Latitude: 40.70258,
    Location: 'Black Bennet Rd. near Grape Creek, 8 miles southwest of Burnt Ranch',
    Longitude: -123.55012,
    MajorIncident: 'False',
    Name: 'Grape Fire',
    Started: '2018-04-24T16:59:00Z',
    UniqueId: 'd6753341-5c6f-4530-9c02-25974496ddc8'
  },
  // {
  //   AcresBurned: 0,
  //   AdminUnit: 'Ventura County Fire and Santa Barbara County Fire',
  //   ArchiveYear: 2018,
  //   CalFireIncident: 'False',
  //   CanonicalUrl: '/incidents/2018/1/9/montecito-flooding-mudflows/',
  //   Counties: 'Santa Barbara',
  //   CountyIds: 4256,
  //   Extinguished: '2019-01-03T09:43:00Z',
  //   Latitude: 0,
  //   Location: 'Montecito, Summerland and Carpenteria',
  //   Longitude: 0,
  //   MajorIncident: 'True',
  //   Name: 'Montecito Flooding / Mudflows',
  //   Started: '2018-01-09T04:00:00Z',
  //   UniqueId: '23cbd274-ded3-43ea-9174-b5615eac3244'
  // },
  {
    AcresBurned: 0,
    AdminUnit: 'Ventura County Fire and Santa Barbara County Fire',
    ArchiveYear: 2018,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2018/1/9/montecito-flooding-mudflows/',
    Counties: 'Ventura',
    CountyIds: 4256,
    Extinguished: '2019-01-03T09:43:00Z',
    Latitude: 0,
    Location: 'Montecito, Summerland and Carpenteria',
    Longitude: 0,
    MajorIncident: 'True',
    Name: 'Montecito Flooding / Mudflows',
    Started: '2018-01-09T04:00:00Z',
    UniqueId: '23cbd274-ded3-43ea-9174-b5615eac3244'
  },
  {
    AcresBurned: 1806,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/30/easy-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2019-11-02T18:57:00Z',
    Latitude: 34.282179,
    Location: 'West Easy Street and West Los Angeles Avenue, Simi Valley',
    Longitude: -118.803389,
    MajorIncident: 'False',
    Name: 'Easy Fire',
    Started: '2019-10-30T07:45:14Z',
    UniqueId: '00e6d6d5-f168-45fa-817a-f7758a5170b7'
  },
  {
    AcresBurned: 1300,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/16/gaines-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '',
    Latitude: 37.536069,
    Location: 'Mt Gaines Rd and Bear Valley Rd, Bear Valley',
    Longitude: -120.177018,
    MajorIncident: 'False',
    Name: 'Gaines Fire',
    Started: '2019-08-16T14:11:02Z',
    UniqueId: '547b7d19-9b75-4c11-8b88-56adb6460a3c'
  },
  {
    AcresBurned: 1011,
    AdminUnit: 'Unified Command: CAL FIRE/Riverside County Fire Department, City of Calimesa and City of Yucaipa',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/10/sandalwood-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '',
    Latitude: 33.9925,
    Location: 'Calimesa Boulevard and Sandalwood Drive',
    Longitude: -117.059167,
    MajorIncident: 'True',
    Name: 'Sandalwood Fire',
    Started: '2019-10-10T15:38:44Z',
    UniqueId: '7ff84b11-c3fb-4f5c-8a00-07243d4a4e33'
  },
  {
    AcresBurned: 605,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/27/rawson-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-10-28T07:22:00Z',
    Latitude: 40.00171,
    Location: 'Gyle Road and Long Dirt Road, Northwest of Corning',
    Longitude: -122.25421,
    MajorIncident: 'False',
    Name: 'Rawson Fire',
    Started: '2019-10-27T02:47:20Z',
    UniqueId: '828b2492-fc44-4fc0-97fa-f0b439e6fa0d'
  },
  {
    AcresBurned: 494,
    AdminUnit: 'CAL FIRE Riverside County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/30/hill-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-11-02T18:44:00Z',
    Latitude: 34.01778,
    Location: 'Granite Hill and Pyrite Street, in Jurupa Valley',
    Longitude: -117.4625,
    MajorIncident: 'True',
    Name: 'Hill Fire',
    Started: '2019-10-30T11:19:00Z',
    UniqueId: '8f23653c-1a4c-4609-bfb3-72b1665eab69'
  },
  {
    AcresBurned: 355,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/11/25/foothills-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '',
    Latitude: 38.838992,
    Location: 'Foothills and McAnally Drive, northwest of Roseville',
    Longitude: -121.325842,
    MajorIncident: 'False',
    Name: 'Foothills Fire',
    Started: '2019-11-25T12:39:44Z',
    UniqueId: '77d64e4c-a50f-4f4d-a750-e6a6f0ddadc9'
  },
  // {
  //   AcresBurned: 289,
  //   AdminUnit: 'CAL FIRE San Benito-Monterey Unit and CAL FIRE San Luis Obispo Unit',
  //   ArchiveYear: 2019,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2019/10/9/cross-fire/',
  //   Counties: 'Monterey',
  //   CountyIds: 2740,
  //   Extinguished: '2019-10-11T07:30:00Z',
  //   Latitude: 35.79069,
  //   Location: 'Indian Valley Road and Monterey County Line near Camp Robert\'s',
  //   Longitude: -120.73102,
  //   MajorIncident: 'False',
  //   Name: 'Cross Fire',
  //   Started: '2019-10-09T06:52:14Z',
  //   UniqueId: '207f72f7-1453-40dc-919e-3551f7041b22'
  // },
  {
    AcresBurned: 289,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit and CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/9/cross-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 2740,
    Extinguished: '2019-10-11T07:30:00Z',
    Latitude: 35.79069,
    Location: 'Indian Valley Road and Monterey County Line near Camp Robert\'s',
    Longitude: -120.73102,
    MajorIncident: 'False',
    Name: 'Cross Fire',
    Started: '2019-10-09T06:52:14Z',
    UniqueId: '207f72f7-1453-40dc-919e-3551f7041b22'
  },
  {
    AcresBurned: 149,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/21/valley-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '',
    Latitude: 37.241427,
    Location: 'Old Hwy and Guadalupe, East of Mariposa',
    Longitude: -120.027731,
    MajorIncident: 'False',
    Name: 'Valley Fire',
    Started: '2019-07-21T12:01:40Z',
    UniqueId: 'f8a2fd4a-286e-4688-8a5c-fa2ad98751ab'
  },
  {
    AcresBurned: 137,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/18/mud-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2019-10-19T15:00:00Z',
    Latitude: 36.319291,
    Location: 'Los Gatos Creek Road and Joaquin Rocks Lookout Road, east of Coalinga',
    Longitude: -120.460189,
    MajorIncident: 'False',
    Name: 'Mud Fire',
    Started: '2019-10-18T12:17:32Z',
    UniqueId: 'ff8701f0-a12a-4b40-baa9-b58c4e2e31f3'
  },
  {
    AcresBurned: 107,
    AdminUnit: 'Lassen National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/7/3-2-willow-previously-h-1-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '',
    Latitude: 40.900458,
    Location: 'Pittville Road and Sheep Flat Road, southeast of Fall River Mills',
    Longitude: -121.320838,
    MajorIncident: 'False',
    Name: '3-2 Willow (Previously H-1 Fire)',
    Started: '2019-08-07T18:48:57Z',
    UniqueId: '9a9bc21f-36f5-4092-b98e-c0d584d198db'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/10/wolf-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-10-12T17:22:00Z',
    Latitude: 33.8615,
    Location: 'Wolfskill Truck Road near Silver Creek Drive, south of Banning',
    Longitude: -116.897333,
    MajorIncident: 'False',
    Name: 'Wolf Fire',
    Started: '2019-10-10T18:36:46Z',
    UniqueId: 'd37acb3f-94c8-47ef-b3da-6eb0d7353aa7'
  },
  {
    AcresBurned: 40,
    AdminUnit: 'City of Moraga',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/10/merrill-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-10-10T12:00:00Z',
    Latitude: 37.828267,
    Location: 'Merrill Circle N and Merrill Dr, Moraga',
    Longitude: -122.103867,
    MajorIncident: 'False',
    Name: 'Merrill Fire',
    Started: '2019-10-10T06:42:19Z',
    UniqueId: '19578ef2-6101-45b0-a82e-db3004c3a8a5'
  },
  {
    AcresBurned: 37,
    AdminUnit: 'CAL FIRE San Diego County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/25/miller-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-10-27T18:05:00Z',
    Latitude: 33.259861,
    Location: 'Miller Lane and Cole Grade Lane, North of Valley Center',
    Longitude: -117.027333,
    MajorIncident: 'True',
    Name: 'Miller Fire',
    Started: '2019-10-25T15:05:52Z',
    UniqueId: '7ff229e4-be94-4319-8916-19eb43753843'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/24/mines-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-10-27T13:55:00Z',
    Latitude: 37.62782,
    Location: 'Mines Rd and Del Valle Rd, southeast of Livermore',
    Longitude: -121.68598,
    MajorIncident: 'False',
    Name: 'Mines Fire',
    Started: '2019-10-24T23:16:18Z',
    UniqueId: '87404846-bc30-41b8-82fe-31c9aedb9ef7'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/18/rains-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2019-07-18T10:29:00Z',
    Latitude: 37.420988,
    Location: 'Frank Raines Park on Del Puerto Canyon Road, west of Patterson',
    Longitude: -121.371276,
    MajorIncident: 'False',
    Name: 'Rains Fire',
    Started: '2019-07-18T09:07:57Z',
    UniqueId: '900997e0-f30a-48bf-9358-971ca2afa1d6'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/12/horse-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '',
    Latitude: 40.463936,
    Location: 'Blue Horse Rd and Saddle Trail, 2 miles NW of Olinda',
    Longitude: -122.435492,
    MajorIncident: 'False',
    Name: 'Horse Fire',
    Started: '2019-07-12T19:08:54Z',
    UniqueId: 'ab6d9c8e-5fbb-4a0d-a206-30e83ab51877'
  },
  {
    AcresBurned: 27,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/18/whiskey-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '2019-07-20T08:56:00Z',
    Latitude: 38.115224,
    Location: 'near the Whiskey Creek Day Use area of New Hogan Lake',
    Longitude: -120.78068,
    MajorIncident: 'False',
    Name: 'Whiskey Fire',
    Started: '2019-07-18T18:31:00Z',
    UniqueId: '17596a7a-31fc-4270-8aaf-efe1df3ba848'
  },
  {
    AcresBurned: 26,
    AdminUnit: 'CAL FIRE San Bernardino Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/3/la-barisa-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2019-08-04T06:39:00Z',
    Latitude: 34.202883,
    Location: 'Off La Barisa Dr & Hwy 247 in Landers',
    Longitude: -116.4449,
    MajorIncident: 'False',
    Name: 'La Barisa Fire',
    Started: '2019-08-03T17:22:51Z',
    UniqueId: '4433d477-a962-4ad9-a306-71f0f79fff65'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE / San Diego County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/17/vista-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-07-18T15:58:00Z',
    Latitude: 32.794768,
    Location: 'Off Vista De La Montana in the Dehesa area',
    Longitude: -116.839743,
    MajorIncident: 'True',
    Name: 'Vista Fire',
    Started: '2019-07-17T17:42:04Z',
    UniqueId: '06fa2750-afea-4f88-b1c4-48b9bc21f4eb'
  },
  {
    AcresBurned: 22,
    AdminUnit: 'CAL FIRE Amador-El Dorado',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/29/chaparral-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2019-09-29T21:35:00Z',
    Latitude: 38.538467,
    Location: 'Chaparral Drive and Latrobe Road in Latrobe',
    Longitude: -120.965105,
    MajorIncident: 'False',
    Name: 'Chaparral Fire',
    Started: '2019-09-29T21:44:45Z',
    UniqueId: '48f89096-4641-42cc-8ec4-9cba635e79a1'
  },
  {
    AcresBurned: 22,
    AdminUnit: 'CAL FIRE SCU',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/12/mid-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-07-12T19:20:00Z',
    Latitude: 37.093243,
    Location: 'patterson pass and mid way, eastern',
    Longitude: -121.586846,
    MajorIncident: 'False',
    Name: 'Mid Fire',
    Started: '2019-07-12T18:40:09Z',
    UniqueId: '3fc9ae75-8844-43a5-8330-6956cdb6e3a7'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/15/nustar-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '',
    Latitude: 38.045866,
    Location: 'San Pablo Ave and Cummings Skyway, Crockett',
    Longitude: -122.245186,
    MajorIncident: 'False',
    Name: 'Nustar Fire',
    Started: '2019-10-15T16:17:18Z',
    UniqueId: '0baff961-3ce3-45ec-80f1-a72957f2f3f4'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/27/sage-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-08-27T08:54:00Z',
    Latitude: 33.463991,
    Location: 'near the intersection of Sage Road and Highway 79, in Aguanga',
    Longitude: -116.914799,
    MajorIncident: 'False',
    Name: 'Sage Fire',
    Started: '2019-08-27T11:33:56Z',
    UniqueId: 'faf6064e-fc50-4289-8486-1235f20289d7'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'MEU',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/4/wilson-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '',
    Latitude: 39.613783,
    Location: 'Highway 101 south of Sloan and Old Sherwood Road in Willits, California',
    Longitude: -123.458782,
    MajorIncident: 'False',
    Name: 'Wilson Fire',
    Started: '2019-10-04T18:38:09Z',
    UniqueId: '1dd6f339-956d-4ec5-bac5-713ba3cd53d4'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE San Mateo-Santa Cruz Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/3/deer-fire/',
    Counties: 'Santa Cruz',
    CountyIds: 44,
    Extinguished: '2019-09-06T19:48:00Z',
    Latitude: 37.178353,
    Location: 'Deer Creek Road and Rons Road, northeast of Boulder Creek',
    Longitude: -122.07743,
    MajorIncident: 'False',
    Name: 'Deer Fire',
    Started: '2019-09-03T15:36:45Z',
    UniqueId: '23f65de3-bf4d-4edf-a5eb-b21299195b0f'
  },
  {
    AcresBurned: 77758,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/23/kincade-fire/',
    Counties: 'Sonoma',
    CountyIds: 49,
    Extinguished: '2019-11-06T19:00:00Z',
    Latitude: 38.792458,
    Location: 'John Kincade Road and Burned Mountain Road, northeast of Geyserville',
    Longitude: -122.780053,
    MajorIncident: 'True',
    Name: 'Kincade Fire',
    Started: '2019-10-23T21:27:00Z',
    UniqueId: '809d101c-8aa3-4a53-bf20-f38ae7ec7941'
  },
  {
    AcresBurned: 54612,
    AdminUnit: 'USFS Plumas National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/4/walker-fire/',
    Counties: 'Plumas',
    CountyIds: 32,
    Extinguished: '',
    Latitude: 40.061389,
    Location: 'Indian Creek and Beckworth Genesee Road, east of Genesee',
    Longitude: -120.680556,
    MajorIncident: 'False',
    Name: 'Walker Fire',
    Started: '2019-09-04T15:17:31Z',
    UniqueId: '3a48b649-8714-433d-9952-ff2bf9e8c90a'
  },
  {
    AcresBurned: 14217,
    AdminUnit: 'Modoc National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/7/28/tucker-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2019-08-11T12:16:00Z',
    Latitude: 41.79591,
    Location: 'Hwy 139 and Tucker Butte Rd, 6 miles SW of Clear Lake Reservoir',
    Longitude: -121.260305,
    MajorIncident: 'False',
    Name: 'Tucker Fire',
    Started: '2019-07-28T15:58:00Z',
    UniqueId: '2939928b-0308-4d76-b232-246f064ddd11'
  },
  {
    AcresBurned: 10296,
    AdminUnit: 'Inyo National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/6/taboose-fire/',
    Counties: 'Inyo',
    CountyIds: 14,
    Extinguished: '2019-11-21T16:09:00Z',
    Latitude: 37.034,
    Location: 'south west of Big Pine and north west of Aberdeen',
    Longitude: -118.345,
    MajorIncident: 'True',
    Name: 'Taboose Fire',
    Started: '2019-09-06T12:43:35Z',
    UniqueId: 'e7ea56c5-4290-4406-b0a5-c9d1718e9700'
  },
  {
    AcresBurned: 9999,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/31/maria-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2019-11-06T18:00:00Z',
    Latitude: 34.302212,
    Location: 'off of Bradley Road and Solano Verde Dr, Top of South Mt, Santa Paula',
    Longitude: -118.997115,
    MajorIncident: 'True',
    Name: 'Maria Fire',
    Started: '2019-10-31T20:58:28Z',
    UniqueId: '31852a71-e639-496f-9e7d-0968d1c218b3'
  },
  {
    AcresBurned: 8838,
    AdminUnit: 'CAL FIRE Tehama Glenn Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/5/red-bank-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-09-13T19:00:00Z',
    Latitude: 40.12,
    Location: 'Off Hammer Loop Road and Petty John Road, West of Red Bluff',
    Longitude: -122.64,
    MajorIncident: 'True',
    Name: 'Red Bank Fire',
    Started: '2019-09-05T13:19:56Z',
    UniqueId: '14ad161c-bfc6-41ae-af84-a464084a4142'
  },
  {
    AcresBurned: 8799,
    AdminUnit: 'Unified Command: Los Angeles County Fire Department and Los Angeles City Fire Department and Angeles National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/10/saddle-ridge-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2019-10-31T09:10:00Z',
    Latitude: 34.32988,
    Location: 'Saddle Ridge Rd, Sylmar',
    Longitude: -118.48161,
    MajorIncident: 'True',
    Name: 'Saddle Ridge Fire',
    Started: '2019-10-10T21:02:00Z',
    UniqueId: 'c52717d6-0297-4c5b-a0f1-f17abcd7ac27'
  },
  {
    AcresBurned: 5737,
    AdminUnit: 'USFS - Modoc National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/6/lone-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2019-09-13T07:19:00Z',
    Latitude: 41.748,
    Location: 'Pinnacle Lake, Doublehead Ranger district, Modoc National Forest',
    Longitude: -121.056,
    MajorIncident: 'False',
    Name: 'Lone Fire',
    Started: '2019-09-06T11:34:27Z',
    UniqueId: '81977367-45ad-4962-92f3-ae30f22ef723'
  },
  {
    AcresBurned: 5563,
    AdminUnit: 'CAL FIRE Madera Mariposa Merced Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/6/briceburg-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '',
    Latitude: 37.604638,
    Location: 'Highway 140 and Briceburg Bridge Road north of Midpines',
    Longitude: -119.96606,
    MajorIncident: 'True',
    Name: 'Briceburg Fire',
    Started: '2019-10-06T16:15:12Z',
    UniqueId: 'e7aeb204-15af-4a2a-8f2a-bfd2c8dbe411'
  },
  {
    AcresBurned: 5332,
    AdminUnit: 'Shasta-Trinity National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/5/south-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-12-02T16:12:00Z',
    Latitude: 40.109,
    Location: 'Southeast aspect of Tomhead Mountain, South of Platina',
    Longitude: -122.789,
    MajorIncident: 'False',
    Name: 'South Fire',
    Started: '2019-09-05T19:59:46Z',
    UniqueId: '38d46a2f-d1f6-4ed8-a502-e57e393844ea'
  },
  {
    AcresBurned: 4840,
    AdminUnit: 'USFS - Inyo National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/6/springs-fire/',
    Counties: 'Mono',
    CountyIds: 26,
    Extinguished: '',
    Latitude: 37.826,
    Location: 'southeast of Lee Vining, CA',
    Longitude: -118.872,
    MajorIncident: 'False',
    Name: 'Springs Fire',
    Started: '2019-09-06T11:24:11Z',
    UniqueId: '226da8c8-26c0-49d7-b5ef-952cd969f918'
  },
  {
    AcresBurned: 4615,
    AdminUnit: 'Los Angeles County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/24/tick-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '',
    Latitude: 34.472778,
    Location: 'Tick Canyon Rd and Summit Knoll Rd, Canyon Country',
    Longitude: -118.368056,
    MajorIncident: 'True',
    Name: 'Tick Fire',
    Started: '2019-10-24T14:51:46Z',
    UniqueId: '020310d3-7834-4f57-a125-eff0eb3f54e5'
  },
  {
    AcresBurned: 3435,
    AdminUnit: 'USFS El Dorado National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/11/caples-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '',
    Latitude: 38.724,
    Location: 'Northern ridge above Caples Creek north of Highway 88',
    Longitude: -120.145,
    MajorIncident: 'False',
    Name: 'Caples Fire',
    Started: '2019-10-11T12:47:59Z',
    UniqueId: '451c3012-2831-44c1-8fc7-146fd02d2ce0'
  },
  {
    AcresBurned: 3380,
    AdminUnit: 'Bureau of Land Management',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/8/28/r-1-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-09-04T16:22:00Z',
    Latitude: 40.593,
    Location: 'Hagata Canyon, east of Eagle Lake',
    Longitude: -120.581,
    MajorIncident: 'False',
    Name: 'R-1 Fire',
    Started: '2019-08-28T19:48:14Z',
    UniqueId: '4ee8f023-1c92-4266-bb79-d41fdb3a5826'
  },
  {
    AcresBurned: 3126,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/11/25/cave-fire-no-longer-a-cal-fire-incident/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2019-12-14T08:22:00Z',
    Latitude: 34.5025,
    Location: 'Highway 154 and E Camino Cielo near Painted Cave in the Los Padres National Forest',
    Longitude: -119.785,
    MajorIncident: 'False',
    Name: 'Cave Fire (No Longer a CAL FIRE Incident)',
    Started: '2019-11-25T19:59:12Z',
    UniqueId: '7555692b-f672-4660-8f15-d0dab068a193'
  },
  {
    AcresBurned: 2546,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/26/lonoak-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2019-06-26T18:02:00Z',
    Latitude: 36.28426,
    Location: 'Lonoak Rd & Airline Hwy, East of King City',
    Longitude: -120.94771,
    MajorIncident: 'False',
    Name: 'Lonoak Fire',
    Started: '2019-06-26T09:18:22Z',
    UniqueId: '35ba5eb8-520f-4660-af60-9e0e00e7b42b'
  },
  {
    AcresBurned: 2534,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/11/3/ranch-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-11-14T18:02:00Z',
    Latitude: 40.036379,
    Location: 'Colyer Springs Rd and Raglin Ridge Rd, southwest of Red Bluff',
    Longitude: -122.637837,
    MajorIncident: 'True',
    Name: 'Ranch Fire',
    Started: '2019-11-03T14:16:17Z',
    UniqueId: '69d98a94-4980-4dc0-b388-61c37c635f32'
  },
  {
    AcresBurned: 2512,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/8/sand-fire/',
    Counties: 'Yolo',
    CountyIds: 57,
    Extinguished: '2019-06-17T10:40:00Z',
    Latitude: 38.88978,
    Location: 'Guinda',
    Longitude: -122.23922,
    MajorIncident: 'True',
    Name: 'Sand Fire',
    Started: '2019-06-08T14:50:00Z',
    UniqueId: '1760d7f8-57a2-4a04-b7e5-0861cc0ee963'
  },
  {
    AcresBurned: 2500,
    AdminUnit: 'Kern County Fire and the US Fish and Wildlife Service',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/5/7/refuge-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2019-05-09T09:37:00Z',
    Latitude: 35.72057,
    Location: 'off Twisselmen Road, in the Kern National Wildlife Refuge,15 miles west of Delano',
    Longitude: -119.62762,
    MajorIncident: 'False',
    Name: 'Refuge Fire',
    Started: '2019-05-07T15:47:00Z',
    UniqueId: '6f329208-5aa0-45fc-a4ec-db9caf865ca7'
  },
  {
    AcresBurned: 2438,
    AdminUnit: 'Bureau of Land Management',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/8/24/long-valley-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-08-27T09:01:00Z',
    Latitude: 39.892222,
    Location: 'Off Highway 395 and Red Rock Road, North of Hallelujah Junction',
    Longitude: -120.029722,
    MajorIncident: 'False',
    Name: 'Long Valley Fire',
    Started: '2019-08-24T17:25:04Z',
    UniqueId: '2ce810c9-88f1-4efe-9254-8cbd339d2397'
  },
  {
    AcresBurned: 2422,
    AdminUnit: 'CAL FIRE',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/26/rock-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2019-06-27T19:06:00Z',
    Latitude: 37.46577,
    Location: 'Del Puerto Canyon Rd, east of Patterson',
    Longitude: -121.28312,
    MajorIncident: 'False',
    Name: 'Rock Fire',
    Started: '2019-06-26T08:54:24Z',
    UniqueId: '4edb5c7c-08d6-4ae0-b8b3-7bb471e26d8e'
  },
  {
    AcresBurned: 1975,
    AdminUnit: 'USFS - Inyo National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/6/cow-fire/',
    Counties: 'Inyo',
    CountyIds: 14,
    Extinguished: '2019-11-21T16:08:00Z',
    Latitude: 36.284,
    Location: 'Golden Trout Wilderness, Inyo National Forest',
    Longitude: -118.228,
    MajorIncident: 'False',
    Name: 'Cow Fire',
    Started: '2019-09-06T12:23:00Z',
    UniqueId: 'c3b236b9-3a1d-481d-b1eb-b0aa77c5b462'
  },
  {
    AcresBurned: 1926,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/4/tenaja/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-09-14T19:00:00Z',
    Latitude: 33.528469,
    Location: 'Tenaja Road and Clinton Keith Road, in La Cresta',
    Longitude: -117.273157,
    MajorIncident: 'True',
    Name: 'Tenaja',
    Started: '2019-09-04T16:43:36Z',
    UniqueId: 'f68808fb-a705-4083-a136-1a45c61c7f74'
  },
  {
    AcresBurned: 1872,
    AdminUnit: 'Klamath National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/7/lime-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '',
    Latitude: 41.862237,
    Location: 'Ash Creek and Highway 96, Southwest of Hornbrook',
    Longitude: -122.662258,
    MajorIncident: 'False',
    Name: 'Lime Fire',
    Started: '2019-09-07T08:36:32Z',
    UniqueId: '5c74d3fc-eaeb-4a75-9a07-5f8af961237b'
  },
  {
    AcresBurned: 1764,
    AdminUnit: 'CAL FIRE San Luis Obispo County',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/12/mcmillan-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-06-24T10:25:00Z',
    Latitude: 35.66318,
    Location: 'Highway 46 East and McMillan Canyon Road, North of Shandon',
    Longitude: -120.41128,
    MajorIncident: 'False',
    Name: 'McMillan Fire',
    Started: '2019-06-12T12:48:00Z',
    UniqueId: '88a285bc-0dc7-4c51-a35a-5026850b0a6d'
  },
  {
    AcresBurned: 1507,
    AdminUnit: 'Unified Command: CAL FIRE and Mexican Fire Agency Consulate Emergency Services Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/16/border-8-fire/',
    Counties: 'Mexico',
    CountyIds: 62,
    Extinguished: '2019-08-17T14:30:00Z',
    Latitude: 32.573437,
    Location: 'City of Tecate, southeast of San Diego',
    Longitude: -116.658735,
    MajorIncident: 'False',
    Name: 'Border 8 Fire',
    Started: '2019-08-16T06:14:55Z',
    UniqueId: '74b94fe9-3524-40ce-ac18-ee637bf66f15'
  },
  {
    AcresBurned: 1350,
    AdminUnit: 'Sutter County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/6/8/west-butte-fire/',
    Counties: 'Sutter',
    CountyIds: 51,
    Extinguished: '2019-06-17T15:16:00Z',
    Latitude: 39.28926,
    Location: 'North Butte Rd & West Butte Rd, northeast of Colusa',
    Longitude: -121.85906,
    MajorIncident: 'False',
    Name: 'West Butte Fire',
    Started: '2019-06-08T14:37:00Z',
    UniqueId: '23cee99c-662f-4409-80d0-b9eb3a6287b3'
  },
  {
    AcresBurned: 1301,
    AdminUnit: 'Oregon Department of Forestry',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/8/9/ward-fire/',
    Counties: 'State of Oregon',
    CountyIds: 61,
    Extinguished: '2019-08-18T16:33:00Z',
    Latitude: 42.033,
    Location: 'Highway 66 and Ward Rd, 13 miles west of Keno, Oregon',
    Longitude: -122.175,
    MajorIncident: 'False',
    Name: 'Ward Fire',
    Started: '2019-08-09T23:08:25Z',
    UniqueId: 'e3d66b1b-3b3b-40a3-96ec-574c1a27cbe9'
  },
  {
    AcresBurned: 1165,
    AdminUnit: 'CAL FIRE NEU',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/7/13/jasper-fire/',
    Counties: 'State of Nevada',
    CountyIds: 59,
    Extinguished: '2019-07-16T08:50:00Z',
    Latitude: 39.631945,
    Location: 'Chimney Rd and Barrel Springs Rd, 2 miles North of Sun Valley Nevada',
    Longitude: -119.769881,
    MajorIncident: 'False',
    Name: 'Jasper Fire',
    Started: '2019-07-13T18:42:22Z',
    UniqueId: '3086ac2b-bbb3-4321-81e3-3cfdb9e571e9'
  },
  {
    AcresBurned: 1127,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/5/boulder-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-06-11T14:49:00Z',
    Latitude: 35.343761,
    Location: 'off Highway 58 and Boulder Creek Road, California Valley',
    Longitude: -119.913717,
    MajorIncident: 'False',
    Name: 'Boulder Fire',
    Started: '2019-06-05T10:49:00Z',
    UniqueId: '107dd529-31b8-4b5f-ab09-4aa79c770d4b'
  },
  {
    AcresBurned: 1020,
    AdminUnit: 'USFS Lassen National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/8/8/w1-mcdonald-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-08-11T11:35:00Z',
    Latitude: 40.943799,
    Location: 'Cold Springs Rd and McDonald Peak, 11 miles southeast of Madeline',
    Longitude: -120.275298,
    MajorIncident: 'False',
    Name: 'W1 McDonald Fire',
    Started: '2019-08-08T18:42:41Z',
    UniqueId: '94cdd032-ea04-4713-b54a-dc3476635684'
  },
  {
    AcresBurned: 974,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/8/gillis-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-07-09T18:22:00Z',
    Latitude: 35.63111111,
    Location: 'Gillis Canyon and South East of Shandon',
    Longitude: -120.26916667,
    MajorIncident: 'False',
    Name: 'Gillis Fire',
    Started: '2019-07-08T16:44:08Z',
    UniqueId: '1fd11e53-a132-4b89-bc8f-f7061f685ad3'
  },
  {
    AcresBurned: 835,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/5/29/belmont-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-06-03T08:44:00Z',
    Latitude: 35.30759,
    Location: 'Belmont & Costa Mesa Rd, In California Valley',
    Longitude: -119.96498,
    MajorIncident: 'False',
    Name: 'Belmont Fire',
    Started: '2019-05-29T17:10:00Z',
    UniqueId: 'e2d77e59-b831-4267-a50b-89ede499a885'
  },
  {
    AcresBurned: 757,
    AdminUnit: 'Unified Command: CAL FIRE Santa Clara Unit and East Contra Costa Fire Protection District',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/3/marsh-complex/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-08-06T18:42:00Z',
    Latitude: 37.908362,
    Location: 'Marsh Creek Rd and Morgan Territory Rd, southwest of Brentwood',
    Longitude: -121.872941,
    MajorIncident: 'False',
    Name: 'Marsh Complex',
    Started: '2019-08-03T03:16:00Z',
    UniqueId: '1f576988-2ad0-4a7b-afed-f650caafc579'
  },
  {
    AcresBurned: 756,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/31/creek-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '',
    Latitude: 36.40193,
    Location: 'Dry Creek Dr and Lomitas Drive, east of Woodlake',
    Longitude: -119.030621,
    MajorIncident: 'False',
    Name: 'Creek Fire',
    Started: '2019-08-31T15:31:59Z',
    UniqueId: '8faaa845-634f-4f94-b25e-f5ae78703da6'
  },
  {
    AcresBurned: 745,
    AdminUnit: 'Los Angeles Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/28/getty-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2019-11-05T17:30:00Z',
    Latitude: 34.098191,
    Location: 'East Sepulveda Blvd and I-405 near Los Angeles City',
    Longitude: -118.478717,
    MajorIncident: 'False',
    Name: 'Getty Fire',
    Started: '2019-10-28T06:46:55Z',
    UniqueId: 'e693477a-37d2-4aba-9e73-a63421a2b3a6'
  },
  {
    AcresBurned: 703,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/27/burris-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2019-11-03T18:52:00Z',
    Latitude: 39.22431,
    Location: 'Potter Valley Road and  Highway 20, east of Calpella in Mendocino County',
    Longitude: -123.12887,
    MajorIncident: 'False',
    Name: 'Burris Fire',
    Started: '2019-10-27T14:54:40Z',
    UniqueId: '9cc1af36-29f2-4af5-afa7-23b9ce17630e'
  },
  {
    AcresBurned: 604,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/20/baseline-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '',
    Latitude: 38.751648,
    Location: 'Baseline Road and Country Acres Lane, north of Rio Linda',
    Longitude: -121.432636,
    MajorIncident: 'False',
    Name: 'Baseline Fire',
    Started: '2019-09-20T15:02:08Z',
    UniqueId: 'ebc468e3-c2ec-43ff-95e9-c319a7ec3d40'
  },
  {
    AcresBurned: 600,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/22/mountain-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-08-26T17:00:00Z',
    Latitude: 40.715556,
    Location: 'Bear Mountain Road and Dry Creek Road, north of Bella Vista',
    Longitude: -122.241944,
    MajorIncident: 'True',
    Name: 'Mountain Fire',
    Started: '2019-08-22T11:02:09Z',
    UniqueId: '1bf3e829-5fb3-43d2-9179-6c337709df19'
  },
  {
    AcresBurned: 600,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/7/stuhr-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2019-06-11T17:14:00Z',
    Latitude: 37.25988,
    Location: 'Interstate 5 and Pete Miller Road, southwest of Newman',
    Longitude: -121.09375,
    MajorIncident: 'False',
    Name: 'Stuhr Fire',
    Started: '2019-06-07T16:55:00Z',
    UniqueId: '8edf51ea-1e4f-4e73-8e04-e168417ed39b'
  },
  {
    AcresBurned: 526,
    AdminUnit: 'Unified Command: CAL FIRE Sonoma-Lake-Napa Unit and American Canyon Fire Protection District',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/6/american-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2019-10-07T18:34:00Z',
    Latitude: 38.165873,
    Location: 'American Canyon and Highway 80, east of American Canyon',
    Longitude: -122.211671,
    MajorIncident: 'False',
    Name: 'American Fire',
    Started: '2019-10-06T16:36:50Z',
    UniqueId: '74c3d01f-8809-40bc-a0e2-b1cc24bf1a7d'
  },
  {
    AcresBurned: 525,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/21/jerry-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-06-24T11:43:00Z',
    Latitude: 33.919507,
    Location: 'off Gilman Springs Road, between Highway 60 and Jack Rabbit Trail',
    Longitude: -117.103765,
    MajorIncident: 'False',
    Name: 'Jerry Fire',
    Started: '2019-06-21T13:02:00Z',
    UniqueId: '8c666963-1f9d-43c6-bc3a-cab623d81f27'
  },
  {
    AcresBurned: 520,
    AdminUnit: 'CAL FIRE RRU (Riverside County Fire)',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/14/horseshoe-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '',
    Latitude: 33.4853,
    Location: 'Horseshoe Trail and Stagecoach Road, Juniper Flats',
    Longitude: -117.043723,
    MajorIncident: 'True',
    Name: 'Horseshoe Fire',
    Started: '2019-09-14T17:53:00Z',
    UniqueId: 'c9327432-b3d3-4ea1-b810-d339dc9e25c3'
  },
  {
    AcresBurned: 496,
    AdminUnit: 'CAL FIRE Butte County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/7/swedes-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-09-13T19:00:00Z',
    Latitude: 39.45296,
    Location: 'Swedes Flat Road and Oro Bangor Highway, east of Oroville',
    Longitude: -121.412619,
    MajorIncident: 'True',
    Name: 'Swedes Fire',
    Started: '2019-09-07T15:06:00Z',
    UniqueId: '63a43984-64ce-40aa-bbc3-98330a46353f'
  },
  {
    AcresBurned: 448,
    AdminUnit: 'City of San Diego Fire-Rescue',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/8/1/caliente-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-08-03T09:10:00Z',
    Latitude: 32.575556,
    Location: 'Off Airway Road and Caliente Ave, in San Ysidro',
    Longitude: -117.026667,
    MajorIncident: 'False',
    Name: 'Caliente Fire',
    Started: '2019-08-01T14:53:15Z',
    UniqueId: 'ca65fae0-e6d7-4600-890c-62da03753131'
  },
  {
    AcresBurned: 448,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/7/31/mesa-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '',
    Latitude: 35.60989,
    Location: 'near Quail Dr and Bobcat Dr in the Kern River Valley, South of Lake Isabela',
    Longitude: -118.41204,
    MajorIncident: 'False',
    Name: 'Mesa Fire',
    Started: '2019-07-31T17:13:53Z',
    UniqueId: '1f0d1a35-bf41-45d8-b3b8-26cca8d2d83e'
  },
  {
    AcresBurned: 423,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/15/hunter-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '',
    Latitude: 37.532028,
    Location: 'Bear Valley Rd and Cotton Creek Rd, east of Snelling',
    Longitude: -120.208019,
    MajorIncident: 'False',
    Name: 'Hunter Fire',
    Started: '2019-08-15T15:15:56Z',
    UniqueId: '852f3058-ccaa-4877-8e8e-f5b8a9649936'
  },
  {
    AcresBurned: 420,
    AdminUnit: 'Santa Barbara County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/17/real-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2019-10-21T06:00:00Z',
    Latitude: 34.484722,
    Location: 'Calle Real & Hwy 101 west of El Capitan',
    Longitude: -120.190833,
    MajorIncident: 'False',
    Name: 'Real Fire',
    Started: '2019-10-17T16:31:00Z',
    UniqueId: 'baa2a51c-40bc-420c-9f88-db4783872d65'
  },
  {
    AcresBurned: 381,
    AdminUnit: 'USFS - Sequoia National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/6/broder-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '',
    Latitude: 36.151,
    Location: 'Northeast of Broder Meadow',
    Longitude: -118.185,
    MajorIncident: 'False',
    Name: 'Broder Fire',
    Started: '2019-09-06T12:39:18Z',
    UniqueId: '737ef617-abaa-44a1-9bbc-f46240468b8f'
  },
  {
    AcresBurned: 350,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/10/reche-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-10-13T07:30:00Z',
    Latitude: 33.975405,
    Location: 'Reche Canyon Rd and Jordan Dr, Moreno Valley',
    Longitude: -117.207068,
    MajorIncident: 'True',
    Name: 'Reche Fire',
    Started: '2019-10-10T14:18:17Z',
    UniqueId: '8739a46c-9d9b-464c-87d0-31738601d96f'
  },
  {
    AcresBurned: 328,
    AdminUnit: 'CAL FIRE Riverside County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/31/46-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-11-03T16:15:00Z',
    Latitude: 33.985972,
    Location: '5300 block of 46th Street, East Jurupa Valley',
    Longitude: -117.414111,
    MajorIncident: 'False',
    Name: '46 Fire',
    Started: '2019-10-31T06:22:34Z',
    UniqueId: 'e59fa47f-0f47-49a9-a2c5-092cfaf68ed5'
  },
  {
    AcresBurned: 316,
    AdminUnit: 'CAL FIRE San Benito - Monterey Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/29/lake-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '',
    Latitude: 35.908333,
    Location: 'near Lake San Antonio, Jolon Road and New Pleyto Road, Lockwood',
    Longitude: -120.984167,
    MajorIncident: 'False',
    Name: 'Lake Fire',
    Started: '2019-07-29T15:43:48Z',
    UniqueId: '540b19a4-b84c-4d9c-9cb3-746b53a094b7'
  },
  {
    AcresBurned: 300,
    AdminUnit: 'CAL FIRE Butte/ Butte County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/28/hwy-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-09-28T18:40:00Z',
    Latitude: 39.622137,
    Location: 'Off of Hwy 99 and Hwy 149, Southeast of Chico',
    Longitude: -121.693472,
    MajorIncident: 'False',
    Name: 'Hwy Fire',
    Started: '2019-09-28T17:48:10Z',
    UniqueId: 'b8e5a940-0fb5-4c63-93ab-a855cfdc4e0c'
  },
  {
    AcresBurned: 283,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/3/hollow-fire/',
    Counties: 'San Joaquin',
    CountyIds: 39,
    Extinguished: '2019-07-05T07:50:00Z',
    Latitude: 37.63206,
    Location: 'West Corral Hollow Road, Carnegie State Vehicular Recreational Area, southwest of Tracy',
    Longitude: -121.538382,
    MajorIncident: 'False',
    Name: 'Hollow Fire',
    Started: '2019-07-03T15:34:12Z',
    UniqueId: '89db8bb4-6e3b-4de7-b7d9-287c1a9032c0'
  },
  {
    AcresBurned: 280,
    AdminUnit: 'Shasta-Trinity National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/7/rams-horn-fire/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2019-09-12T10:08:00Z',
    Latitude: 41.150392,
    Location: 'Highway 3 and Bear Creek Loop, Northeast of Coffee Creek',
    Longitude: -122.634108,
    MajorIncident: 'False',
    Name: 'Rams Horn Fire',
    Started: '2019-09-07T08:49:58Z',
    UniqueId: 'b24dc89c-632d-46a1-8984-2ce037e37834'
  },
  {
    AcresBurned: 280,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/7/30/mill-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2019-08-12T08:20:00Z',
    Latitude: 36.008889,
    Location: 'In Los Padres National Forest, West of Fort Hunter Liggett',
    Longitude: -121.466944,
    MajorIncident: 'False',
    Name: 'Mill Fire',
    Started: '2019-07-30T13:28:17Z',
    UniqueId: '233708cc-ed2d-4b85-ba8c-60cf71c912c8'
  },
  {
    AcresBurned: 279,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/1/snail-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2019-09-05T08:14:00Z',
    Latitude: 34.71011,
    Location: '3 miles northwest of Reyes Creek',
    Longitude: -119.3547,
    MajorIncident: 'False',
    Name: 'Snail Fire',
    Started: '2019-09-01T17:37:43Z',
    UniqueId: '1b6cdbc8-4ab9-49e9-b6ed-e38d55e263cc'
  },
  {
    AcresBurned: 263,
    AdminUnit: 'Susanville Bureau of Land Management',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/7/5/snowstorm-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-07-06T07:49:00Z',
    Latitude: 40.679318,
    Location: 'Snowstorm Rd, south of Ravendale',
    Longitude: -120.392768,
    MajorIncident: 'False',
    Name: 'Snowstorm Fire',
    Started: '2019-07-05T16:37:04Z',
    UniqueId: '0f965f2f-3977-4ba5-bf7c-29feef27ee82'
  },
  {
    AcresBurned: 260,
    AdminUnit: 'Bureau of Land Management - Northern CA District',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/6/r-6-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-09-11T18:30:00Z',
    Latitude: 44.734,
    Location: 'North of Fredonyer Peak, southwest of Termo',
    Longitude: -120.606,
    MajorIncident: 'False',
    Name: 'R-6 Fire',
    Started: '2019-09-06T13:20:00Z',
    UniqueId: '393edada-d2bf-4a33-94f2-2d2123357015'
  },
  {
    AcresBurned: 257,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/2/citrus-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2019-06-11T14:48:00Z',
    Latitude: 36.18479,
    Location: 'Off Rd 256 & Ave 220, east of Strathmore',
    Longitude: -118.99229,
    MajorIncident: 'False',
    Name: 'Citrus Fire',
    Started: '2019-06-02T16:12:00Z',
    UniqueId: '11e0324e-e8ff-4591-b592-9e704ade60d6'
  },
  {
    AcresBurned: 250,
    AdminUnit: 'Riverside City Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/7/sycamore-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-09-08T18:00:00Z',
    Latitude: 33.9369,
    Location: 'Kangaroo Court and River Ridge Drive, Riverside',
    Longitude: -117.3063,
    MajorIncident: 'False',
    Name: 'Sycamore Fire',
    Started: '2019-09-07T20:31:46Z',
    UniqueId: 'a14c1f49-8e49-4709-a21b-6c06471a1002'
  },
  {
    AcresBurned: 244,
    AdminUnit: 'USFS Mendocino National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/5/henthorne-fire/',
    Counties: 'Trinity',
    CountyIds: 53,
    Extinguished: '2019-09-18T12:17:00Z',
    Latitude: 40.062304,
    Location: 'Yolla Bolly Middle Eel Wilderness near Henthorne Lake, North of Covelo',
    Longitude: -123.222196,
    MajorIncident: 'False',
    Name: 'Henthorne Fire',
    Started: '2019-09-05T09:25:00Z',
    UniqueId: '791059a2-b50f-4ab0-924a-bfdac001e4b9'
  },
  {
    AcresBurned: 244,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/8/lake-fire/',
    Counties: 'Mariposa',
    CountyIds: 22,
    Extinguished: '',
    Latitude: 37.524378,
    Location: 'McSwain Entrance and Lake McClure Rd, Hornitos',
    Longitude: -120.296551,
    MajorIncident: 'False',
    Name: 'Lake Fire',
    Started: '2019-07-08T15:30:14Z',
    UniqueId: '6be8378d-9a89-40a3-bc66-4fc0ab22ebc2'
  },
  {
    AcresBurned: 240,
    AdminUnit: 'CAL FIRE SCU',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/8/9/harte-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '',
    Latitude: 37.708743,
    Location: 'Central Pkwy and Croak Rd, 4 miles east of Dublin',
    Longitude: -121.841879,
    MajorIncident: 'False',
    Name: 'Harte Fire',
    Started: '2019-08-09T15:09:50Z',
    UniqueId: '4affde91-31a9-4588-bf14-7201fc5c548b'
  },
  {
    AcresBurned: 227,
    AdminUnit: 'Klamath National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/7/kidder-2-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-09-26T08:00:00Z',
    Latitude: 41.4929742,
    Location: 'Marble Mountain Wilderness and Kidder Creek, Northwest of Etna',
    Longitude: -123.2129356,
    MajorIncident: 'False',
    Name: 'Kidder 2 Fire',
    Started: '2019-09-07T08:47:46Z',
    UniqueId: '69b0cca6-c0c6-4a96-8f61-07ebb0ff9dc7'
  },
  {
    AcresBurned: 225,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/12/moose-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '2019-08-17T18:15:00Z',
    Latitude: 39.005262,
    Location: 'Off Moose Rd & Bus McGall Rd northwest of Hopland',
    Longitude: -123.195306,
    MajorIncident: 'True',
    Name: 'Moose Fire',
    Started: '2019-08-12T17:10:00Z',
    UniqueId: 'c8f94c30-d0ee-450a-8501-30678aa37c0f'
  },
  {
    AcresBurned: 220,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/21/lopez-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-09-27T18:00:00Z',
    Latitude: 35.214364,
    Location: 'Upper Lopez Canyon Road & Wittenberg Creek Rd, southeast of San Luis Obispo',
    Longitude: -120.455883,
    MajorIncident: 'True',
    Name: 'Lopez Fire',
    Started: '2019-09-21T14:26:00Z',
    UniqueId: '840010ca-aef0-4f91-b771-3bf196317d03'
  },
  {
    AcresBurned: 214,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/29/wolf-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-06-30T15:51:00Z',
    Latitude: 33.911,
    Location: 'Off of Lamb Canyon Road and California Avenue, Southeast of Beaumont',
    Longitude: -116.980528,
    MajorIncident: 'False',
    Name: 'Wolf Fire',
    Started: '2019-06-29T12:54:13Z',
    UniqueId: '24d9c2ae-8b11-4536-9b9c-5f4e0d476af0'
  },
  {
    AcresBurned: 213,
    AdminUnit: 'CAL FIRE Madera-Mariposa-Merced Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/15/madera-fire/',
    Counties: 'Madera',
    CountyIds: 20,
    Extinguished: '2019-07-16T06:49:00Z',
    Latitude: 37.016944,
    Location: 'Off Road 33 and Highway 145, Bonadelle',
    Longitude: -119.934167,
    MajorIncident: 'False',
    Name: 'Madera Fire',
    Started: '2019-07-15T18:19:31Z',
    UniqueId: 'f2629bc3-1c8c-4a97-95fa-7d08566dc246'
  },
  {
    AcresBurned: 210,
    AdminUnit: 'CAL FIRE Madera- Mariposa- Merced Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/29/merced-fire/',
    Counties: 'Merced',
    CountyIds: 24,
    Extinguished: '2019-07-02T15:51:00Z',
    Latitude: 37.312877,
    Location: 'Off of Merced Fall Road and La Grange Road, East of Snelling',
    Longitude: -120.242411,
    MajorIncident: 'False',
    Name: 'Merced Fire',
    Started: '2019-06-29T15:09:52Z',
    UniqueId: 'cc06431a-5153-4f66-8ada-07af53c175c3'
  },
  {
    AcresBurned: 210,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/9/malech-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-06-11T17:17:00Z',
    Latitude: 37.21638,
    Location: 'Malech Rd & Bailey Rd, South San Jose',
    Longitude: -121.70768,
    MajorIncident: 'False',
    Name: 'Malech Fire',
    Started: '2019-06-09T14:29:00Z',
    UniqueId: '6f509c42-9d2b-45df-b705-02dcb9147dde'
  },
  {
    AcresBurned: 208,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/7/21/tejon-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '',
    Latitude: 34.9008333,
    Location: 'I 5 and Diger Rd, South of Bakersfield',
    Longitude: -118.9183333,
    MajorIncident: 'False',
    Name: 'Tejon Fire',
    Started: '2019-07-21T15:30:17Z',
    UniqueId: '49dbe286-1cfe-4e03-a872-13185aae767a'
  },
  {
    AcresBurned: 207,
    AdminUnit: 'USFS Klamath National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/6/17/lumgrey-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-06-24T16:56:00Z',
    Latitude: 39.28926,
    Location: 'off Highway 96 and Lumgrey Road, West of Gottsville',
    Longitude: -121.85906,
    MajorIncident: 'False',
    Name: 'Lumgrey Fire',
    Started: '2019-06-17T17:50:00Z',
    UniqueId: '48d3b3c4-fcf5-47d9-920f-3b3c1b0f6fb1'
  },
  {
    AcresBurned: 202,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/15/milton-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2019-07-16T06:48:00Z',
    Latitude: 37.944751,
    Location: 'Off of Milton Road and Highway 4, North of Oakdale',
    Longitude: -120.84372,
    MajorIncident: 'False',
    Name: 'Milton Fire',
    Started: '2019-07-15T10:49:00Z',
    UniqueId: 'a03c52ec-7366-43c5-965e-52e2b73df452'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'San Bernardino County Fire Department/ San Bernardino Nation Forest Service',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/31/hillside-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2019-11-05T09:03:00Z',
    Latitude: 34.183,
    Location: 'off of W 59th and Hill Dr, in San Bernardino National Forest',
    Longitude: -117.285,
    MajorIncident: 'False',
    Name: 'Hillside Fire',
    Started: '2019-10-31T06:53:47Z',
    UniqueId: 'dfc32e06-b88e-4d30-ae3d-22bc18792f5e'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'East Contra Costa County Fire Protection District',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/27/cypress-complex/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-10-28T16:26:00Z',
    Latitude: 37.99136,
    Location: 'East Cypress Rd and Bethel Island Road, Knightsen, CA',
    Longitude: -121.64118,
    MajorIncident: 'False',
    Name: 'Cypress Complex',
    Started: '2019-10-27T08:50:23Z',
    UniqueId: 'd299dec7-b09f-47f7-80c9-859ddd1ecef3'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/11/olivas-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2019-10-12T18:00:00Z',
    Latitude: 34.23955,
    Location: 'Olivas Park Drive, near the Buenaventura Golf Course',
    Longitude: -119.20187,
    MajorIncident: 'False',
    Name: 'Olivas Fire',
    Started: '2019-10-11T15:57:10Z',
    UniqueId: '02e6023e-d306-4a67-a09c-b9224b98661e'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'CAL FIRE/San Diego County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/24/dehesa-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '',
    Latitude: 32.787656,
    Location: 'Dehesa Road and Sloan Canyon Road',
    Longitude: -116.806941,
    MajorIncident: 'True',
    Name: 'Dehesa Fire',
    Started: '2019-09-24T15:00:00Z',
    UniqueId: '94cd8534-defa-4a82-b1be-42a2704c13d2'
  },
  {
    AcresBurned: 200,
    AdminUnit: 'Santa Barbara County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/9/mcmurray-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2019-09-14T08:00:00Z',
    Latitude: 34.630919,
    Location: 'McMurray Rd and Hwy 101, north of Buellton',
    Longitude: -120.187368,
    MajorIncident: 'False',
    Name: 'McMurray Fire',
    Started: '2019-09-09T17:42:43Z',
    UniqueId: '4cebaf5a-70a7-4262-864b-fb3fe3b1d84d'
  },
  {
    AcresBurned: 193,
    AdminUnit: 'Bureau of Land Management',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/7/14/doyle-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-07-16T09:00:00Z',
    Latitude: 40.072739,
    Location: 'Off Old Highway and Cowboy Joe Road, Northwest of Doyle',
    Longitude: -120.158273,
    MajorIncident: 'False',
    Name: 'Doyle Fire',
    Started: '2019-07-14T14:02:31Z',
    UniqueId: '0ab090de-1ec9-41db-b6cf-c7acd370626a'
  },
  {
    AcresBurned: 190,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/11/stuhr-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '',
    Latitude: 37.32585,
    Location: 'Off SB Interstate 5 and West Stuhr Road, South of Patterson City',
    Longitude: -121.110146,
    MajorIncident: 'False',
    Name: 'Stuhr Fire',
    Started: '2019-09-11T11:25:43Z',
    UniqueId: '8f6c8f60-1daf-4c04-8507-dcc81656b8c5'
  },
  {
    AcresBurned: 190,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/9/sargent-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2019-07-10T16:04:00Z',
    Latitude: 35.95191,
    Location: 'Sargent Canyon Road and Sheep Canyon, San Ardo Oil Fields',
    Longitude: -120.8092,
    MajorIncident: 'False',
    Name: 'Sargent Fire',
    Started: '2019-07-09T21:43:36Z',
    UniqueId: 'f32eaf92-82dc-4c31-8a05-76c21845f078'
  },
  {
    AcresBurned: 183,
    AdminUnit: 'CAL FIRE Sonoma Lake Napa Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/24/marshview-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '',
    Latitude: 38.158333,
    Location: 'Off Marshview Road and Highway 680, South of Cordelia',
    Longitude: -122.118889,
    MajorIncident: 'False',
    Name: 'Marshview Fire',
    Started: '2019-07-24T12:28:45Z',
    UniqueId: 'f0577ec6-5504-4460-83ce-d9bd91624e0a'
  },
  {
    AcresBurned: 172,
    AdminUnit: 'Kern County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/5/3/vulcan-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2019-05-08T08:48:00Z',
    Latitude: 35.03855,
    Location: 'Off Highway 166 at Wind Wolves Preserve',
    Longitude: -119.19454,
    MajorIncident: 'False',
    Name: 'Vulcan Fire',
    Started: '2019-05-03T15:04:00Z',
    UniqueId: 'ee290ec6-3815-4c44-a96a-edb331fcc925'
  },
  {
    AcresBurned: 167,
    AdminUnit: 'San Bernardino National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/15/bautista-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-09-22T18:00:00Z',
    Latitude: 33.635,
    Location: 'Bautista Road and Tripp Flats, West of Lake Hemet',
    Longitude: -116.801111,
    MajorIncident: 'False',
    Name: 'Bautista Fire',
    Started: '2019-09-15T20:13:05Z',
    UniqueId: '980c4c7d-dcc9-45b3-b5c1-181c1cd445e9'
  },
  {
    AcresBurned: 167,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/2/antelope-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2019-09-03T07:11:00Z',
    Latitude: 36.600167,
    Location: 'Panoche Road and New Idria Road, Paicines',
    Longitude: -120.8405,
    MajorIncident: 'False',
    Name: 'Antelope Fire',
    Started: '2019-09-02T15:40:37Z',
    UniqueId: 'ebdceb89-fa30-486a-94f8-3eff8eedbd67'
  },
  {
    AcresBurned: 161,
    AdminUnit: 'Fresno-Kings County',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/4/28/york-fire/',
    Counties: 'Kings',
    CountyIds: 16,
    Extinguished: '2019-06-24T11:45:00Z',
    Latitude: 35.81778,
    Location: 'Hwy 41 and York Ave, 13 miles south of Avenal (Kings County)',
    Longitude: -120.09715,
    MajorIncident: 'False',
    Name: 'York Fire',
    Started: '2019-04-28T22:20:00Z',
    UniqueId: '85bdd89a-4ce5-4539-a274-23fa2b030e7d'
  },
  {
    AcresBurned: 156,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/15/cottage-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-08-17T18:43:00Z',
    Latitude: 40.484329,
    Location: 'Dersch Rd and Cottage Hill Dr, northeast of Anderson',
    Longitude: -122.159393,
    MajorIncident: 'True',
    Name: 'Cottage Fire',
    Started: '2019-08-15T15:09:55Z',
    UniqueId: '2443f637-15d7-4cf9-a405-133cf1748300'
  },
  {
    AcresBurned: 156,
    AdminUnit: 'Angeles National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/8/3/five-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2019-08-05T12:25:00Z',
    Latitude: 34.677864,
    Location: 'Off Interstate 5 & Templin Hwy',
    Longitude: -118.752395,
    MajorIncident: 'False',
    Name: 'Five Fire',
    Started: '2019-08-03T17:01:15Z',
    UniqueId: 'ed5e111d-e34a-42c0-9ce7-818270037c2c'
  },
  {
    AcresBurned: 156,
    AdminUnit: 'City of Chino',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/7/28/star-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '',
    Latitude: 33.997528,
    Location: 'Chino Hils Parkway and Grand Avenue, Chino Hills',
    Longitude: -117.769766,
    MajorIncident: 'False',
    Name: 'Star Fire',
    Started: '2019-07-28T13:20:11Z',
    UniqueId: 'd79e71f2-d827-465d-95a8-d80b6e54456e'
  },
  {
    AcresBurned: 155,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/1/spruce-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2019-06-11T14:48:00Z',
    Latitude: 36.28001,
    Location: 'Off Spruce Rd & Myer Dr, east of Exeter',
    Longitude: -119.10974,
    MajorIncident: 'False',
    Name: 'Spruce Fire',
    Started: '2019-06-01T15:49:00Z',
    UniqueId: '812a492e-35cb-4bb0-9e5a-1ec181d8b97e'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'Unified Command: CAL FIRE Santa Clara Unit, Crockett Fire and Contra Costa Fire.',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/27/sky-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-10-28T16:30:00Z',
    Latitude: 38.03545,
    Location: 'Commings Skyway and I-80, south of Crockett',
    Longitude: -122.2241,
    MajorIncident: 'False',
    Name: 'Sky Fire',
    Started: '2019-10-27T11:29:03Z',
    UniqueId: '64104ca2-a187-4b11-bb43-e22253bbcb52'
  },
  {
    AcresBurned: 150,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/28/dehesa-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '',
    Latitude: 32.767649,
    Location: 'Dehesa Road and Slone Canyon Road, Dehesa',
    Longitude: -116.796032,
    MajorIncident: 'False',
    Name: 'Dehesa Fire',
    Started: '2019-07-28T19:51:55Z',
    UniqueId: '5a633180-7b70-4fb6-b859-b5826775b5fc'
  },
  {
    AcresBurned: 148,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/26/dyer-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '2019-06-27T08:26:00Z',
    Latitude: 38.73817,
    Location: 'Watt Ave & Dyer Road, northeast of Rio Linda',
    Longitude: -121.39419,
    MajorIncident: 'False',
    Name: 'Dyer Fire',
    Started: '2019-06-26T22:43:07Z',
    UniqueId: 'ac723863-413e-43f8-b4b6-2311e81e36ae'
  },
  {
    AcresBurned: 145,
    AdminUnit: 'San Bernardino County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/24/old-water-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '',
    Latitude: 34.183624,
    Location: 'near Old Waterman Canyon Road and Hwy 18.',
    Longitude: -117.274276,
    MajorIncident: 'False',
    Name: 'Old Water Fire',
    Started: '2019-10-24T04:53:17Z',
    UniqueId: '956f8cd5-f4fb-43d7-8a34-1bb5db551995'
  },
  {
    AcresBurned: 144,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/5/30/canyon-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-06-11T14:40:00Z',
    Latitude: 37.45899,
    Location: 'Off Del Puerto Canyon Rd & Diablo Grande Pkwy, west of Patterson',
    Longitude: -121.22093,
    MajorIncident: 'False',
    Name: 'Canyon Fire',
    Started: '2019-05-30T16:19:00Z',
    UniqueId: '329ac0b8-a2c1-4a72-bd09-dd86c477162b'
  },
  {
    AcresBurned: 140,
    AdminUnit: 'Vallejo city fire',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/27/glencove-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2019-10-28T16:28:00Z',
    Latitude: 38.07205,
    Location: 'Glen Cove Pkwy and Lookout Dr, south of Vallejo',
    Longitude: -122.22463,
    MajorIncident: 'False',
    Name: 'Glencove Fire',
    Started: '2019-10-27T11:52:15Z',
    UniqueId: 'c9f9ded3-170f-4b04-a50e-2c03153c663f'
  },
  {
    AcresBurned: 139,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/21/patterson-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-08-21T18:27:00Z',
    Latitude: 37.71734,
    Location: 'Patterson Pass and Midway Road, west of Tracy',
    Longitude: -121.55867,
    MajorIncident: 'False',
    Name: 'Patterson Fire',
    Started: '2019-08-21T17:56:05Z',
    UniqueId: 'd35fa87b-0f19-4dd8-8739-4bdbc92d1361'
  },
  {
    AcresBurned: 131,
    AdminUnit: 'Bureau of Land Management',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/8/24/horse-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-08-27T10:44:00Z',
    Latitude: 40.562,
    Location: 'Off Highway 139  and Horselake Road, North of Susanville',
    Longitude: -120.544,
    MajorIncident: 'False',
    Name: 'Horse Fire',
    Started: '2019-08-24T16:33:58Z',
    UniqueId: '97c4d72f-c1e9-425e-9dcf-44150047af92'
  },
  {
    AcresBurned: 131,
    AdminUnit: 'CAL FIRE San Luis Obispo',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/14/south-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '2019-07-15T14:10:00Z',
    Latitude: 34.366111,
    Location: 'Off of South Mountain Rd and Balcom Canyon Road East of Santa Paula',
    Longitude: -118.96,
    MajorIncident: 'False',
    Name: 'South Fire',
    Started: '2019-07-14T11:45:00Z',
    UniqueId: 'c1574fd4-92ca-400f-84cb-b10f18ebb4bd'
  },
  {
    AcresBurned: 130,
    AdminUnit: 'BLM Northern California District',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/8/7/r-1-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '',
    Latitude: 40.886677,
    Location: 'Juniper Ridge Road and Juniper Tree Road, north of Ravendale',
    Longitude: -120.336977,
    MajorIncident: 'False',
    Name: 'R-1 Fire',
    Started: '2019-08-07T17:21:13Z',
    UniqueId: '5f7b19a6-5f22-49ac-bf0e-ecef96385d37'
  },
  {
    AcresBurned: 130,
    AdminUnit: 'CAL FIRE Mendocino Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/27/usal-fire/',
    Counties: 'Mendocino',
    CountyIds: 23,
    Extinguished: '',
    Latitude: 39.831762,
    Location: 'Usal Creek and Usal Rd, west of Leggett',
    Longitude: -123.846013,
    MajorIncident: 'False',
    Name: 'Usal Fire',
    Started: '2019-07-27T23:36:00Z',
    UniqueId: '5edb4ec4-615c-45fb-a236-9a4225eedaff'
  },
  {
    AcresBurned: 130,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/5/18/shady-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-05-24T14:23:00Z',
    Latitude: 33.650237,
    Location: 'off Airport Boulevard and Shady Lane in Thermal, southwest of Coachella',
    Longitude: -116.172534,
    MajorIncident: 'False',
    Name: 'Shady Fire',
    Started: '2019-05-18T22:53:00Z',
    UniqueId: 'e98603d2-f44e-4a9e-b83d-5e9f94766b53'
  },
  {
    AcresBurned: 128,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/21/reservoir-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-09-24T18:00:00Z',
    Latitude: 37.467744,
    Location: 'Calaveras Rd and Felter Road, 5 miles northeast of Milpitas',
    Longitude: -121.842751,
    MajorIncident: 'False',
    Name: 'Reservoir Fire',
    Started: '2019-09-21T11:49:00Z',
    UniqueId: '3934f762-ba99-471a-b1d9-dc064276c383'
  },
  {
    AcresBurned: 128,
    AdminUnit: 'Modoc National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/7/17/goose-2-fire/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2019-07-20T09:05:00Z',
    Latitude: 41.909,
    Location: 'Off Highway 395 and South Willow Ranch Road, West of Fort Bidwell',
    Longitude: -120.306,
    MajorIncident: 'False',
    Name: 'Goose 2 Fire',
    Started: '2019-07-17T16:13:41Z',
    UniqueId: 'd5ebf295-49d5-4a6a-ae13-47a921355e19'
  },
  {
    AcresBurned: 121,
    AdminUnit: 'CAL FIRE / Fresno County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/5/29/hill-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '2019-06-05T15:07:00Z',
    Latitude: 36.66909,
    Location: 'S. Hills Valley Road, north of Orange Cove',
    Longitude: -119.3046,
    MajorIncident: 'False',
    Name: 'Hill Fire',
    Started: '2019-05-29T17:18:00Z',
    UniqueId: '72cb3684-c194-4180-bdfe-22775f86a594'
  },
  {
    AcresBurned: 120,
    AdminUnit: 'Camp Pendleton',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/20/weisgarber-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-06-21T14:22:00Z',
    Latitude: 33.39684,
    Location: 'one mile west of the DeLuz gate, Camp Pendleton',
    Longitude: -117.29665,
    MajorIncident: 'True',
    Name: 'Weisgarber Fire',
    Started: '2019-06-20T14:56:00Z',
    UniqueId: '779c4b9a-19bf-487f-ba65-6589aea27420'
  },
  {
    AcresBurned: 120,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/10/bitter-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-06-11T17:18:00Z',
    Latitude: 35.57376,
    Location: 'Bitterwater Road East of Paso Robles',
    Longitude: -120.11738,
    MajorIncident: 'False',
    Name: 'Bitter Fire',
    Started: '2019-06-10T11:55:00Z',
    UniqueId: 'e1e4dad4-7ea6-48ec-b34d-3128cf55cc43'
  },
  {
    AcresBurned: 115,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/4/30/woody-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2019-05-08T08:47:00Z',
    Latitude: 35.65189,
    Location: 'Woody Rd & Horseshoe Ranch Rd, northeast of Bakersfield',
    Longitude: -118.92545,
    MajorIncident: 'False',
    Name: 'Woody Fire',
    Started: '2019-04-30T18:37:00Z',
    UniqueId: 'd3beabf6-63e9-4cad-a17c-58bb36abd7ac'
  },
  {
    AcresBurned: 105,
    AdminUnit: 'CAL FIRE Los Angeles County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/13/west-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '',
    Latitude: 34.675542,
    Location: 'off of 120th Street  West and Coppermill Road, Lancaster',
    Longitude: -118.342239,
    MajorIncident: 'False',
    Name: 'West Fire',
    Started: '2019-08-13T14:37:54Z',
    UniqueId: 'eb975e90-a689-40fc-8f44-b13c774de0e8'
  },
  {
    AcresBurned: 103,
    AdminUnit: 'Davis Creek Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/8/2/meadow-fire-not-a-cal-fire-incident/',
    Counties: 'Modoc',
    CountyIds: 25,
    Extinguished: '2019-08-02T21:39:00Z',
    Latitude: 41.43783,
    Location: 'County Road 48 and Highway 395, northeast of Alturas',
    Longitude: -120.23976,
    MajorIncident: 'False',
    Name: 'Meadow Fire (Not a CAL FIRE incident)',
    Started: '2019-08-02T16:53:18Z',
    UniqueId: '2f735b66-c275-4557-a8ad-0ff60e0552f3'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/7/28/range-fire/',
    Counties: 'Santa Barbara',
    CountyIds: 42,
    Extinguished: '2019-08-05T12:27:00Z',
    Latitude: 34.665699,
    Location: 'north of Lake Cachuma',
    Longitude: -119.94974,
    MajorIncident: 'False',
    Name: 'Range Fire',
    Started: '2019-07-28T22:39:05Z',
    UniqueId: 'bc2edb86-fb4b-4dba-a9e0-5339f27d9bce'
  },
  {
    AcresBurned: 100,
    AdminUnit: 'CAL FIRE San Diego County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/12/border-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-07-15T17:10:00Z',
    Latitude: 32.566389,
    Location: 'Off of Cottonwood Creak and Barrett Truck Trail along the US/Mexico border',
    Longitude: -116.7525,
    MajorIncident: 'False',
    Name: 'Border Fire',
    Started: '2019-07-12T13:20:39Z',
    UniqueId: '8c46fde6-7a1c-482b-97cc-afff1bc5d27c'
  },
  {
    AcresBurned: 98,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/21/kennedy-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-09-22T17:00:00Z',
    Latitude: 33.900994,
    Location: 'Moreno Beach Dr & John F. Kennedy Dr, near Lake Perris',
    Longitude: -117.170588,
    MajorIncident: 'False',
    Name: 'Kennedy Fire',
    Started: '2019-09-21T17:22:00Z',
    UniqueId: '7b283f4f-c613-4840-aa90-1f6e9fa1573a'
  },
  {
    AcresBurned: 97,
    AdminUnit: 'CALFIRE San Diego',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/25/sawday-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-10-28T19:31:00Z',
    Latitude: 33.055124,
    Location: 'Sawday Truck Trail and Little Page Rd, Community of Witch Creek',
    Longitude: -116.742508,
    MajorIncident: 'True',
    Name: 'Sawday Fire',
    Started: '2019-10-25T10:52:04Z',
    UniqueId: 'a6701bb9-7086-4dbc-ac5f-8c98eeb0279a'
  },
  {
    AcresBurned: 96,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/13/orange-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-07-13T15:13:00Z',
    Latitude: 33.8128372,
    Location: '27000 block of Orange Avenue in Nuevo',
    Longitude: -117.1228851,
    MajorIncident: 'False',
    Name: 'Orange fire',
    Started: '2019-07-13T10:36:00Z',
    UniqueId: '777caabb-3850-4db2-ba02-2d95fda38db6'
  },
  {
    AcresBurned: 95,
    AdminUnit: 'CAL FIRE San Luis Obispo Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/24/thompson-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '',
    Latitude: 35.004722,
    Location: 'Off Highway 166  and Highway 101, North of Santa Maria',
    Longitude: -120.435278,
    MajorIncident: 'False',
    Name: 'Thompson Fire',
    Started: '2019-07-24T20:09:59Z',
    UniqueId: '63b69be6-bd39-4bb4-aee1-7b59dbf7c360'
  },
  {
    AcresBurned: 94,
    AdminUnit: 'CAL FIRE Riverside County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/5/toro-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-08-06T18:42:00Z',
    Latitude: 33.740219,
    Location: '26000 Block El Toro Road, North of Lake Elsinore',
    Longitude: -117.333728,
    MajorIncident: 'False',
    Name: 'Toro Fire',
    Started: '2019-08-05T15:36:23Z',
    UniqueId: '0089d3c4-c554-46e1-8eb9-af95e4dfae0c'
  },
  {
    AcresBurned: 91,
    AdminUnit: 'Ventura County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/10/wendy-fire/',
    Counties: 'Ventura',
    CountyIds: 56,
    Extinguished: '',
    Latitude: 34.156389,
    Location: 'Potrero Rd and S Wendy Dr, Newbury Park',
    Longitude: -118.950833,
    MajorIncident: 'False',
    Name: 'Wendy Fire',
    Started: '2019-10-10T21:28:58Z',
    UniqueId: 'fd21c9dc-a89f-4a29-990b-33b95ae2adc9'
  },
  {
    AcresBurned: 91,
    AdminUnit: 'Klamath National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/15/bar-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '',
    Latitude: 41.749667,
    Location: 'Southwest of Bald Mountain and Klamath Bar, Klamath National Forest',
    Longitude: -123.000833,
    MajorIncident: 'False',
    Name: 'Bar Fire',
    Started: '2019-09-15T15:52:00Z',
    UniqueId: '8b4a5b95-3f51-4038-a7ea-b5ed3c73c2e5'
  },
  {
    AcresBurned: 90,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/16/whiskey-fire/',
    Counties: 'San Joaquin',
    CountyIds: 39,
    Extinguished: '',
    Latitude: 37.962557,
    Location: 'west Lower Jones Road, west of the Community of Slough',
    Longitude: -121.468074,
    MajorIncident: 'False',
    Name: 'Whiskey Fire',
    Started: '2019-07-16T18:44:15Z',
    UniqueId: '12528e0f-03e0-4598-8df0-e3017fa7382a'
  },
  {
    AcresBurned: 90,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/26/trinity-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-06-26T06:00:00Z',
    Latitude: 40.41404,
    Location: 'Trinity Alps Vista Road and Bland Road, southwest of Ono',
    Longitude: -122.66779,
    MajorIncident: 'False',
    Name: 'Trinity Fire',
    Started: '2019-06-26T15:35:00Z',
    UniqueId: '2f3e47bb-8595-4c9f-bfa6-6fd76e465c12'
  },
  {
    AcresBurned: 85,
    AdminUnit: 'CAL FIRE Amador - El Dorado Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/3/country-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2019-09-06T07:24:00Z',
    Latitude: 38.898915,
    Location: 'Highway 193 and Penobscot Rd, east of Cool',
    Longitude: -120.946657,
    MajorIncident: 'True',
    Name: 'Country Fire',
    Started: '2019-09-03T14:57:31Z',
    UniqueId: '89008310-149d-480f-946f-4ce5a2a71c3f'
  },
  {
    AcresBurned: 84,
    AdminUnit: 'CAL FIRE Amador El Dorado Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/2/browns-fire/',
    Counties: 'Sacramento',
    CountyIds: 34,
    Extinguished: '2019-08-02T14:03:00Z',
    Latitude: 38.3525,
    Location: 'Off Twin Cities Road and Clay Station Road, Northeast of Herald',
    Longitude: -121.123611,
    MajorIncident: 'False',
    Name: 'Browns Fire',
    Started: '2019-08-02T09:23:00Z',
    UniqueId: '12e44df4-d425-4f09-96b9-25256ffbdcb2'
  },
  {
    AcresBurned: 83,
    AdminUnit: 'CAL FIRE Tuolumne-Calaveras Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/23/tulloch-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2019-09-24T10:21:00Z',
    Latitude: 37.838333,
    Location: 'By the intersection of Tulloch Road and Highway 108 in Jamestown, California.',
    Longitude: -120.625556,
    MajorIncident: 'False',
    Name: 'Tulloch Fire',
    Started: '2019-09-23T15:55:57Z',
    UniqueId: 'e7910549-a5ca-4712-bd04-349c49c1ba15'
  },
  {
    AcresBurned: 83,
    AdminUnit: 'Klamath National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/7/27/tree-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '',
    Latitude: 41.834366,
    Location: 'Tree of Heaven Campground, east of Gottsville',
    Longitude: -122.656569,
    MajorIncident: 'False',
    Name: 'Tree Fire',
    Started: '2019-07-27T10:15:00Z',
    UniqueId: '4ba68199-b45d-49da-91e8-bee9921b621b'
  },
  {
    AcresBurned: 81,
    AdminUnit: 'CAL FIRE Sonoma Lake Napa Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/13/timm-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2019-08-13T18:00:00Z',
    Latitude: 38.455,
    Location: 'Off of Timm Road and Allendale Road, South of Winters',
    Longitude: -121.969167,
    MajorIncident: 'False',
    Name: 'Timm Fire',
    Started: '2019-08-13T15:41:24Z',
    UniqueId: 'ce97fe6d-a635-45f1-bc18-cdd1698673c2'
  },
  {
    AcresBurned: 81,
    AdminUnit: 'CAL FIRE San Bernardino Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/22/milpas-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '',
    Latitude: 34.42386,
    Location: 'Milpas Rd and Valley View Rd, 10 miles SE of Apple Valley',
    Longitude: -117.10318,
    MajorIncident: 'False',
    Name: 'Milpas Fire',
    Started: '2019-07-22T19:45:27Z',
    UniqueId: '9e6b72f0-5f8a-41fe-a60d-40d7bc2f5637'
  },
  {
    AcresBurned: 81,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/16/meadow-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-07-17T21:29:00Z',
    Latitude: 33.514658,
    Location: 'Highway 371 near Lake Riverside Drive',
    Longitude: -116.7884,
    MajorIncident: 'False',
    Name: 'Meadow Fire',
    Started: '2019-07-16T13:45:43Z',
    UniqueId: '72384606-035c-4d00-8887-84a9da7d0e57'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CALFIRE/Butte County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/24/nelson-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-10-24T17:15:00Z',
    Latitude: 39.551423,
    Location: 'Between Durham and Richvale',
    Longitude: -121.800538,
    MajorIncident: 'False',
    Name: 'Nelson Fire',
    Started: '2019-10-24T14:43:10Z',
    UniqueId: '6890469e-78d7-4dac-b162-6c23498fabcc'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/25/ivy-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-08-25T13:00:00Z',
    Latitude: 33.77777348,
    Location: 'near Northbound Intestate 15 and Temescal Canyon',
    Longitude: -117.487578,
    MajorIncident: 'False',
    Name: 'Ivy Fire',
    Started: '2019-08-25T10:58:28Z',
    UniqueId: 'cb87a6f4-a560-41a5-81c0-1064d0c368b6'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE San Diego County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/15/border-9-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-08-16T18:44:00Z',
    Latitude: 32.57394,
    Location: 'Off of Marron Valley Road and Border Road, Southeast of Dulzura',
    Longitude: -116.760465,
    MajorIncident: 'False',
    Name: 'Border 9 Fire',
    Started: '2019-08-15T16:24:24Z',
    UniqueId: 'e094035d-ac9c-4ea9-a23b-bb55321a64d6'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/24/sweigert-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '',
    Latitude: 37.433192,
    Location: 'Off of Kahler Court and Felter Road, East of Milpitas',
    Longitude: -121.807258,
    MajorIncident: 'False',
    Name: 'Sweigert Fire',
    Started: '2019-07-24T20:01:44Z',
    UniqueId: 'a8c2bf1e-bb0f-4eec-a435-36d7723dfda6'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE Riverside Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/12/lincoln-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-07-17T10:00:00Z',
    Latitude: 33.56938,
    Location: 'Lincoln St and Ave 66, Mecca, 6 miles south of Coachella',
    Longitude: -116.07896,
    MajorIncident: 'False',
    Name: 'Lincoln Fire',
    Started: '2019-07-12T17:15:31Z',
    UniqueId: '6311a921-f8e9-45c1-b10d-fee8be8dae29'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/25/scott-fire/',
    Counties: 'Yuba',
    CountyIds: 58,
    Extinguished: '2019-06-25T13:50:00Z',
    Latitude: 39.24678,
    Location: 'off Scott Forbes Rd, 5 miles east of Browns Valley',
    Longitude: -121.32399,
    MajorIncident: 'False',
    Name: 'Scott Fire',
    Started: '2019-06-25T13:51:09Z',
    UniqueId: '31cbc968-6d9d-412b-8bc3-6846ca398fe2'
  },
  {
    AcresBurned: 80,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/24/scott-fire/',
    Counties: 'Yuba',
    CountyIds: 58,
    Extinguished: '2019-06-24T18:30:00Z',
    Latitude: 39.24678,
    Location: 'off Scott Forbes Rd, 5 miles east of Browns Valley',
    Longitude: -121.32399,
    MajorIncident: 'False',
    Name: 'Scott Fire',
    Started: '2019-06-24T11:57:00Z',
    UniqueId: '937f9f26-8d23-4ee7-a0f3-61313dcc63f3'
  },
  {
    AcresBurned: 75,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/11/5/eagle-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2019-11-06T18:30:00Z',
    Latitude: 39.100408,
    Location: 'Walker Ridge Road and Bartlett Springs Road, northeast of Clearlake',
    Longitude: -122.496548,
    MajorIncident: 'False',
    Name: 'Eagle Fire',
    Started: '2019-11-05T06:52:14Z',
    UniqueId: '600d608d-6279-435d-bc9b-99aacaa5e80f'
  },
  {
    AcresBurned: 74,
    AdminUnit: 'San Jose Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/7/2/coyote-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-07-02T18:32:00Z',
    Latitude: 37.18904,
    Location: 'Northbound US 101 at Coyote Creek Golf Drive in San Jose',
    Longitude: -121.694968,
    MajorIncident: 'False',
    Name: 'Coyote Fire',
    Started: '2019-07-02T16:10:02Z',
    UniqueId: 'be4489fb-f51f-4109-8132-c7a28e0d9995'
  },
  {
    AcresBurned: 70,
    AdminUnit: 'City of Marysville',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/6/8/levee-fire/',
    Counties: 'Yuba',
    CountyIds: 58,
    Extinguished: '2019-06-17T08:34:00Z',
    Latitude: 39.15641,
    Location: 'Highway 20 & E 22nd Street, in Marysville',
    Longitude: -121.56363,
    MajorIncident: 'False',
    Name: 'Levee Fire',
    Started: '2019-06-08T13:07:00Z',
    UniqueId: '3fd43a39-4e82-4b7e-a642-be86b5c73522'
  },
  {
    AcresBurned: 68,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/9/corning-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-10-09T12:39:00Z',
    Latitude: 39.847708,
    Location: 'Inghram Road, South Corning',
    Longitude: -122.1604,
    MajorIncident: 'False',
    Name: 'Corning Fire',
    Started: '2019-10-09T08:31:40Z',
    UniqueId: '18fe1e24-799d-4aa9-a7ec-fa8e331ae3e9'
  },
  {
    AcresBurned: 67,
    AdminUnit: 'Marin County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/24/muir-fire/',
    Counties: 'Marin',
    CountyIds: 21,
    Extinguished: '',
    Latitude: 37.896231,
    Location: 'Highway 1 and Panoramic Hwy, Stinson Beach',
    Longitude: -122.636471,
    MajorIncident: 'False',
    Name: 'Muir Fire',
    Started: '2019-10-24T12:15:33Z',
    UniqueId: '16b1921b-f753-4a36-85bc-d903555f0af4'
  },
  {
    AcresBurned: 67,
    AdminUnit: 'Tuolumne-Calaveras Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/22/lynette-fire/',
    Counties: 'Calaveras',
    CountyIds: 5,
    Extinguished: '',
    Latitude: 38.20177,
    Location: 'By the intersection of Loera Hills Road on Paloma Road in Valley Springs, California.',
    Longitude: -120.827386,
    MajorIncident: 'False',
    Name: 'Lynette Fire',
    Started: '2019-09-22T18:25:56Z',
    UniqueId: '9fc12331-47f4-4d79-bffe-914f13658993'
  },
  {
    AcresBurned: 66,
    AdminUnit: 'CAL FIRE San Benito-Monterey Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/1/jolon-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2019-09-02T10:08:00Z',
    Latitude: 35.906482,
    Location: 'Jolon Road and New Pleyto Road, Lockwood',
    Longitude: -120.992914,
    MajorIncident: 'False',
    Name: 'Jolon Fire',
    Started: '2019-09-01T16:35:55Z',
    UniqueId: '954bfbe7-424c-49e0-9611-23e9f7a475a2'
  },
  {
    AcresBurned: 65,
    AdminUnit: 'US Forest Service - Tahoe National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/5/10/sugar-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '2019-05-24T14:28:00Z',
    Latitude: 39.11536,
    Location: 'Sugar Pine Road and Big Reservoir Lane, northeast of Foresthill',
    Longitude: -120.76088,
    MajorIncident: 'False',
    Name: 'Sugar Fire',
    Started: '2019-05-10T14:14:00Z',
    UniqueId: '0888bb9d-0d9b-4a49-bf3d-a55a7c40a707'
  },
  {
    AcresBurned: 64,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/22/canyon-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '',
    Latitude: 38.481258,
    Location: 'Hwy 128 and Wragg Canyon Rd 16 miles east of St. Helena',
    Longitude: -122.143942,
    MajorIncident: 'False',
    Name: 'Canyon Fire',
    Started: '2019-07-22T15:05:34Z',
    UniqueId: '26676376-4e61-4d68-a28f-5fd8b4501acd'
  },
  {
    AcresBurned: 63,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/4/elk-fire/',
    Counties: 'Glenn',
    CountyIds: 11,
    Extinguished: '2019-10-03T12:03:00Z',
    Latitude: 41.70611111,
    Location: 'Elk Creek',
    Longitude: -123.4375,
    MajorIncident: 'False',
    Name: 'Elk Fire',
    Started: '2019-10-04T12:03:48Z',
    UniqueId: '082bd2d3-457b-496b-a469-0d2550aac7ef'
  },
  {
    AcresBurned: 63,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/5/20/paskenta-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-05-24T14:23:00Z',
    Latitude: 39.98097,
    Location: 'Paskenta Rd and Canal View Road, northwest of Corning',
    Longitude: -122.30737,
    MajorIncident: 'False',
    Name: 'Paskenta Fire',
    Started: '2019-05-20T10:57:00Z',
    UniqueId: 'aed86291-4631-4d79-ba5f-6b2c8ca399c9'
  },
  {
    AcresBurned: 62,
    AdminUnit: 'CAL FIRE San Mateo- Santa Cruz Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/24/cabrillo-fire/',
    Counties: 'San Mateo',
    CountyIds: 41,
    Extinguished: '2019-10-27T12:11:00Z',
    Latitude: 37.166674,
    Location: 'Highway 1 and Gazos Creek Rd, south of Pescadero',
    Longitude: -122.361112,
    MajorIncident: 'False',
    Name: 'Cabrillo Fire',
    Started: '2019-10-24T20:15:36Z',
    UniqueId: 'ab8109fd-e8eb-4690-9f5c-3a8c9c47ff48'
  },
  {
    AcresBurned: 60,
    AdminUnit: 'Unified command: CAL FIRE Santa Clara Unit and San Jose Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/15/bayliss-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '',
    Latitude: 37.219717,
    Location: 'Santa Teresa Blvd and Bayliss Drive, South San Jose',
    Longitude: -121.761974,
    MajorIncident: 'False',
    Name: 'Bayliss Fire',
    Started: '2019-08-15T13:44:02Z',
    UniqueId: '0deca389-4481-4d91-8765-40caba3ea31c'
  },
  {
    AcresBurned: 58,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/6/forbestown-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-09-12T18:49:00Z',
    Latitude: 39.470333,
    Location: 'Forbestown Road and Hurleton Swedes Flat Road, east of Oroville',
    Longitude: -121.412333,
    MajorIncident: 'False',
    Name: 'Forbestown Fire',
    Started: '2019-09-06T15:18:52Z',
    UniqueId: '2de3ab6b-60c5-4400-9bff-74c79ed7d553'
  },
  {
    AcresBurned: 58,
    AdminUnit: 'East Contra Costa Fire Protection District',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/8/7/sellers-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '',
    Latitude: 37.968494,
    Location: 'Sellers Ave and Delta Rd, 2 miles northeast of Brentwood',
    Longitude: -121.678172,
    MajorIncident: 'False',
    Name: 'Sellers Fire',
    Started: '2019-08-07T15:13:52Z',
    UniqueId: 'e338f506-b9fa-44c0-ae64-324ed0e590d4'
  },
  {
    AcresBurned: 55,
    AdminUnit: 'Bureau of Land Management - Northern California District',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/13/horse-fire/',
    Counties: 'Lassen',
    CountyIds: 18,
    Extinguished: '2019-10-16T13:44:00Z',
    Latitude: 40.387772,
    Location: 'Shaffer Mountain, Northeast of Susanville in Lassen County',
    Longitude: -120.304341,
    MajorIncident: 'False',
    Name: 'Horse Fire',
    Started: '2019-10-13T14:45:37Z',
    UniqueId: '72c6a0db-a014-4cd9-9788-926707ef839c'
  },
  {
    AcresBurned: 55,
    AdminUnit: 'Bureau of Indian Affairs',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/5/29/66-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-06-24T11:46:00Z',
    Latitude: 33.57039,
    Location: 'Off Avenue 66 in Thermal',
    Longitude: -116.1466,
    MajorIncident: 'False',
    Name: '66 Fire',
    Started: '2019-05-29T21:06:00Z',
    UniqueId: 'b4616173-5807-4c04-a416-5374139f3fcc'
  },
  {
    AcresBurned: 53,
    AdminUnit: 'CAL FIRE Sonoma Lake Napa Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/7/oak-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2019-09-08T07:00:00Z',
    Latitude: 38.955024,
    Location: 'Highway 29 and Cole Creek Road, South of Kelseyville',
    Longitude: -122.833831,
    MajorIncident: 'False',
    Name: 'Oak Fire',
    Started: '2019-09-07T14:00:00Z',
    UniqueId: '25e65946-2e28-453b-bcb4-617b623be750'
  },
  {
    AcresBurned: 52,
    AdminUnit: 'Los Padres National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/1/ranch-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '',
    Latitude: 35.189783,
    Location: 'Off of Pozo Road and Avenales Ranch Rd, Southeast of Pozo',
    Longitude: -120.1755,
    MajorIncident: 'False',
    Name: 'Ranch Fire',
    Started: '2019-10-01T22:35:52Z',
    UniqueId: 'e2a0252b-2da9-4967-ba33-7abe3ced1efa'
  },
  {
    AcresBurned: 52,
    AdminUnit: 'Unified Command: CAL FIRE San Diego County Fire & Lakeside Fire Protection District',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/25/willow-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-09-25T20:00:00Z',
    Latitude: 32.87833333,
    Location: 'near 14000 block of Willow Rd, Northeast Lakeside',
    Longitude: -116.88,
    MajorIncident: 'False',
    Name: 'Willow Fire',
    Started: '2019-09-25T14:17:25Z',
    UniqueId: 'abdb011f-15d8-475b-b08e-4df583700411'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE San Diego',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/31/copper-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '',
    Latitude: 32.564583,
    Location: 'off of Border road and Canyon Road, Southeast of Chula Vista',
    Longitude: -116.834583,
    MajorIncident: 'False',
    Name: 'Copper Fire',
    Started: '2019-10-31T06:39:56Z',
    UniqueId: 'e471b23c-f00c-44bc-afc1-6ab02b0af4c3'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'Contra Costa Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/27/forest-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-10-28T16:26:00Z',
    Latitude: 37.97911,
    Location: 'Alhambra Ave and Alhambra Hills Dr, Martinez in Contra Costa County',
    Longitude: -122.11092,
    MajorIncident: 'False',
    Name: 'Forest Fire',
    Started: '2019-10-27T17:36:15Z',
    UniqueId: 'b36ed23e-a3de-4aff-bdbc-d6ebf8d8f077'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/2/prairie-fire/',
    Counties: 'Sacramento',
    CountyIds: 34,
    Extinguished: '2019-08-02T17:00:00Z',
    Latitude: 38.622058,
    Location: 'off White Rock Road and Prairie City Road',
    Longitude: -121.114095,
    MajorIncident: 'False',
    Name: 'Prairie Fire',
    Started: '2019-08-02T14:45:00Z',
    UniqueId: 'a0d95805-48db-467e-8dd5-db761eb5ae74'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/8/ink-fire/',
    Counties: 'Napa',
    CountyIds: 28,
    Extinguished: '2019-06-17T08:46:00Z',
    Latitude: 38.63047,
    Location: 'Pope Valley Rd, northeast of Calistoga',
    Longitude: -122.47282,
    MajorIncident: 'False',
    Name: 'Ink Fire',
    Started: '2019-06-08T14:37:00Z',
    UniqueId: '78c1dacb-653a-42fe-b025-ab80ec4996bd'
  },
  {
    AcresBurned: 50,
    AdminUnit: 'CAL FIRE Butte Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/5/1/meridian-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-05-08T08:47:00Z',
    Latitude: 39.85484,
    Location: 'Off Munjar Rd, north of Chico',
    Longitude: -121.905,
    MajorIncident: 'True',
    Name: 'Meridian Fire',
    Started: '2019-05-01T16:46:00Z',
    UniqueId: '398bb669-190d-4dbf-9af0-6ccb27817c13'
  },
  {
    AcresBurned: 47,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/15/aborn-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-07-15T18:19:00Z',
    Latitude: 37.32555556,
    Location: 'Off Aborn Road and Murillo Avenue, East San Jose',
    Longitude: -121.76444444,
    MajorIncident: 'False',
    Name: 'Aborn Fire',
    Started: '2019-07-15T11:12:00Z',
    UniqueId: '42dab7c3-458f-4838-b70f-d5bb3d0f0b80'
  },
  {
    AcresBurned: 47,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/10/springs-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2019-06-11T17:18:00Z',
    Latitude: 35.89593,
    Location: 'Off Mountain Road 56 East of Ducor',
    Longitude: -118.94106,
    MajorIncident: 'False',
    Name: 'Springs Fire',
    Started: '2019-06-10T17:51:00Z',
    UniqueId: 'b671965d-2369-4107-98fe-432eab6ffdc0'
  },
  {
    AcresBurned: 46,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/12/lower-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-08-13T16:15:00Z',
    Latitude: 40.46968,
    Location: 'Gas Point Rd & Lower Gas Point Rd in Igo',
    Longitude: -122.54364,
    MajorIncident: 'False',
    Name: 'Lower Fire',
    Started: '2019-08-12T14:16:53Z',
    UniqueId: '618ca03c-28fd-4d66-abf3-d065d72d8cb4'
  },
  {
    AcresBurned: 46,
    AdminUnit: 'CAL FIRE Tehama - Glenn Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/22/paskenta-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-06-24T11:43:00Z',
    Latitude: 39.97083,
    Location: 'off Corning Road and Paskenta Road, West of Corning',
    Longitude: -122.48277,
    MajorIncident: 'False',
    Name: 'Paskenta Fire',
    Started: '2019-06-22T03:12:00Z',
    UniqueId: '50328016-5e03-4e90-bff0-95d36942728f'
  },
  {
    AcresBurned: 45,
    AdminUnit: 'CAL FIRE/ Riverside County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/5/30/diversion-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-06-03T08:48:00Z',
    Latitude: 33.69078,
    Location: 'Near the Intersection of Highway 95 and 2nd Avenue, in Blythe',
    Longitude: -114.57265,
    MajorIncident: 'False',
    Name: 'Diversion Fire',
    Started: '2019-05-30T12:41:00Z',
    UniqueId: 'e354cde8-d0e6-4150-9f6b-1c12045e77d0'
  },
  {
    AcresBurned: 44,
    AdminUnit: 'CAL FIRE Tuolumne Calaveras Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/5/flood-fire/',
    Counties: 'San Joaquin',
    CountyIds: 39,
    Extinguished: '2019-09-05T19:56:00Z',
    Latitude: 38.017138,
    Location: 'near Flood Rd and N. Waverly Road, Southwest of Rancho Calaveras',
    Longitude: -120.945044,
    MajorIncident: 'False',
    Name: 'Flood Fire',
    Started: '2019-09-05T14:33:01Z',
    UniqueId: '3d4c2809-cd37-4f07-b86e-68dcd52c7434'
  },
  {
    AcresBurned: 43,
    AdminUnit: 'CAL FIRE San Benito - Monterey Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/12/ardo-fire/',
    Counties: 'Monterey',
    CountyIds: 27,
    Extinguished: '2019-06-17T08:46:00Z',
    Latitude: 35.97059,
    Location: 'near San Ardo',
    Longitude: -120.88241,
    MajorIncident: 'False',
    Name: 'Ardo Fire',
    Started: '2019-06-12T17:23:00Z',
    UniqueId: '20ccd7ec-de69-4967-9877-db5e143fe99a'
  },
  {
    AcresBurned: 42,
    AdminUnit: 'Los Angeles Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/21/palisades-fire/',
    Counties: 'Los Angeles',
    CountyIds: 19,
    Extinguished: '2019-10-31T14:16:00Z',
    Latitude: 34.055768,
    Location: 'North Palisades Dr., Pacific Palisades',
    Longitude: -118.554091,
    MajorIncident: 'False',
    Name: 'Palisades Fire',
    Started: '2019-10-21T11:52:52Z',
    UniqueId: '24eb323e-b97f-4087-886b-7efae8937bae'
  },
  {
    AcresBurned: 42,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/10/plains-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-10-10T19:05:00Z',
    Latitude: 40.4988,
    Location: 'Millville Plains Road and Sprig Road in Millville',
    Longitude: -122.19911,
    MajorIncident: 'False',
    Name: 'Plains Fire',
    Started: '2019-10-10T15:49:07Z',
    UniqueId: 'f20ba27e-4c6c-4ca9-a356-ef88c4f788bb'
  },
  {
    AcresBurned: 38,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/6/far-fire/',
    Counties: 'Yuba',
    CountyIds: 58,
    Extinguished: '',
    Latitude: 39.06066,
    Location: 'Camp Far West rd & Nisenan Ln, northeast of Wheatland',
    Longitude: -121.35014,
    MajorIncident: 'False',
    Name: 'Far Fire',
    Started: '2019-07-06T20:21:25Z',
    UniqueId: '2d3b577c-7b58-4ee3-9e21-cbec5abd8ce4'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/25/jamieson-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '',
    Latitude: 37.034183,
    Location: 'at Jamieson Road and Cañada Road near Gilroy',
    Longitude: -121.45597,
    MajorIncident: 'False',
    Name: 'Jamieson Fire',
    Started: '2019-08-25T13:06:49Z',
    UniqueId: '19343958-2921-41d2-a3f8-501badcd0bee'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/15/patterson-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2019-08-16T10:35:00Z',
    Latitude: 38.652475,
    Location: 'Patterson Drive, south of Placerville',
    Longitude: -120.826165,
    MajorIncident: 'False',
    Name: 'Patterson Fire',
    Started: '2019-08-15T17:47:43Z',
    UniqueId: '2760040b-e17b-430f-b581-a81694b450ac'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'Klamath National Forest',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/7/27/community-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '',
    Latitude: 41.838,
    Location: 'Hwy 96 near the Klamath River Community Hall',
    Longitude: -122.845,
    MajorIncident: 'False',
    Name: 'Community Fire',
    Started: '2019-07-27T10:15:00Z',
    UniqueId: 'ee681e0b-54a3-48ad-900c-8037eeb88159'
  },
  {
    AcresBurned: 35,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/10/calaveras-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-06-17T08:46:00Z',
    Latitude: 37.44422,
    Location: 'Calaveras Road and Weller Road East of Milpitas',
    Longitude: -121.84082,
    MajorIncident: 'False',
    Name: 'Calaveras Fire',
    Started: '2019-06-10T15:16:00Z',
    UniqueId: '0cd5a369-2f91-4786-9df1-98ece3e9e78c'
  },
  {
    AcresBurned: 34,
    AdminUnit: 'CAL FIRE Riverside Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/12/redwood-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '',
    Latitude: 33.854597,
    Location: 'Mead Valley',
    Longitude: -117.270144,
    MajorIncident: 'False',
    Name: 'Redwood Fire',
    Started: '2019-09-12T20:30:41Z',
    UniqueId: 'b277af3b-3785-44c1-bdfb-c5a5ba766d2b'
  },
  {
    AcresBurned: 34,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/22/yucca-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-08-23T23:00:00Z',
    Latitude: 33.4506,
    Location: 'Highway 371 cross of Yucca Road',
    Longitude: -116.857817,
    MajorIncident: 'False',
    Name: 'Yucca Fire',
    Started: '2019-08-22T19:31:10Z',
    UniqueId: '46896a04-8502-403c-b362-e4adc9e7ad4d'
  },
  {
    AcresBurned: 33,
    AdminUnit: 'Beale Air Force Base',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/8/10/heavy-range-fire/',
    Counties: 'Yolo',
    CountyIds: 57,
    Extinguished: '2019-08-10T15:07:00Z',
    Latitude: 39.171091,
    Location: 'Hammonton Smartsville Rd. and Kendal Rd, Beale Air Force Base',
    Longitude: -121.423281,
    MajorIncident: 'False',
    Name: 'Heavy Range Fire',
    Started: '2019-08-10T18:47:02Z',
    UniqueId: 'f044a406-06ab-457d-8a93-c52bb1930604'
  },
  {
    AcresBurned: 33,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/3/yokohl-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2019-06-04T16:03:00Z',
    Latitude: 36.23012,
    Location: 'off of Yokohl Drive in Tulare County',
    Longitude: -118.85712,
    MajorIncident: 'False',
    Name: 'Yokohl Fire',
    Started: '2019-06-03T12:18:00Z',
    UniqueId: 'db2a5b4c-260b-4888-aeb3-663b8bf41106'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE San Luis Obispo County',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/11/bitter-fire/',
    Counties: 'San Luis Obispo',
    CountyIds: 40,
    Extinguished: '2019-10-11T16:21:00Z',
    Latitude: 35.709176,
    Location: 'Highway 46 and Bitterwater Rd',
    Longitude: -120.312856,
    MajorIncident: 'False',
    Name: 'Bitter Fire',
    Started: '2019-10-11T12:30:19Z',
    UniqueId: 'fd1bc30a-4377-45f6-ba2b-b4e1c7e65ee7'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'City of Vallejo Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/9/26/mare-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '',
    Latitude: 38.07944444,
    Location: 'Off Tyler Road and Jennings Road, Southwest of Vallejo',
    Longitude: -122.25611111,
    MajorIncident: 'False',
    Name: 'Mare Fire',
    Started: '2019-09-26T15:29:06Z',
    UniqueId: '178b2af3-340c-409d-80e6-21ac119969f0'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/4/gilbert-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '',
    Latitude: 40.55924,
    Location: 'Highway 44 and Gilbert Drive, Palo Cedro, East of Redding',
    Longitude: -122.25409,
    MajorIncident: 'False',
    Name: 'Gilbert Fire',
    Started: '2019-08-04T17:18:21Z',
    UniqueId: '0f3326bd-4a0f-4351-b978-38eb29f4d490'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/5/ranch-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-07-06T20:03:00Z',
    Latitude: 40.41741,
    Location: 'Near Yolla Bolla Rd & Roaring Creek in Igo',
    Longitude: -122.767256,
    MajorIncident: 'False',
    Name: 'Ranch Fire',
    Started: '2019-07-05T14:46:33Z',
    UniqueId: '65330473-c21f-446b-a6f4-7bd76bf0ebdc'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'Alameda County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/6/21/mountain-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-06-24T11:06:00Z',
    Latitude: 37.75427,
    Location: 'off Grant Line Rd and Mountain House Rd',
    Longitude: -121.57382,
    MajorIncident: 'False',
    Name: 'Mountain Fire',
    Started: '2019-06-21T14:42:00Z',
    UniqueId: 'bc5d73ab-3100-4117-9978-a99b8e3daf5c'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'Palm Springs City Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/4/9/girasol-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-04-10T10:23:00Z',
    Latitude: 0,
    Location: 'Hwy 111 and Tramway Rd, Palm Springs',
    Longitude: 0,
    MajorIncident: 'False',
    Name: 'Girasol Fire',
    Started: '2019-04-09T22:18:00Z',
    UniqueId: '3b5c5d57-f61d-4c7d-a966-9d522c77e8fc'
  },
  {
    AcresBurned: 30,
    AdminUnit: 'CAL FIRE Humbolt-Del Norte Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/1/1/pilot-fire/',
    Counties: 'Humboldt',
    CountyIds: 12,
    Extinguished: '2019-01-15T10:38:00Z',
    Latitude: 40.61805556,
    Location: 'Pilot Ridge Rd & USFS Route 1, southwest of Willow Creek',
    Longitude: -123.67555556,
    MajorIncident: 'False',
    Name: 'Pilot Fire',
    Started: '2019-01-01T14:14:00Z',
    UniqueId: '6004d3e5-66f8-487a-80a4-689d3852378c'
  },
  {
    AcresBurned: 29,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/7/point-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-10-07T09:58:00Z',
    Latitude: 37.066483,
    Location: 'Highway 152 and Dinosaur Point Rd',
    Longitude: -121.219163,
    MajorIncident: 'False',
    Name: 'Point Fire',
    Started: '2019-10-07T09:58:51.763Z',
    UniqueId: '25e80e7d-5790-4192-9cf0-a190f36158f0'
  },
  {
    AcresBurned: 29,
    AdminUnit: 'Kern County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/8/5/caliente-fire/',
    Counties: 'Kern',
    CountyIds: 15,
    Extinguished: '2019-08-06T18:43:00Z',
    Latitude: 35.287373,
    Location: 'Caliente Bodfish Rd, east of Bakersfield',
    Longitude: -118.623651,
    MajorIncident: 'False',
    Name: 'Caliente Fire',
    Started: '2019-08-05T13:56:02Z',
    UniqueId: 'fbe088d0-2a17-4d04-aac7-0e32ac8a1ef7'
  },
  {
    AcresBurned: 28,
    AdminUnit: 'Sonoma-Lake-Napa Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/4/glass-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2019-09-05T10:03:00Z',
    Latitude: 38.910498,
    Location: 'Highway 29 and DNA Ridge Rock, Southwest of Clear Lake.',
    Longitude: -122.642572,
    MajorIncident: 'True',
    Name: 'Glass Fire',
    Started: '2019-09-04T16:26:00Z',
    UniqueId: 'da7fa4d6-cbf3-4cf9-babf-1cc79aa2f536'
  },
  {
    AcresBurned: 28,
    AdminUnit: 'CAL FIRE San Diego County Fire Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/29/otay-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-06-30T16:50:00Z',
    Latitude: 32.62305556,
    Location: 'East of the Lower Otay Reservoir, East of Chula Vista',
    Longitude: -116.91416667,
    MajorIncident: 'False',
    Name: 'Otay Fire',
    Started: '2019-06-29T11:11:55Z',
    UniqueId: 'c51a2db5-6d0b-4b4a-8692-a6d73714829f'
  },
  {
    AcresBurned: 27,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/7/watt-fire/',
    Counties: 'Placer',
    CountyIds: 31,
    Extinguished: '2019-06-11T14:50:00Z',
    Latitude: 38.75263,
    Location: 'Watt Ave near Baseline Road',
    Longitude: -121.39259,
    MajorIncident: 'False',
    Name: 'Watt Fire',
    Started: '2019-06-07T12:59:00Z',
    UniqueId: '24997ef5-a558-4ea6-8a96-b3cdff79fe2b'
  },
  {
    AcresBurned: 26,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/5/20/foothill-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-05-24T14:23:00Z',
    Latitude: 33.81678,
    Location: 'Off Foothill Avenue & Orange Avenue, in Nuevo',
    Longitude: -117.18194,
    MajorIncident: 'False',
    Name: 'Foothill Fire',
    Started: '2019-05-20T13:50:00Z',
    UniqueId: '9d7c5ad0-6682-430a-b4d1-d39cfea73a29'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/17/grove-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '',
    Latitude: 38.88913,
    Location: 'Hwy 29 and Spruce Grove Road in Lake County',
    Longitude: -122.604425,
    MajorIncident: 'False',
    Name: 'Grove Fire',
    Started: '2019-10-17T20:06:00Z',
    UniqueId: 'df7805d1-682e-4a3d-b917-1bbab5e078ef'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Fresno-Kings Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/30/frame-fire/',
    Counties: 'Fresno',
    CountyIds: 10,
    Extinguished: '',
    Latitude: 36.154184,
    Location: 'Hwy 198 x Frame Rd, east of Monterey County Line',
    Longitude: -120.634179,
    MajorIncident: 'False',
    Name: 'Frame Fire',
    Started: '2019-09-30T17:39:00Z',
    UniqueId: '05b9432b-a5cf-4a8f-bf0e-9b95a04bbdde'
  },
  // {
  //   AcresBurned: 25,
  //   AdminUnit: 'CAL FIRE San Diego Unit',
  //   ArchiveYear: 2019,
  //   CalFireIncident: 'True',
  //   CanonicalUrl: '/incidents/2019/8/25/border-10-fire/',
  //   Counties: 'Mexico',
  //   CountyIds: 6237,
  //   Extinguished: '2019-08-28T08:54:00Z',
  //   Latitude: 32.557546,
  //   Location: 'Mexico / California International border in the area east of the Otay port of entry.',
  //   Longitude: -116.873955,
  //   MajorIncident: 'False',
  //   Name: 'Border 10 Fire',
  //   Started: '2019-08-25T16:15:15Z',
  //   UniqueId: '808c34bb-4e64-4eb5-9c3e-2a1e58195074'
  // },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE San Diego Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/25/border-10-fire/',
    Counties: 'San Diego',
    CountyIds: 6237,
    Extinguished: '2019-08-28T08:54:00Z',
    Latitude: 32.557546,
    Location: 'Mexico / California International border in the area east of the Otay port of entry.',
    Longitude: -116.873955,
    MajorIncident: 'False',
    Name: 'Border 10 Fire',
    Started: '2019-08-25T16:15:15Z',
    UniqueId: '808c34bb-4e64-4eb5-9c3e-2a1e58195074'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/5/bikeway-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-07-05T03:20:00Z',
    Latitude: 37.469,
    Location: 'Christensen Road, Near Bethany Reservoir',
    Longitude: -121.3697,
    MajorIncident: 'False',
    Name: 'Bikeway Fire',
    Started: '2019-07-05T09:46:01.973Z',
    UniqueId: '65e8fbe1-5300-4c90-9f48-0e7bfe55b1bc'
  },
  {
    AcresBurned: 25,
    AdminUnit: 'CAL FIRE Tulare Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/3/bear-fire/',
    Counties: 'Tulare',
    CountyIds: 54,
    Extinguished: '2019-06-11T14:48:00Z',
    Latitude: 36.14246,
    Location: 'Off of Balch Park Rd in Springville',
    Longitude: -118.80582,
    MajorIncident: 'False',
    Name: 'Bear Fire',
    Started: '2019-06-03T12:18:00Z',
    UniqueId: 'e1f34f39-beea-4a6d-9ba6-64b6b55ff567'
  },
  {
    AcresBurned: 24,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/5/fellow-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-07-05T14:58:00Z',
    Latitude: 37.99837,
    Location: 'Franklin Canyon Rd.',
    Longitude: -122.16201,
    MajorIncident: 'False',
    Name: 'Fellow Fire',
    Started: '2019-07-05T13:33:56Z',
    UniqueId: 'bc3e7037-5022-4e6a-8a1f-925c7e9aafc8'
  },
  {
    AcresBurned: 24,
    AdminUnit: 'City of Fairfield',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/6/7/nelson-fire/',
    Counties: 'Solano',
    CountyIds: 48,
    Extinguished: '2019-06-17T08:49:00Z',
    Latitude: 38.21416,
    Location: 'Cordelia Road and Link Road',
    Longitude: -122.12214,
    MajorIncident: 'False',
    Name: 'Nelson Fire',
    Started: '2019-06-07T12:59:00Z',
    UniqueId: 'b433dceb-f5b4-4b46-8eb3-2aae9fc2d45a'
  },
  {
    AcresBurned: 23,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/6/willow-fire/',
    Counties: 'Contra Costa',
    CountyIds: 7,
    Extinguished: '2019-06-11T14:47:00Z',
    Latitude: 38.02503,
    Location: 'Highway 4 and Willow Pass Rd, 2 miles west of Bay Point',
    Longitude: -121.9763,
    MajorIncident: 'False',
    Name: 'Willow Fire',
    Started: '2019-06-06T14:24:00Z',
    UniqueId: '2e71d51a-49f1-4e86-82e2-054637efd1a5'
  },
  {
    AcresBurned: 22,
    AdminUnit: 'CAL FIRE/San Diego County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/5/13/border-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-05-19T09:26:00Z',
    Latitude: 32.557566,
    Location: 'off Tin Can Canyon along the border in Otay Mesa',
    Longitude: -116.8663,
    MajorIncident: 'False',
    Name: 'Border Fire',
    Started: '2019-05-13T18:46:00Z',
    UniqueId: 'a81e03a3-de18-48e4-93bf-f8da83a17927'
  },
  {
    AcresBurned: 21,
    AdminUnit: 'CAL FIRE TCU',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/8/preston-fire/',
    Counties: 'Tuolumne',
    CountyIds: 55,
    Extinguished: '2019-08-08T17:12:00Z',
    Latitude: 37.949747,
    Location: '10,000 Block Preston Lane, Jamestown',
    Longitude: -120.420058,
    MajorIncident: 'False',
    Name: 'Preston Fire',
    Started: '2019-08-08T16:16:40Z',
    UniqueId: '3e020c0d-e35b-4e01-96b7-a3c8e40fd281'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Sonoma Lake Napa Unit & William Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/14/spring-fire/',
    Counties: 'Colusa',
    CountyIds: 6,
    Extinguished: '2019-08-14T18:51:00Z',
    Latitude: 39.088333,
    Location: 'Off of Spring Valley Road and Highway 20',
    Longitude: -122.309167,
    MajorIncident: 'True',
    Name: 'Spring Fire',
    Started: '2019-08-14T12:52:00Z',
    UniqueId: 'f2a78d1c-66be-40f8-a2d8-5756eb265162'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/12/radio-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-08-12T08:21:00Z',
    Latitude: 33.909792,
    Location: 'David Mountain Radio Road at David Mountain Road in Beaumont',
    Longitude: -117.004667,
    MajorIncident: 'False',
    Name: 'Radio Fire',
    Started: '2019-08-12T10:53:10Z',
    UniqueId: '073d3328-3d8c-459a-8ac8-5dc6095511ec'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Sonoma-Lake-Napa Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/8/golf-fire/',
    Counties: 'Lake',
    CountyIds: 17,
    Extinguished: '2019-08-11T10:28:00Z',
    Latitude: 38.99174,
    Location: 'Soda Bay Road and Golf Drive, northwest of Clearlake',
    Longitude: -122.7751,
    MajorIncident: 'False',
    Name: 'Golf Fire',
    Started: '2019-08-08T14:55:59Z',
    UniqueId: '280f9652-7843-4275-9016-b95296fbf571'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE Riverside County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/11/gibbel-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-07-11T08:26:00Z',
    Latitude: 33.69055556,
    Location: 'Off of Girard Street and Quiet Hills Drive',
    Longitude: -116.953889,
    MajorIncident: 'False',
    Name: 'Gibbel Fire',
    Started: '2019-07-11T16:27:17Z',
    UniqueId: '6564081d-5ce7-4330-8ad7-2d1d976d778a'
  },
  {
    AcresBurned: 20,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/27/nuevo-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-06-27T17:36:00Z',
    Latitude: 33.80493,
    Location: 'Nuevo Road and Menifee Road',
    Longitude: -117.15738,
    MajorIncident: 'False',
    Name: 'Nuevo Fire',
    Started: '2019-06-27T16:14:25Z',
    UniqueId: 'c6e38284-336a-4435-a3a1-b2b91ee84a91'
  },
  {
    AcresBurned: 19,
    AdminUnit: 'CAL FIRE Riverside County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/11/1/sobrante-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-11-01T08:55:00Z',
    Latitude: 33.849906,
    Location: 'off of La Sierra Ave and Tin Mine Road,  East of Corona',
    Longitude: -117.461363,
    MajorIncident: 'False',
    Name: 'Sobrante Fire',
    Started: '2019-11-01T13:04:34Z',
    UniqueId: '305f30f5-622d-4c55-8813-45ffbc15aed0'
  },
  {
    AcresBurned: 19,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/30/warren-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-09-30T09:05:00Z',
    Latitude: 33.703546,
    Location: 'Warren Rd & Old Mine Rd in Hemet',
    Longitude: -117.033598,
    MajorIncident: 'False',
    Name: 'Warren Fire',
    Started: '2019-09-30T07:07:00Z',
    UniqueId: '1e85b2a3-0d55-4c3a-9fbb-5208d615cccd'
  },
  {
    AcresBurned: 19,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/31/carroll-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-08-31T12:50:00Z',
    Latitude: 37.718636,
    Location: 'eastbound 580 and North Flynn Road',
    Longitude: -121.657011,
    MajorIncident: 'False',
    Name: 'Carroll Fire',
    Started: '2019-08-31T12:55:15Z',
    UniqueId: '40ce99a7-fbca-4b41-b3bf-e2f863fdcc7e'
  },
  {
    AcresBurned: 18,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/3/del-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2019-10-04T10:39:00Z',
    Latitude: 37.429506,
    Location: 'Del Puerto Canyon Road east of Frank Raines Park west of Patterson',
    Longitude: -121.336465,
    MajorIncident: 'False',
    Name: 'Del Fire',
    Started: '2019-10-03T13:36:04Z',
    UniqueId: '2e4017ba-5c18-4de6-8098-54b2a6caf5bd'
  },
  {
    AcresBurned: 17,
    AdminUnit: 'CAL FIRE San Benito Monterey Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/4/foster-fire/',
    Counties: 'San Benito',
    CountyIds: 35,
    Extinguished: '2019-09-04T20:33:00Z',
    Latitude: 36.732866,
    Location: 'off of Grass Valley Road and Cienega Road, in Hollister',
    Longitude: -121.39478,
    MajorIncident: 'False',
    Name: 'Foster Fire',
    Started: '2019-09-04T20:33:59Z',
    UniqueId: 'd8c705d2-2820-43d2-bee4-8335354bcab0'
  },
  {
    AcresBurned: 17,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/26/mines-fire/',
    Counties: 'Santa Clara',
    CountyIds: 43,
    Extinguished: '2019-06-27T08:48:00Z',
    Latitude: 37.494136,
    Location: 'Mines Road and Turner Gulch in the San Antone Valley.',
    Longitude: -121.534827,
    MajorIncident: 'False',
    Name: 'Mines Fire',
    Started: '2019-06-26T18:06:54Z',
    UniqueId: '7a0029c7-64c8-442d-8c7a-080a553e2b8e'
  },
  {
    AcresBurned: 17,
    AdminUnit: 'CAL FIRE Chico Butte Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/15/32-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-06-24T11:06:00Z',
    Latitude: 39.76242,
    Location: 'Humboldt Road and Highway 32',
    Longitude: -121.73659,
    MajorIncident: 'False',
    Name: '32 Fire',
    Started: '2019-06-15T15:29:00Z',
    UniqueId: '921a69d2-ddde-4fd8-a874-f5ba15a4edd2'
  },
  {
    AcresBurned: 17,
    AdminUnit: 'CAL FIRE Siskiyou',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/14/rocky-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-06-17T10:39:00Z',
    Latitude: 41.64895,
    Location: 'Rocky Rd and Harry Cash Rd, 9 miles east of Grenada',
    Longitude: -122.35962,
    MajorIncident: 'False',
    Name: 'Rocky Fire',
    Started: '2019-06-14T16:14:00Z',
    UniqueId: '45cad03f-97e7-4301-92e2-e63a0040913a'
  },
  {
    AcresBurned: 16,
    AdminUnit: 'CAL FIRE Shasta-Trinity Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/24/cow-fire/',
    Counties: 'Shasta',
    CountyIds: 45,
    Extinguished: '2019-09-24T14:52:00Z',
    Latitude: 40.612556,
    Location: 'at Whitmore Road and Cow Creek Ranch Road in Millville',
    Longitude: -122.039167,
    MajorIncident: 'False',
    Name: 'Cow Fire',
    Started: '2019-09-24T08:40:45Z',
    UniqueId: 'f24e0e23-63ee-4038-a04d-41fe70cac747'
  },
  {
    AcresBurned: 16,
    AdminUnit: 'CAL FIRE Amador El Dorado Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/8/14/greenstone-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2019-08-14T18:52:00Z',
    Latitude: 38.703889,
    Location: 'Off of Greenstone Road and Buck Mountain Road',
    Longitude: -120.890556,
    MajorIncident: 'False',
    Name: 'Greenstone Fire',
    Started: '2019-08-14T16:07:49Z',
    UniqueId: '22c3cb30-55b1-4fcd-9606-6a0dcedce4ef'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE Siskiyou unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/7/duzel-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-09-10T19:27:00Z',
    Latitude: 41.512917,
    Location: 'Near Duzel Rock Lookout, northeast of Etna',
    Longitude: -122.740333,
    MajorIncident: 'False',
    Name: 'Duzel Fire',
    Started: '2019-09-07T18:19:16Z',
    UniqueId: 'efba4d61-2027-4b05-8506-04d9858154ca'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE San Bernardino Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/2/telephone-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2019-09-06T08:00:00Z',
    Latitude: 34.353667,
    Location: 'Old Dump Road, south of Summit Valley Road, Hesperia',
    Longitude: -117.343833,
    MajorIncident: 'False',
    Name: 'Telephone Fire',
    Started: '2019-09-02T20:27:29Z',
    UniqueId: 'a5331bf6-d695-4309-a846-96808e41d757'
  },
  {
    AcresBurned: 15,
    AdminUnit: 'CAL FIRE / San Diego County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/10/pauma-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-06-24T11:44:00Z',
    Latitude: 33.30267,
    Location: 'Highway 76 and Pauma Valley Road',
    Longitude: -116.97772,
    MajorIncident: 'False',
    Name: 'Pauma Fire',
    Started: '2019-06-10T14:25:00Z',
    UniqueId: '77671ac0-0868-4cc9-a699-26f0131cd493'
  },
  {
    AcresBurned: 13,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/30/carson-fire/',
    Counties: 'El Dorado',
    CountyIds: 9,
    Extinguished: '2019-07-31T06:47:00Z',
    Latitude: 38.757636,
    Location: 'Northeast of Placerville in the community of Camino, off of Shadow Ridge Road',
    Longitude: -120.75664,
    MajorIncident: 'False',
    Name: 'Carson Fire',
    Started: '2019-07-30T19:27:46Z',
    UniqueId: '6ac64fee-1420-420c-bff1-1d4908b059be'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/8/little-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-10-08T17:51:00Z',
    Latitude: 37.606,
    Location: 'SR 84 and Little Valley Road in Sunol',
    Longitude: -121.853,
    MajorIncident: 'False',
    Name: 'Little Fire',
    Started: '2019-10-08T17:25:12Z',
    UniqueId: 'a87ab8be-3da9-4cb0-a72c-5125acc001ef'
  },
  {
    AcresBurned: 12,
    AdminUnit: 'CAL FIRE Butte County Fire Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/29/mayberry-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-06-29T18:20:00Z',
    Latitude: 39.32889,
    Location: 'Off Craig Access Road, Near Lake Oroville',
    Longitude: -121.23431,
    MajorIncident: 'False',
    Name: 'Mayberry Fire',
    Started: '2019-06-29T22:07:59Z',
    UniqueId: '42e2b6f0-2d63-4fbf-bbb4-4fc2eda4805d'
  },
  {
    AcresBurned: 11,
    AdminUnit: 'CAL FIRE San Bernardino Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/21/beaumont-fire/',
    Counties: 'San Bernardino',
    CountyIds: 36,
    Extinguished: '2019-10-22T13:30:00Z',
    Latitude: 34.033117,
    Location: 'Beaumont and San Timorese Canyon',
    Longitude: -117.21545,
    MajorIncident: 'False',
    Name: 'Beaumont Fire',
    Started: '2019-10-21T08:16:33Z',
    UniqueId: '6ad5dc4a-bd52-4cb4-9664-2ab606289d21'
  },
  {
    AcresBurned: 11,
    AdminUnit: 'CAL FIRE Tehama Glenn Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/7/dales-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-10-07T11:03:00Z',
    Latitude: 40.314187,
    Location: 'Highway 36E east of Dales Station and Manton Road',
    Longitude: -122.070055,
    MajorIncident: 'False',
    Name: 'Dales Fire',
    Started: '2019-10-07T11:03:29.963Z',
    UniqueId: 'a4bd4cbb-53de-47c8-972f-cca4c36aaf74'
  },
  {
    AcresBurned: 11,
    AdminUnit: 'CAL FIRE TCU (Tuolumne-Calaveras Unit)',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/13/bridge-fire/',
    Counties: 'Stanislaus',
    CountyIds: 50,
    Extinguished: '2019-09-13T21:43:00Z',
    Latitude: 37.492002,
    Location: 'Knights Ferry',
    Longitude: -120.401028,
    MajorIncident: 'False',
    Name: 'Bridge Fire',
    Started: '2019-09-13T20:00:29Z',
    UniqueId: 'a8b79d35-dab7-4513-ac65-25fd99541662'
  },
  {
    AcresBurned: 11,
    AdminUnit: 'CAL FIRE Santa Clara Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/2/mines-fire/',
    Counties: 'Alameda',
    CountyIds: 1,
    Extinguished: '2019-09-02T19:13:00Z',
    Latitude: 37.545167,
    Location: 'Mines Road, Livermore',
    Longitude: -121.596667,
    MajorIncident: 'False',
    Name: 'Mines Fire',
    Started: '2019-09-02T14:36:35Z',
    UniqueId: 'de9cacb4-0be2-47d1-8cf2-7a25aabacfae'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'San Diego City Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/15/fairmont-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '2019-10-16T13:50:00Z',
    Latitude: 32.762706,
    Location: 'Off Fairmont Avenue and Aldine Drive, Northwest of Talmadge',
    Longitude: -117.097441,
    MajorIncident: 'False',
    Name: 'Fairmont Fire',
    Started: '2019-10-15T17:41:57Z',
    UniqueId: '2a516d14-36ce-43b0-b34c-7483759a9c84'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Tehama-Glenn Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/9/inghram-fire/',
    Counties: 'Tehama',
    CountyIds: 52,
    Extinguished: '2019-10-08T09:52:00Z',
    Latitude: 39.847708,
    Location: 'Inghram Road, South Corning',
    Longitude: -122.160416,
    MajorIncident: 'False',
    Name: 'Inghram Fire',
    Started: '2019-10-09T09:52:52.477Z',
    UniqueId: 'd6114db7-8a39-4b86-92a5-5c3dea1f348f'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Amador-El Dorado Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/25/electra-fire/',
    Counties: 'Amador',
    CountyIds: 3,
    Extinguished: '2019-09-25T17:00:00Z',
    Latitude: 38.332083,
    Location: 'Electra Road and Highway 49, east of Jackson',
    Longitude: -120.67131,
    MajorIncident: 'True',
    Name: 'Electra Fire',
    Started: '2019-09-25T13:13:41Z',
    UniqueId: '755df0b3-ad02-406b-af5d-738b67d8c755'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE/Riverside County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/9/10/bailey-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-09-10T10:45:00Z',
    Latitude: 33.496633,
    Location: 'Bailey Road and Terwilliger Road in Anza',
    Longitude: -116.631106,
    MajorIncident: 'False',
    Name: 'Bailey Fire',
    Started: '2019-09-10T10:43:58Z',
    UniqueId: '5a4639e4-0d1d-4cee-8215-0aa1d53a5160'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Butte County Fire Department',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/7/23/moms-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '',
    Latitude: 39.423833,
    Location: 'Off Moms Lane and Lone Tree Road, South of Orville',
    Longitude: -121.579738,
    MajorIncident: 'False',
    Name: 'Moms Fire',
    Started: '2019-07-23T14:41:00Z',
    UniqueId: '7955a367-99da-4047-9f69-cc60ad3208e6'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE Siskiyou Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/16/irongate-fire/',
    Counties: 'Siskiyou',
    CountyIds: 47,
    Extinguished: '2019-06-21T14:23:00Z',
    Latitude: 41.94622,
    Location: 'Deer Run Road, east of Iron Gate Reservoir',
    Longitude: -122.40157,
    MajorIncident: 'False',
    Name: 'IronGate Fire',
    Started: '2019-06-16T20:33:00Z',
    UniqueId: 'fe63d965-9069-4a96-b9da-99d5fefdaa19'
  },
  {
    AcresBurned: 10,
    AdminUnit: 'CAL FIRE / Butte County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/4/30/cana-fire/',
    Counties: 'Butte',
    CountyIds: 4,
    Extinguished: '2019-05-08T08:47:00Z',
    Latitude: 39.83958,
    Location: 'Off Hamilton Nord Cana Hwy & Cana Hwy, northeast of Chico',
    Longitude: -121.957,
    MajorIncident: 'False',
    Name: 'Cana Fire',
    Started: '2019-04-30T12:20:00Z',
    UniqueId: '34abbc65-5bbe-474b-85c8-16d07bb5b503'
  },
  {
    AcresBurned: 9,
    AdminUnit: 'CAL FIRE / Riverside County Fire',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/10/10/eagle-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '2019-10-10T18:11:00Z',
    Latitude: 33.827979,
    Location: 'Eagle Canyon Rd. and Cajalco Rd., southwest of Corona',
    Longitude: -117.499619,
    MajorIncident: 'False',
    Name: 'Eagle Fire',
    Started: '2019-10-10T12:08:00Z',
    UniqueId: '6e93b252-99a3-4214-9921-238373b17535'
  },
  {
    AcresBurned: 2,
    AdminUnit: 'CAL FIRE Nevada-Yuba-Placer Unit',
    ArchiveYear: 2019,
    CalFireIncident: 'True',
    CanonicalUrl: '/incidents/2019/6/28/long-fire/',
    Counties: 'Nevada',
    CountyIds: 29,
    Extinguished: '2019-06-28T17:33:00Z',
    Latitude: 39.40972222,
    Location: 'Off of  Long Point Road and Old Mill Road, Southeast of Camptonville in Nevada County',
    Longitude: -121.00055556,
    MajorIncident: 'False',
    Name: 'Long Fire',
    Started: '2019-06-28T15:03:04Z',
    UniqueId: 'b38c0563-b321-431b-9174-6336c5a0d449'
  },
  {
    AcresBurned: '',
    AdminUnit: 'Yolo County Fire Protection District',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/11/25/cashe-fire/',
    Counties: 'Yolo',
    CountyIds: 57,
    Extinguished: '',
    Latitude: 38.734634,
    Location: 'County Road 102 and County Road 17, North of Woodland',
    Longitude: -121.729691,
    MajorIncident: 'False',
    Name: 'Cashe Fire',
    Started: '2019-11-25T12:02:02Z',
    UniqueId: '9c26f915-1b33-422d-b30a-9eb4da6fd729'
  },
  {
    AcresBurned: '',
    AdminUnit: 'Camp Pendleton Marine Corps Base',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/22/oak-fire/',
    Counties: 'San Diego',
    CountyIds: 37,
    Extinguished: '',
    Latitude: 33.351145,
    Location: 'Near Basilone Road and Las Pulgas Road, near Camp Pendleton North',
    Longitude: -117.403719,
    MajorIncident: 'False',
    Name: 'Oak Fire',
    Started: '2019-10-22T19:20:44Z',
    UniqueId: '7264a106-e0f4-41de-8fd0-3f9110431e28'
  },
  {
    AcresBurned: '',
    AdminUnit: 'Bureau of Indian Affairs',
    ArchiveYear: 2019,
    CalFireIncident: 'False',
    CanonicalUrl: '/incidents/2019/10/14/johnson-fire/',
    Counties: 'Riverside',
    CountyIds: 33,
    Extinguished: '',
    Latitude: 33.45148,
    Location: 'Johnson Street and Ave 82',
    Longitude: -116.05898,
    MajorIncident: 'False',
    Name: 'Johnson Fire',
    Started: '2019-10-14T15:32:20Z',
    UniqueId: '8bf75401-999f-42bd-8c0a-8db508591545'
  }
]
export default data;